import { wktToGeoJSON as e } from "@terraformer/wkt";
import { jwtDecode as t } from "jwt-decode";
import { nanoid as n } from "nanoid";
//#region \0rolldown/runtime.js
var r = Object.create, i = Object.defineProperty, a = Object.getOwnPropertyDescriptor, o = Object.getOwnPropertyNames, s = Object.getPrototypeOf, c = Object.prototype.hasOwnProperty, l = (e, t) => () => (t || (e((t = { exports: {} }).exports, t), e = null), t.exports), u = (e, t) => {
	let n = {};
	for (var r in e) i(n, r, {
		get: e[r],
		enumerable: !0
	});
	return t || i(n, Symbol.toStringTag, { value: "Module" }), n;
}, d = (e, t, n, r) => {
	if (t && typeof t == "object" || typeof t == "function") for (var s = o(t), l = 0, u = s.length, d; l < u; l++) d = s[l], !c.call(e, d) && d !== n && i(e, d, {
		get: ((e) => t[e]).bind(null, d),
		enumerable: !(r = a(t, d)) || r.enumerable
	});
	return e;
}, f = (e, t, n) => (n = e == null ? {} : r(s(e)), d(t || !e || !e.__esModule ? i(n, "default", {
	value: e,
	enumerable: !0
}) : n, e)), p = /* @__PURE__ */ function(e) {
	return e[e.Month = 0] = "Month", e[e.Week = 1] = "Week", e;
}({}), m = /* @__PURE__ */ function(e) {
	return e.String = "string", e.Number = "number", e.Boolean = "boolean", e.Date = "date", e.Array = "array", e.Geography = "geography", e.ArrayNumbers = "array_numbers", e.ArrayStrings = "array_strings", e;
}({}), h = /* @__PURE__ */ function(e) {
	return e.FirebaseToken = "firebase_token", e.Audit = "audit", e.BigQueryCustomPOIS = "big_query_custom_POIS", e.Aida = "aida", e.SharedPlan = "share_plan", e.Isochrones = "isochrones", e.Auth0 = "auth0", e.CustomGeoboundaries = "custom_geoboundaries", e.SignedUrls = "signed_urls", e.OptimizeDistribution = "optimize_distribution", e.Geocoding = "geocoding", e;
}({}), g = /* @__PURE__ */ function(e) {
	return e.DeletePlan = "delete_plan", e;
}({}), ee = /* @__PURE__ */ function(e) {
	return e.GeoboundariesWithOutGeometry = "", e.GeoboundariesWithGeometry = "_geoboundaries_with_geometry", e.CustomGeoboundaries = "_custom_geoboundaries", e;
}({}), te = /* @__PURE__ */ function(e) {
	return e.GeoboundaryWithOutGeometry = "all_pois", e.GeoboundaryWithGeometry = "regions_geoboundaries_with_geometry", e.CustomGeoboundaries = "regions_custom_geoboundaries", e.CombinateGeoboundaries = "union_of_all_pois", e;
}({}), _ = /* @__PURE__ */ function(e) {
	return e.Share = "share", e.Assets = "load_assets", e.AssetsPagination = "load_assets_pagination", e.Plan = "load_plan", e.Geoboundary = "geoboundary_geometries", e.CustomPOIs = "custom_POIs", e.Asset = "asset_details", e.Insights = "insights", e.GetSharedPlanInfo = "get_shared_plan_info", e.SharedExportPoisAssets = "shared_export_pois_assets", e.SharedExportAllPois = "shared_export_all_pois", e.SharedExportAudiencesAssets = "shared_export_audiences_assets", e.SharedExportAssetsPOIsDistance = "shared_export_assets_pois_distance", e.ExistCustomPOIsGroups = "exist_custom_pois_groups", e.Isochrones = "isochrones", e.AudiencesQuintiles = "audiences_quintiles", e.AdvanceOptions = "advance_options", e.AllMediaTypeOptions = "all_media_type_options", e.PoisIcons = "pois_icons", e.MappingPOIsBrands = "mapping_pois_brands", e.MappingPOIsTags = "mapping_pois_tags", e.MappingPOIsTopCategories = "mapping_pois_top_categories", e.MappingPOIsSubCategories = "mapping_pois_sub_categories", e;
}({}), ne = /* @__PURE__ */ function(e) {
	return e.PlanNotFound = "PlanNotFoundError", e.SharedPlanInvalidPassword = "SharedPlanInvalidPasswordError", e.SharedPlanNotEnabled = "SharedPlanNotEnabledError", e.SharedPlanExpired = "SharedPlanExpiredError", e;
}({}), re = /* @__PURE__ */ function(e) {
	return e.Development = "dev", e.Production = "pro", e.Staging = "stg", e.Local = "local", e;
}({}), v = /* @__PURE__ */ function(e) {
	return e.PowerUser = "power_user", e.Admin = "admin", e.User = "user", e.Unknown = "unknown", e.Anonymous = "anonymous", e;
}({}), ie = /* @__PURE__ */ function(e) {
	return e.StoreFileData = "store_file_data", e.CheckStatusStoreFileData = "check_status_store_file_data", e.ProcessFileData = "process_file_data", e.GetSignedUrl = "signed_url", e.DeleteFileData = "delete_file_data", e;
}({}), ae = /* @__PURE__ */ l(((e, t) => {
	var n = typeof self < "u" ? self : e, r = (function() {
		function e() {
			this.fetch = !1, this.DOMException = n.DOMException;
		}
		return e.prototype = n, new e();
	})();
	(function(e) {
		(function(t) {
			var n = {
				searchParams: "URLSearchParams" in e,
				iterable: "Symbol" in e && "iterator" in Symbol,
				blob: "FileReader" in e && "Blob" in e && (function() {
					try {
						return new Blob(), !0;
					} catch {
						return !1;
					}
				})(),
				formData: "FormData" in e,
				arrayBuffer: "ArrayBuffer" in e
			};
			function r(e) {
				return e && DataView.prototype.isPrototypeOf(e);
			}
			if (n.arrayBuffer) var i = [
				"[object Int8Array]",
				"[object Uint8Array]",
				"[object Uint8ClampedArray]",
				"[object Int16Array]",
				"[object Uint16Array]",
				"[object Int32Array]",
				"[object Uint32Array]",
				"[object Float32Array]",
				"[object Float64Array]"
			], a = ArrayBuffer.isView || function(e) {
				return e && i.indexOf(Object.prototype.toString.call(e)) > -1;
			};
			function o(e) {
				if (typeof e != "string" && (e = String(e)), /[^a-z0-9\-#$%&'*+.^_`|~]/i.test(e)) throw TypeError("Invalid character in header field name");
				return e.toLowerCase();
			}
			function s(e) {
				return typeof e != "string" && (e = String(e)), e;
			}
			function c(e) {
				var t = { next: function() {
					var t = e.shift();
					return {
						done: t === void 0,
						value: t
					};
				} };
				return n.iterable && (t[Symbol.iterator] = function() {
					return t;
				}), t;
			}
			function l(e) {
				this.map = {}, e instanceof l ? e.forEach(function(e, t) {
					this.append(t, e);
				}, this) : Array.isArray(e) ? e.forEach(function(e) {
					this.append(e[0], e[1]);
				}, this) : e && Object.getOwnPropertyNames(e).forEach(function(t) {
					this.append(t, e[t]);
				}, this);
			}
			l.prototype.append = function(e, t) {
				e = o(e), t = s(t);
				var n = this.map[e];
				this.map[e] = n ? n + ", " + t : t;
			}, l.prototype.delete = function(e) {
				delete this.map[o(e)];
			}, l.prototype.get = function(e) {
				return e = o(e), this.has(e) ? this.map[e] : null;
			}, l.prototype.has = function(e) {
				return this.map.hasOwnProperty(o(e));
			}, l.prototype.set = function(e, t) {
				this.map[o(e)] = s(t);
			}, l.prototype.forEach = function(e, t) {
				for (var n in this.map) this.map.hasOwnProperty(n) && e.call(t, this.map[n], n, this);
			}, l.prototype.keys = function() {
				var e = [];
				return this.forEach(function(t, n) {
					e.push(n);
				}), c(e);
			}, l.prototype.values = function() {
				var e = [];
				return this.forEach(function(t) {
					e.push(t);
				}), c(e);
			}, l.prototype.entries = function() {
				var e = [];
				return this.forEach(function(t, n) {
					e.push([n, t]);
				}), c(e);
			}, n.iterable && (l.prototype[Symbol.iterator] = l.prototype.entries);
			function u(e) {
				if (e.bodyUsed) return Promise.reject(/* @__PURE__ */ TypeError("Already read"));
				e.bodyUsed = !0;
			}
			function d(e) {
				return new Promise(function(t, n) {
					e.onload = function() {
						t(e.result);
					}, e.onerror = function() {
						n(e.error);
					};
				});
			}
			function f(e) {
				var t = new FileReader(), n = d(t);
				return t.readAsArrayBuffer(e), n;
			}
			function p(e) {
				var t = new FileReader(), n = d(t);
				return t.readAsText(e), n;
			}
			function m(e) {
				for (var t = new Uint8Array(e), n = Array(t.length), r = 0; r < t.length; r++) n[r] = String.fromCharCode(t[r]);
				return n.join("");
			}
			function h(e) {
				if (e.slice) return e.slice(0);
				var t = new Uint8Array(e.byteLength);
				return t.set(new Uint8Array(e)), t.buffer;
			}
			function g() {
				return this.bodyUsed = !1, this._initBody = function(e) {
					this._bodyInit = e, e ? typeof e == "string" ? this._bodyText = e : n.blob && Blob.prototype.isPrototypeOf(e) ? this._bodyBlob = e : n.formData && FormData.prototype.isPrototypeOf(e) ? this._bodyFormData = e : n.searchParams && URLSearchParams.prototype.isPrototypeOf(e) ? this._bodyText = e.toString() : n.arrayBuffer && n.blob && r(e) ? (this._bodyArrayBuffer = h(e.buffer), this._bodyInit = new Blob([this._bodyArrayBuffer])) : n.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(e) || a(e)) ? this._bodyArrayBuffer = h(e) : this._bodyText = e = Object.prototype.toString.call(e) : this._bodyText = "", this.headers.get("content-type") || (typeof e == "string" ? this.headers.set("content-type", "text/plain;charset=UTF-8") : this._bodyBlob && this._bodyBlob.type ? this.headers.set("content-type", this._bodyBlob.type) : n.searchParams && URLSearchParams.prototype.isPrototypeOf(e) && this.headers.set("content-type", "application/x-www-form-urlencoded;charset=UTF-8"));
				}, n.blob && (this.blob = function() {
					var e = u(this);
					if (e) return e;
					if (this._bodyBlob) return Promise.resolve(this._bodyBlob);
					if (this._bodyArrayBuffer) return Promise.resolve(new Blob([this._bodyArrayBuffer]));
					if (this._bodyFormData) throw Error("could not read FormData body as blob");
					return Promise.resolve(new Blob([this._bodyText]));
				}, this.arrayBuffer = function() {
					return this._bodyArrayBuffer ? u(this) || Promise.resolve(this._bodyArrayBuffer) : this.blob().then(f);
				}), this.text = function() {
					var e = u(this);
					if (e) return e;
					if (this._bodyBlob) return p(this._bodyBlob);
					if (this._bodyArrayBuffer) return Promise.resolve(m(this._bodyArrayBuffer));
					if (this._bodyFormData) throw Error("could not read FormData body as text");
					return Promise.resolve(this._bodyText);
				}, n.formData && (this.formData = function() {
					return this.text().then(ne);
				}), this.json = function() {
					return this.text().then(JSON.parse);
				}, this;
			}
			var ee = [
				"DELETE",
				"GET",
				"HEAD",
				"OPTIONS",
				"POST",
				"PUT"
			];
			function te(e) {
				var t = e.toUpperCase();
				return ee.indexOf(t) > -1 ? t : e;
			}
			function _(e, t) {
				t ||= {};
				var n = t.body;
				if (e instanceof _) {
					if (e.bodyUsed) throw TypeError("Already read");
					this.url = e.url, this.credentials = e.credentials, t.headers || (this.headers = new l(e.headers)), this.method = e.method, this.mode = e.mode, this.signal = e.signal, !n && e._bodyInit != null && (n = e._bodyInit, e.bodyUsed = !0);
				} else this.url = String(e);
				if (this.credentials = t.credentials || this.credentials || "same-origin", (t.headers || !this.headers) && (this.headers = new l(t.headers)), this.method = te(t.method || this.method || "GET"), this.mode = t.mode || this.mode || null, this.signal = t.signal || this.signal, this.referrer = null, (this.method === "GET" || this.method === "HEAD") && n) throw TypeError("Body not allowed for GET or HEAD requests");
				this._initBody(n);
			}
			_.prototype.clone = function() {
				return new _(this, { body: this._bodyInit });
			};
			function ne(e) {
				var t = new FormData();
				return e.trim().split("&").forEach(function(e) {
					if (e) {
						var n = e.split("="), r = n.shift().replace(/\+/g, " "), i = n.join("=").replace(/\+/g, " ");
						t.append(decodeURIComponent(r), decodeURIComponent(i));
					}
				}), t;
			}
			function re(e) {
				var t = new l();
				return e.replace(/\r?\n[\t ]+/g, " ").split(/\r?\n/).forEach(function(e) {
					var n = e.split(":"), r = n.shift().trim();
					if (r) {
						var i = n.join(":").trim();
						t.append(r, i);
					}
				}), t;
			}
			g.call(_.prototype);
			function v(e, t) {
				t ||= {}, this.type = "default", this.status = t.status === void 0 ? 200 : t.status, this.ok = this.status >= 200 && this.status < 300, this.statusText = "statusText" in t ? t.statusText : "OK", this.headers = new l(t.headers), this.url = t.url || "", this._initBody(e);
			}
			g.call(v.prototype), v.prototype.clone = function() {
				return new v(this._bodyInit, {
					status: this.status,
					statusText: this.statusText,
					headers: new l(this.headers),
					url: this.url
				});
			}, v.error = function() {
				var e = new v(null, {
					status: 0,
					statusText: ""
				});
				return e.type = "error", e;
			};
			var ie = [
				301,
				302,
				303,
				307,
				308
			];
			v.redirect = function(e, t) {
				if (ie.indexOf(t) === -1) throw RangeError("Invalid status code");
				return new v(null, {
					status: t,
					headers: { location: e }
				});
			}, t.DOMException = e.DOMException;
			try {
				new t.DOMException();
			} catch {
				t.DOMException = function(e, t) {
					this.message = e, this.name = t;
					var n = Error(e);
					this.stack = n.stack;
				}, t.DOMException.prototype = Object.create(Error.prototype), t.DOMException.prototype.constructor = t.DOMException;
			}
			function ae(e, r) {
				return new Promise(function(i, a) {
					var o = new _(e, r);
					if (o.signal && o.signal.aborted) return a(new t.DOMException("Aborted", "AbortError"));
					var s = new XMLHttpRequest();
					function c() {
						s.abort();
					}
					s.onload = function() {
						var e = {
							status: s.status,
							statusText: s.statusText,
							headers: re(s.getAllResponseHeaders() || "")
						};
						e.url = "responseURL" in s ? s.responseURL : e.headers.get("X-Request-URL"), i(new v("response" in s ? s.response : s.responseText, e));
					}, s.onerror = function() {
						a(/* @__PURE__ */ TypeError("Network request failed"));
					}, s.ontimeout = function() {
						a(/* @__PURE__ */ TypeError("Network request failed"));
					}, s.onabort = function() {
						a(new t.DOMException("Aborted", "AbortError"));
					}, s.open(o.method, o.url, !0), o.credentials === "include" ? s.withCredentials = !0 : o.credentials === "omit" && (s.withCredentials = !1), "responseType" in s && n.blob && (s.responseType = "blob"), o.headers.forEach(function(e, t) {
						s.setRequestHeader(t, e);
					}), o.signal && (o.signal.addEventListener("abort", c), s.onreadystatechange = function() {
						s.readyState === 4 && o.signal.removeEventListener("abort", c);
					}), s.send(o._bodyInit === void 0 ? null : o._bodyInit);
				});
			}
			return ae.polyfill = !0, e.fetch || (e.fetch = ae, e.Headers = l, e.Request = _, e.Response = v), t.Headers = l, t.Request = _, t.Response = v, t.fetch = ae, Object.defineProperty(t, "__esModule", { value: !0 }), t;
		})({});
	})(r), r.fetch.ponyfill = !0, delete r.fetch.polyfill;
	var i = r;
	e = i.fetch, e.default = i.fetch, e.fetch = i.fetch, e.Headers = i.Headers, e.Request = i.Request, e.Response = i.Response, t.exports = e;
})), oe = /* @__PURE__ */ l(((e, t) => {
	var n = function(e) {
		return r(e) && !i(e);
	};
	function r(e) {
		return !!e && typeof e == "object";
	}
	function i(e) {
		var t = Object.prototype.toString.call(e);
		return t === "[object RegExp]" || t === "[object Date]" || o(e);
	}
	var a = typeof Symbol == "function" && Symbol.for ? Symbol.for("react.element") : 60103;
	function o(e) {
		return e.$$typeof === a;
	}
	function s(e) {
		return Array.isArray(e) ? [] : {};
	}
	function c(e, t) {
		return t.clone !== !1 && t.isMergeableObject(e) ? g(s(e), e, t) : e;
	}
	function l(e, t, n) {
		return e.concat(t).map(function(e) {
			return c(e, n);
		});
	}
	function u(e, t) {
		if (!t.customMerge) return g;
		var n = t.customMerge(e);
		return typeof n == "function" ? n : g;
	}
	function d(e) {
		return Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols(e).filter(function(t) {
			return e.propertyIsEnumerable(t);
		}) : [];
	}
	function f(e) {
		return Object.keys(e).concat(d(e));
	}
	function p(e, t) {
		try {
			return t in e;
		} catch {
			return !1;
		}
	}
	function m(e, t) {
		return p(e, t) && !(Object.hasOwnProperty.call(e, t) && Object.propertyIsEnumerable.call(e, t));
	}
	function h(e, t, n) {
		var r = {};
		return n.isMergeableObject(e) && f(e).forEach(function(t) {
			r[t] = c(e[t], n);
		}), f(t).forEach(function(i) {
			m(e, i) || (p(e, i) && n.isMergeableObject(t[i]) ? r[i] = u(i, n)(e[i], t[i], n) : r[i] = c(t[i], n));
		}), r;
	}
	function g(e, t, r) {
		r ||= {}, r.arrayMerge = r.arrayMerge || l, r.isMergeableObject = r.isMergeableObject || n, r.cloneUnlessOtherwiseSpecified = c;
		var i = Array.isArray(t);
		return i === Array.isArray(e) ? i ? r.arrayMerge(e, t, r) : h(e, t, r) : c(t, r);
	}
	g.all = function(e, t) {
		if (!Array.isArray(e)) throw Error("first argument should be an array");
		return e.reduce(function(e, n) {
			return g(e, n, t);
		}, {});
	}, t.exports = g;
})), se = /* @__PURE__ */ f(ae(), 1), ce = /* @__PURE__ */ f(oe(), 1), le = /* @__PURE__ */ ((e) => (e.Get = "GET", e.Post = "POST", e.Put = "PUT", e.Patch = "PATCH", e.Delete = "DELETE", e))(le || {});
function ue(e, t) {
	return Array.isArray(t) ? t.map((t) => ue(e, t)).join("&") : t == null || t === "" ? "" : typeof t == "object" ? `${e}=${encodeURIComponent(JSON.stringify(t))}` : `${e}=${encodeURIComponent(t)}`;
}
function de({ params: e, url: t }) {
	return e ? `${t}?${Object.entries(e).map(([e, t]) => ue(e, t)).filter(Boolean).join("&")}` : t;
}
function fe(e) {
	return (0, ce.default)({
		method: le.Get,
		headers: { Accept: "application/json" }
	}, e);
}
function pe(e, t) {
	return (0, ce.default)({
		method: le.Post,
		headers: {
			Accept: "application/json",
			"Content-Type": "application/json"
		},
		body: JSON.stringify(t)
	}, e);
}
var me = {
	GET: fe,
	POST: pe,
	PUT: pe,
	PATCH: pe,
	DELETE: fe
};
function he({ body: e, credentials: t, method: n, other: r = {} }) {
	let i = t?.accessToken;
	return i && i.indexOf("Bearer") === -1 && (i = "Bearer " + i), me[n]((0, ce.default)({
		method: n,
		headers: { ...!!i && { authorization: i } }
	}, r), e);
}
var ge = 6144;
async function _e({ abortController: e, body: t, credentials: n, method: r = le.Get, params: i, url: a, requestOptions: { getMaxUrlLength: o } = { getMaxUrlLength: ge }, ...s }) {
	let c = de({
		url: a,
		params: i
	}), l = t, u = r;
	r === le.Get && c.length > o && (l = i, u = le.Post, c = a);
	let d = he({
		body: l,
		credentials: n,
		method: u,
		...s
	});
	e && (d.signal = e);
	let f = await (0, se.default)(c, d);
	if (!f.ok) {
		let e = await f.text();
		return Promise.reject(e);
	}
	return f.status === 204 ? Promise.resolve() : await f.json();
}
//#endregion
//#region \0@oxc-project+runtime@0.133.0/helpers/esm/typeof.js
function ve(e) {
	"@babel/helpers - typeof";
	return ve = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
		return typeof e;
	} : function(e) {
		return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
	}, ve(e);
}
//#endregion
//#region \0@oxc-project+runtime@0.133.0/helpers/esm/toPrimitive.js
function ye(e, t) {
	if (ve(e) != "object" || !e) return e;
	var n = e[Symbol.toPrimitive];
	if (n !== void 0) {
		var r = n.call(e, t || "default");
		if (ve(r) != "object") return r;
		throw TypeError("@@toPrimitive must return a primitive value.");
	}
	return (t === "string" ? String : Number)(e);
}
//#endregion
//#region \0@oxc-project+runtime@0.133.0/helpers/esm/toPropertyKey.js
function be(e) {
	var t = ye(e, "string");
	return ve(t) == "symbol" ? t : t + "";
}
//#endregion
//#region \0@oxc-project+runtime@0.133.0/helpers/esm/defineProperty.js
function xe(e, t, n) {
	return (t = be(t)) in e ? Object.defineProperty(e, t, {
		value: n,
		enumerable: !0,
		configurable: !0,
		writable: !0
	}) : e[t] = n, e;
}
//#endregion
//#region src/auth/auth.manager.ts
var y = class e {
	constructor() {
		xe(this, "cartoAuthorizer", null);
	}
	async init(e) {
		this.cartoAuthorizer = e;
	}
	static getInstance() {
		return e.instance ||= new e(), e.instance;
	}
	getToken() {
		if (this.cartoAuthorizer === null) throw Error("AuthManager not initialized");
		return this.cartoAuthorizer.getToken();
	}
};
xe(y, "instance", void 0);
//#endregion
//#region src/common/geometry.helper.ts
function Se(t) {
	try {
		return e(t);
	} catch (e) {
		return console.error("Could not convert field", e), null;
	}
}
function Ce(e, t) {
	let n = e;
	return t.filter((e) => e in n);
}
function we(e, t) {
	return e.map((e) => {
		let n = { ...e };
		for (let e of t) {
			let t = n[e], r = Se(t);
			r && (n[e] = r);
		}
		return n;
	});
}
function Te(e, t) {
	let n = e[0];
	if (!n) return e;
	let r = Ce(n, t);
	return r.length === 0 ? e : (console.debug(`Rows to convert to geom: rows.length = ${e.length}`), we(e, r));
}
//#endregion
//#region src/common/sql.service.ts
var Ee = "radarview-eu", De = ["geom", "geometry"], Oe = 5, ke = "wrapped_data";
function Ae(e) {
	return e.trim().replace(/;\s*$/, "");
}
function je(e, t) {
	return `
    WITH source_array AS (
      SELECT ARRAY(SELECT t FROM (${Ae(e)}) AS t) as arr
    ),
    numbered_data AS (
      SELECT
        t,
        offset as row_idx,
        ARRAY_LENGTH(arr) as total_rows
      FROM source_array, UNNEST(arr) as t WITH OFFSET as offset
    ),
    bucketed_data AS (
      SELECT
        t,
        row_idx,
        TRUNC(row_idx * ${t} / GREATEST(total_rows, 1)) as bucket_id
      FROM numbered_data
    )
    SELECT
      ARRAY_AGG(t ORDER BY row_idx) AS ${ke}
    FROM bucketed_data
    GROUP BY bucket_id
    ORDER BY bucket_id
  `;
}
async function Me(e) {
	let t = {
		type: "query",
		client: e.client ?? Ee,
		source: e.query.query,
		params: {
			column: e.query.columns,
			limit: e.query.limit,
			offset: e.query.offset
		},
		filters: {},
		spatialDataType: "geo",
		spatialDataColumn: "geom_alt126"
	}, n = `${e.apiBaseUrl}/v3/sql/${e.connection}/model/table`, r = e.avoidCache ?? !1;
	return await _e({
		abortController: e.abortController ?? new AbortController().signal,
		method: r ? le.Post : le.Get,
		url: n,
		credentials: { accessToken: e.token },
		...r ? { body: t } : { params: t }
	});
}
async function Ne({ credentials: e, connection: t, client: n, query: r, params: i, fetcherOptions: a, geometryFields: o = De, buckets: s = Oe }) {
	let c = await Me({
		query: {
			query: je(r, s),
			columns: [ke],
			limit: s,
			offset: 0
		},
		token: e.accessToken,
		apiBaseUrl: e.apiBaseUrl,
		connection: t,
		client: n,
		avoidCache: i?.avoidCache ?? !1,
		abortController: a?.abortController
	}), l = Te(c.rows.flatMap((e) => e[ke] ?? []), o);
	return {
		...c,
		rows: l
	};
}
//#endregion
//#region src/helpers/query-executor.helper.ts
var Pe = "_test", Fe = "_live", Ie = "default";
function Le(e, t, n = Ie) {
	return `${Je(e, t)}${t.isTesting() ? Pe : Fe}_${n}`;
}
async function b(e, t, n, r = !1, i) {
	let a = y.getInstance().getToken(), { apiBaseUrl: o, cartoConnection: s } = qe(t, n);
	return (await Ne({
		credentials: {
			accessToken: a,
			apiBaseUrl: o
		},
		connection: i ?? s,
		client: Le(t, n),
		query: e,
		params: { avoidCache: r },
		fetcherOptions: { abortController: new AbortController().signal }
	})).rows;
}
//#endregion
//#region src/cache.service.ts
async function Re(e, t, n, r, i) {
	return await b(`
  SELECT
    table_id as table_name,
    FORMAT_TIMESTAMP('%FT%T', TIMESTAMP_MILLIS(last_modified_time), "UTC") AS last_modified
  FROM \`${r}.${n}.__TABLES__\`
  WHERE NOT STARTS_WITH(table_id, 'rollback')
  `, e, t, !0, i);
}
//#endregion
//#region src/cache/cache.manager.ts
var ze = class e {
	constructor() {
		xe(this, "cacheInfo", /* @__PURE__ */ new Map()), xe(this, "cacheInfoAsArray", []), xe(this, "environment", null), xe(this, "bigQueryDataset", ""), xe(this, "authManager", null), xe(this, "connection", void 0);
	}
	async init(e, t, n, r = !1, i) {
		if (this.environment = e, this.authManager = t, this.connection = i, !r && this.cacheInfoAsArray.length > 0) return;
		let a = this.environment.getEnvironment(), o = this.environment.isTesting();
		this.bigQueryDataset = o ? `${a}_testing` : a, await this.updateCacheInfo(n);
	}
	async updateCacheInfo(e, t) {
		if (this.authManager === null || this.environment === null) throw Error("CacheManager not initialized");
		let n = Ge(e, this.environment);
		this.cacheInfoAsArray = await Re(e, this.environment, this.bigQueryDataset, n, t ?? this.connection), this.cacheInfoAsArray.reduce((e, t) => (e.set(t.table_name, t.last_modified), e), this.cacheInfo);
	}
	static getInstance() {
		return e.instance ||= new e(), e.instance;
	}
	getCacheInfo() {
		return this.cacheInfoAsArray;
	}
	getCacheInfoForTable(e) {
		let t = this.cacheInfo.get(e);
		if (!t) throw Error(`Cache info not found for table ${e}`);
		return t;
	}
};
xe(ze, "instance", void 0);
//#endregion
//#region src/helpers/metadata.helper.ts
function Be(e) {
	return e.join(", ");
}
var Ve = /* @__PURE__ */ function(e) {
	return e[e.Filterable = 0] = "Filterable", e[e.Autocomplete = 1] = "Autocomplete", e[e.Display = 2] = "Display", e[e.Startup = 3] = "Startup", e[e.Background = 4] = "Background", e;
}({});
function x(e, t) {
	return e.filter((e) => {
		switch (t) {
			case 0: return e.filterable;
			case 2: return e.display;
			case 1: return "autocomplete" in e ? e.autocomplete : !1;
			case 3: return e.startup;
			case 4: return e.background;
			default: throw Error("Executing getColunmsFromModel: Invalid filter option");
		}
	});
}
function He(e, t) {
	return x(e, t).map((e) => e.id);
}
function Ue(e, t) {
	return Be(He(e, t));
}
function We(e, t, n) {
	let r = e.getEnvironment();
	return `\`${t}.${e.isTesting() ? `${r}_testing` : r}.${n}\` ${`/*${ze.getInstance().getCacheInfoForTable(n)}*/`}`;
}
function Ge(e, t) {
	let n = t.getEnvironment(), r = e.bq_project;
	switch (n) {
		case re.Development: return r.dev;
		case re.Staging: return r.staging;
		case re.Production: return r.prod;
	}
	throw Error(`Could not find BQ project for environment ${n}. Check metadata file to verify values are correctly set under bq_project parameter`);
}
function S(e, t, n) {
	return We(t, Ge(e, t), n.table_name);
}
function Ke(e, t, n, r) {
	return We(t, Ge(e, t), r ? n.autocomplete_locations : n.autocomplete);
}
function qe(e, t) {
	return {
		apiBaseUrl: e.base_url,
		cartoConnection: Je(e, t)
	};
}
function Je(e, t) {
	let n = t.getEnvironment();
	return `${e.connection}_${n}`;
}
function Ye(e) {
	return e.flavour;
}
function Xe(e) {
	return e.plan_filters.widget_audiences.delivery_human_representation;
}
function Ze(e) {
	return e.local_storage_keys.firebase_token;
}
function Qe(e) {
	return e.features.export.columnsPOIs;
}
function $e(e) {
	return e.features.export.columnsAllPOIs;
}
function et(e) {
	return e.countries.length > 1;
}
function tt(e) {
	return e.countries[0].id;
}
function C(e, t, n) {
	let r = t.getEnvironment(), i = e.app_config.remote_functions[n];
	if (!i) throw Error(`🛑 Getting remote function. Remote function ${n} not found. Check flavour metadata.`);
	switch (r) {
		case "dev": return i.dev || "";
		case "stg": return i.staging || "";
		case "pro": return i.prod || "";
		default: throw Error(`🛑 Getting remote function. Unrecognized environment value: ${r} . Check .env file to verify VITE_APP_ENV is set.`);
	}
}
function nt(e, t) {
	let n = t.getEnvironment(), r = e.app_config.firebase;
	switch (n) {
		case "dev": return r.dev;
		case "stg": return r.staging;
		case "pro": return r.prod;
		default: throw Error(`🛑 Getting Firebase config. Unrecognized environment value: ${t}. Check .env file to verify VITE_APP_ENV is set.`);
	}
}
function rt(e) {
	return e.carto_events_url;
}
//#endregion
//#region src/helpers/query-construction.helper.ts
var w = /* @__PURE__ */ function(e) {
	return e.EQUALS = "=", e.NOT_EQUALS = "<>", e;
}({}), T = /* @__PURE__ */ function(e) {
	return e.AND = "AND", e.OR = "OR", e.WHERE = "WHERE", e.NONE = "", e;
}({});
function it(e, t, n, r = "", i = !1) {
	return E({
		columnName: e,
		ids: t,
		equalityOperator: n,
		logicalOperator: r,
		normalizedStringSearch: i
	});
}
function E(e) {
	let { columnName: t, ids: n, equalityOperator: r, logicalOperator: i, normalizedStringSearch: a, returnEmptyIfIdsEmpty: o } = e;
	if (n.length === 0) {
		if (o) return "";
		throw Error("When generating a where clause from ids, the ids array must not be empty");
	}
	let s = a ? `NORMALIZE_AND_CASEFOLD(${t})` : t;
	if (n.length === 1) {
		let e = n[0];
		return typeof n[0] == "string" && (e = `"${n[0]}"`), `${i} ${s} ${r} ${e}`;
	}
	let c = n.join(", ");
	typeof n[0] == "string" && (c = `"${n.join("\", \"")}"`);
	let l = `${i} ${s} `;
	return r === "=" ? l += `IN UNNEST([${c}])` : l += `NOT IN UNNEST([${c}])`, l;
}
function at(e, t) {
	return t.length ? t.map((t) => ` CONTAINS_SUBSTR((${e}), '${t}') `).join(" OR ") : " 1 = 1 ";
}
var ot = /^\d{4}-\d{2}-\d{2}$/;
function st(e, t, n, r) {
	let i = S(e, t, e.data_model.audiences_classes);
	if (n !== null) {
		if (!ot.test(n)) throw Error(`Invalid delivery date format: "${n}"`);
		return {
			joinClause: "",
			whereCondition: `year_month_or_week = "${n}"`
		};
	}
	let a = "year_month_or_week > '1900-01-01'", o = `WHERE ${a}`;
	if (r && r.length > 0) {
		let e = E({
			columnName: "country_id",
			ids: r,
			equalityOperator: "=",
			logicalOperator: "AND"
		});
		o += ` ${e}`;
	}
	return {
		joinClause: `INNER JOIN (
      SELECT
        MAX(year_month_or_week) AS group_max_delivery,
        source_id AS group_source_id
      FROM ${i}
      ${o}
      GROUP BY source_id
    ) group_latest_delivery
    ON year_month_or_week = group_latest_delivery.group_max_delivery
    AND source_id = group_latest_delivery.group_source_id`,
		whereCondition: a
	};
}
//#endregion
//#region src/helpers/formatter.helper.ts
function ct(e, t) {
	return t instanceof Error ? {
		name: t.name,
		message: t.message
	} : t;
}
function D(e) {
	return e instanceof Error ? `\n${e.name}: ${e.message}` : "\n" + JSON.stringify(e, ct, 2);
}
function lt(e) {
	let t = new Date(e.getTime());
	t.setHours(0, 0, 0, 0), t.setDate(t.getDate() + 4 - (t.getDay() || 7));
	let n = t.getFullYear(), r = new Date(n, 0, 1);
	r.getDay() > 4 ? r.setDate(r.getDate() + 7 - r.getDay()) : r.setDate(r.getDate() - r.getDay());
	let i = Math.floor((t.getTime() - r.getTime()) / 864e5), a = Math.ceil((i + r.getDay() + 1) / 7).toString().padStart(2, "0");
	return {
		year: n.toString(),
		week: a
	};
}
//#endregion
//#region src/assets.helper.ts
function ut(e, t, n, r, i, a) {
	return `${n} AS (
    SELECT
      distinct(asset_id)
    FROM ${S(e, t, e.data_model.audiences)}
    WHERE
      year_month_or_week = "${r}"
      AND index >= ${i}
      ${it("class_uid", a, w.EQUALS, T.AND)}
  )`;
}
function dt(e, t, n) {
	if (n.audiences === void 0 || n.audiences.audiences.length === 0) return {
		ctes: "",
		audienceCTEsName: []
	};
	let r = n.audiences.index, i = n.delivery, a = [];
	return {
		ctes: n.audiences.audiences.map((n, o) => {
			let s = `cte_assets_by_audience_${o}`;
			return a.push(s), ut(e, t, s, i, r, n);
		}).join(", \n"),
		audienceCTEsName: a
	};
}
function ft(e, t) {
	return t.length === 0 ? "" : `${e} AS (
    ${t.map((e) => `SELECT * FROM ${e}`).join("\n INTERSECT DISTINCT \n")}
  )`;
}
function pt(e, t, n) {
	let { ctes: r, audienceCTEsName: i } = dt(e, t, n), a = "assets_intersections";
	return `
    WITH
    ${r},
    ${ft(a, i)}

    SELECT *
    from ${a} a`;
}
function mt(e, t) {
	return !e.andGroup || e.andGroup.length === 0 ? `
      cte_asset_and ${t},
    ` : `
    cte_asset_and_pre AS (
      SELECT
        asset_id,
        COUNT(DISTINCT class_uid) as occurrences,
        AVG(index) as index
      FROM cte_asset_basic_filter
      ${E({
		columnName: "class_uid",
		ids: e.andGroup,
		equalityOperator: w.EQUALS,
		logicalOperator: T.WHERE
	})}
      GROUP BY asset_id
    ),
    cte_asset_and AS (
      SELECT
        asset_id,
        index
      FROM cte_asset_and_pre
      WHERE occurrences >= ${e.andGroup?.length ?? 0}
    ), `;
}
function ht(e, t) {
	return !e.orGroup || e.orGroup.length === 0 ? `
      cte_asset_or ${t}
    ` : `
    cte_asset_or AS (
      SELECT
        asset_id,
        AVG(index) as index
      FROM cte_asset_basic_filter
      ${E({
		columnName: "class_uid",
		ids: e.orGroup,
		equalityOperator: w.EQUALS,
		logicalOperator: T.WHERE
	})}
      GROUP BY asset_id
    )
    `;
}
function gt(e, t, n) {
	let r = S(e, t, e.data_model.audiences), i = "";
	n.country_ids && n.country_ids.length > 0 && (i = E({
		columnName: "country_id",
		ids: n.country_ids,
		equalityOperator: w.EQUALS,
		logicalOperator: T.AND
	}));
	let { joinClause: a, whereCondition: o } = st(e, t, n.delivery, n.country_ids), s = "\n  AS (SELECT 'unknown' as asset_id, 0 as index  limit 0)\n  ", c = mt(n, s), l = ht(n, s);
	return `
    WITH
    cte_asset_basic_filter AS (
      SELECT asset_id, class_uid, index
      FROM  ${r}
      ${a}
      WHERE ${o || "1=1"}
      ${i}
      AND index >= ${n.lowerRange}
      AND index <= ${n.upperRange}
    ),
    ${c}
    ${l}
    SELECT asset_id, index
    FROM (
      SELECT asset_id, index FROM cte_asset_and
      UNION DISTINCT
      SELECT asset_id, index FROM cte_asset_or
    )
  `;
}
function _t(e, t, n) {
	let r = S(e, t, e.data_model.audiences), i = "";
	n.country_ids && n.country_ids.length > 0 && (i = E({
		columnName: "country_id",
		ids: n.country_ids,
		equalityOperator: w.EQUALS,
		logicalOperator: T.AND
	}));
	let { joinClause: a, whereCondition: o } = st(e, t, n.delivery, n.country_ids), s = "\n  AS (SELECT 'unknown' as asset_id, 0 as index limit 0)\n  ", c = mt(n, s), l = ht(n, s);
	return `
  WITH
  cte_asset_basic_filter AS (
    SELECT asset_id, class_uid, index
    FROM  ${r}
    ${a}
    WHERE ${o || "1=1"}
    ${i}
  ),
  ${c}
  ${l}
  ,cte_all_results AS (
    SELECT *
    FROM (
      SELECT * FROM cte_asset_and
      UNION ALL
      SELECT * FROM cte_asset_or
    )
  )
  SELECT asset_id, AVG(index) as index FROM cte_all_results
  group by asset_id
  order by index desc
`;
}
function vt(e, t, n) {
	if (n.isIndexActive && !n.isPercentageActive) return gt(e, t, n);
	if (!n.isIndexActive && n.isPercentageActive) return _t(e, t, n);
	let r = "🛑 Audience filter is not valid. Expected isIndexActive or isPercentageActive to be true";
	throw console.error(r), Error(r);
}
async function yt(e, t, n, r) {
	let i = e.plan_filters.widget_optimize_distribution.min_distance_between_assets.num_elements_direct_query, a = S(e, t, e.data_model.assets), o = "";
	if (n.length <= i) o = `
      SELECT
        a as id,
        b as importance
      FROM
        UNNEST([${n.map((e, t) => `STRUCT('${e}' as a, ${t} as b)`).join(",")}])`;
	else {
		let r = S(e, t, e.data_model.assets_optimize_distribution), i = await xt(e, t, n);
		o = `
      SELECT
        asset_id as id,
        importance
      FROM
        ${r} /*${Date.now()}*/
      WHERE
        id = '${i}'
      ORDER BY importance asc
    `;
	}
	return `
    WITH raw_assets as (
      ${o}
    ), assets as (
      SELECT
          aa.id as id,
          aa.geom as geom,
          ra.importance as importance
        FROM
          ${a} aa
        JOIN raw_assets ra
          ON aa.id = ra.id
        ORDER BY ra.importance
    ), clusters as (
      SELECT
        id,
        ST_CLUSTERDBSCAN(geom, ${r}, 0) OVER () as cluster_num,
        importance
      FROM
        assets
      ORDER BY importance
    ), ordered_assets as (
      SELECT
        *,
        ROW_NUMBER() OVER (PARTITION BY cluster_num ORDER BY importance) as rn
      FROM
        clusters
      ORDER BY cluster_num, importance
    )
    SELECT
      id as asset_id
    FROM ordered_assets
    WHERE rn = 1
  `;
}
function bt(e, t, n) {
	return `SELECT ${Ue(e.data_model.assets.columns, Ve.Display)} FROM ${S(e, t, e.data_model.assets)} WHERE id = '${n}'`;
}
async function xt(e, t, n) {
	let r = `Bearer ${y.getInstance().getToken()}`;
	try {
		let i = C(e, t, h.OptimizeDistribution);
		if (!i) throw Error("🔴🔴🔴 No cloud function url define for inserting optimize distribution asset IDs 🔴🔴🔴");
		let a = { optimize_distribution_ids: n.join(",") };
		return await (await fetch(i, {
			method: "POST",
			body: JSON.stringify(a),
			headers: { Authorization: r }
		})).json();
	} catch (e) {
		throw Error(`Cloud function error ${D(e)}`);
	}
}
function St(e, t, n) {
	let r = S(e, t, e.data_model.assets), i = `WITH assets_by_countries AS (SELECT * FROM ${r})`;
	return e.countries.length === 1 || n.countries === void 0 || n.countries.length === 0 ? i : `WITH assets_by_countries AS (
    SELECT
      *
    FROM ${r}
    WHERE
      country_id in (${n.countries.join(",")})
  )`;
}
function Ct(e, t, n, r) {
	return `
    ${St(e, t, n)}

    SELECT DISTINCT
      a.business_unit_id,
      a.l1panelclass_id as id,
      a.l1_panel_class as name
    FROM assets_by_countries a
    WHERE a.is_digital = ${r ? "true" : "false"} AND name IS NOT NULL AND id IS NOT NULL`;
}
function wt(e, t, n) {
	return Ct(e, t, n, !0);
}
function Tt(e, t, n) {
	return Ct(e, t, n, !1);
}
//#endregion
//#region src/assets.service.ts
var Et = /* @__PURE__ */ u({
	fetchLayerSource: () => zt,
	getAidaAssetsFromFile: () => $t,
	getAllAssetsWithBackgroundProperties: () => Ft,
	getAllAssetsWithStartupProperties: () => Pt,
	getAllMediaTypeOptionsForSharedPlan: () => tn,
	getAssetById: () => Qt,
	getAssetProperties: () => It,
	getAssetPropertiesQuery: () => Dt,
	getAssetsByMinimumDistance: () => en,
	getAssetsCountPerCountry: () => Lt,
	getAssetsSQL: () => Rt,
	getAssetsToShowBasedOnAudienceFilter: () => Bt,
	getAssetsToShowBasedOnAudienceFilterV2: () => Vt,
	getAssetsTypeL1: () => Wt,
	getAssetsTypeL1DigitalFilter: () => Ht,
	getAssetsTypeL1StaticFilter: () => Ut,
	getAssetsTypeL2: () => Gt,
	getAssetsTypeL3: () => Kt,
	getAssetsTypeL4: () => qt,
	getAssetsTypeL5: () => Jt,
	getAssetsTypeL6: () => Yt,
	getAssetsTypeL7: () => O,
	getAssetsTypeL8: () => Xt,
	getAssetsTypeL9: () => Zt
});
function Dt(e, t, n, r, i) {
	return `SELECT ${Ue(e.data_model.assets.columns, Ve.Background)} FROM ${S(e, t, e.data_model.assets)}
  ${n ? E({
		columnName: "country_id",
		ids: [n],
		equalityOperator: w.EQUALS,
		logicalOperator: T.WHERE
	}) : ""}
  ORDER BY id
  LIMIT ${r} OFFSET ${i}`;
}
function Ot(e, t) {
	if (typeof e != "string") throw Error(`Executing convertFromStringToProvidedType: Value ${e} is not a string`);
	if (e === "NULL") return null;
	switch (t) {
		case m.String: return e;
		case m.Number: return Number(e);
		case m.Boolean: return e.toLocaleLowerCase() === "true";
		case m.Date: return new Date(e);
		case m.ArrayNumbers: return e.split(";").map((e) => Number(e));
		default: throw Error(`Executing convertFromStringToProvidedType: Type not supported ${t}`);
	}
}
async function kt(e, t, n, r, i, a, o) {
	let s = `, '${n}', `, c = S(e, t, e.data_model.assets), l = "";
	r.forEach((e) => e.type === m.ArrayNumbers ? l += `COALESCE(SAFE_CAST((SELECT STRING_AGG(CAST(id AS STRING), ';') FROM UNNEST(${e.id}) id) AS STRING), 'NULL')${s}` : l += `COALESCE(SAFE_CAST(${e.id} AS STRING), 'NULL')${s}`), l = l.slice(0, -s.length);
	let u = i === -1 ? "" : `WHERE country_id = ${i}`;
	return await b(`
  SELECT CONCAT(${l}) as asset
  FROM ${c}
  ${u}
  ORDER BY id
  LIMIT ${a}
  OFFSET ${o}`, e, t);
}
async function At(e, t, n, r, i, a) {
	let o = [], s = [];
	n.forEach((n) => {
		let c = Math.ceil(n.assets / a);
		for (let l = 0; l < c; l++) {
			let c = l * a;
			o.push(n.country_id), s.push(kt(e, t, i, r, n.country_id, a, c));
		}
	});
	let c = await Promise.all(s), l = o.length, u = [], d = [], f = o[0];
	for (let e = 0; e < l; e++) f === o[e] ? d = d.concat(c[e]) : (u.push({
		countryId: f,
		assets: d.map((e) => e.asset)
	}), d = c[e]), f = o[e];
	return u.push({
		countryId: f,
		assets: d.map((e) => e.asset)
	}), u;
}
function jt(e, t, n) {
	return e.map((e) => {
		let r = e.split(n), i = {};
		return r.forEach((e, n) => {
			let r = t[n], a = Ot(e, r.type);
			i[r.id] = a;
		}), i;
	});
}
function Mt(e) {
	return e.map((e) => ({
		type: "Feature",
		geometry: {
			coordinates: [e.longitude, e.latitude],
			type: "Point"
		},
		properties: e
	}));
}
async function Nt(e, t, n, r, i) {
	let a = "%&&%";
	return (await At(e, t, n, r, a, i)).map((e) => {
		let t = Mt(jt(e.assets, r, a));
		return {
			countryId: e.countryId,
			assets: t
		};
	});
}
async function Pt(e, t, n, r) {
	return await Nt(e, t, n, x(e.data_model.assets.columns, Ve.Startup), r);
}
async function Ft(e, t, n, r) {
	let i = "%&&%", a = x(e.data_model.assets.columns, Ve.Background);
	return (await At(e, t, n, a, i, r)).map((e) => {
		let t = jt(e.assets, a, i);
		return {
			countryId: e.countryId,
			assets: t
		};
	});
}
async function It(e, t, n, r, i) {
	return await b(Dt(e, t, n, r, i), e, t);
}
async function Lt(e, t) {
	let n = S(e, t, e.data_model.assets), r = "country_id";
	et(e) || (r = `${tt(e).toString()} as country_id`);
	let i = await b(`SELECT
    ${r},
    COUNT(*) as assets
  FROM ${n}

  GROUP BY country_id`, e, t);
	return i.length === 0 && (console.debug("🔥 ----------------------------------------------------- "), console.debug("🔥 There are no assets in the database                   "), console.debug("🔥 Restore the assets table with the last rollback table "), console.debug("🔥 ----------------------------------------------------- ")), i;
}
async function Rt(e, t, n) {
	return await b(n, e, t);
}
function zt(e, t, n, r, i) {
	return `SELECT ${Ue(e.data_model.assets.columns, Ve.Startup)} FROM ${S(e, t, e.data_model.assets)}
  ${n ? E({
		columnName: "country_id",
		ids: [n],
		equalityOperator: w.EQUALS,
		logicalOperator: T.WHERE
	}) : ""}
  ORDER BY id
  LIMIT ${r} OFFSET ${i}`;
}
async function Bt(e, t, n) {
	return (await b(pt(e, t, n), e, t)).map((e) => e.asset_id);
}
async function Vt(e, t, n) {
	return await b(vt(e, t, n), e, t);
}
async function Ht(e, t, n) {
	return await b(wt(e, t, n), e, t);
}
async function Ut(e, t, n) {
	return await b(Tt(e, t, n), e, t);
}
async function Wt(e, t, n) {
	return await b(`
    ${St(e, t, n)}

    SELECT DISTINCT
      a.country_id,
      NULL as parent_id,
      a.l1panelclass_id as id,
      a.l1panelclass as name
    FROM assets_by_countries a
    WHERE l1panelclass_id IS NOT NULL
    GROUP BY a.country_id, a.l1panelclass_id, a.l1panelclass
    `, e, t);
}
async function Gt(e, t, n) {
	return await b(`
    ${St(e, t, n)}

    SELECT DISTINCT
      a.country_id,
      a.l1panelclass_id as parent_id,
      a.l2product_id as id,
      a.l2product as name
    FROM assets_by_countries a
    WHERE l2product_id IS NOT NULL
    GROUP BY a.country_id, a.l1panelclass_id, a.l2product_id, a.l2product
    `, e, t);
}
async function Kt(e, t, n) {
	return await b(`
    ${St(e, t, n)}

    SELECT DISTINCT
      a.country_id,
      a.l2product_id as parent_id,
      a.l3subproduct_id as id,
      a.l3subproduct as name
    FROM assets_by_countries a
    WHERE l3subproduct_id IS NOT NULL
    GROUP BY a.country_id, a.l2product_id, a.l3subproduct_id, a.l3subproduct
    `, e, t);
}
async function qt(e, t, n) {
	return await b(`
    ${St(e, t, n)}

    SELECT DISTINCT
      a.country_id,
      a.l3subproduct_id as parent_id,
      a.l4_id as id,
      a.l4 as name
    FROM assets_by_countries a
    WHERE l4_id IS NOT NULL
    GROUP BY a.country_id, a.l3subproduct_id, a.l4_id, a.l4
    `, e, t);
}
async function Jt(e, t, n) {
	return await b(`
    ${St(e, t, n)}

    SELECT DISTINCT
      a.country_id,
      a.l4_id as parent_id,
      a.l5_id as id,
      a.l5 as name
    FROM assets_by_countries a
    WHERE l5_id IS NOT NULL
    GROUP BY a.country_id, a.l4_id, a.l5_id, a.l5
    `, e, t);
}
async function Yt(e, t, n) {
	return await b(`
    ${St(e, t, n)}

    SELECT DISTINCT
      a.country_id,
      a.l5_id as parent_id,
      a.l6_id as id,
      a.l6 as name
    FROM assets_by_countries a
    WHERE l6_id IS NOT NULL
    GROUP BY a.country_id, a.l5_id, a.l6_id, a.l6
    `, e, t);
}
async function O(e, t, n) {
	return await b(`
    ${St(e, t, n)}

    SELECT DISTINCT
      a.country_id,
      a.l6_id as parent_id,
      a.l7_id as id,
      a.l7 as name
    FROM assets_by_countries a
    WHERE l7_id IS NOT NULL
    GROUP BY a.country_id, a.l6_id, a.l7_id, a.l7
    `, e, t);
}
async function Xt(e, t, n) {
	return await b(`
    ${St(e, t, n)}

    SELECT DISTINCT
      a.country_id,
      a.l7_id as parent_id,
      a.l8_id as id,
      a.l8 as name
    FROM assets_by_countries a
    WHERE l8_id IS NOT NULL
    GROUP BY a.country_id, a.l7_id, a.l8_id, a.l8
    `, e, t);
}
async function Zt(e, t, n) {
	return await b(`
    ${St(e, t, n)}

    SELECT DISTINCT
      a.country_id,
      a.l8_id as parent_id,
      a.l9_id as id,
      a.l9 as name
    FROM assets_by_countries a
    WHERE l9_id IS NOT NULL
    GROUP BY a.country_id, a.l8_id, a.l9_id, a.l9
    `, e, t);
}
async function Qt(e, t, n) {
	return await b(bt(e, t, n), e, t);
}
async function $t(e, t, n) {
	let r = `Bearer ${y.getInstance().getToken()}`;
	try {
		let i = C(e, t, h.Aida);
		if (!i) throw Error("🔴🔴🔴 No cloud function url define for getting managing custom POIs in BQ. Check .env file 🔴🔴🔴");
		return i = `${i}/file?file=${n}`, await (await fetch(i, {
			method: "GET",
			headers: { Authorization: r }
		})).json();
	} catch (e) {
		throw Error(`Cloud function error: ${JSON.stringify(e)}`);
	}
}
async function en(e, t, n, r) {
	return (await b(await yt(e, t, n, r), e, t)).flat();
}
async function tn(e, t, n, r, i) {
	let a = C(e, r, h.SharedPlan), o = new URLSearchParams(window.location.search).get("appVersion") || e.flavour, s = new URLSearchParams({
		action: _.AllMediaTypeOptions,
		appVersion: o,
		planId: t,
		activeSubfilterIndex: n.toString()
	});
	return i && s.set("password", i), a += `?${s.toString()}`, await (await fetch(a, {
		method: "POST",
		body: JSON.stringify({ planId: t })
	})).json();
}
//#endregion
//#region src/helpers/array.helper.ts
function nn(e) {
	try {
		return e.length === 0;
	} catch (e) {
		return console.warn("Checking if an array is empty but its undefined.\nConsidering it empty", e), !0;
	}
}
function rn(e) {
	return !e || !Array.isArray(e) ? !1 : e.length > 0;
}
//#endregion
//#region src/geoboundary.helper.ts
var an = 1;
function on(e) {
	if (!e.length) return "and  1 = 2";
	let t = `type_id IN (${e.map((e) => e.id).join(",")})`;
	return t = "and (" + e.reduce((e, t) => (rn(t.filterIds) ? e.push(`(id IN (${t.filterIds.join(",")}))`) : e.push(`( type_id = ${t.id} )`), e), []).join(" OR ") + ")", t;
}
function sn(e) {
	return e.reduce((e, t) => (t.id !== an && t.geom && e.push(t), e), []);
}
function cn(e) {
	return e.reduce((e, t) => (t.id !== an && !t.geom && e.push(t), e), []);
}
function ln(e, t, n) {
	let r = S(e, t, e.data_model.regions), i = [], a = [
		"id",
		"name",
		"type_id",
		"country_id",
		"normalized_name"
	], o = [...a, "geom"], s = n.country_iso2.join("','");
	if (n.active_regions.map((e) => e.id).includes(an)) {
		let e = `
      SELECT
        ${a.join(",")}
      FROM ${r} regions
      WHERE
        type_id = ${an}
        and iso2 IN ('${s}')
      ORDER BY type_id, name ASC
    `;
		i.push(e);
	}
	let c = sn(n.active_regions), l = sn(n.filter_regions).find((e) => e.filterIds.length);
	if (rn(c)) {
		let e = on(c), t = `
      SELECT
        ${l ? o.join(",") : a.join(",")}
      FROM ${r}
      WHERE
      iso2 IN ('${s}')
      ${e}
      ORDER BY type_id, name ASC
    `;
		if (!l) i.push(t);
		else {
			let e = `
        WITH topLimitRegions AS (
          SELECT geom
          FROM ${r}
          WHERE id IN (${l.filterIds.join(",")})
        ), filteredRegions AS (
          ${t}
        )
        SELECT
          ${a.join(",")}
        FROM filteredRegions a
        JOIN topLimitRegions f
          ON ST_INTERSECTS(a.geom, ST_BUFFER(f.geom,-1000))
        ORDER BY type_id, name ASC

      `;
			i.push(e);
		}
	}
	let u = cn(n.active_regions);
	if (u.length) {
		let e = on(u), t = `
      SELECT
        ${a.join(",")}
      FROM ${r}
      WHERE
      iso2 IN ('${s}')
      ${e}
      ORDER BY type_id, name ASC
    `;
		i.push(t);
	}
	return i.length === 1 ? i[0] : `(${i.join(") UNION ALL (")})`;
}
function un(e, t, n, r = !0) {
	let i = S(e, t, e.data_model.regions), a = E({
		columnName: "type_id",
		ids: [n.type_id],
		equalityOperator: w.EQUALS,
		logicalOperator: T.NONE
	}), o = E({
		columnName: "normalized_name",
		ids: n.names,
		equalityOperator: w.EQUALS,
		logicalOperator: T.AND
	});
	return `SELECT
  name,
  normalized_name,
  ${r ? "" : "ST_ASGEOJSON(geom) as "}geom,
  FROM ${i}
  WHERE
    ${a}
    ${o}
  `;
}
function dn(e, t, n, r = !0) {
	let i = S(e, t, e.data_model.regions), a = it("type_id", [n.type_id], w.EQUALS, T.NONE), o = it("id", n.ids, w.EQUALS, T.AND);
	return `SELECT
  id,
  type_id,
  ${r ? "" : "ST_ASGEOJSON(geom) as "}geom,
  FROM ${i}
  WHERE
    ${a}
    ${o}
  `;
}
//#endregion
//#region src/geoboundary.service.ts
var fn = /* @__PURE__ */ u({
	getGeoboundariesByTypeAndCountry: () => _n,
	getGeomertyByName: () => hn,
	getGeometryByIds: () => gn,
	getValuesGroupByPattern: () => mn
}), pn = "normalized_name";
async function mn(e, t, n) {
	let r = S(e, t, e.data_model.regions), i = n.countries_id, a = "", o = "", s = "", c = "", l = n.only_results_with_geometry, u = "";
	return i && (s = "country_id, country_name, ", a = E({
		columnName: "country_id",
		ids: i,
		equalityOperator: w.EQUALS,
		logicalOperator: T.AND
	}), o = "ORDER BY country_id", c = "country_id, country_name, "), l && (u = "AND geom IS NOT NULL"), await b(`SELECT
  ${s}
  count(*) as count,
  type_id as type_id,
  type as type,
  array_agg(struct(id, name, type_id, IF(geom IS NULL, false, true) AS has_geometry)) as data
  FROM ${r}
  WHERE
    ${pn} LIKE LOWER('%${n.pattern}%')
    ${a}
    ${u}
    GROUP BY ${c} type_id, type
    ${o}`, e, t);
}
async function hn(e, t, n) {
	return await b(un(e, t, n), e, t);
}
async function gn(e, t, n) {
	return await b(dn(e, t, n), e, t);
}
async function _n(e, t, n) {
	return await b(ln(e, t, n), e, t);
}
//#endregion
//#region ../node_modules/@firebase/util/dist/index.esm2017.js
var vn = function(e) {
	let t = [], n = 0;
	for (let r = 0; r < e.length; r++) {
		let i = e.charCodeAt(r);
		i < 128 ? t[n++] = i : i < 2048 ? (t[n++] = i >> 6 | 192, t[n++] = i & 63 | 128) : (i & 64512) == 55296 && r + 1 < e.length && (e.charCodeAt(r + 1) & 64512) == 56320 ? (i = 65536 + ((i & 1023) << 10) + (e.charCodeAt(++r) & 1023), t[n++] = i >> 18 | 240, t[n++] = i >> 12 & 63 | 128, t[n++] = i >> 6 & 63 | 128, t[n++] = i & 63 | 128) : (t[n++] = i >> 12 | 224, t[n++] = i >> 6 & 63 | 128, t[n++] = i & 63 | 128);
	}
	return t;
}, yn = function(e) {
	let t = [], n = 0, r = 0;
	for (; n < e.length;) {
		let i = e[n++];
		if (i < 128) t[r++] = String.fromCharCode(i);
		else if (i > 191 && i < 224) {
			let a = e[n++];
			t[r++] = String.fromCharCode((i & 31) << 6 | a & 63);
		} else if (i > 239 && i < 365) {
			let a = e[n++], o = e[n++], s = e[n++], c = ((i & 7) << 18 | (a & 63) << 12 | (o & 63) << 6 | s & 63) - 65536;
			t[r++] = String.fromCharCode(55296 + (c >> 10)), t[r++] = String.fromCharCode(56320 + (c & 1023));
		} else {
			let a = e[n++], o = e[n++];
			t[r++] = String.fromCharCode((i & 15) << 12 | (a & 63) << 6 | o & 63);
		}
	}
	return t.join("");
}, bn = {
	byteToCharMap_: null,
	charToByteMap_: null,
	byteToCharMapWebSafe_: null,
	charToByteMapWebSafe_: null,
	ENCODED_VALS_BASE: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789",
	get ENCODED_VALS() {
		return this.ENCODED_VALS_BASE + "+/=";
	},
	get ENCODED_VALS_WEBSAFE() {
		return this.ENCODED_VALS_BASE + "-_.";
	},
	HAS_NATIVE_SUPPORT: typeof atob == "function",
	encodeByteArray(e, t) {
		if (!Array.isArray(e)) throw Error("encodeByteArray takes an array as a parameter");
		this.init_();
		let n = t ? this.byteToCharMapWebSafe_ : this.byteToCharMap_, r = [];
		for (let t = 0; t < e.length; t += 3) {
			let i = e[t], a = t + 1 < e.length, o = a ? e[t + 1] : 0, s = t + 2 < e.length, c = s ? e[t + 2] : 0, l = i >> 2, u = (i & 3) << 4 | o >> 4, d = (o & 15) << 2 | c >> 6, f = c & 63;
			s || (f = 64, a || (d = 64)), r.push(n[l], n[u], n[d], n[f]);
		}
		return r.join("");
	},
	encodeString(e, t) {
		return this.HAS_NATIVE_SUPPORT && !t ? btoa(e) : this.encodeByteArray(vn(e), t);
	},
	decodeString(e, t) {
		return this.HAS_NATIVE_SUPPORT && !t ? atob(e) : yn(this.decodeStringToByteArray(e, t));
	},
	decodeStringToByteArray(e, t) {
		this.init_();
		let n = t ? this.charToByteMapWebSafe_ : this.charToByteMap_, r = [];
		for (let t = 0; t < e.length;) {
			let i = n[e.charAt(t++)], a = t < e.length ? n[e.charAt(t)] : 0;
			++t;
			let o = t < e.length ? n[e.charAt(t)] : 64;
			++t;
			let s = t < e.length ? n[e.charAt(t)] : 64;
			if (++t, i == null || a == null || o == null || s == null) throw new xn();
			let c = i << 2 | a >> 4;
			if (r.push(c), o !== 64) {
				let e = a << 4 & 240 | o >> 2;
				if (r.push(e), s !== 64) {
					let e = o << 6 & 192 | s;
					r.push(e);
				}
			}
		}
		return r;
	},
	init_() {
		if (!this.byteToCharMap_) {
			this.byteToCharMap_ = {}, this.charToByteMap_ = {}, this.byteToCharMapWebSafe_ = {}, this.charToByteMapWebSafe_ = {};
			for (let e = 0; e < this.ENCODED_VALS.length; e++) this.byteToCharMap_[e] = this.ENCODED_VALS.charAt(e), this.charToByteMap_[this.byteToCharMap_[e]] = e, this.byteToCharMapWebSafe_[e] = this.ENCODED_VALS_WEBSAFE.charAt(e), this.charToByteMapWebSafe_[this.byteToCharMapWebSafe_[e]] = e, e >= this.ENCODED_VALS_BASE.length && (this.charToByteMap_[this.ENCODED_VALS_WEBSAFE.charAt(e)] = e, this.charToByteMapWebSafe_[this.ENCODED_VALS.charAt(e)] = e);
		}
	}
}, xn = class extends Error {
	constructor() {
		super(...arguments), this.name = "DecodeBase64StringError";
	}
}, Sn = function(e) {
	let t = vn(e);
	return bn.encodeByteArray(t, !0);
}, Cn = function(e) {
	return Sn(e).replace(/\./g, "");
}, wn = function(e) {
	try {
		return bn.decodeString(e, !0);
	} catch (e) {
		console.error("base64Decode failed: ", e);
	}
	return null;
};
function k() {
	if (typeof self < "u") return self;
	if (typeof window < "u") return window;
	if (typeof global < "u") return global;
	throw Error("Unable to locate global object.");
}
var Tn = () => k().__FIREBASE_DEFAULTS__, En = () => {
	if (typeof process > "u" || process.env === void 0) return;
	let e = process.env.__FIREBASE_DEFAULTS__;
	if (e) return JSON.parse(e);
}, Dn = () => {
	if (typeof document > "u") return;
	let e;
	try {
		e = document.cookie.match(/__FIREBASE_DEFAULTS__=([^;]+)/);
	} catch {
		return;
	}
	let t = e && wn(e[1]);
	return t && JSON.parse(t);
}, On = () => {
	try {
		return Tn() || En() || Dn();
	} catch (e) {
		console.info(`Unable to get __FIREBASE_DEFAULTS__ due to: ${e}`);
		return;
	}
}, kn = (e) => On()?.emulatorHosts?.[e], An = (e) => {
	let t = kn(e);
	if (!t) return;
	let n = t.lastIndexOf(":");
	if (n <= 0 || n + 1 === t.length) throw Error(`Invalid host ${t} with no separate hostname and port!`);
	let r = parseInt(t.substring(n + 1), 10);
	return t[0] === "[" ? [t.substring(1, n - 1), r] : [t.substring(0, n), r];
}, jn = () => On()?.config, Mn = (e) => On()?.[`_${e}`], Nn = class {
	constructor() {
		this.reject = () => {}, this.resolve = () => {}, this.promise = new Promise((e, t) => {
			this.resolve = e, this.reject = t;
		});
	}
	wrapCallback(e) {
		return (t, n) => {
			t ? this.reject(t) : this.resolve(n), typeof e == "function" && (this.promise.catch(() => {}), e.length === 1 ? e(t) : e(t, n));
		};
	}
};
function Pn(e, t) {
	if (e.uid) throw Error("The \"uid\" field is no longer supported by mockUserToken. Please use \"sub\" instead for Firebase Auth User ID.");
	let n = {
		alg: "none",
		type: "JWT"
	}, r = t || "demo-project", i = e.iat || 0, a = e.sub || e.user_id;
	if (!a) throw Error("mockUserToken must contain 'sub' or 'user_id' field!");
	let o = Object.assign({
		iss: `https://securetoken.google.com/${r}`,
		aud: r,
		iat: i,
		exp: i + 3600,
		auth_time: i,
		sub: a,
		user_id: a,
		firebase: {
			sign_in_provider: "custom",
			identities: {}
		}
	}, e);
	return [
		Cn(JSON.stringify(n)),
		Cn(JSON.stringify(o)),
		""
	].join(".");
}
function A() {
	return typeof navigator < "u" && typeof navigator.userAgent == "string" ? navigator.userAgent : "";
}
function Fn() {
	return typeof window < "u" && !!(window.cordova || window.phonegap || window.PhoneGap) && /ios|iphone|ipod|ipad|android|blackberry|iemobile/i.test(A());
}
function In() {
	let e = On()?.forceEnvironment;
	if (e === "node") return !0;
	if (e === "browser") return !1;
	try {
		return Object.prototype.toString.call(global.process) === "[object process]";
	} catch {
		return !1;
	}
}
function Ln() {
	return typeof navigator < "u" && navigator.userAgent === "Cloudflare-Workers";
}
function Rn() {
	let e = typeof chrome == "object" ? chrome.runtime : typeof browser == "object" ? browser.runtime : void 0;
	return typeof e == "object" && e.id !== void 0;
}
function zn() {
	return typeof navigator == "object" && navigator.product === "ReactNative";
}
function Bn() {
	let e = A();
	return e.indexOf("MSIE ") >= 0 || e.indexOf("Trident/") >= 0;
}
function Vn() {
	return !In() && !!navigator.userAgent && navigator.userAgent.includes("Safari") && !navigator.userAgent.includes("Chrome");
}
function Hn() {
	try {
		return typeof indexedDB == "object";
	} catch {
		return !1;
	}
}
function Un() {
	return new Promise((e, t) => {
		try {
			let n = !0, r = "validate-browser-context-for-indexeddb-analytics-module", i = self.indexedDB.open(r);
			i.onsuccess = () => {
				i.result.close(), n || self.indexedDB.deleteDatabase(r), e(!0);
			}, i.onupgradeneeded = () => {
				n = !1;
			}, i.onerror = () => {
				t(i.error?.message || "");
			};
		} catch (e) {
			t(e);
		}
	});
}
var Wn = "FirebaseError", Gn = class e extends Error {
	constructor(t, n, r) {
		super(n), this.code = t, this.customData = r, this.name = Wn, Object.setPrototypeOf(this, e.prototype), Error.captureStackTrace && Error.captureStackTrace(this, Kn.prototype.create);
	}
}, Kn = class {
	constructor(e, t, n) {
		this.service = e, this.serviceName = t, this.errors = n;
	}
	create(e, ...t) {
		let n = t[0] || {}, r = `${this.service}/${e}`, i = this.errors[e], a = i ? qn(i, n) : "Error";
		return new Gn(r, `${this.serviceName}: ${a} (${r}).`, n);
	}
};
function qn(e, t) {
	return e.replace(Jn, (e, n) => {
		let r = t[n];
		return r == null ? `<${n}?>` : String(r);
	});
}
var Jn = /\{\$([^}]+)}/g;
function Yn(e) {
	for (let t in e) if (Object.prototype.hasOwnProperty.call(e, t)) return !1;
	return !0;
}
function Xn(e, t) {
	if (e === t) return !0;
	let n = Object.keys(e), r = Object.keys(t);
	for (let i of n) {
		if (!r.includes(i)) return !1;
		let n = e[i], a = t[i];
		if (Zn(n) && Zn(a)) {
			if (!Xn(n, a)) return !1;
		} else if (n !== a) return !1;
	}
	for (let e of r) if (!n.includes(e)) return !1;
	return !0;
}
function Zn(e) {
	return typeof e == "object" && !!e;
}
function Qn(e) {
	let t = [];
	for (let [n, r] of Object.entries(e)) Array.isArray(r) ? r.forEach((e) => {
		t.push(encodeURIComponent(n) + "=" + encodeURIComponent(e));
	}) : t.push(encodeURIComponent(n) + "=" + encodeURIComponent(r));
	return t.length ? "&" + t.join("&") : "";
}
function $n(e) {
	let t = {};
	return e.replace(/^\?/, "").split("&").forEach((e) => {
		if (e) {
			let [n, r] = e.split("=");
			t[decodeURIComponent(n)] = decodeURIComponent(r);
		}
	}), t;
}
function er(e) {
	let t = e.indexOf("?");
	if (!t) return "";
	let n = e.indexOf("#", t);
	return e.substring(t, n > 0 ? n : void 0);
}
function tr(e, t) {
	let n = new nr(e, t);
	return n.subscribe.bind(n);
}
var nr = class {
	constructor(e, t) {
		this.observers = [], this.unsubscribes = [], this.observerCount = 0, this.task = Promise.resolve(), this.finalized = !1, this.onNoObservers = t, this.task.then(() => {
			e(this);
		}).catch((e) => {
			this.error(e);
		});
	}
	next(e) {
		this.forEachObserver((t) => {
			t.next(e);
		});
	}
	error(e) {
		this.forEachObserver((t) => {
			t.error(e);
		}), this.close(e);
	}
	complete() {
		this.forEachObserver((e) => {
			e.complete();
		}), this.close();
	}
	subscribe(e, t, n) {
		let r;
		if (e === void 0 && t === void 0 && n === void 0) throw Error("Missing Observer.");
		r = rr(e, [
			"next",
			"error",
			"complete"
		]) ? e : {
			next: e,
			error: t,
			complete: n
		}, r.next === void 0 && (r.next = ir), r.error === void 0 && (r.error = ir), r.complete === void 0 && (r.complete = ir);
		let i = this.unsubscribeOne.bind(this, this.observers.length);
		return this.finalized && this.task.then(() => {
			try {
				this.finalError ? r.error(this.finalError) : r.complete();
			} catch {}
		}), this.observers.push(r), i;
	}
	unsubscribeOne(e) {
		this.observers === void 0 || this.observers[e] === void 0 || (delete this.observers[e], --this.observerCount, this.observerCount === 0 && this.onNoObservers !== void 0 && this.onNoObservers(this));
	}
	forEachObserver(e) {
		if (!this.finalized) for (let t = 0; t < this.observers.length; t++) this.sendOne(t, e);
	}
	sendOne(e, t) {
		this.task.then(() => {
			if (this.observers !== void 0 && this.observers[e] !== void 0) try {
				t(this.observers[e]);
			} catch (e) {
				typeof console < "u" && console.error && console.error(e);
			}
		});
	}
	close(e) {
		this.finalized || (this.finalized = !0, e !== void 0 && (this.finalError = e), this.task.then(() => {
			this.observers = void 0, this.onNoObservers = void 0;
		}));
	}
};
function rr(e, t) {
	if (typeof e != "object" || !e) return !1;
	for (let n of t) if (n in e && typeof e[n] == "function") return !0;
	return !1;
}
function ir() {}
function j(e) {
	return e && e._delegate ? e._delegate : e;
}
//#endregion
//#region ../node_modules/@firebase/component/dist/esm/index.esm2017.js
var ar = class {
	constructor(e, t, n) {
		this.name = e, this.instanceFactory = t, this.type = n, this.multipleInstances = !1, this.serviceProps = {}, this.instantiationMode = "LAZY", this.onInstanceCreated = null;
	}
	setInstantiationMode(e) {
		return this.instantiationMode = e, this;
	}
	setMultipleInstances(e) {
		return this.multipleInstances = e, this;
	}
	setServiceProps(e) {
		return this.serviceProps = e, this;
	}
	setInstanceCreatedCallback(e) {
		return this.onInstanceCreated = e, this;
	}
}, or = "[DEFAULT]", sr = class {
	constructor(e, t) {
		this.name = e, this.container = t, this.component = null, this.instances = /* @__PURE__ */ new Map(), this.instancesDeferred = /* @__PURE__ */ new Map(), this.instancesOptions = /* @__PURE__ */ new Map(), this.onInitCallbacks = /* @__PURE__ */ new Map();
	}
	get(e) {
		let t = this.normalizeInstanceIdentifier(e);
		if (!this.instancesDeferred.has(t)) {
			let e = new Nn();
			if (this.instancesDeferred.set(t, e), this.isInitialized(t) || this.shouldAutoInitialize()) try {
				let n = this.getOrInitializeService({ instanceIdentifier: t });
				n && e.resolve(n);
			} catch {}
		}
		return this.instancesDeferred.get(t).promise;
	}
	getImmediate(e) {
		let t = this.normalizeInstanceIdentifier(e?.identifier), n = e?.optional ?? !1;
		if (this.isInitialized(t) || this.shouldAutoInitialize()) try {
			return this.getOrInitializeService({ instanceIdentifier: t });
		} catch (e) {
			if (n) return null;
			throw e;
		}
		else if (n) return null;
		else throw Error(`Service ${this.name} is not available`);
	}
	getComponent() {
		return this.component;
	}
	setComponent(e) {
		if (e.name !== this.name) throw Error(`Mismatching Component ${e.name} for Provider ${this.name}.`);
		if (this.component) throw Error(`Component for ${this.name} has already been provided`);
		if (this.component = e, this.shouldAutoInitialize()) {
			if (lr(e)) try {
				this.getOrInitializeService({ instanceIdentifier: or });
			} catch {}
			for (let [e, t] of this.instancesDeferred.entries()) {
				let n = this.normalizeInstanceIdentifier(e);
				try {
					let e = this.getOrInitializeService({ instanceIdentifier: n });
					t.resolve(e);
				} catch {}
			}
		}
	}
	clearInstance(e = or) {
		this.instancesDeferred.delete(e), this.instancesOptions.delete(e), this.instances.delete(e);
	}
	async delete() {
		let e = Array.from(this.instances.values());
		await Promise.all([...e.filter((e) => "INTERNAL" in e).map((e) => e.INTERNAL.delete()), ...e.filter((e) => "_delete" in e).map((e) => e._delete())]);
	}
	isComponentSet() {
		return this.component != null;
	}
	isInitialized(e = or) {
		return this.instances.has(e);
	}
	getOptions(e = or) {
		return this.instancesOptions.get(e) || {};
	}
	initialize(e = {}) {
		let { options: t = {} } = e, n = this.normalizeInstanceIdentifier(e.instanceIdentifier);
		if (this.isInitialized(n)) throw Error(`${this.name}(${n}) has already been initialized`);
		if (!this.isComponentSet()) throw Error(`Component ${this.name} has not been registered yet`);
		let r = this.getOrInitializeService({
			instanceIdentifier: n,
			options: t
		});
		for (let [e, t] of this.instancesDeferred.entries()) n === this.normalizeInstanceIdentifier(e) && t.resolve(r);
		return r;
	}
	onInit(e, t) {
		let n = this.normalizeInstanceIdentifier(t), r = this.onInitCallbacks.get(n) ?? /* @__PURE__ */ new Set();
		r.add(e), this.onInitCallbacks.set(n, r);
		let i = this.instances.get(n);
		return i && e(i, n), () => {
			r.delete(e);
		};
	}
	invokeOnInitCallbacks(e, t) {
		let n = this.onInitCallbacks.get(t);
		if (n) for (let r of n) try {
			r(e, t);
		} catch {}
	}
	getOrInitializeService({ instanceIdentifier: e, options: t = {} }) {
		let n = this.instances.get(e);
		if (!n && this.component && (n = this.component.instanceFactory(this.container, {
			instanceIdentifier: cr(e),
			options: t
		}), this.instances.set(e, n), this.instancesOptions.set(e, t), this.invokeOnInitCallbacks(n, e), this.component.onInstanceCreated)) try {
			this.component.onInstanceCreated(this.container, e, n);
		} catch {}
		return n || null;
	}
	normalizeInstanceIdentifier(e = or) {
		return this.component ? this.component.multipleInstances ? e : or : e;
	}
	shouldAutoInitialize() {
		return !!this.component && this.component.instantiationMode !== "EXPLICIT";
	}
};
function cr(e) {
	return e === or ? void 0 : e;
}
function lr(e) {
	return e.instantiationMode === "EAGER";
}
var ur = class {
	constructor(e) {
		this.name = e, this.providers = /* @__PURE__ */ new Map();
	}
	addComponent(e) {
		let t = this.getProvider(e.name);
		if (t.isComponentSet()) throw Error(`Component ${e.name} has already been registered with ${this.name}`);
		t.setComponent(e);
	}
	addOrOverwriteComponent(e) {
		this.getProvider(e.name).isComponentSet() && this.providers.delete(e.name), this.addComponent(e);
	}
	getProvider(e) {
		if (this.providers.has(e)) return this.providers.get(e);
		let t = new sr(e, this);
		return this.providers.set(e, t), t;
	}
	getProviders() {
		return Array.from(this.providers.values());
	}
}, dr = [], M;
(function(e) {
	e[e.DEBUG = 0] = "DEBUG", e[e.VERBOSE = 1] = "VERBOSE", e[e.INFO = 2] = "INFO", e[e.WARN = 3] = "WARN", e[e.ERROR = 4] = "ERROR", e[e.SILENT = 5] = "SILENT";
})(M ||= {});
var fr = {
	debug: M.DEBUG,
	verbose: M.VERBOSE,
	info: M.INFO,
	warn: M.WARN,
	error: M.ERROR,
	silent: M.SILENT
}, pr = M.INFO, mr = {
	[M.DEBUG]: "log",
	[M.VERBOSE]: "log",
	[M.INFO]: "info",
	[M.WARN]: "warn",
	[M.ERROR]: "error"
}, hr = (e, t, ...n) => {
	if (t < e.logLevel) return;
	let r = (/* @__PURE__ */ new Date()).toISOString(), i = mr[t];
	if (i) console[i](`[${r}]  ${e.name}:`, ...n);
	else throw Error(`Attempted to log a message with an invalid logType (value: ${t})`);
}, gr = class {
	constructor(e) {
		this.name = e, this._logLevel = pr, this._logHandler = hr, this._userLogHandler = null, dr.push(this);
	}
	get logLevel() {
		return this._logLevel;
	}
	set logLevel(e) {
		if (!(e in M)) throw TypeError(`Invalid value "${e}" assigned to \`logLevel\``);
		this._logLevel = e;
	}
	setLogLevel(e) {
		this._logLevel = typeof e == "string" ? fr[e] : e;
	}
	get logHandler() {
		return this._logHandler;
	}
	set logHandler(e) {
		if (typeof e != "function") throw TypeError("Value assigned to `logHandler` must be a function");
		this._logHandler = e;
	}
	get userLogHandler() {
		return this._userLogHandler;
	}
	set userLogHandler(e) {
		this._userLogHandler = e;
	}
	debug(...e) {
		this._userLogHandler && this._userLogHandler(this, M.DEBUG, ...e), this._logHandler(this, M.DEBUG, ...e);
	}
	log(...e) {
		this._userLogHandler && this._userLogHandler(this, M.VERBOSE, ...e), this._logHandler(this, M.VERBOSE, ...e);
	}
	info(...e) {
		this._userLogHandler && this._userLogHandler(this, M.INFO, ...e), this._logHandler(this, M.INFO, ...e);
	}
	warn(...e) {
		this._userLogHandler && this._userLogHandler(this, M.WARN, ...e), this._logHandler(this, M.WARN, ...e);
	}
	error(...e) {
		this._userLogHandler && this._userLogHandler(this, M.ERROR, ...e), this._logHandler(this, M.ERROR, ...e);
	}
}, _r = (e, t) => t.some((t) => e instanceof t), vr, yr;
function br() {
	return vr ||= [
		IDBDatabase,
		IDBObjectStore,
		IDBIndex,
		IDBCursor,
		IDBTransaction
	];
}
function xr() {
	return yr ||= [
		IDBCursor.prototype.advance,
		IDBCursor.prototype.continue,
		IDBCursor.prototype.continuePrimaryKey
	];
}
var Sr = /* @__PURE__ */ new WeakMap(), Cr = /* @__PURE__ */ new WeakMap(), wr = /* @__PURE__ */ new WeakMap(), Tr = /* @__PURE__ */ new WeakMap(), Er = /* @__PURE__ */ new WeakMap();
function Dr(e) {
	let t = new Promise((t, n) => {
		let r = () => {
			e.removeEventListener("success", i), e.removeEventListener("error", a);
		}, i = () => {
			t(Nr(e.result)), r();
		}, a = () => {
			n(e.error), r();
		};
		e.addEventListener("success", i), e.addEventListener("error", a);
	});
	return t.then((t) => {
		t instanceof IDBCursor && Sr.set(t, e);
	}).catch(() => {}), Er.set(t, e), t;
}
function Or(e) {
	if (Cr.has(e)) return;
	let t = new Promise((t, n) => {
		let r = () => {
			e.removeEventListener("complete", i), e.removeEventListener("error", a), e.removeEventListener("abort", a);
		}, i = () => {
			t(), r();
		}, a = () => {
			n(e.error || new DOMException("AbortError", "AbortError")), r();
		};
		e.addEventListener("complete", i), e.addEventListener("error", a), e.addEventListener("abort", a);
	});
	Cr.set(e, t);
}
var kr = {
	get(e, t, n) {
		if (e instanceof IDBTransaction) {
			if (t === "done") return Cr.get(e);
			if (t === "objectStoreNames") return e.objectStoreNames || wr.get(e);
			if (t === "store") return n.objectStoreNames[1] ? void 0 : n.objectStore(n.objectStoreNames[0]);
		}
		return Nr(e[t]);
	},
	set(e, t, n) {
		return e[t] = n, !0;
	},
	has(e, t) {
		return e instanceof IDBTransaction && (t === "done" || t === "store") ? !0 : t in e;
	}
};
function Ar(e) {
	kr = e(kr);
}
function jr(e) {
	return e === IDBDatabase.prototype.transaction && !("objectStoreNames" in IDBTransaction.prototype) ? function(t, ...n) {
		let r = e.call(Pr(this), t, ...n);
		return wr.set(r, t.sort ? t.sort() : [t]), Nr(r);
	} : xr().includes(e) ? function(...t) {
		return e.apply(Pr(this), t), Nr(Sr.get(this));
	} : function(...t) {
		return Nr(e.apply(Pr(this), t));
	};
}
function Mr(e) {
	return typeof e == "function" ? jr(e) : (e instanceof IDBTransaction && Or(e), _r(e, br()) ? new Proxy(e, kr) : e);
}
function Nr(e) {
	if (e instanceof IDBRequest) return Dr(e);
	if (Tr.has(e)) return Tr.get(e);
	let t = Mr(e);
	return t !== e && (Tr.set(e, t), Er.set(t, e)), t;
}
var Pr = (e) => Er.get(e);
//#endregion
//#region ../node_modules/idb/build/index.js
function Fr(e, t, { blocked: n, upgrade: r, blocking: i, terminated: a } = {}) {
	let o = indexedDB.open(e, t), s = Nr(o);
	return r && o.addEventListener("upgradeneeded", (e) => {
		r(Nr(o.result), e.oldVersion, e.newVersion, Nr(o.transaction), e);
	}), n && o.addEventListener("blocked", (e) => n(e.oldVersion, e.newVersion, e)), s.then((e) => {
		a && e.addEventListener("close", () => a()), i && e.addEventListener("versionchange", (e) => i(e.oldVersion, e.newVersion, e));
	}).catch(() => {}), s;
}
var Ir = [
	"get",
	"getKey",
	"getAll",
	"getAllKeys",
	"count"
], Lr = [
	"put",
	"add",
	"delete",
	"clear"
], Rr = /* @__PURE__ */ new Map();
function zr(e, t) {
	if (!(e instanceof IDBDatabase && !(t in e) && typeof t == "string")) return;
	if (Rr.get(t)) return Rr.get(t);
	let n = t.replace(/FromIndex$/, ""), r = t !== n, i = Lr.includes(n);
	if (!(n in (r ? IDBIndex : IDBObjectStore).prototype) || !(i || Ir.includes(n))) return;
	let a = async function(e, ...t) {
		let a = this.transaction(e, i ? "readwrite" : "readonly"), o = a.store;
		return r && (o = o.index(t.shift())), (await Promise.all([o[n](...t), i && a.done]))[0];
	};
	return Rr.set(t, a), a;
}
Ar((e) => ({
	...e,
	get: (t, n, r) => zr(t, n) || e.get(t, n, r),
	has: (t, n) => !!zr(t, n) || e.has(t, n)
}));
//#endregion
//#region ../node_modules/@firebase/app/dist/esm/index.esm2017.js
var Br = class {
	constructor(e) {
		this.container = e;
	}
	getPlatformInfoString() {
		return this.container.getProviders().map((e) => {
			if (Vr(e)) {
				let t = e.getImmediate();
				return `${t.library}/${t.version}`;
			} else return null;
		}).filter((e) => e).join(" ");
	}
};
function Vr(e) {
	return e.getComponent()?.type === "VERSION";
}
var Hr = "@firebase/app", Ur = "0.10.15", Wr = new gr("@firebase/app"), Gr = "@firebase/app-compat", Kr = "@firebase/analytics-compat", qr = "@firebase/analytics", Jr = "@firebase/app-check-compat", Yr = "@firebase/app-check", Xr = "@firebase/auth", Zr = "@firebase/auth-compat", Qr = "@firebase/database", $r = "@firebase/data-connect", ei = "@firebase/database-compat", ti = "@firebase/functions", ni = "@firebase/functions-compat", ri = "@firebase/installations", ii = "@firebase/installations-compat", ai = "@firebase/messaging", oi = "@firebase/messaging-compat", si = "@firebase/performance", ci = "@firebase/performance-compat", li = "@firebase/remote-config", ui = "@firebase/remote-config-compat", di = "@firebase/storage", fi = "@firebase/storage-compat", pi = "@firebase/firestore", mi = "@firebase/vertexai", hi = "@firebase/firestore-compat", gi = "firebase", _i = "11.0.1", vi = "[DEFAULT]", yi = {
	[Hr]: "fire-core",
	[Gr]: "fire-core-compat",
	[qr]: "fire-analytics",
	[Kr]: "fire-analytics-compat",
	[Yr]: "fire-app-check",
	[Jr]: "fire-app-check-compat",
	[Xr]: "fire-auth",
	[Zr]: "fire-auth-compat",
	[Qr]: "fire-rtdb",
	[$r]: "fire-data-connect",
	[ei]: "fire-rtdb-compat",
	[ti]: "fire-fn",
	[ni]: "fire-fn-compat",
	[ri]: "fire-iid",
	[ii]: "fire-iid-compat",
	[ai]: "fire-fcm",
	[oi]: "fire-fcm-compat",
	[si]: "fire-perf",
	[ci]: "fire-perf-compat",
	[li]: "fire-rc",
	[ui]: "fire-rc-compat",
	[di]: "fire-gcs",
	[fi]: "fire-gcs-compat",
	[pi]: "fire-fst",
	[hi]: "fire-fst-compat",
	[mi]: "fire-vertex",
	"fire-js": "fire-js",
	[gi]: "fire-js-all"
}, bi = /* @__PURE__ */ new Map(), xi = /* @__PURE__ */ new Map(), Si = /* @__PURE__ */ new Map();
function Ci(e, t) {
	try {
		e.container.addComponent(t);
	} catch (n) {
		Wr.debug(`Component ${t.name} failed to register with FirebaseApp ${e.name}`, n);
	}
}
function wi(e) {
	let t = e.name;
	if (Si.has(t)) return Wr.debug(`There were multiple attempts to register component ${t}.`), !1;
	Si.set(t, e);
	for (let t of bi.values()) Ci(t, e);
	for (let t of xi.values()) Ci(t, e);
	return !0;
}
function Ti(e, t) {
	let n = e.container.getProvider("heartbeat").getImmediate({ optional: !0 });
	return n && n.triggerHeartbeat(), e.container.getProvider(t);
}
function Ei(e) {
	return e.settings !== void 0;
}
var Di = new Kn("app", "Firebase", {
	"no-app": "No Firebase App '{$appName}' has been created - call initializeApp() first",
	"bad-app-name": "Illegal App name: '{$appName}'",
	"duplicate-app": "Firebase App named '{$appName}' already exists with different options or config",
	"app-deleted": "Firebase App named '{$appName}' already deleted",
	"server-app-deleted": "Firebase Server App has been deleted",
	"no-options": "Need to provide options, when not being deployed to hosting via source.",
	"invalid-app-argument": "firebase.{$appName}() takes either no argument or a Firebase App instance.",
	"invalid-log-argument": "First argument to `onLog` must be null or a function.",
	"idb-open": "Error thrown when opening IndexedDB. Original error: {$originalErrorMessage}.",
	"idb-get": "Error thrown when reading from IndexedDB. Original error: {$originalErrorMessage}.",
	"idb-set": "Error thrown when writing to IndexedDB. Original error: {$originalErrorMessage}.",
	"idb-delete": "Error thrown when deleting from IndexedDB. Original error: {$originalErrorMessage}.",
	"finalization-registry-not-supported": "FirebaseServerApp deleteOnDeref field defined but the JS runtime does not support FinalizationRegistry.",
	"invalid-server-app-environment": "FirebaseServerApp is not for use in browser environments."
}), Oi = class {
	constructor(e, t, n) {
		this._isDeleted = !1, this._options = Object.assign({}, e), this._config = Object.assign({}, t), this._name = t.name, this._automaticDataCollectionEnabled = t.automaticDataCollectionEnabled, this._container = n, this.container.addComponent(new ar("app", () => this, "PUBLIC"));
	}
	get automaticDataCollectionEnabled() {
		return this.checkDestroyed(), this._automaticDataCollectionEnabled;
	}
	set automaticDataCollectionEnabled(e) {
		this.checkDestroyed(), this._automaticDataCollectionEnabled = e;
	}
	get name() {
		return this.checkDestroyed(), this._name;
	}
	get options() {
		return this.checkDestroyed(), this._options;
	}
	get config() {
		return this.checkDestroyed(), this._config;
	}
	get container() {
		return this._container;
	}
	get isDeleted() {
		return this._isDeleted;
	}
	set isDeleted(e) {
		this._isDeleted = e;
	}
	checkDestroyed() {
		if (this.isDeleted) throw Di.create("app-deleted", { appName: this._name });
	}
}, ki = _i;
function Ai(e, t = {}) {
	let n = e;
	typeof t != "object" && (t = { name: t });
	let r = Object.assign({
		name: vi,
		automaticDataCollectionEnabled: !1
	}, t), i = r.name;
	if (typeof i != "string" || !i) throw Di.create("bad-app-name", { appName: String(i) });
	if (n ||= jn(), !n) throw Di.create("no-options");
	let a = bi.get(i);
	if (a) {
		if (Xn(n, a.options) && Xn(r, a.config)) return a;
		throw Di.create("duplicate-app", { appName: i });
	}
	let o = new ur(i);
	for (let e of Si.values()) o.addComponent(e);
	let s = new Oi(n, r, o);
	return bi.set(i, s), s;
}
function ji(e = vi) {
	let t = bi.get(e);
	if (!t && e === "[DEFAULT]" && jn()) return Ai();
	if (!t) throw Di.create("no-app", { appName: e });
	return t;
}
function Mi(e, t, n) {
	let r = yi[e] ?? e;
	n && (r += `-${n}`);
	let i = r.match(/\s|\//), a = t.match(/\s|\//);
	if (i || a) {
		let e = [`Unable to register library "${r}" with version "${t}":`];
		i && e.push(`library name "${r}" contains illegal characters (whitespace or "/")`), i && a && e.push("and"), a && e.push(`version name "${t}" contains illegal characters (whitespace or "/")`), Wr.warn(e.join(" "));
		return;
	}
	wi(new ar(`${r}-version`, () => ({
		library: r,
		version: t
	}), "VERSION"));
}
var Ni = "firebase-heartbeat-database", Pi = 1, Fi = "firebase-heartbeat-store", Ii = null;
function Li() {
	return Ii ||= Fr(Ni, Pi, { upgrade: (e, t) => {
		switch (t) {
			case 0: try {
				e.createObjectStore(Fi);
			} catch (e) {
				console.warn(e);
			}
		}
	} }).catch((e) => {
		throw Di.create("idb-open", { originalErrorMessage: e.message });
	}), Ii;
}
async function Ri(e) {
	try {
		let t = (await Li()).transaction(Fi), n = await t.objectStore(Fi).get(Bi(e));
		return await t.done, n;
	} catch (e) {
		if (e instanceof Gn) Wr.warn(e.message);
		else {
			let t = Di.create("idb-get", { originalErrorMessage: e?.message });
			Wr.warn(t.message);
		}
	}
}
async function zi(e, t) {
	try {
		let n = (await Li()).transaction(Fi, "readwrite");
		await n.objectStore(Fi).put(t, Bi(e)), await n.done;
	} catch (e) {
		if (e instanceof Gn) Wr.warn(e.message);
		else {
			let t = Di.create("idb-set", { originalErrorMessage: e?.message });
			Wr.warn(t.message);
		}
	}
}
function Bi(e) {
	return `${e.name}!${e.options.appId}`;
}
var Vi = 1024, Hi = 720 * 60 * 60 * 1e3, Ui = class {
	constructor(e) {
		this.container = e, this._heartbeatsCache = null;
		let t = this.container.getProvider("app").getImmediate();
		this._storage = new Ki(t), this._heartbeatsCachePromise = this._storage.read().then((e) => (this._heartbeatsCache = e, e));
	}
	async triggerHeartbeat() {
		try {
			let e = this.container.getProvider("platform-logger").getImmediate().getPlatformInfoString(), t = Wi();
			return this._heartbeatsCache?.heartbeats == null && (this._heartbeatsCache = await this._heartbeatsCachePromise, this._heartbeatsCache?.heartbeats == null) || this._heartbeatsCache.lastSentHeartbeatDate === t || this._heartbeatsCache.heartbeats.some((e) => e.date === t) ? void 0 : (this._heartbeatsCache.heartbeats.push({
				date: t,
				agent: e
			}), this._heartbeatsCache.heartbeats = this._heartbeatsCache.heartbeats.filter((e) => {
				let t = new Date(e.date).valueOf();
				return Date.now() - t <= Hi;
			}), this._storage.overwrite(this._heartbeatsCache));
		} catch (e) {
			Wr.warn(e);
		}
	}
	async getHeartbeatsHeader() {
		try {
			if (this._heartbeatsCache === null && await this._heartbeatsCachePromise, this._heartbeatsCache?.heartbeats == null || this._heartbeatsCache.heartbeats.length === 0) return "";
			let e = Wi(), { heartbeatsToSend: t, unsentEntries: n } = Gi(this._heartbeatsCache.heartbeats), r = Cn(JSON.stringify({
				version: 2,
				heartbeats: t
			}));
			return this._heartbeatsCache.lastSentHeartbeatDate = e, n.length > 0 ? (this._heartbeatsCache.heartbeats = n, await this._storage.overwrite(this._heartbeatsCache)) : (this._heartbeatsCache.heartbeats = [], this._storage.overwrite(this._heartbeatsCache)), r;
		} catch (e) {
			return Wr.warn(e), "";
		}
	}
};
function Wi() {
	return (/* @__PURE__ */ new Date()).toISOString().substring(0, 10);
}
function Gi(e, t = Vi) {
	let n = [], r = e.slice();
	for (let i of e) {
		let e = n.find((e) => e.agent === i.agent);
		if (!e) {
			if (n.push({
				agent: i.agent,
				dates: [i.date]
			}), qi(n) > t) {
				n.pop();
				break;
			}
		} else if (e.dates.push(i.date), qi(n) > t) {
			e.dates.pop();
			break;
		}
		r = r.slice(1);
	}
	return {
		heartbeatsToSend: n,
		unsentEntries: r
	};
}
var Ki = class {
	constructor(e) {
		this.app = e, this._canUseIndexedDBPromise = this.runIndexedDBEnvironmentCheck();
	}
	async runIndexedDBEnvironmentCheck() {
		return Hn() ? Un().then(() => !0).catch(() => !1) : !1;
	}
	async read() {
		if (await this._canUseIndexedDBPromise) {
			let e = await Ri(this.app);
			return e?.heartbeats ? e : { heartbeats: [] };
		} else return { heartbeats: [] };
	}
	async overwrite(e) {
		if (await this._canUseIndexedDBPromise) {
			let t = await this.read();
			return zi(this.app, {
				lastSentHeartbeatDate: e.lastSentHeartbeatDate ?? t.lastSentHeartbeatDate,
				heartbeats: e.heartbeats
			});
		} else return;
	}
	async add(e) {
		if (await this._canUseIndexedDBPromise) {
			let t = await this.read();
			return zi(this.app, {
				lastSentHeartbeatDate: e.lastSentHeartbeatDate ?? t.lastSentHeartbeatDate,
				heartbeats: [...t.heartbeats, ...e.heartbeats]
			});
		} else return;
	}
};
function qi(e) {
	return Cn(JSON.stringify({
		version: 2,
		heartbeats: e
	})).length;
}
function Ji(e) {
	wi(new ar("platform-logger", (e) => new Br(e), "PRIVATE")), wi(new ar("heartbeat", (e) => new Ui(e), "PRIVATE")), Mi(Hr, Ur, e), Mi(Hr, Ur, "esm2017"), Mi("fire-js", "");
}
Ji("");
//#endregion
//#region ../node_modules/@firebase/webchannel-wrapper/dist/bloom-blob/esm/bloom_blob_es2018.js
var Yi = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {}, Xi = {}, Zi, Qi;
(function() {
	var e;
	function t(e, t) {
		function n() {}
		n.prototype = t.prototype, e.D = t.prototype, e.prototype = new n(), e.prototype.constructor = e, e.C = function(e, n, r) {
			for (var i = Array(arguments.length - 2), a = 2; a < arguments.length; a++) i[a - 2] = arguments[a];
			return t.prototype[n].apply(e, i);
		};
	}
	function n() {
		this.blockSize = -1;
	}
	function r() {
		this.blockSize = -1, this.blockSize = 64, this.g = [
			,
			,
			,
			,
		], this.B = Array(this.blockSize), this.o = this.h = 0, this.s();
	}
	t(r, n), r.prototype.s = function() {
		this.g[0] = 1732584193, this.g[1] = 4023233417, this.g[2] = 2562383102, this.g[3] = 271733878, this.o = this.h = 0;
	};
	function i(e, t, n) {
		n ||= 0;
		var r = Array(16);
		if (typeof t == "string") for (var i = 0; 16 > i; ++i) r[i] = t.charCodeAt(n++) | t.charCodeAt(n++) << 8 | t.charCodeAt(n++) << 16 | t.charCodeAt(n++) << 24;
		else for (i = 0; 16 > i; ++i) r[i] = t[n++] | t[n++] << 8 | t[n++] << 16 | t[n++] << 24;
		t = e.g[0], n = e.g[1], i = e.g[2];
		var a = e.g[3], o = t + (a ^ n & (i ^ a)) + r[0] + 3614090360 & 4294967295;
		t = n + (o << 7 & 4294967295 | o >>> 25), o = a + (i ^ t & (n ^ i)) + r[1] + 3905402710 & 4294967295, a = t + (o << 12 & 4294967295 | o >>> 20), o = i + (n ^ a & (t ^ n)) + r[2] + 606105819 & 4294967295, i = a + (o << 17 & 4294967295 | o >>> 15), o = n + (t ^ i & (a ^ t)) + r[3] + 3250441966 & 4294967295, n = i + (o << 22 & 4294967295 | o >>> 10), o = t + (a ^ n & (i ^ a)) + r[4] + 4118548399 & 4294967295, t = n + (o << 7 & 4294967295 | o >>> 25), o = a + (i ^ t & (n ^ i)) + r[5] + 1200080426 & 4294967295, a = t + (o << 12 & 4294967295 | o >>> 20), o = i + (n ^ a & (t ^ n)) + r[6] + 2821735955 & 4294967295, i = a + (o << 17 & 4294967295 | o >>> 15), o = n + (t ^ i & (a ^ t)) + r[7] + 4249261313 & 4294967295, n = i + (o << 22 & 4294967295 | o >>> 10), o = t + (a ^ n & (i ^ a)) + r[8] + 1770035416 & 4294967295, t = n + (o << 7 & 4294967295 | o >>> 25), o = a + (i ^ t & (n ^ i)) + r[9] + 2336552879 & 4294967295, a = t + (o << 12 & 4294967295 | o >>> 20), o = i + (n ^ a & (t ^ n)) + r[10] + 4294925233 & 4294967295, i = a + (o << 17 & 4294967295 | o >>> 15), o = n + (t ^ i & (a ^ t)) + r[11] + 2304563134 & 4294967295, n = i + (o << 22 & 4294967295 | o >>> 10), o = t + (a ^ n & (i ^ a)) + r[12] + 1804603682 & 4294967295, t = n + (o << 7 & 4294967295 | o >>> 25), o = a + (i ^ t & (n ^ i)) + r[13] + 4254626195 & 4294967295, a = t + (o << 12 & 4294967295 | o >>> 20), o = i + (n ^ a & (t ^ n)) + r[14] + 2792965006 & 4294967295, i = a + (o << 17 & 4294967295 | o >>> 15), o = n + (t ^ i & (a ^ t)) + r[15] + 1236535329 & 4294967295, n = i + (o << 22 & 4294967295 | o >>> 10), o = t + (i ^ a & (n ^ i)) + r[1] + 4129170786 & 4294967295, t = n + (o << 5 & 4294967295 | o >>> 27), o = a + (n ^ i & (t ^ n)) + r[6] + 3225465664 & 4294967295, a = t + (o << 9 & 4294967295 | o >>> 23), o = i + (t ^ n & (a ^ t)) + r[11] + 643717713 & 4294967295, i = a + (o << 14 & 4294967295 | o >>> 18), o = n + (a ^ t & (i ^ a)) + r[0] + 3921069994 & 4294967295, n = i + (o << 20 & 4294967295 | o >>> 12), o = t + (i ^ a & (n ^ i)) + r[5] + 3593408605 & 4294967295, t = n + (o << 5 & 4294967295 | o >>> 27), o = a + (n ^ i & (t ^ n)) + r[10] + 38016083 & 4294967295, a = t + (o << 9 & 4294967295 | o >>> 23), o = i + (t ^ n & (a ^ t)) + r[15] + 3634488961 & 4294967295, i = a + (o << 14 & 4294967295 | o >>> 18), o = n + (a ^ t & (i ^ a)) + r[4] + 3889429448 & 4294967295, n = i + (o << 20 & 4294967295 | o >>> 12), o = t + (i ^ a & (n ^ i)) + r[9] + 568446438 & 4294967295, t = n + (o << 5 & 4294967295 | o >>> 27), o = a + (n ^ i & (t ^ n)) + r[14] + 3275163606 & 4294967295, a = t + (o << 9 & 4294967295 | o >>> 23), o = i + (t ^ n & (a ^ t)) + r[3] + 4107603335 & 4294967295, i = a + (o << 14 & 4294967295 | o >>> 18), o = n + (a ^ t & (i ^ a)) + r[8] + 1163531501 & 4294967295, n = i + (o << 20 & 4294967295 | o >>> 12), o = t + (i ^ a & (n ^ i)) + r[13] + 2850285829 & 4294967295, t = n + (o << 5 & 4294967295 | o >>> 27), o = a + (n ^ i & (t ^ n)) + r[2] + 4243563512 & 4294967295, a = t + (o << 9 & 4294967295 | o >>> 23), o = i + (t ^ n & (a ^ t)) + r[7] + 1735328473 & 4294967295, i = a + (o << 14 & 4294967295 | o >>> 18), o = n + (a ^ t & (i ^ a)) + r[12] + 2368359562 & 4294967295, n = i + (o << 20 & 4294967295 | o >>> 12), o = t + (n ^ i ^ a) + r[5] + 4294588738 & 4294967295, t = n + (o << 4 & 4294967295 | o >>> 28), o = a + (t ^ n ^ i) + r[8] + 2272392833 & 4294967295, a = t + (o << 11 & 4294967295 | o >>> 21), o = i + (a ^ t ^ n) + r[11] + 1839030562 & 4294967295, i = a + (o << 16 & 4294967295 | o >>> 16), o = n + (i ^ a ^ t) + r[14] + 4259657740 & 4294967295, n = i + (o << 23 & 4294967295 | o >>> 9), o = t + (n ^ i ^ a) + r[1] + 2763975236 & 4294967295, t = n + (o << 4 & 4294967295 | o >>> 28), o = a + (t ^ n ^ i) + r[4] + 1272893353 & 4294967295, a = t + (o << 11 & 4294967295 | o >>> 21), o = i + (a ^ t ^ n) + r[7] + 4139469664 & 4294967295, i = a + (o << 16 & 4294967295 | o >>> 16), o = n + (i ^ a ^ t) + r[10] + 3200236656 & 4294967295, n = i + (o << 23 & 4294967295 | o >>> 9), o = t + (n ^ i ^ a) + r[13] + 681279174 & 4294967295, t = n + (o << 4 & 4294967295 | o >>> 28), o = a + (t ^ n ^ i) + r[0] + 3936430074 & 4294967295, a = t + (o << 11 & 4294967295 | o >>> 21), o = i + (a ^ t ^ n) + r[3] + 3572445317 & 4294967295, i = a + (o << 16 & 4294967295 | o >>> 16), o = n + (i ^ a ^ t) + r[6] + 76029189 & 4294967295, n = i + (o << 23 & 4294967295 | o >>> 9), o = t + (n ^ i ^ a) + r[9] + 3654602809 & 4294967295, t = n + (o << 4 & 4294967295 | o >>> 28), o = a + (t ^ n ^ i) + r[12] + 3873151461 & 4294967295, a = t + (o << 11 & 4294967295 | o >>> 21), o = i + (a ^ t ^ n) + r[15] + 530742520 & 4294967295, i = a + (o << 16 & 4294967295 | o >>> 16), o = n + (i ^ a ^ t) + r[2] + 3299628645 & 4294967295, n = i + (o << 23 & 4294967295 | o >>> 9), o = t + (i ^ (n | ~a)) + r[0] + 4096336452 & 4294967295, t = n + (o << 6 & 4294967295 | o >>> 26), o = a + (n ^ (t | ~i)) + r[7] + 1126891415 & 4294967295, a = t + (o << 10 & 4294967295 | o >>> 22), o = i + (t ^ (a | ~n)) + r[14] + 2878612391 & 4294967295, i = a + (o << 15 & 4294967295 | o >>> 17), o = n + (a ^ (i | ~t)) + r[5] + 4237533241 & 4294967295, n = i + (o << 21 & 4294967295 | o >>> 11), o = t + (i ^ (n | ~a)) + r[12] + 1700485571 & 4294967295, t = n + (o << 6 & 4294967295 | o >>> 26), o = a + (n ^ (t | ~i)) + r[3] + 2399980690 & 4294967295, a = t + (o << 10 & 4294967295 | o >>> 22), o = i + (t ^ (a | ~n)) + r[10] + 4293915773 & 4294967295, i = a + (o << 15 & 4294967295 | o >>> 17), o = n + (a ^ (i | ~t)) + r[1] + 2240044497 & 4294967295, n = i + (o << 21 & 4294967295 | o >>> 11), o = t + (i ^ (n | ~a)) + r[8] + 1873313359 & 4294967295, t = n + (o << 6 & 4294967295 | o >>> 26), o = a + (n ^ (t | ~i)) + r[15] + 4264355552 & 4294967295, a = t + (o << 10 & 4294967295 | o >>> 22), o = i + (t ^ (a | ~n)) + r[6] + 2734768916 & 4294967295, i = a + (o << 15 & 4294967295 | o >>> 17), o = n + (a ^ (i | ~t)) + r[13] + 1309151649 & 4294967295, n = i + (o << 21 & 4294967295 | o >>> 11), o = t + (i ^ (n | ~a)) + r[4] + 4149444226 & 4294967295, t = n + (o << 6 & 4294967295 | o >>> 26), o = a + (n ^ (t | ~i)) + r[11] + 3174756917 & 4294967295, a = t + (o << 10 & 4294967295 | o >>> 22), o = i + (t ^ (a | ~n)) + r[2] + 718787259 & 4294967295, i = a + (o << 15 & 4294967295 | o >>> 17), o = n + (a ^ (i | ~t)) + r[9] + 3951481745 & 4294967295, e.g[0] = e.g[0] + t & 4294967295, e.g[1] = e.g[1] + (i + (o << 21 & 4294967295 | o >>> 11)) & 4294967295, e.g[2] = e.g[2] + i & 4294967295, e.g[3] = e.g[3] + a & 4294967295;
	}
	r.prototype.u = function(e, t) {
		t === void 0 && (t = e.length);
		for (var n = t - this.blockSize, r = this.B, a = this.h, o = 0; o < t;) {
			if (a == 0) for (; o <= n;) i(this, e, o), o += this.blockSize;
			if (typeof e == "string") {
				for (; o < t;) if (r[a++] = e.charCodeAt(o++), a == this.blockSize) {
					i(this, r), a = 0;
					break;
				}
			} else for (; o < t;) if (r[a++] = e[o++], a == this.blockSize) {
				i(this, r), a = 0;
				break;
			}
		}
		this.h = a, this.o += t;
	}, r.prototype.v = function() {
		var e = Array((56 > this.h ? this.blockSize : 2 * this.blockSize) - this.h);
		e[0] = 128;
		for (var t = 1; t < e.length - 8; ++t) e[t] = 0;
		var n = 8 * this.o;
		for (t = e.length - 8; t < e.length; ++t) e[t] = n & 255, n /= 256;
		for (this.u(e), e = Array(16), t = n = 0; 4 > t; ++t) for (var r = 0; 32 > r; r += 8) e[n++] = this.g[t] >>> r & 255;
		return e;
	};
	function a(e, t) {
		var n = s;
		return Object.prototype.hasOwnProperty.call(n, e) ? n[e] : n[e] = t(e);
	}
	function o(e, t) {
		this.h = t;
		for (var n = [], r = !0, i = e.length - 1; 0 <= i; i--) {
			var a = e[i] | 0;
			r && a == t || (n[i] = a, r = !1);
		}
		this.g = n;
	}
	var s = {};
	function c(e) {
		return -128 <= e && 128 > e ? a(e, function(e) {
			return new o([e | 0], 0 > e ? -1 : 0);
		}) : new o([e | 0], 0 > e ? -1 : 0);
	}
	function l(e) {
		if (isNaN(e) || !isFinite(e)) return d;
		if (0 > e) return g(l(-e));
		for (var t = [], n = 1, r = 0; e >= n; r++) t[r] = e / n | 0, n *= 4294967296;
		return new o(t, 0);
	}
	function u(e, t) {
		if (e.length == 0) throw Error("number format error: empty string");
		if (t ||= 10, 2 > t || 36 < t) throw Error("radix out of range: " + t);
		if (e.charAt(0) == "-") return g(u(e.substring(1), t));
		if (0 <= e.indexOf("-")) throw Error("number format error: interior \"-\" character");
		for (var n = l(t ** 8), r = d, i = 0; i < e.length; i += 8) {
			var a = Math.min(8, e.length - i), o = parseInt(e.substring(i, i + a), t);
			8 > a ? (a = l(t ** +a), r = r.j(a).add(l(o))) : (r = r.j(n), r = r.add(l(o)));
		}
		return r;
	}
	var d = c(0), f = c(1), p = c(16777216);
	e = o.prototype, e.m = function() {
		if (h(this)) return -g(this).m();
		for (var e = 0, t = 1, n = 0; n < this.g.length; n++) {
			var r = this.i(n);
			e += (0 <= r ? r : 4294967296 + r) * t, t *= 4294967296;
		}
		return e;
	}, e.toString = function(e) {
		if (e ||= 10, 2 > e || 36 < e) throw Error("radix out of range: " + e);
		if (m(this)) return "0";
		if (h(this)) return "-" + g(this).toString(e);
		for (var t = l(e ** 6), n = this, r = "";;) {
			var i = ne(n, t).g;
			n = ee(n, i.j(t));
			var a = ((0 < n.g.length ? n.g[0] : n.h) >>> 0).toString(e);
			if (n = i, m(n)) return a + r;
			for (; 6 > a.length;) a = "0" + a;
			r = a + r;
		}
	}, e.i = function(e) {
		return 0 > e ? 0 : e < this.g.length ? this.g[e] : this.h;
	};
	function m(e) {
		if (e.h != 0) return !1;
		for (var t = 0; t < e.g.length; t++) if (e.g[t] != 0) return !1;
		return !0;
	}
	function h(e) {
		return e.h == -1;
	}
	e.l = function(e) {
		return e = ee(this, e), h(e) ? -1 : +!m(e);
	};
	function g(e) {
		for (var t = e.g.length, n = [], r = 0; r < t; r++) n[r] = ~e.g[r];
		return new o(n, ~e.h).add(f);
	}
	e.abs = function() {
		return h(this) ? g(this) : this;
	}, e.add = function(e) {
		for (var t = Math.max(this.g.length, e.g.length), n = [], r = 0, i = 0; i <= t; i++) {
			var a = r + (this.i(i) & 65535) + (e.i(i) & 65535), s = (a >>> 16) + (this.i(i) >>> 16) + (e.i(i) >>> 16);
			r = s >>> 16, a &= 65535, s &= 65535, n[i] = s << 16 | a;
		}
		return new o(n, n[n.length - 1] & -2147483648 ? -1 : 0);
	};
	function ee(e, t) {
		return e.add(g(t));
	}
	e.j = function(e) {
		if (m(this) || m(e)) return d;
		if (h(this)) return h(e) ? g(this).j(g(e)) : g(g(this).j(e));
		if (h(e)) return g(this.j(g(e)));
		if (0 > this.l(p) && 0 > e.l(p)) return l(this.m() * e.m());
		for (var t = this.g.length + e.g.length, n = [], r = 0; r < 2 * t; r++) n[r] = 0;
		for (r = 0; r < this.g.length; r++) for (var i = 0; i < e.g.length; i++) {
			var a = this.i(r) >>> 16, s = this.i(r) & 65535, c = e.i(i) >>> 16, u = e.i(i) & 65535;
			n[2 * r + 2 * i] += s * u, te(n, 2 * r + 2 * i), n[2 * r + 2 * i + 1] += a * u, te(n, 2 * r + 2 * i + 1), n[2 * r + 2 * i + 1] += s * c, te(n, 2 * r + 2 * i + 1), n[2 * r + 2 * i + 2] += a * c, te(n, 2 * r + 2 * i + 2);
		}
		for (r = 0; r < t; r++) n[r] = n[2 * r + 1] << 16 | n[2 * r];
		for (r = t; r < 2 * t; r++) n[r] = 0;
		return new o(n, 0);
	};
	function te(e, t) {
		for (; (e[t] & 65535) != e[t];) e[t + 1] += e[t] >>> 16, e[t] &= 65535, t++;
	}
	function _(e, t) {
		this.g = e, this.h = t;
	}
	function ne(e, t) {
		if (m(t)) throw Error("division by zero");
		if (m(e)) return new _(d, d);
		if (h(e)) return t = ne(g(e), t), new _(g(t.g), g(t.h));
		if (h(t)) return t = ne(e, g(t)), new _(g(t.g), t.h);
		if (30 < e.g.length) {
			if (h(e) || h(t)) throw Error("slowDivide_ only works with positive integers.");
			for (var n = f, r = t; 0 >= r.l(e);) n = re(n), r = re(r);
			var i = v(n, 1), a = v(r, 1);
			for (r = v(r, 2), n = v(n, 2); !m(r);) {
				var o = a.add(r);
				0 >= o.l(e) && (i = i.add(n), a = o), r = v(r, 1), n = v(n, 1);
			}
			return t = ee(e, i.j(t)), new _(i, t);
		}
		for (i = d; 0 <= e.l(t);) {
			for (n = Math.max(1, Math.floor(e.m() / t.m())), r = Math.ceil(Math.log(n) / Math.LN2), r = 48 >= r ? 1 : 2 ** (r - 48), a = l(n), o = a.j(t); h(o) || 0 < o.l(e);) n -= r, a = l(n), o = a.j(t);
			m(a) && (a = f), i = i.add(a), e = ee(e, o);
		}
		return new _(i, e);
	}
	e.A = function(e) {
		return ne(this, e).h;
	}, e.and = function(e) {
		for (var t = Math.max(this.g.length, e.g.length), n = [], r = 0; r < t; r++) n[r] = this.i(r) & e.i(r);
		return new o(n, this.h & e.h);
	}, e.or = function(e) {
		for (var t = Math.max(this.g.length, e.g.length), n = [], r = 0; r < t; r++) n[r] = this.i(r) | e.i(r);
		return new o(n, this.h | e.h);
	}, e.xor = function(e) {
		for (var t = Math.max(this.g.length, e.g.length), n = [], r = 0; r < t; r++) n[r] = this.i(r) ^ e.i(r);
		return new o(n, this.h ^ e.h);
	};
	function re(e) {
		for (var t = e.g.length + 1, n = [], r = 0; r < t; r++) n[r] = e.i(r) << 1 | e.i(r - 1) >>> 31;
		return new o(n, e.h);
	}
	function v(e, t) {
		var n = t >> 5;
		t %= 32;
		for (var r = e.g.length - n, i = [], a = 0; a < r; a++) i[a] = 0 < t ? e.i(a + n) >>> t | e.i(a + n + 1) << 32 - t : e.i(a + n);
		return new o(i, e.h);
	}
	r.prototype.digest = r.prototype.v, r.prototype.reset = r.prototype.s, r.prototype.update = r.prototype.u, Qi = Xi.Md5 = r, o.prototype.add = o.prototype.add, o.prototype.multiply = o.prototype.j, o.prototype.modulo = o.prototype.A, o.prototype.compare = o.prototype.l, o.prototype.toNumber = o.prototype.m, o.prototype.toString = o.prototype.toString, o.prototype.getBits = o.prototype.i, o.fromNumber = l, o.fromString = u, Zi = Xi.Integer = o;
}).apply(Yi === void 0 ? typeof self < "u" ? self : typeof window < "u" ? window : {} : Yi);
//#endregion
//#region ../node_modules/@firebase/webchannel-wrapper/dist/webchannel-blob/esm/webchannel_blob_es2018.js
var $i = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {}, ea = {}, ta, na, ra, ia, aa, oa, sa, ca;
(function() {
	var e, t = typeof Object.defineProperties == "function" ? Object.defineProperty : function(e, t, n) {
		return e == Array.prototype || e == Object.prototype || (e[t] = n.value), e;
	};
	function n(e) {
		e = [
			typeof globalThis == "object" && globalThis,
			e,
			typeof window == "object" && window,
			typeof self == "object" && self,
			typeof $i == "object" && $i
		];
		for (var t = 0; t < e.length; ++t) {
			var n = e[t];
			if (n && n.Math == Math) return n;
		}
		throw Error("Cannot find global object");
	}
	var r = n(this);
	function i(e, n) {
		if (n) a: {
			var i = r;
			e = e.split(".");
			for (var a = 0; a < e.length - 1; a++) {
				var o = e[a];
				if (!(o in i)) break a;
				i = i[o];
			}
			e = e[e.length - 1], a = i[e], n = n(a), n != a && n != null && t(i, e, {
				configurable: !0,
				writable: !0,
				value: n
			});
		}
	}
	function a(e, t) {
		e instanceof String && (e += "");
		var n = 0, r = !1, i = { next: function() {
			if (!r && n < e.length) {
				var i = n++;
				return {
					value: t(i, e[i]),
					done: !1
				};
			}
			return r = !0, {
				done: !0,
				value: void 0
			};
		} };
		return i[Symbol.iterator] = function() {
			return i;
		}, i;
	}
	i("Array.prototype.values", function(e) {
		return e || function() {
			return a(this, function(e, t) {
				return t;
			});
		};
	});
	var o = o || {}, s = this || self;
	function c(e) {
		var t = typeof e;
		return t = t == "object" ? e ? Array.isArray(e) ? "array" : t : "null" : t, t == "array" || t == "object" && typeof e.length == "number";
	}
	function l(e) {
		var t = typeof e;
		return t == "object" && e != null || t == "function";
	}
	function u(e, t, n) {
		return e.call.apply(e.bind, arguments);
	}
	function d(e, t, n) {
		if (!e) throw Error();
		if (2 < arguments.length) {
			var r = Array.prototype.slice.call(arguments, 2);
			return function() {
				var n = Array.prototype.slice.call(arguments);
				return Array.prototype.unshift.apply(n, r), e.apply(t, n);
			};
		}
		return function() {
			return e.apply(t, arguments);
		};
	}
	function f(e, t, n) {
		return f = Function.prototype.bind && Function.prototype.bind.toString().indexOf("native code") != -1 ? u : d, f.apply(null, arguments);
	}
	function p(e, t) {
		var n = Array.prototype.slice.call(arguments, 1);
		return function() {
			var t = n.slice();
			return t.push.apply(t, arguments), e.apply(this, t);
		};
	}
	function m(e, t) {
		function n() {}
		n.prototype = t.prototype, e.aa = t.prototype, e.prototype = new n(), e.prototype.constructor = e, e.Qb = function(e, n, r) {
			for (var i = Array(arguments.length - 2), a = 2; a < arguments.length; a++) i[a - 2] = arguments[a];
			return t.prototype[n].apply(e, i);
		};
	}
	function h(e) {
		let t = e.length;
		if (0 < t) {
			let n = Array(t);
			for (let r = 0; r < t; r++) n[r] = e[r];
			return n;
		}
		return [];
	}
	function g(e, t) {
		for (let t = 1; t < arguments.length; t++) {
			let n = arguments[t];
			if (c(n)) {
				let t = e.length || 0, r = n.length || 0;
				e.length = t + r;
				for (let i = 0; i < r; i++) e[t + i] = n[i];
			} else e.push(n);
		}
	}
	class ee {
		constructor(e, t) {
			this.i = e, this.j = t, this.h = 0, this.g = null;
		}
		get() {
			let e;
			return 0 < this.h ? (this.h--, e = this.g, this.g = e.next, e.next = null) : e = this.i(), e;
		}
	}
	function te(e) {
		return /^[\s\xa0]*$/.test(e);
	}
	function _() {
		var e = s.navigator;
		return (e &&= e.userAgent) ? e : "";
	}
	function ne(e) {
		return ne[" "](e), e;
	}
	ne[" "] = function() {};
	var re = _().indexOf("Gecko") != -1 && !(_().toLowerCase().indexOf("webkit") != -1 && _().indexOf("Edge") == -1) && !(_().indexOf("Trident") != -1 || _().indexOf("MSIE") != -1) && _().indexOf("Edge") == -1;
	function v(e, t, n) {
		for (let r in e) t.call(n, e[r], r, e);
	}
	function ie(e, t) {
		for (let n in e) t.call(void 0, e[n], n, e);
	}
	function ae(e) {
		let t = {};
		for (let n in e) t[n] = e[n];
		return t;
	}
	let oe = "constructor hasOwnProperty isPrototypeOf propertyIsEnumerable toLocaleString toString valueOf".split(" ");
	function se(e, t) {
		let n, r;
		for (let t = 1; t < arguments.length; t++) {
			for (n in r = arguments[t], r) e[n] = r[n];
			for (let t = 0; t < oe.length; t++) n = oe[t], Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
		}
	}
	function ce(e) {
		var t = 1;
		e = e.split(":");
		let n = [];
		for (; 0 < t && e.length;) n.push(e.shift()), t--;
		return e.length && n.push(e.join(":")), n;
	}
	function le(e) {
		s.setTimeout(() => {
			throw e;
		}, 0);
	}
	function ue() {
		var e = ge;
		let t = null;
		return e.g && (t = e.g, e.g = e.g.next, e.g || (e.h = null), t.next = null), t;
	}
	class de {
		constructor() {
			this.h = this.g = null;
		}
		add(e, t) {
			let n = fe.get();
			n.set(e, t), this.h ? this.h.next = n : this.g = n, this.h = n;
		}
	}
	var fe = new ee(() => new pe(), (e) => e.reset());
	class pe {
		constructor() {
			this.next = this.g = this.h = null;
		}
		set(e, t) {
			this.h = e, this.g = t, this.next = null;
		}
		reset() {
			this.next = this.g = this.h = null;
		}
	}
	let me, he = !1, ge = new de(), _e = () => {
		let e = s.Promise.resolve(void 0);
		me = () => {
			e.then(ve);
		};
	};
	var ve = () => {
		for (var e; e = ue();) {
			try {
				e.h.call(e.g);
			} catch (e) {
				le(e);
			}
			var t = fe;
			t.j(e), 100 > t.h && (t.h++, e.next = t.g, t.g = e);
		}
		he = !1;
	};
	function ye() {
		this.s = this.s, this.C = this.C;
	}
	ye.prototype.s = !1, ye.prototype.ma = function() {
		this.s || (this.s = !0, this.N());
	}, ye.prototype.N = function() {
		if (this.C) for (; this.C.length;) this.C.shift()();
	};
	function be(e, t) {
		this.type = e, this.g = this.target = t, this.defaultPrevented = !1;
	}
	be.prototype.h = function() {
		this.defaultPrevented = !0;
	};
	var xe = function() {
		if (!s.addEventListener || !Object.defineProperty) return !1;
		var e = !1, t = Object.defineProperty({}, "passive", { get: function() {
			e = !0;
		} });
		try {
			let e = () => {};
			s.addEventListener("test", e, t), s.removeEventListener("test", e, t);
		} catch {}
		return e;
	}();
	function y(e, t) {
		if (be.call(this, e ? e.type : ""), this.relatedTarget = this.g = this.target = null, this.button = this.screenY = this.screenX = this.clientY = this.clientX = 0, this.key = "", this.metaKey = this.shiftKey = this.altKey = this.ctrlKey = !1, this.state = null, this.pointerId = 0, this.pointerType = "", this.i = null, e) {
			var n = this.type = e.type, r = e.changedTouches && e.changedTouches.length ? e.changedTouches[0] : null;
			if (this.target = e.target || e.srcElement, this.g = t, t = e.relatedTarget) {
				if (re) {
					a: {
						try {
							ne(t.nodeName);
							var i = !0;
							break a;
						} catch {}
						i = !1;
					}
					i || (t = null);
				}
			} else n == "mouseover" ? t = e.fromElement : n == "mouseout" && (t = e.toElement);
			this.relatedTarget = t, r ? (this.clientX = r.clientX === void 0 ? r.pageX : r.clientX, this.clientY = r.clientY === void 0 ? r.pageY : r.clientY, this.screenX = r.screenX || 0, this.screenY = r.screenY || 0) : (this.clientX = e.clientX === void 0 ? e.pageX : e.clientX, this.clientY = e.clientY === void 0 ? e.pageY : e.clientY, this.screenX = e.screenX || 0, this.screenY = e.screenY || 0), this.button = e.button, this.key = e.key || "", this.ctrlKey = e.ctrlKey, this.altKey = e.altKey, this.shiftKey = e.shiftKey, this.metaKey = e.metaKey, this.pointerId = e.pointerId || 0, this.pointerType = typeof e.pointerType == "string" ? e.pointerType : Se[e.pointerType] || "", this.state = e.state, this.i = e, e.defaultPrevented && y.aa.h.call(this);
		}
	}
	m(y, be);
	var Se = {
		2: "touch",
		3: "pen",
		4: "mouse"
	};
	y.prototype.h = function() {
		y.aa.h.call(this);
		var e = this.i;
		e.preventDefault ? e.preventDefault() : e.returnValue = !1;
	};
	var Ce = "closure_listenable_" + (1e6 * Math.random() | 0), we = 0;
	function Te(e, t, n, r, i) {
		this.listener = e, this.proxy = null, this.src = t, this.type = n, this.capture = !!r, this.ha = i, this.key = ++we, this.da = this.fa = !1;
	}
	function Ee(e) {
		e.da = !0, e.listener = null, e.proxy = null, e.src = null, e.ha = null;
	}
	function De(e) {
		this.src = e, this.g = {}, this.h = 0;
	}
	De.prototype.add = function(e, t, n, r, i) {
		var a = e.toString();
		e = this.g[a], e || (e = this.g[a] = [], this.h++);
		var o = ke(e, t, r, i);
		return -1 < o ? (t = e[o], n || (t.fa = !1)) : (t = new Te(t, this.src, a, !!r, i), t.fa = n, e.push(t)), t;
	};
	function Oe(e, t) {
		var n = t.type;
		if (n in e.g) {
			var r = e.g[n], i = Array.prototype.indexOf.call(r, t, void 0), a;
			(a = 0 <= i) && Array.prototype.splice.call(r, i, 1), a && (Ee(t), e.g[n].length == 0 && (delete e.g[n], e.h--));
		}
	}
	function ke(e, t, n, r) {
		for (var i = 0; i < e.length; ++i) {
			var a = e[i];
			if (!a.da && a.listener == t && a.capture == !!n && a.ha == r) return i;
		}
		return -1;
	}
	var Ae = "closure_lm_" + (1e6 * Math.random() | 0), je = {};
	function Me(e, t, n, r, i) {
		if (r && r.once) return Fe(e, t, n, r, i);
		if (Array.isArray(t)) {
			for (var a = 0; a < t.length; a++) Me(e, t[a], n, r, i);
			return null;
		}
		return n = Ve(n), e && e[Ce] ? e.K(t, n, l(r) ? !!r.capture : !!r, i) : Ne(e, t, n, !1, r, i);
	}
	function Ne(e, t, n, r, i, a) {
		if (!t) throw Error("Invalid event type");
		var o = l(i) ? !!i.capture : !!i, s = ze(e);
		if (s || (e[Ae] = s = new De(e)), n = s.add(t, n, r, o, a), n.proxy) return n;
		if (r = Pe(), n.proxy = r, r.src = e, r.listener = n, e.addEventListener) xe || (i = o), i === void 0 && (i = !1), e.addEventListener(t.toString(), r, i);
		else if (e.attachEvent) e.attachEvent(b(t.toString()), r);
		else if (e.addListener && e.removeListener) e.addListener(r);
		else throw Error("addEventListener and attachEvent are unavailable.");
		return n;
	}
	function Pe() {
		function e(n) {
			return t.call(e.src, e.listener, n);
		}
		let t = Re;
		return e;
	}
	function Fe(e, t, n, r, i) {
		if (Array.isArray(t)) {
			for (var a = 0; a < t.length; a++) Fe(e, t[a], n, r, i);
			return null;
		}
		return n = Ve(n), e && e[Ce] ? e.L(t, n, l(r) ? !!r.capture : !!r, i) : Ne(e, t, n, !0, r, i);
	}
	function Ie(e, t, n, r, i) {
		if (Array.isArray(t)) for (var a = 0; a < t.length; a++) Ie(e, t[a], n, r, i);
		else r = l(r) ? !!r.capture : !!r, n = Ve(n), e && e[Ce] ? (e = e.i, t = String(t).toString(), t in e.g && (a = e.g[t], n = ke(a, n, r, i), -1 < n && (Ee(a[n]), Array.prototype.splice.call(a, n, 1), a.length == 0 && (delete e.g[t], e.h--)))) : (e &&= ze(e)) && (t = e.g[t.toString()], e = -1, t && (e = ke(t, n, r, i)), (n = -1 < e ? t[e] : null) && Le(n));
	}
	function Le(e) {
		if (typeof e != "number" && e && !e.da) {
			var t = e.src;
			if (t && t[Ce]) Oe(t.i, e);
			else {
				var n = e.type, r = e.proxy;
				t.removeEventListener ? t.removeEventListener(n, r, e.capture) : t.detachEvent ? t.detachEvent(b(n), r) : t.addListener && t.removeListener && t.removeListener(r), (n = ze(t)) ? (Oe(n, e), n.h == 0 && (n.src = null, t[Ae] = null)) : Ee(e);
			}
		}
	}
	function b(e) {
		return e in je ? je[e] : je[e] = "on" + e;
	}
	function Re(e, t) {
		if (e.da) e = !0;
		else {
			t = new y(t, this);
			var n = e.listener, r = e.ha || e.src;
			e.fa && Le(e), e = n.call(r, t);
		}
		return e;
	}
	function ze(e) {
		return e = e[Ae], e instanceof De ? e : null;
	}
	var Be = "__closure_events_fn_" + (1e9 * Math.random() >>> 0);
	function Ve(e) {
		return typeof e == "function" ? e : (e[Be] || (e[Be] = function(t) {
			return e.handleEvent(t);
		}), e[Be]);
	}
	function x() {
		ye.call(this), this.i = new De(this), this.M = this, this.F = null;
	}
	m(x, ye), x.prototype[Ce] = !0, x.prototype.removeEventListener = function(e, t, n, r) {
		Ie(this, e, t, n, r);
	};
	function He(e, t) {
		var n, r = e.F;
		if (r) for (n = []; r; r = r.F) n.push(r);
		if (e = e.M, r = t.type || t, typeof t == "string") t = new be(t, e);
		else if (t instanceof be) t.target = t.target || e;
		else {
			var i = t;
			t = new be(r, e), se(t, i);
		}
		if (i = !0, n) for (var a = n.length - 1; 0 <= a; a--) {
			var o = t.g = n[a];
			i = Ue(o, r, !0, t) && i;
		}
		if (o = t.g = e, i = Ue(o, r, !0, t) && i, i = Ue(o, r, !1, t) && i, n) for (a = 0; a < n.length; a++) o = t.g = n[a], i = Ue(o, r, !1, t) && i;
	}
	x.prototype.N = function() {
		if (x.aa.N.call(this), this.i) {
			var e = this.i, t;
			for (t in e.g) {
				for (var n = e.g[t], r = 0; r < n.length; r++) Ee(n[r]);
				delete e.g[t], e.h--;
			}
		}
		this.F = null;
	}, x.prototype.K = function(e, t, n, r) {
		return this.i.add(String(e), t, !1, n, r);
	}, x.prototype.L = function(e, t, n, r) {
		return this.i.add(String(e), t, !0, n, r);
	};
	function Ue(e, t, n, r) {
		if (t = e.i.g[String(t)], !t) return !0;
		t = t.concat();
		for (var i = !0, a = 0; a < t.length; ++a) {
			var o = t[a];
			if (o && !o.da && o.capture == n) {
				var s = o.listener, c = o.ha || o.src;
				o.fa && Oe(e.i, o), i = !1 !== s.call(c, r) && i;
			}
		}
		return i && !r.defaultPrevented;
	}
	function We(e, t, n) {
		if (typeof e == "function") n && (e = f(e, n));
		else if (e && typeof e.handleEvent == "function") e = f(e.handleEvent, e);
		else throw Error("Invalid listener argument");
		return 2147483647 < Number(t) ? -1 : s.setTimeout(e, t || 0);
	}
	function Ge(e) {
		e.g = We(() => {
			e.g = null, e.i && (e.i = !1, Ge(e));
		}, e.l);
		let t = e.h;
		e.h = null, e.m.apply(null, t);
	}
	class S extends ye {
		constructor(e, t) {
			super(), this.m = e, this.l = t, this.h = null, this.i = !1, this.g = null;
		}
		j(e) {
			this.h = arguments, this.g ? this.i = !0 : Ge(this);
		}
		N() {
			super.N(), this.g && (s.clearTimeout(this.g), this.g = null, this.i = !1, this.h = null);
		}
	}
	function Ke(e) {
		ye.call(this), this.h = e, this.g = {};
	}
	m(Ke, ye);
	var qe = [];
	function Je(e) {
		v(e.g, function(e, t) {
			this.g.hasOwnProperty(t) && Le(e);
		}, e), e.g = {};
	}
	Ke.prototype.N = function() {
		Ke.aa.N.call(this), Je(this);
	}, Ke.prototype.handleEvent = function() {
		throw Error("EventHandler.handleEvent not implemented");
	};
	var Ye = s.JSON.stringify, Xe = s.JSON.parse, Ze = class {
		stringify(e) {
			return s.JSON.stringify(e, void 0);
		}
		parse(e) {
			return s.JSON.parse(e, void 0);
		}
	};
	function Qe() {}
	Qe.prototype.h = null;
	function $e(e) {
		return e.h ||= e.i();
	}
	function et() {}
	var tt = {
		OPEN: "a",
		kb: "b",
		Ja: "c",
		wb: "d"
	};
	function C() {
		be.call(this, "d");
	}
	m(C, be);
	function nt() {
		be.call(this, "c");
	}
	m(nt, be);
	var rt = {}, w = null;
	function T() {
		return w ||= new x();
	}
	rt.La = "serverreachability";
	function it(e) {
		be.call(this, rt.La, e);
	}
	m(it, be);
	function E(e) {
		let t = T();
		He(t, new it(t));
	}
	rt.STAT_EVENT = "statevent";
	function at(e, t) {
		be.call(this, rt.STAT_EVENT, e), this.stat = t;
	}
	m(at, be);
	function ot(e) {
		let t = T();
		He(t, new at(t, e));
	}
	rt.Ma = "timingevent";
	function st(e, t) {
		be.call(this, rt.Ma, e), this.size = t;
	}
	m(st, be);
	function ct(e, t) {
		if (typeof e != "function") throw Error("Fn must not be null and must be a function");
		return s.setTimeout(function() {
			e();
		}, t);
	}
	function D() {
		this.g = !0;
	}
	D.prototype.xa = function() {
		this.g = !1;
	};
	function lt(e, t, n, r, i, a) {
		e.info(function() {
			if (e.g) if (a) for (var o = "", s = a.split("&"), c = 0; c < s.length; c++) {
				var l = s[c].split("=");
				if (1 < l.length) {
					var u = l[0];
					l = l[1];
					var d = u.split("_");
					o = 2 <= d.length && d[1] == "type" ? o + (u + "=" + l + "&") : o + (u + "=redacted&");
				}
			}
			else o = null;
			else o = a;
			return "XMLHTTP REQ (" + r + ") [attempt " + i + "]: " + t + "\n" + n + "\n" + o;
		});
	}
	function ut(e, t, n, r, i, a, o) {
		e.info(function() {
			return "XMLHTTP RESP (" + r + ") [ attempt " + i + "]: " + t + "\n" + n + "\n" + a + " " + o;
		});
	}
	function dt(e, t, n, r) {
		e.info(function() {
			return "XMLHTTP TEXT (" + t + "): " + pt(e, n) + (r ? " " + r : "");
		});
	}
	function ft(e, t) {
		e.info(function() {
			return "TIMEOUT: " + t;
		});
	}
	D.prototype.info = function() {};
	function pt(e, t) {
		if (!e.g) return t;
		if (!t) return null;
		try {
			var n = JSON.parse(t);
			if (n) {
				for (e = 0; e < n.length; e++) if (Array.isArray(n[e])) {
					var r = n[e];
					if (!(2 > r.length)) {
						var i = r[1];
						if (Array.isArray(i) && !(1 > i.length)) {
							var a = i[0];
							if (a != "noop" && a != "stop" && a != "close") for (var o = 1; o < i.length; o++) i[o] = "";
						}
					}
				}
			}
			return Ye(n);
		} catch {
			return t;
		}
	}
	var mt = {
		NO_ERROR: 0,
		gb: 1,
		tb: 2,
		sb: 3,
		nb: 4,
		rb: 5,
		ub: 6,
		Ia: 7,
		TIMEOUT: 8,
		xb: 9
	}, ht = {
		lb: "complete",
		Hb: "success",
		Ja: "error",
		Ia: "abort",
		zb: "ready",
		Ab: "readystatechange",
		TIMEOUT: "timeout",
		vb: "incrementaldata",
		yb: "progress",
		ob: "downloadprogress",
		Pb: "uploadprogress"
	}, gt;
	function _t() {}
	m(_t, Qe), _t.prototype.g = function() {
		return new XMLHttpRequest();
	}, _t.prototype.i = function() {
		return {};
	}, gt = new _t();
	function vt(e, t, n, r) {
		this.j = e, this.i = t, this.l = n, this.R = r || 1, this.U = new Ke(this), this.I = 45e3, this.H = null, this.o = !1, this.m = this.A = this.v = this.L = this.F = this.S = this.B = null, this.D = [], this.g = null, this.C = 0, this.s = this.u = null, this.X = -1, this.J = !1, this.O = 0, this.M = null, this.W = this.K = this.T = this.P = !1, this.h = new yt();
	}
	function yt() {
		this.i = null, this.g = "", this.h = !1;
	}
	var bt = {}, xt = {};
	function St(e, t, n) {
		e.L = 1, e.v = Xt(Kt(t)), e.m = n, e.P = !0, Ct(e, null);
	}
	function Ct(e, t) {
		e.F = Date.now(), Et(e), e.A = Kt(e.v);
		var n = e.A, r = e.R;
		Array.isArray(r) || (r = [String(r)]), un(n.i, "t", r), e.C = 0, n = e.j.J, e.h = new yt(), e.g = er(e.j, n ? t : null, !e.m), 0 < e.O && (e.M = new S(f(e.Y, e, e.g), e.O)), t = e.U, n = e.g, r = e.ca;
		var i = "readystatechange";
		Array.isArray(i) || (i && (qe[0] = i.toString()), i = qe);
		for (var a = 0; a < i.length; a++) {
			var o = Me(n, i[a], r || t.handleEvent, !1, t.h || t);
			if (!o) break;
			t.g[o.key] = o;
		}
		t = e.H ? ae(e.H) : {}, e.m ? (e.u ||= "POST", t["Content-Type"] = "application/x-www-form-urlencoded", e.g.ea(e.A, e.u, e.m, t)) : (e.u = "GET", e.g.ea(e.A, e.u, null, t)), E(), lt(e.i, e.u, e.A, e.l, e.R, e.m);
	}
	vt.prototype.ca = function(e) {
		e = e.target;
		let t = this.M;
		t && Mn(e) == 3 ? t.j() : this.Y(e);
	}, vt.prototype.Y = function(e) {
		try {
			if (e == this.g) a: {
				let f = Mn(this.g);
				var t = this.g.Ba();
				let p = this.g.Z();
				if (!(3 > f) && (f != 3 || this.g && (this.h.h || this.g.oa() || Nn(this.g)))) {
					this.J || f != 4 || t == 7 || E(t == 8 || 0 >= p ? 3 : 2), Ot(this);
					var n = this.g.Z();
					this.X = n;
					b: if (wt(this)) {
						var r = Nn(this.g);
						e = "";
						var i = r.length, a = Mn(this.g) == 4;
						if (!this.h.i) {
							if (typeof TextDecoder > "u") {
								At(this), kt(this);
								var o = "";
								break b;
							}
							this.h.i = new s.TextDecoder();
						}
						for (t = 0; t < i; t++) this.h.h = !0, e += this.h.i.decode(r[t], { stream: !(a && t == i - 1) });
						r.length = 0, this.h.g += e, this.C = 0, o = this.h.g;
					} else o = this.g.oa();
					if (this.o = n == 200, ut(this.i, this.u, this.A, this.l, this.R, f, n), this.o) {
						if (this.T && !this.K) {
							b: {
								if (this.g) {
									var c, l = this.g;
									if ((c = l.g ? l.g.getResponseHeader("X-HTTP-Initial-Response") : null) && !te(c)) {
										var u = c;
										break b;
									}
								}
								u = null;
							}
							if (n = u) dt(this.i, this.l, n, "Initial handshake response via X-HTTP-Initial-Response"), this.K = !0, jt(this, n);
							else {
								this.o = !1, this.s = 3, ot(12), At(this), kt(this);
								break a;
							}
						}
						if (this.P) {
							n = !0;
							let e;
							for (; !this.J && this.C < o.length;) if (e = Tt(this, o), e == xt) {
								f == 4 && (this.s = 4, ot(14), n = !1), dt(this.i, this.l, null, "[Incomplete Response]");
								break;
							} else if (e == bt) {
								this.s = 4, ot(15), dt(this.i, this.l, o, "[Invalid Chunk]"), n = !1;
								break;
							} else dt(this.i, this.l, e, null), jt(this, e);
							if (wt(this) && this.C != 0 && (this.h.g = this.h.g.slice(this.C), this.C = 0), f != 4 || o.length != 0 || this.h.h || (this.s = 1, ot(16), n = !1), this.o = this.o && n, !n) dt(this.i, this.l, o, "[Invalid Chunked Response]"), At(this), kt(this);
							else if (0 < o.length && !this.W) {
								this.W = !0;
								var d = this.j;
								d.g == this && d.ba && !d.M && (d.j.info("Great, no buffering proxy detected. Bytes received: " + o.length), Kn(d), d.M = !0, ot(11));
							}
						} else dt(this.i, this.l, o, null), jt(this, o);
						f == 4 && At(this), this.o && !this.J && (f == 4 ? Yn(this.j, this) : (this.o = !1, Et(this)));
					} else Pn(this.g), n == 400 && 0 < o.indexOf("Unknown SID") ? (this.s = 3, ot(12)) : (this.s = 0, ot(13)), At(this), kt(this);
				}
			}
		} catch {}
	};
	function wt(e) {
		return e.g ? e.u == "GET" && e.L != 2 && e.j.Ca : !1;
	}
	function Tt(e, t) {
		var n = e.C, r = t.indexOf("\n", n);
		return r == -1 ? xt : (n = Number(t.substring(n, r)), isNaN(n) ? bt : (r += 1, r + n > t.length ? xt : (t = t.slice(r, r + n), e.C = r + n, t)));
	}
	vt.prototype.cancel = function() {
		this.J = !0, At(this);
	};
	function Et(e) {
		e.S = Date.now() + e.I, Dt(e, e.I);
	}
	function Dt(e, t) {
		if (e.B != null) throw Error("WatchDog timer not null");
		e.B = ct(f(e.ba, e), t);
	}
	function Ot(e) {
		e.B &&= (s.clearTimeout(e.B), null);
	}
	vt.prototype.ba = function() {
		this.B = null;
		let e = Date.now();
		0 <= e - this.S ? (ft(this.i, this.A), this.L != 2 && (E(), ot(17)), At(this), this.s = 2, kt(this)) : Dt(this, this.S - e);
	};
	function kt(e) {
		e.j.G == 0 || e.J || Yn(e.j, e);
	}
	function At(e) {
		Ot(e);
		var t = e.M;
		t && typeof t.ma == "function" && t.ma(), e.M = null, Je(e.U), e.g && (t = e.g, e.g = null, t.abort(), t.ma());
	}
	function jt(e, t) {
		try {
			var n = e.j;
			if (n.G != 0 && (n.g == e || It(n.h, e))) {
				if (!e.K && It(n.h, e) && n.G == 3) {
					try {
						var r = n.Da.g.parse(t);
					} catch {
						r = null;
					}
					if (Array.isArray(r) && r.length == 3) {
						var i = r;
						if (i[0] == 0) {
							a: if (!n.u) {
								if (n.g) if (n.g.F + 3e3 < e.F) Jn(n), Ln(n);
								else break a;
								Gn(n), ot(18);
							}
						} else n.za = i[1], 0 < n.za - n.T && 37500 > i[2] && n.F && n.v == 0 && !n.C && (n.C = ct(f(n.Za, n), 6e3));
						if (1 >= Ft(n.h) && n.ca) {
							try {
								n.ca();
							} catch {}
							n.ca = void 0;
						}
					} else Zn(n, 11);
				} else if ((e.K || n.g == e) && Jn(n), !te(t)) for (i = n.Da.g.parse(t), t = 0; t < i.length; t++) {
					let l = i[t];
					if (n.T = l[0], l = l[1], n.G == 2) if (l[0] == "c") {
						n.K = l[1], n.ia = l[2];
						let t = l[3];
						t != null && (n.la = t, n.j.info("VER=" + n.la));
						let i = l[4];
						i != null && (n.Aa = i, n.j.info("SVER=" + n.Aa));
						let u = l[5];
						u != null && typeof u == "number" && 0 < u && (r = 1.5 * u, n.L = r, n.j.info("backChannelRequestTimeoutMs_=" + r)), r = n;
						let d = e.g;
						if (d) {
							let e = d.g ? d.g.getResponseHeader("X-Client-Wire-Protocol") : null;
							if (e) {
								var a = r.h;
								a.g || e.indexOf("spdy") == -1 && e.indexOf("quic") == -1 && e.indexOf("h2") == -1 || (a.j = a.l, a.g = /* @__PURE__ */ new Set(), a.h &&= (Lt(a, a.h), null));
							}
							if (r.D) {
								let e = d.g ? d.g.getResponseHeader("X-HTTP-Session-Id") : null;
								e && (r.ya = e, O(r.I, r.D, e));
							}
						}
						n.G = 3, n.l && n.l.ua(), n.ba && (n.R = Date.now() - e.F, n.j.info("Handshake RTT: " + n.R + "ms")), r = n;
						var o = e;
						if (r.qa = $n(r, r.J ? r.ia : null, r.W), o.K) {
							Rt(r.h, o);
							var s = o, c = r.L;
							c && (s.I = c), s.B && (Ot(s), Et(s)), r.g = o;
						} else Wn(r);
						0 < n.i.length && zn(n);
					} else l[0] != "stop" && l[0] != "close" || Zn(n, 7);
					else n.G == 3 && (l[0] == "stop" || l[0] == "close" ? l[0] == "stop" ? Zn(n, 7) : In(n) : l[0] != "noop" && n.l && n.l.ta(l), n.v = 0);
				}
			}
			E(4);
		} catch {}
	}
	var Mt = class {
		constructor(e, t) {
			this.g = e, this.map = t;
		}
	};
	function Nt(e) {
		this.l = e || 10, s.PerformanceNavigationTiming ? (e = s.performance.getEntriesByType("navigation"), e = 0 < e.length && (e[0].nextHopProtocol == "hq" || e[0].nextHopProtocol == "h2")) : e = !!(s.chrome && s.chrome.loadTimes && s.chrome.loadTimes() && s.chrome.loadTimes().wasFetchedViaSpdy), this.j = e ? this.l : 1, this.g = null, 1 < this.j && (this.g = /* @__PURE__ */ new Set()), this.h = null, this.i = [];
	}
	function Pt(e) {
		return e.h ? !0 : e.g ? e.g.size >= e.j : !1;
	}
	function Ft(e) {
		return e.h ? 1 : e.g ? e.g.size : 0;
	}
	function It(e, t) {
		return e.h ? e.h == t : e.g ? e.g.has(t) : !1;
	}
	function Lt(e, t) {
		e.g ? e.g.add(t) : e.h = t;
	}
	function Rt(e, t) {
		e.h && e.h == t ? e.h = null : e.g && e.g.has(t) && e.g.delete(t);
	}
	Nt.prototype.cancel = function() {
		if (this.i = zt(this), this.h) this.h.cancel(), this.h = null;
		else if (this.g && this.g.size !== 0) {
			for (let e of this.g.values()) e.cancel();
			this.g.clear();
		}
	};
	function zt(e) {
		if (e.h != null) return e.i.concat(e.h.D);
		if (e.g != null && e.g.size !== 0) {
			let t = e.i;
			for (let n of e.g.values()) t = t.concat(n.D);
			return t;
		}
		return h(e.i);
	}
	function Bt(e) {
		if (e.V && typeof e.V == "function") return e.V();
		if (typeof Map < "u" && e instanceof Map || typeof Set < "u" && e instanceof Set) return Array.from(e.values());
		if (typeof e == "string") return e.split("");
		if (c(e)) {
			for (var t = [], n = e.length, r = 0; r < n; r++) t.push(e[r]);
			return t;
		}
		for (r in t = [], n = 0, e) t[n++] = e[r];
		return t;
	}
	function Vt(e) {
		if (e.na && typeof e.na == "function") return e.na();
		if (!e.V || typeof e.V != "function") {
			if (typeof Map < "u" && e instanceof Map) return Array.from(e.keys());
			if (!(typeof Set < "u" && e instanceof Set)) {
				if (c(e) || typeof e == "string") {
					var t = [];
					e = e.length;
					for (var n = 0; n < e; n++) t.push(n);
					return t;
				}
				t = [], n = 0;
				for (let r in e) t[n++] = r;
				return t;
			}
		}
	}
	function Ht(e, t) {
		if (e.forEach && typeof e.forEach == "function") e.forEach(t, void 0);
		else if (c(e) || typeof e == "string") Array.prototype.forEach.call(e, t, void 0);
		else for (var n = Vt(e), r = Bt(e), i = r.length, a = 0; a < i; a++) t.call(void 0, r[a], n && n[a], e);
	}
	var Ut = RegExp("^(?:([^:/?#.]+):)?(?://(?:([^\\\\/?#]*)@)?([^\\\\/?#]*?)(?::([0-9]+))?(?=[\\\\/?#]|$))?([^?#]+)?(?:\\?([^#]*))?(?:#([\\s\\S]*))?$");
	function Wt(e, t) {
		if (e) {
			e = e.split("&");
			for (var n = 0; n < e.length; n++) {
				var r = e[n].indexOf("="), i = null;
				if (0 <= r) {
					var a = e[n].substring(0, r);
					i = e[n].substring(r + 1);
				} else a = e[n];
				t(a, i ? decodeURIComponent(i.replace(/\+/g, " ")) : "");
			}
		}
	}
	function Gt(e) {
		if (this.g = this.o = this.j = "", this.s = null, this.m = this.l = "", this.h = !1, e instanceof Gt) {
			this.h = e.h, qt(this, e.j), this.o = e.o, this.g = e.g, Jt(this, e.s), this.l = e.l;
			var t = e.i, n = new on();
			n.i = t.i, t.g && (n.g = new Map(t.g), n.h = t.h), Yt(this, n), this.m = e.m;
		} else e && (t = String(e).match(Ut)) ? (this.h = !1, qt(this, t[1] || "", !0), this.o = Zt(t[2] || ""), this.g = Zt(t[3] || "", !0), Jt(this, t[4]), this.l = Zt(t[5] || "", !0), Yt(this, t[6] || "", !0), this.m = Zt(t[7] || "")) : (this.h = !1, this.i = new on(null, this.h));
	}
	Gt.prototype.toString = function() {
		var e = [], t = this.j;
		t && e.push(Qt(t, en, !0), ":");
		var n = this.g;
		return (n || t == "file") && (e.push("//"), (t = this.o) && e.push(Qt(t, en, !0), "@"), e.push(encodeURIComponent(String(n)).replace(/%25([0-9a-fA-F]{2})/g, "%$1")), n = this.s, n != null && e.push(":", String(n))), (n = this.l) && (this.g && n.charAt(0) != "/" && e.push("/"), e.push(Qt(n, n.charAt(0) == "/" ? nn : tn, !0))), (n = this.i.toString()) && e.push("?", n), (n = this.m) && e.push("#", Qt(n, an)), e.join("");
	};
	function Kt(e) {
		return new Gt(e);
	}
	function qt(e, t, n) {
		e.j = n ? Zt(t, !0) : t, e.j &&= e.j.replace(/:$/, "");
	}
	function Jt(e, t) {
		if (t) {
			if (t = Number(t), isNaN(t) || 0 > t) throw Error("Bad port number " + t);
			e.s = t;
		} else e.s = null;
	}
	function Yt(e, t, n) {
		t instanceof on ? (e.i = t, fn(e.i, e.h)) : (n || (t = Qt(t, rn)), e.i = new on(t, e.h));
	}
	function O(e, t, n) {
		e.i.set(t, n);
	}
	function Xt(e) {
		return O(e, "zx", Math.floor(2147483648 * Math.random()).toString(36) + Math.abs(Math.floor(2147483648 * Math.random()) ^ Date.now()).toString(36)), e;
	}
	function Zt(e, t) {
		return e ? t ? decodeURI(e.replace(/%25/g, "%2525")) : decodeURIComponent(e) : "";
	}
	function Qt(e, t, n) {
		return typeof e == "string" ? (e = encodeURI(e).replace(t, $t), n && (e = e.replace(/%25([0-9a-fA-F]{2})/g, "%$1")), e) : null;
	}
	function $t(e) {
		return e = e.charCodeAt(0), "%" + (e >> 4 & 15).toString(16) + (e & 15).toString(16);
	}
	var en = /[#\/\?@]/g, tn = /[#\?:]/g, nn = /[#\?]/g, rn = /[#\?@]/g, an = /#/g;
	function on(e, t) {
		this.h = this.g = null, this.i = e || null, this.j = !!t;
	}
	function sn(e) {
		e.g || (e.g = /* @__PURE__ */ new Map(), e.h = 0, e.i && Wt(e.i, function(t, n) {
			e.add(decodeURIComponent(t.replace(/\+/g, " ")), n);
		}));
	}
	e = on.prototype, e.add = function(e, t) {
		sn(this), this.i = null, e = dn(this, e);
		var n = this.g.get(e);
		return n || this.g.set(e, n = []), n.push(t), this.h += 1, this;
	};
	function cn(e, t) {
		sn(e), t = dn(e, t), e.g.has(t) && (e.i = null, e.h -= e.g.get(t).length, e.g.delete(t));
	}
	function ln(e, t) {
		return sn(e), t = dn(e, t), e.g.has(t);
	}
	e.forEach = function(e, t) {
		sn(this), this.g.forEach(function(n, r) {
			n.forEach(function(n) {
				e.call(t, n, r, this);
			}, this);
		}, this);
	}, e.na = function() {
		sn(this);
		let e = Array.from(this.g.values()), t = Array.from(this.g.keys()), n = [];
		for (let r = 0; r < t.length; r++) {
			let i = e[r];
			for (let e = 0; e < i.length; e++) n.push(t[r]);
		}
		return n;
	}, e.V = function(e) {
		sn(this);
		let t = [];
		if (typeof e == "string") ln(this, e) && (t = t.concat(this.g.get(dn(this, e))));
		else {
			e = Array.from(this.g.values());
			for (let n = 0; n < e.length; n++) t = t.concat(e[n]);
		}
		return t;
	}, e.set = function(e, t) {
		return sn(this), this.i = null, e = dn(this, e), ln(this, e) && (this.h -= this.g.get(e).length), this.g.set(e, [t]), this.h += 1, this;
	}, e.get = function(e, t) {
		return e ? (e = this.V(e), 0 < e.length ? String(e[0]) : t) : t;
	};
	function un(e, t, n) {
		cn(e, t), 0 < n.length && (e.i = null, e.g.set(dn(e, t), h(n)), e.h += n.length);
	}
	e.toString = function() {
		if (this.i) return this.i;
		if (!this.g) return "";
		let e = [], t = Array.from(this.g.keys());
		for (var n = 0; n < t.length; n++) {
			var r = t[n];
			let a = encodeURIComponent(String(r)), o = this.V(r);
			for (r = 0; r < o.length; r++) {
				var i = a;
				o[r] !== "" && (i += "=" + encodeURIComponent(String(o[r]))), e.push(i);
			}
		}
		return this.i = e.join("&");
	};
	function dn(e, t) {
		return t = String(t), e.j && (t = t.toLowerCase()), t;
	}
	function fn(e, t) {
		t && !e.j && (sn(e), e.i = null, e.g.forEach(function(e, t) {
			var n = t.toLowerCase();
			t != n && (cn(this, t), un(this, n, e));
		}, e)), e.j = t;
	}
	function pn(e, t) {
		let n = new D();
		if (s.Image) {
			let r = new Image();
			r.onload = p(hn, n, "TestLoadImage: loaded", !0, t, r), r.onerror = p(hn, n, "TestLoadImage: error", !1, t, r), r.onabort = p(hn, n, "TestLoadImage: abort", !1, t, r), r.ontimeout = p(hn, n, "TestLoadImage: timeout", !1, t, r), s.setTimeout(function() {
				r.ontimeout && r.ontimeout();
			}, 1e4), r.src = e;
		} else t(!1);
	}
	function mn(e, t) {
		let n = new D(), r = new AbortController(), i = setTimeout(() => {
			r.abort(), hn(n, "TestPingServer: timeout", !1, t);
		}, 1e4);
		fetch(e, { signal: r.signal }).then((e) => {
			clearTimeout(i), e.ok ? hn(n, "TestPingServer: ok", !0, t) : hn(n, "TestPingServer: server error", !1, t);
		}).catch(() => {
			clearTimeout(i), hn(n, "TestPingServer: error", !1, t);
		});
	}
	function hn(e, t, n, r, i) {
		try {
			i && (i.onload = null, i.onerror = null, i.onabort = null, i.ontimeout = null), r(n);
		} catch {}
	}
	function gn() {
		this.g = new Ze();
	}
	function _n(e, t, n) {
		let r = n || "";
		try {
			Ht(e, function(e, n) {
				let i = e;
				l(e) && (i = Ye(e)), t.push(r + n + "=" + encodeURIComponent(i));
			});
		} catch (e) {
			throw t.push(r + "type=_badmap"), e;
		}
	}
	function vn(e) {
		this.l = e.Ub || null, this.j = e.eb || !1;
	}
	m(vn, Qe), vn.prototype.g = function() {
		return new yn(this.l, this.j);
	}, vn.prototype.i = function(e) {
		return function() {
			return e;
		};
	}({});
	function yn(e, t) {
		x.call(this), this.D = e, this.o = t, this.m = void 0, this.status = this.readyState = 0, this.responseType = this.responseText = this.response = this.statusText = "", this.onreadystatechange = null, this.u = new Headers(), this.h = null, this.B = "GET", this.A = "", this.g = !1, this.v = this.j = this.l = null;
	}
	m(yn, x), e = yn.prototype, e.open = function(e, t) {
		if (this.readyState != 0) throw this.abort(), Error("Error reopening a connection");
		this.B = e, this.A = t, this.readyState = 1, Sn(this);
	}, e.send = function(e) {
		if (this.readyState != 1) throw this.abort(), Error("need to call open() first. ");
		this.g = !0;
		let t = {
			headers: this.u,
			method: this.B,
			credentials: this.m,
			cache: void 0
		};
		e && (t.body = e), (this.D || s).fetch(new Request(this.A, t)).then(this.Sa.bind(this), this.ga.bind(this));
	}, e.abort = function() {
		this.response = this.responseText = "", this.u = new Headers(), this.status = 0, this.j && this.j.cancel("Request was aborted.").catch(() => {}), 1 <= this.readyState && this.g && this.readyState != 4 && (this.g = !1, xn(this)), this.readyState = 0;
	}, e.Sa = function(e) {
		if (this.g && (this.l = e, this.h || (this.status = this.l.status, this.statusText = this.l.statusText, this.h = e.headers, this.readyState = 2, Sn(this)), this.g && (this.readyState = 3, Sn(this), this.g))) if (this.responseType === "arraybuffer") e.arrayBuffer().then(this.Qa.bind(this), this.ga.bind(this));
		else if (s.ReadableStream !== void 0 && "body" in e) {
			if (this.j = e.body.getReader(), this.o) {
				if (this.responseType) throw Error("responseType must be empty for \"streamBinaryChunks\" mode responses.");
				this.response = [];
			} else this.response = this.responseText = "", this.v = new TextDecoder();
			bn(this);
		} else e.text().then(this.Ra.bind(this), this.ga.bind(this));
	};
	function bn(e) {
		e.j.read().then(e.Pa.bind(e)).catch(e.ga.bind(e));
	}
	e.Pa = function(e) {
		if (this.g) {
			if (this.o && e.value) this.response.push(e.value);
			else if (!this.o) {
				var t = e.value ? e.value : new Uint8Array();
				(t = this.v.decode(t, { stream: !e.done })) && (this.response = this.responseText += t);
			}
			e.done ? xn(this) : Sn(this), this.readyState == 3 && bn(this);
		}
	}, e.Ra = function(e) {
		this.g && (this.response = this.responseText = e, xn(this));
	}, e.Qa = function(e) {
		this.g && (this.response = e, xn(this));
	}, e.ga = function() {
		this.g && xn(this);
	};
	function xn(e) {
		e.readyState = 4, e.l = null, e.j = null, e.v = null, Sn(e);
	}
	e.setRequestHeader = function(e, t) {
		this.u.append(e, t);
	}, e.getResponseHeader = function(e) {
		return this.h && this.h.get(e.toLowerCase()) || "";
	}, e.getAllResponseHeaders = function() {
		if (!this.h) return "";
		let e = [], t = this.h.entries();
		for (var n = t.next(); !n.done;) n = n.value, e.push(n[0] + ": " + n[1]), n = t.next();
		return e.join("\r\n");
	};
	function Sn(e) {
		e.onreadystatechange && e.onreadystatechange.call(e);
	}
	Object.defineProperty(yn.prototype, "withCredentials", {
		get: function() {
			return this.m === "include";
		},
		set: function(e) {
			this.m = e ? "include" : "same-origin";
		}
	});
	function Cn(e) {
		let t = "";
		return v(e, function(e, n) {
			t += n, t += ":", t += e, t += "\r\n";
		}), t;
	}
	function wn(e, t, n) {
		a: {
			for (r in n) {
				var r = !1;
				break a;
			}
			r = !0;
		}
		r || (n = Cn(n), typeof e == "string" || O(e, t, n));
	}
	function k(e) {
		x.call(this), this.headers = /* @__PURE__ */ new Map(), this.o = e || null, this.h = !1, this.v = this.g = null, this.D = "", this.m = 0, this.l = "", this.j = this.B = this.u = this.A = !1, this.I = null, this.H = "", this.J = !1;
	}
	m(k, x);
	var Tn = /^https?$/i, En = ["POST", "PUT"];
	e = k.prototype, e.Ha = function(e) {
		this.J = e;
	}, e.ea = function(e, t, n, r) {
		if (this.g) throw Error("[goog.net.XhrIo] Object is active with another request=" + this.D + "; newUri=" + e);
		t = t ? t.toUpperCase() : "GET", this.D = e, this.l = "", this.m = 0, this.A = !1, this.h = !0, this.g = this.o ? this.o.g() : gt.g(), this.v = this.o ? $e(this.o) : $e(gt), this.g.onreadystatechange = f(this.Ea, this);
		try {
			this.B = !0, this.g.open(t, String(e), !0), this.B = !1;
		} catch (e) {
			Dn(this, e);
			return;
		}
		if (e = n || "", n = new Map(this.headers), r) if (Object.getPrototypeOf(r) === Object.prototype) for (var i in r) n.set(i, r[i]);
		else if (typeof r.keys == "function" && typeof r.get == "function") for (let e of r.keys()) n.set(e, r.get(e));
		else throw Error("Unknown input type for opt_headers: " + String(r));
		r = Array.from(n.keys()).find((e) => e.toLowerCase() == "content-type"), i = s.FormData && e instanceof s.FormData, !(0 <= Array.prototype.indexOf.call(En, t, void 0)) || r || i || n.set("Content-Type", "application/x-www-form-urlencoded;charset=utf-8");
		for (let [e, t] of n) this.g.setRequestHeader(e, t);
		this.H && (this.g.responseType = this.H), "withCredentials" in this.g && this.g.withCredentials !== this.J && (this.g.withCredentials = this.J);
		try {
			jn(this), this.u = !0, this.g.send(e), this.u = !1;
		} catch (e) {
			Dn(this, e);
		}
	};
	function Dn(e, t) {
		e.h = !1, e.g && (e.j = !0, e.g.abort(), e.j = !1), e.l = t, e.m = 5, On(e), An(e);
	}
	function On(e) {
		e.A || (e.A = !0, He(e, "complete"), He(e, "error"));
	}
	e.abort = function(e) {
		this.g && this.h && (this.h = !1, this.j = !0, this.g.abort(), this.j = !1, this.m = e || 7, He(this, "complete"), He(this, "abort"), An(this));
	}, e.N = function() {
		this.g && (this.h && (this.h = !1, this.j = !0, this.g.abort(), this.j = !1), An(this, !0)), k.aa.N.call(this);
	}, e.Ea = function() {
		this.s || (this.B || this.u || this.j ? kn(this) : this.bb());
	}, e.bb = function() {
		kn(this);
	};
	function kn(e) {
		if (e.h && o !== void 0 && (!e.v[1] || Mn(e) != 4 || e.Z() != 2)) {
			if (e.u && Mn(e) == 4) We(e.Ea, 0, e);
			else if (He(e, "readystatechange"), Mn(e) == 4) {
				e.h = !1;
				try {
					let o = e.Z();
					a: switch (o) {
						case 200:
						case 201:
						case 202:
						case 204:
						case 206:
						case 304:
						case 1223:
							var t = !0;
							break a;
						default: t = !1;
					}
					var n;
					if (!(n = t)) {
						var r;
						if (r = o === 0) {
							var i = String(e.D).match(Ut)[1] || null;
							!i && s.self && s.self.location && (i = s.self.location.protocol.slice(0, -1)), r = !Tn.test(i ? i.toLowerCase() : "");
						}
						n = r;
					}
					if (n) He(e, "complete"), He(e, "success");
					else {
						e.m = 6;
						try {
							var a = 2 < Mn(e) ? e.g.statusText : "";
						} catch {
							a = "";
						}
						e.l = a + " [" + e.Z() + "]", On(e);
					}
				} finally {
					An(e);
				}
			}
		}
	}
	function An(e, t) {
		if (e.g) {
			jn(e);
			let n = e.g, r = e.v[0] ? () => {} : null;
			e.g = null, e.v = null, t || He(e, "ready");
			try {
				n.onreadystatechange = r;
			} catch {}
		}
	}
	function jn(e) {
		e.I &&= (s.clearTimeout(e.I), null);
	}
	e.isActive = function() {
		return !!this.g;
	};
	function Mn(e) {
		return e.g ? e.g.readyState : 0;
	}
	e.Z = function() {
		try {
			return 2 < Mn(this) ? this.g.status : -1;
		} catch {
			return -1;
		}
	}, e.oa = function() {
		try {
			return this.g ? this.g.responseText : "";
		} catch {
			return "";
		}
	}, e.Oa = function(e) {
		if (this.g) {
			var t = this.g.responseText;
			return e && t.indexOf(e) == 0 && (t = t.substring(e.length)), Xe(t);
		}
	};
	function Nn(e) {
		try {
			if (!e.g) return null;
			if ("response" in e.g) return e.g.response;
			switch (e.H) {
				case "":
				case "text": return e.g.responseText;
				case "arraybuffer": if ("mozResponseArrayBuffer" in e.g) return e.g.mozResponseArrayBuffer;
			}
			return null;
		} catch {
			return null;
		}
	}
	function Pn(e) {
		let t = {};
		e = (e.g && 2 <= Mn(e) && e.g.getAllResponseHeaders() || "").split("\r\n");
		for (let r = 0; r < e.length; r++) {
			if (te(e[r])) continue;
			var n = ce(e[r]);
			let i = n[0];
			if (n = n[1], typeof n != "string") continue;
			n = n.trim();
			let a = t[i] || [];
			t[i] = a, a.push(n);
		}
		ie(t, function(e) {
			return e.join(", ");
		});
	}
	e.Ba = function() {
		return this.m;
	}, e.Ka = function() {
		return typeof this.l == "string" ? this.l : String(this.l);
	};
	function A(e, t, n) {
		return n && n.internalChannelParams && n.internalChannelParams[e] || t;
	}
	function Fn(e) {
		this.Aa = 0, this.i = [], this.j = new D(), this.ia = this.qa = this.I = this.W = this.g = this.ya = this.D = this.H = this.m = this.S = this.o = null, this.Ya = this.U = 0, this.Va = A("failFast", !1, e), this.F = this.C = this.u = this.s = this.l = null, this.X = !0, this.za = this.T = -1, this.Y = this.v = this.B = 0, this.Ta = A("baseRetryDelayMs", 5e3, e), this.cb = A("retryDelaySeedMs", 1e4, e), this.Wa = A("forwardChannelMaxRetries", 2, e), this.wa = A("forwardChannelRequestTimeoutMs", 2e4, e), this.pa = e && e.xmlHttpFactory || void 0, this.Xa = e && e.Tb || void 0, this.Ca = e && e.useFetchStreams || !1, this.L = void 0, this.J = e && e.supportsCrossDomainXhr || !1, this.K = "", this.h = new Nt(e && e.concurrentRequestLimit), this.Da = new gn(), this.P = e && e.fastHandshake || !1, this.O = e && e.encodeInitMessageHeaders || !1, this.P && this.O && (this.O = !1), this.Ua = e && e.Rb || !1, e && e.xa && this.j.xa(), e && e.forceLongPolling && (this.X = !1), this.ba = !this.P && this.X && e && e.detectBufferingProxy || !1, this.ja = void 0, e && e.longPollingTimeout && 0 < e.longPollingTimeout && (this.ja = e.longPollingTimeout), this.ca = void 0, this.R = 0, this.M = !1, this.ka = this.A = null;
	}
	e = Fn.prototype, e.la = 8, e.G = 1, e.connect = function(e, t, n, r) {
		ot(0), this.W = e, this.H = t || {}, n && r !== void 0 && (this.H.OSID = n, this.H.OAID = r), this.F = this.X, this.I = $n(this, null, this.W), zn(this);
	};
	function In(e) {
		if (Rn(e), e.G == 3) {
			var t = e.U++, n = Kt(e.I);
			if (O(n, "SID", e.K), O(n, "RID", t), O(n, "TYPE", "terminate"), Hn(e, n), t = new vt(e, e.j, t), t.L = 2, t.v = Xt(Kt(n)), n = !1, s.navigator && s.navigator.sendBeacon) try {
				n = s.navigator.sendBeacon(t.v.toString(), "");
			} catch {}
			!n && s.Image && (new Image().src = t.v, n = !0), n || (t.g = er(t.j, null), t.g.ea(t.v)), t.F = Date.now(), Et(t);
		}
		Qn(e);
	}
	function Ln(e) {
		e.g &&= (Kn(e), e.g.cancel(), null);
	}
	function Rn(e) {
		Ln(e), e.u &&= (s.clearTimeout(e.u), null), Jn(e), e.h.cancel(), e.s &&= (typeof e.s == "number" && s.clearTimeout(e.s), null);
	}
	function zn(e) {
		if (!Pt(e.h) && !e.s) {
			e.s = !0;
			var t = e.Ga;
			me || _e(), he ||= (me(), !0), ge.add(t, e), e.B = 0;
		}
	}
	function Bn(e, t) {
		return Ft(e.h) >= e.h.j - +!!e.s ? !1 : e.s ? (e.i = t.D.concat(e.i), !0) : e.G == 1 || e.G == 2 || e.B >= (e.Va ? 0 : e.Wa) ? !1 : (e.s = ct(f(e.Ga, e, t), Xn(e, e.B)), e.B++, !0);
	}
	e.Ga = function(e) {
		if (this.s) if (this.s = null, this.G == 1) {
			if (!e) {
				this.U = Math.floor(1e5 * Math.random()), e = this.U++;
				let i = new vt(this, this.j, e), a = this.o;
				if (this.S && (a ? (a = ae(a), se(a, this.S)) : a = this.S), this.m !== null || this.O || (i.H = a, a = null), this.P) a: {
					for (var t = 0, n = 0; n < this.i.length; n++) {
						b: {
							var r = this.i[n];
							if ("__data__" in r.map && (r = r.map.__data__, typeof r == "string")) {
								r = r.length;
								break b;
							}
							r = void 0;
						}
						if (r === void 0) break;
						if (t += r, 4096 < t) {
							t = n;
							break a;
						}
						if (t === 4096 || n === this.i.length - 1) {
							t = n + 1;
							break a;
						}
					}
					t = 1e3;
				}
				else t = 1e3;
				t = Un(this, i, t), n = Kt(this.I), O(n, "RID", e), O(n, "CVER", 22), this.D && O(n, "X-HTTP-Session-Id", this.D), Hn(this, n), a && (this.O ? t = "headers=" + encodeURIComponent(String(Cn(a))) + "&" + t : this.m && wn(n, this.m, a)), Lt(this.h, i), this.Ua && O(n, "TYPE", "init"), this.P ? (O(n, "$req", t), O(n, "SID", "null"), i.T = !0, St(i, n, null)) : St(i, n, t), this.G = 2;
			}
		} else this.G == 3 && (e ? Vn(this, e) : this.i.length == 0 || Pt(this.h) || Vn(this));
	};
	function Vn(e, t) {
		var n = t ? t.l : e.U++;
		let r = Kt(e.I);
		O(r, "SID", e.K), O(r, "RID", n), O(r, "AID", e.T), Hn(e, r), e.m && e.o && wn(r, e.m, e.o), n = new vt(e, e.j, n, e.B + 1), e.m === null && (n.H = e.o), t && (e.i = t.D.concat(e.i)), t = Un(e, n, 1e3), n.I = Math.round(.5 * e.wa) + Math.round(.5 * e.wa * Math.random()), Lt(e.h, n), St(n, r, t);
	}
	function Hn(e, t) {
		e.H && v(e.H, function(e, n) {
			O(t, n, e);
		}), e.l && Ht({}, function(e, n) {
			O(t, n, e);
		});
	}
	function Un(e, t, n) {
		n = Math.min(e.i.length, n);
		var r = e.l ? f(e.l.Na, e.l, e) : null;
		a: {
			var i = e.i;
			let t = -1;
			for (;;) {
				let e = ["count=" + n];
				t == -1 ? 0 < n ? (t = i[0].g, e.push("ofs=" + t)) : t = 0 : e.push("ofs=" + t);
				let a = !0;
				for (let o = 0; o < n; o++) {
					let n = i[o].g, s = i[o].map;
					if (n -= t, 0 > n) t = Math.max(0, i[o].g - 100), a = !1;
					else try {
						_n(s, e, "req" + n + "_");
					} catch {
						r && r(s);
					}
				}
				if (a) {
					r = e.join("&");
					break a;
				}
			}
		}
		return e = e.i.splice(0, n), t.D = e, r;
	}
	function Wn(e) {
		if (!e.g && !e.u) {
			e.Y = 1;
			var t = e.Fa;
			me || _e(), he ||= (me(), !0), ge.add(t, e), e.v = 0;
		}
	}
	function Gn(e) {
		return e.g || e.u || 3 <= e.v ? !1 : (e.Y++, e.u = ct(f(e.Fa, e), Xn(e, e.v)), e.v++, !0);
	}
	e.Fa = function() {
		if (this.u = null, qn(this), this.ba && !(this.M || this.g == null || 0 >= this.R)) {
			var e = 2 * this.R;
			this.j.info("BP detection timer enabled: " + e), this.A = ct(f(this.ab, this), e);
		}
	}, e.ab = function() {
		this.A && (this.A = null, this.j.info("BP detection timeout reached."), this.j.info("Buffering proxy detected and switch to long-polling!"), this.F = !1, this.M = !0, ot(10), Ln(this), qn(this));
	};
	function Kn(e) {
		e.A != null && (s.clearTimeout(e.A), e.A = null);
	}
	function qn(e) {
		e.g = new vt(e, e.j, "rpc", e.Y), e.m === null && (e.g.H = e.o), e.g.O = 0;
		var t = Kt(e.qa);
		O(t, "RID", "rpc"), O(t, "SID", e.K), O(t, "AID", e.T), O(t, "CI", e.F ? "0" : "1"), !e.F && e.ja && O(t, "TO", e.ja), O(t, "TYPE", "xmlhttp"), Hn(e, t), e.m && e.o && wn(t, e.m, e.o), e.L && (e.g.I = e.L);
		var n = e.g;
		e = e.ia, n.L = 1, n.v = Xt(Kt(t)), n.m = null, n.P = !0, Ct(n, e);
	}
	e.Za = function() {
		this.C != null && (this.C = null, Ln(this), Gn(this), ot(19));
	};
	function Jn(e) {
		e.C != null && (s.clearTimeout(e.C), e.C = null);
	}
	function Yn(e, t) {
		var n = null;
		if (e.g == t) {
			Jn(e), Kn(e), e.g = null;
			var r = 2;
		} else if (It(e.h, t)) n = t.D, Rt(e.h, t), r = 1;
		else return;
		if (e.G != 0) {
			if (t.o) if (r == 1) {
				n = t.m ? t.m.length : 0, t = Date.now() - t.F;
				var i = e.B;
				r = T(), He(r, new st(r, n)), zn(e);
			} else Wn(e);
			else if (i = t.s, i == 3 || i == 0 && 0 < t.X || !(r == 1 && Bn(e, t) || r == 2 && Gn(e))) switch (n && 0 < n.length && (t = e.h, t.i = t.i.concat(n)), i) {
				case 1:
					Zn(e, 5);
					break;
				case 4:
					Zn(e, 10);
					break;
				case 3:
					Zn(e, 6);
					break;
				default: Zn(e, 2);
			}
		}
	}
	function Xn(e, t) {
		let n = e.Ta + Math.floor(Math.random() * e.cb);
		return e.isActive() || (n *= 2), n * t;
	}
	function Zn(e, t) {
		if (e.j.info("Error code " + t), t == 2) {
			var n = f(e.fb, e), r = e.Xa;
			let t = !r;
			r = new Gt(r || "//www.google.com/images/cleardot.gif"), s.location && s.location.protocol == "http" || qt(r, "https"), Xt(r), t ? pn(r.toString(), n) : mn(r.toString(), n);
		} else ot(2);
		e.G = 0, e.l && e.l.sa(t), Qn(e), Rn(e);
	}
	e.fb = function(e) {
		e ? (this.j.info("Successfully pinged google.com"), ot(2)) : (this.j.info("Failed to ping google.com"), ot(1));
	};
	function Qn(e) {
		if (e.G = 0, e.ka = [], e.l) {
			let t = zt(e.h);
			(t.length != 0 || e.i.length != 0) && (g(e.ka, t), g(e.ka, e.i), e.h.i.length = 0, h(e.i), e.i.length = 0), e.l.ra();
		}
	}
	function $n(e, t, n) {
		var r = n instanceof Gt ? Kt(n) : new Gt(n);
		if (r.g != "") t && (r.g = t + "." + r.g), Jt(r, r.s);
		else {
			var i = s.location;
			r = i.protocol, t = t ? t + "." + i.hostname : i.hostname, i = +i.port;
			var a = new Gt(null);
			r && qt(a, r), t && (a.g = t), i && Jt(a, i), n && (a.l = n), r = a;
		}
		return n = e.D, t = e.ya, n && t && O(r, n, t), O(r, "VER", e.la), Hn(e, r), r;
	}
	function er(e, t, n) {
		if (t && !e.J) throw Error("Can't create secondary domain capable XhrIo object.");
		return t = e.Ca && !e.pa ? new k(new vn({ eb: n })) : new k(e.pa), t.Ha(e.J), t;
	}
	e.isActive = function() {
		return !!this.l && this.l.isActive(this);
	};
	function tr() {}
	e = tr.prototype, e.ua = function() {}, e.ta = function() {}, e.sa = function() {}, e.ra = function() {}, e.isActive = function() {
		return !0;
	}, e.Na = function() {};
	function nr() {}
	nr.prototype.g = function(e, t) {
		return new rr(e, t);
	};
	function rr(e, t) {
		x.call(this), this.g = new Fn(t), this.l = e, this.h = t && t.messageUrlParams || null, e = t && t.messageHeaders || null, t && t.clientProtocolHeaderRequired && (e ? e["X-Client-Protocol"] = "webchannel" : e = { "X-Client-Protocol": "webchannel" }), this.g.o = e, e = t && t.initMessageHeaders || null, t && t.messageContentType && (e ? e["X-WebChannel-Content-Type"] = t.messageContentType : e = { "X-WebChannel-Content-Type": t.messageContentType }), t && t.va && (e ? e["X-WebChannel-Client-Profile"] = t.va : e = { "X-WebChannel-Client-Profile": t.va }), this.g.S = e, (e = t && t.Sb) && !te(e) && (this.g.m = e), this.v = t && t.supportsCrossDomainXhr || !1, this.u = t && t.sendRawJson || !1, (t &&= t.httpSessionIdParam) && !te(t) && (this.g.D = t, e = this.h, e !== null && t in e && (e = this.h, t in e && delete e[t])), this.j = new ar(this);
	}
	m(rr, x), rr.prototype.m = function() {
		this.g.l = this.j, this.v && (this.g.J = !0), this.g.connect(this.l, this.h || void 0);
	}, rr.prototype.close = function() {
		In(this.g);
	}, rr.prototype.o = function(e) {
		var t = this.g;
		if (typeof e == "string") {
			var n = {};
			n.__data__ = e, e = n;
		} else this.u && (n = {}, n.__data__ = Ye(e), e = n);
		t.i.push(new Mt(t.Ya++, e)), t.G == 3 && zn(t);
	}, rr.prototype.N = function() {
		this.g.l = null, delete this.j, In(this.g), delete this.g, rr.aa.N.call(this);
	};
	function ir(e) {
		C.call(this), e.__headers__ && (this.headers = e.__headers__, this.statusCode = e.__status__, delete e.__headers__, delete e.__status__);
		var t = e.__sm__;
		if (t) {
			a: {
				for (let n in t) {
					e = n;
					break a;
				}
				e = void 0;
			}
			(this.i = e) && (e = this.i, t = t !== null && e in t ? t[e] : void 0), this.data = t;
		} else this.data = e;
	}
	m(ir, C);
	function j() {
		nt.call(this), this.status = 1;
	}
	m(j, nt);
	function ar(e) {
		this.g = e;
	}
	m(ar, tr), ar.prototype.ua = function() {
		He(this.g, "a");
	}, ar.prototype.ta = function(e) {
		He(this.g, new ir(e));
	}, ar.prototype.sa = function(e) {
		He(this.g, new j());
	}, ar.prototype.ra = function() {
		He(this.g, "b");
	}, nr.prototype.createWebChannel = nr.prototype.g, rr.prototype.send = rr.prototype.o, rr.prototype.open = rr.prototype.m, rr.prototype.close = rr.prototype.close, ca = ea.createWebChannelTransport = function() {
		return new nr();
	}, sa = ea.getStatEventTarget = function() {
		return T();
	}, oa = ea.Event = rt, aa = ea.Stat = {
		mb: 0,
		pb: 1,
		qb: 2,
		Jb: 3,
		Ob: 4,
		Lb: 5,
		Mb: 6,
		Kb: 7,
		Ib: 8,
		Nb: 9,
		PROXY: 10,
		NOPROXY: 11,
		Gb: 12,
		Cb: 13,
		Db: 14,
		Bb: 15,
		Eb: 16,
		Fb: 17,
		ib: 18,
		hb: 19,
		jb: 20
	}, mt.NO_ERROR = 0, mt.TIMEOUT = 8, mt.HTTP_ERROR = 6, ia = ea.ErrorCode = mt, ht.COMPLETE = "complete", ra = ea.EventType = ht, et.EventType = tt, tt.OPEN = "a", tt.CLOSE = "b", tt.ERROR = "c", tt.MESSAGE = "d", x.prototype.listen = x.prototype.K, na = ea.WebChannel = et, ea.FetchXmlHttpFactory = vn, k.prototype.listenOnce = k.prototype.L, k.prototype.getLastError = k.prototype.Ka, k.prototype.getLastErrorCode = k.prototype.Ba, k.prototype.getStatus = k.prototype.Z, k.prototype.getResponseJson = k.prototype.Oa, k.prototype.getResponseText = k.prototype.oa, k.prototype.send = k.prototype.ea, k.prototype.setWithCredentials = k.prototype.Ha, ta = ea.XhrIo = k;
}).apply($i === void 0 ? typeof self < "u" ? self : typeof window < "u" ? window : {} : $i);
//#endregion
//#region ../node_modules/@firebase/firestore/dist/index.esm2017.js
var la = "@firebase/firestore", ua = class {
	constructor(e) {
		this.uid = e;
	}
	isAuthenticated() {
		return this.uid != null;
	}
	toKey() {
		return this.isAuthenticated() ? "uid:" + this.uid : "anonymous-user";
	}
	isEqual(e) {
		return e.uid === this.uid;
	}
};
ua.UNAUTHENTICATED = new ua(null), ua.GOOGLE_CREDENTIALS = new ua("google-credentials-uid"), ua.FIRST_PARTY = new ua("first-party-uid"), ua.MOCK_USER = new ua("mock-user");
var da = "11.0.0", fa = new gr("@firebase/firestore");
function pa() {
	return fa.logLevel;
}
function N(e, ...t) {
	if (fa.logLevel <= M.DEBUG) {
		let n = t.map(ga);
		fa.debug(`Firestore (${da}): ${e}`, ...n);
	}
}
function ma(e, ...t) {
	if (fa.logLevel <= M.ERROR) {
		let n = t.map(ga);
		fa.error(`Firestore (${da}): ${e}`, ...n);
	}
}
function ha(e, ...t) {
	if (fa.logLevel <= M.WARN) {
		let n = t.map(ga);
		fa.warn(`Firestore (${da}): ${e}`, ...n);
	}
}
function ga(e) {
	if (typeof e == "string") return e;
	try {
		return function(e) {
			return JSON.stringify(e);
		}(e);
	} catch {
		return e;
	}
}
function P(e = "Unexpected state") {
	let t = `FIRESTORE (${da}) INTERNAL ASSERTION FAILED: ` + e;
	throw ma(t), Error(t);
}
function F(e, t) {
	e || P();
}
function I(e, t) {
	return e;
}
var L = {
	OK: "ok",
	CANCELLED: "cancelled",
	UNKNOWN: "unknown",
	INVALID_ARGUMENT: "invalid-argument",
	DEADLINE_EXCEEDED: "deadline-exceeded",
	NOT_FOUND: "not-found",
	ALREADY_EXISTS: "already-exists",
	PERMISSION_DENIED: "permission-denied",
	UNAUTHENTICATED: "unauthenticated",
	RESOURCE_EXHAUSTED: "resource-exhausted",
	FAILED_PRECONDITION: "failed-precondition",
	ABORTED: "aborted",
	OUT_OF_RANGE: "out-of-range",
	UNIMPLEMENTED: "unimplemented",
	INTERNAL: "internal",
	UNAVAILABLE: "unavailable",
	DATA_LOSS: "data-loss"
}, R = class extends Gn {
	constructor(e, t) {
		super(e, t), this.code = e, this.message = t, this.toString = () => `${this.name}: [code=${this.code}]: ${this.message}`;
	}
}, _a = class {
	constructor() {
		this.promise = new Promise(((e, t) => {
			this.resolve = e, this.reject = t;
		}));
	}
}, va = class {
	constructor(e, t) {
		this.user = t, this.type = "OAuth", this.headers = /* @__PURE__ */ new Map(), this.headers.set("Authorization", `Bearer ${e}`);
	}
}, ya = class {
	getToken() {
		return Promise.resolve(null);
	}
	invalidateToken() {}
	start(e, t) {
		e.enqueueRetryable((() => t(ua.UNAUTHENTICATED)));
	}
	shutdown() {}
}, ba = class {
	constructor(e) {
		this.token = e, this.changeListener = null;
	}
	getToken() {
		return Promise.resolve(this.token);
	}
	invalidateToken() {}
	start(e, t) {
		this.changeListener = t, e.enqueueRetryable((() => t(this.token.user)));
	}
	shutdown() {
		this.changeListener = null;
	}
}, xa = class {
	constructor(e) {
		this.t = e, this.currentUser = ua.UNAUTHENTICATED, this.i = 0, this.forceRefresh = !1, this.auth = null;
	}
	start(e, t) {
		F(this.o === void 0);
		let n = this.i, r = (e) => this.i === n ? Promise.resolve() : (n = this.i, t(e)), i = new _a();
		this.o = () => {
			this.i++, this.currentUser = this.u(), i.resolve(), i = new _a(), e.enqueueRetryable((() => r(this.currentUser)));
		};
		let a = () => {
			let t = i;
			e.enqueueRetryable((async () => {
				await t.promise, await r(this.currentUser);
			}));
		}, o = (e) => {
			N("FirebaseAuthCredentialsProvider", "Auth detected"), this.auth = e, this.o && (this.auth.addAuthTokenListener(this.o), a());
		};
		this.t.onInit(((e) => o(e))), setTimeout((() => {
			if (!this.auth) {
				let e = this.t.getImmediate({ optional: !0 });
				e ? o(e) : (N("FirebaseAuthCredentialsProvider", "Auth not yet detected"), i.resolve(), i = new _a());
			}
		}), 0), a();
	}
	getToken() {
		let e = this.i, t = this.forceRefresh;
		return this.forceRefresh = !1, this.auth ? this.auth.getToken(t).then(((t) => this.i === e ? t ? (F(typeof t.accessToken == "string"), new va(t.accessToken, this.currentUser)) : null : (N("FirebaseAuthCredentialsProvider", "getToken aborted due to token change."), this.getToken()))) : Promise.resolve(null);
	}
	invalidateToken() {
		this.forceRefresh = !0;
	}
	shutdown() {
		this.auth && this.o && this.auth.removeAuthTokenListener(this.o), this.o = void 0;
	}
	u() {
		let e = this.auth && this.auth.getUid();
		return F(e === null || typeof e == "string"), new ua(e);
	}
}, Sa = class {
	constructor(e, t, n) {
		this.l = e, this.h = t, this.P = n, this.type = "FirstParty", this.user = ua.FIRST_PARTY, this.I = /* @__PURE__ */ new Map();
	}
	T() {
		return this.P ? this.P() : null;
	}
	get headers() {
		this.I.set("X-Goog-AuthUser", this.l);
		let e = this.T();
		return e && this.I.set("Authorization", e), this.h && this.I.set("X-Goog-Iam-Authorization-Token", this.h), this.I;
	}
}, Ca = class {
	constructor(e, t, n) {
		this.l = e, this.h = t, this.P = n;
	}
	getToken() {
		return Promise.resolve(new Sa(this.l, this.h, this.P));
	}
	start(e, t) {
		e.enqueueRetryable((() => t(ua.FIRST_PARTY)));
	}
	shutdown() {}
	invalidateToken() {}
}, wa = class {
	constructor(e) {
		this.value = e, this.type = "AppCheck", this.headers = /* @__PURE__ */ new Map(), e && e.length > 0 && this.headers.set("x-firebase-appcheck", this.value);
	}
}, Ta = class {
	constructor(e) {
		this.A = e, this.forceRefresh = !1, this.appCheck = null, this.R = null;
	}
	start(e, t) {
		F(this.o === void 0);
		let n = (e) => {
			e.error != null && N("FirebaseAppCheckTokenProvider", `Error getting App Check token; using placeholder token instead. Error: ${e.error.message}`);
			let n = e.token !== this.R;
			return this.R = e.token, N("FirebaseAppCheckTokenProvider", `Received ${n ? "new" : "existing"} token.`), n ? t(e.token) : Promise.resolve();
		};
		this.o = (t) => {
			e.enqueueRetryable((() => n(t)));
		};
		let r = (e) => {
			N("FirebaseAppCheckTokenProvider", "AppCheck detected"), this.appCheck = e, this.o && this.appCheck.addTokenListener(this.o);
		};
		this.A.onInit(((e) => r(e))), setTimeout((() => {
			if (!this.appCheck) {
				let e = this.A.getImmediate({ optional: !0 });
				e ? r(e) : N("FirebaseAppCheckTokenProvider", "AppCheck not yet detected");
			}
		}), 0);
	}
	getToken() {
		let e = this.forceRefresh;
		return this.forceRefresh = !1, this.appCheck ? this.appCheck.getToken(e).then(((e) => e ? (F(typeof e.token == "string"), this.R = e.token, new wa(e.token)) : null)) : Promise.resolve(null);
	}
	invalidateToken() {
		this.forceRefresh = !0;
	}
	shutdown() {
		this.appCheck && this.o && this.appCheck.removeTokenListener(this.o), this.o = void 0;
	}
};
function Ea(e) {
	let t = typeof self < "u" && (self.crypto || self.msCrypto), n = new Uint8Array(e);
	if (t && typeof t.getRandomValues == "function") t.getRandomValues(n);
	else for (let t = 0; t < e; t++) n[t] = Math.floor(256 * Math.random());
	return n;
}
var Da = class {
	static newId() {
		let e = "";
		for (; e.length < 20;) {
			let t = Ea(40);
			for (let n = 0; n < t.length; ++n) e.length < 20 && t[n] < 248 && (e += "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789".charAt(t[n] % 62));
		}
		return e;
	}
};
function z(e, t) {
	return e < t ? -1 : +(e > t);
}
function Oa(e, t, n) {
	return e.length === t.length && e.every(((e, r) => n(e, t[r])));
}
var ka = class e {
	constructor(e, t) {
		if (this.seconds = e, this.nanoseconds = t, t < 0 || t >= 1e9) throw new R(L.INVALID_ARGUMENT, "Timestamp nanoseconds out of range: " + t);
		if (e < -62135596800 || e >= 253402300800) throw new R(L.INVALID_ARGUMENT, "Timestamp seconds out of range: " + e);
	}
	static now() {
		return e.fromMillis(Date.now());
	}
	static fromDate(t) {
		return e.fromMillis(t.getTime());
	}
	static fromMillis(t) {
		let n = Math.floor(t / 1e3);
		return new e(n, Math.floor(1e6 * (t - 1e3 * n)));
	}
	toDate() {
		return new Date(this.toMillis());
	}
	toMillis() {
		return 1e3 * this.seconds + this.nanoseconds / 1e6;
	}
	_compareTo(e) {
		return this.seconds === e.seconds ? z(this.nanoseconds, e.nanoseconds) : z(this.seconds, e.seconds);
	}
	isEqual(e) {
		return e.seconds === this.seconds && e.nanoseconds === this.nanoseconds;
	}
	toString() {
		return "Timestamp(seconds=" + this.seconds + ", nanoseconds=" + this.nanoseconds + ")";
	}
	toJSON() {
		return {
			seconds: this.seconds,
			nanoseconds: this.nanoseconds
		};
	}
	valueOf() {
		let e = this.seconds - -62135596800;
		return String(e).padStart(12, "0") + "." + String(this.nanoseconds).padStart(9, "0");
	}
}, B = class e {
	constructor(e) {
		this.timestamp = e;
	}
	static fromTimestamp(t) {
		return new e(t);
	}
	static min() {
		return new e(new ka(0, 0));
	}
	static max() {
		return new e(new ka(253402300799, 999999999));
	}
	compareTo(e) {
		return this.timestamp._compareTo(e.timestamp);
	}
	isEqual(e) {
		return this.timestamp.isEqual(e.timestamp);
	}
	toMicroseconds() {
		return 1e6 * this.timestamp.seconds + this.timestamp.nanoseconds / 1e3;
	}
	toString() {
		return "SnapshotVersion(" + this.timestamp.toString() + ")";
	}
	toTimestamp() {
		return this.timestamp;
	}
}, Aa = class e {
	constructor(e, t, n) {
		t === void 0 ? t = 0 : t > e.length && P(), n === void 0 ? n = e.length - t : n > e.length - t && P(), this.segments = e, this.offset = t, this.len = n;
	}
	get length() {
		return this.len;
	}
	isEqual(t) {
		return e.comparator(this, t) === 0;
	}
	child(t) {
		let n = this.segments.slice(this.offset, this.limit());
		return t instanceof e ? t.forEach(((e) => {
			n.push(e);
		})) : n.push(t), this.construct(n);
	}
	limit() {
		return this.offset + this.length;
	}
	popFirst(e) {
		return e = e === void 0 ? 1 : e, this.construct(this.segments, this.offset + e, this.length - e);
	}
	popLast() {
		return this.construct(this.segments, this.offset, this.length - 1);
	}
	firstSegment() {
		return this.segments[this.offset];
	}
	lastSegment() {
		return this.get(this.length - 1);
	}
	get(e) {
		return this.segments[this.offset + e];
	}
	isEmpty() {
		return this.length === 0;
	}
	isPrefixOf(e) {
		if (e.length < this.length) return !1;
		for (let t = 0; t < this.length; t++) if (this.get(t) !== e.get(t)) return !1;
		return !0;
	}
	isImmediateParentOf(e) {
		if (this.length + 1 !== e.length) return !1;
		for (let t = 0; t < this.length; t++) if (this.get(t) !== e.get(t)) return !1;
		return !0;
	}
	forEach(e) {
		for (let t = this.offset, n = this.limit(); t < n; t++) e(this.segments[t]);
	}
	toArray() {
		return this.segments.slice(this.offset, this.limit());
	}
	static comparator(e, t) {
		let n = Math.min(e.length, t.length);
		for (let r = 0; r < n; r++) {
			let n = e.get(r), i = t.get(r);
			if (n < i) return -1;
			if (n > i) return 1;
		}
		return e.length < t.length ? -1 : +(e.length > t.length);
	}
}, V = class e extends Aa {
	construct(t, n, r) {
		return new e(t, n, r);
	}
	canonicalString() {
		return this.toArray().join("/");
	}
	toString() {
		return this.canonicalString();
	}
	toUriEncodedString() {
		return this.toArray().map(encodeURIComponent).join("/");
	}
	static fromString(...t) {
		let n = [];
		for (let e of t) {
			if (e.indexOf("//") >= 0) throw new R(L.INVALID_ARGUMENT, `Invalid segment (${e}). Paths must not contain // in them.`);
			n.push(...e.split("/").filter(((e) => e.length > 0)));
		}
		return new e(n);
	}
	static emptyPath() {
		return new e([]);
	}
}, ja = /^[_a-zA-Z][_a-zA-Z0-9]*$/, Ma = class e extends Aa {
	construct(t, n, r) {
		return new e(t, n, r);
	}
	static isValidIdentifier(e) {
		return ja.test(e);
	}
	canonicalString() {
		return this.toArray().map(((t) => (t = t.replace(/\\/g, "\\\\").replace(/`/g, "\\`"), e.isValidIdentifier(t) || (t = "`" + t + "`"), t))).join(".");
	}
	toString() {
		return this.canonicalString();
	}
	isKeyField() {
		return this.length === 1 && this.get(0) === "__name__";
	}
	static keyField() {
		return new e(["__name__"]);
	}
	static fromServerFormat(t) {
		let n = [], r = "", i = 0, a = () => {
			if (r.length === 0) throw new R(L.INVALID_ARGUMENT, `Invalid field path (${t}). Paths must not be empty, begin with '.', end with '.', or contain '..'`);
			n.push(r), r = "";
		}, o = !1;
		for (; i < t.length;) {
			let e = t[i];
			if (e === "\\") {
				if (i + 1 === t.length) throw new R(L.INVALID_ARGUMENT, "Path has trailing escape character: " + t);
				let e = t[i + 1];
				if (e !== "\\" && e !== "." && e !== "`") throw new R(L.INVALID_ARGUMENT, "Path has invalid escape sequence: " + t);
				r += e, i += 2;
			} else e === "`" ? (o = !o, i++) : e !== "." || o ? (r += e, i++) : (a(), i++);
		}
		if (a(), o) throw new R(L.INVALID_ARGUMENT, "Unterminated ` in path: " + t);
		return new e(n);
	}
	static emptyPath() {
		return new e([]);
	}
}, H = class e {
	constructor(e) {
		this.path = e;
	}
	static fromPath(t) {
		return new e(V.fromString(t));
	}
	static fromName(t) {
		return new e(V.fromString(t).popFirst(5));
	}
	static empty() {
		return new e(V.emptyPath());
	}
	get collectionGroup() {
		return this.path.popLast().lastSegment();
	}
	hasCollectionId(e) {
		return this.path.length >= 2 && this.path.get(this.path.length - 2) === e;
	}
	getCollectionGroup() {
		return this.path.get(this.path.length - 2);
	}
	getCollectionPath() {
		return this.path.popLast();
	}
	isEqual(e) {
		return e !== null && V.comparator(this.path, e.path) === 0;
	}
	toString() {
		return this.path.toString();
	}
	static comparator(e, t) {
		return V.comparator(e.path, t.path);
	}
	static isDocumentKey(e) {
		return e.length % 2 == 0;
	}
	static fromSegments(t) {
		return new e(new V(t.slice()));
	}
}, Na = class {
	constructor(e, t, n, r) {
		this.indexId = e, this.collectionGroup = t, this.fields = n, this.indexState = r;
	}
};
Na.UNKNOWN_ID = -1;
function Pa(e, t) {
	let n = e.toTimestamp().seconds, r = e.toTimestamp().nanoseconds + 1;
	return new Ia(B.fromTimestamp(r === 1e9 ? new ka(n + 1, 0) : new ka(n, r)), H.empty(), t);
}
function Fa(e) {
	return new Ia(e.readTime, e.key, -1);
}
var Ia = class e {
	constructor(e, t, n) {
		this.readTime = e, this.documentKey = t, this.largestBatchId = n;
	}
	static min() {
		return new e(B.min(), H.empty(), -1);
	}
	static max() {
		return new e(B.max(), H.empty(), -1);
	}
};
function La(e, t) {
	let n = e.readTime.compareTo(t.readTime);
	return n === 0 ? (n = H.comparator(e.documentKey, t.documentKey), n === 0 ? z(e.largestBatchId, t.largestBatchId) : n) : n;
}
var Ra = "The current tab is not in the required state to perform this operation. It might be necessary to refresh the browser tab.", za = class {
	constructor() {
		this.onCommittedListeners = [];
	}
	addOnCommittedListener(e) {
		this.onCommittedListeners.push(e);
	}
	raiseOnCommittedEvent() {
		this.onCommittedListeners.forEach(((e) => e()));
	}
};
async function Ba(e) {
	if (e.code !== L.FAILED_PRECONDITION || e.message !== Ra) throw e;
	N("LocalStore", "Unexpectedly lost primary lease");
}
var U = class e {
	constructor(e) {
		this.nextCallback = null, this.catchCallback = null, this.result = void 0, this.error = void 0, this.isDone = !1, this.callbackAttached = !1, e(((e) => {
			this.isDone = !0, this.result = e, this.nextCallback && this.nextCallback(e);
		}), ((e) => {
			this.isDone = !0, this.error = e, this.catchCallback && this.catchCallback(e);
		}));
	}
	catch(e) {
		return this.next(void 0, e);
	}
	next(t, n) {
		return this.callbackAttached && P(), this.callbackAttached = !0, this.isDone ? this.error ? this.wrapFailure(n, this.error) : this.wrapSuccess(t, this.result) : new e(((e, r) => {
			this.nextCallback = (n) => {
				this.wrapSuccess(t, n).next(e, r);
			}, this.catchCallback = (t) => {
				this.wrapFailure(n, t).next(e, r);
			};
		}));
	}
	toPromise() {
		return new Promise(((e, t) => {
			this.next(e, t);
		}));
	}
	wrapUserFunction(t) {
		try {
			let n = t();
			return n instanceof e ? n : e.resolve(n);
		} catch (t) {
			return e.reject(t);
		}
	}
	wrapSuccess(t, n) {
		return t ? this.wrapUserFunction((() => t(n))) : e.resolve(n);
	}
	wrapFailure(t, n) {
		return t ? this.wrapUserFunction((() => t(n))) : e.reject(n);
	}
	static resolve(t) {
		return new e(((e, n) => {
			e(t);
		}));
	}
	static reject(t) {
		return new e(((e, n) => {
			n(t);
		}));
	}
	static waitFor(t) {
		return new e(((e, n) => {
			let r = 0, i = 0, a = !1;
			t.forEach(((t) => {
				++r, t.next((() => {
					++i, a && i === r && e();
				}), ((e) => n(e)));
			})), a = !0, i === r && e();
		}));
	}
	static or(t) {
		let n = e.resolve(!1);
		for (let r of t) n = n.next(((t) => t ? e.resolve(t) : r()));
		return n;
	}
	static forEach(e, t) {
		let n = [];
		return e.forEach(((e, r) => {
			n.push(t.call(this, e, r));
		})), this.waitFor(n);
	}
	static mapArray(t, n) {
		return new e(((e, r) => {
			let i = t.length, a = Array(i), o = 0;
			for (let s = 0; s < i; s++) {
				let c = s;
				n(t[c]).next(((t) => {
					a[c] = t, ++o, o === i && e(a);
				}), ((e) => r(e)));
			}
		}));
	}
	static doWhile(t, n) {
		return new e(((e, r) => {
			let i = () => {
				!0 === t() ? n().next((() => {
					i();
				}), r) : e();
			};
			i();
		}));
	}
};
function Va(e) {
	let t = e.match(/Android ([\d.]+)/i), n = t ? t[1].split(".").slice(0, 2).join(".") : "-1";
	return Number(n);
}
function Ha(e) {
	return e.name === "IndexedDbTransactionError";
}
var Ua = class {
	constructor(e, t) {
		this.previousValue = e, t && (t.sequenceNumberHandler = (e) => this.ie(e), this.se = (e) => t.writeSequenceNumber(e));
	}
	ie(e) {
		return this.previousValue = Math.max(e, this.previousValue), this.previousValue;
	}
	next() {
		let e = ++this.previousValue;
		return this.se && this.se(e), e;
	}
};
Ua.oe = -1;
function Wa(e) {
	return e == null;
}
function Ga(e) {
	return e === 0 && 1 / e == -Infinity;
}
function Ka(e) {
	return typeof e == "number" && Number.isInteger(e) && !Ga(e) && e <= 2 ** 53 - 1 && e >= -(2 ** 53 - 1);
}
function qa(e) {
	let t = "";
	for (let n = 0; n < e.length; n++) t.length > 0 && (t = Ya(t)), t = Ja(e.get(n), t);
	return Ya(t);
}
function Ja(e, t) {
	let n = t, r = e.length;
	for (let t = 0; t < r; t++) {
		let r = e.charAt(t);
		switch (r) {
			case "\0":
				n += "";
				break;
			case "":
				n += "";
				break;
			default: n += r;
		}
	}
	return n;
}
function Ya(e) {
	return e + "";
}
function Xa(e) {
	let t = 0;
	for (let n in e) Object.prototype.hasOwnProperty.call(e, n) && t++;
	return t;
}
function Za(e, t) {
	for (let n in e) Object.prototype.hasOwnProperty.call(e, n) && t(n, e[n]);
}
function Qa(e) {
	for (let t in e) if (Object.prototype.hasOwnProperty.call(e, t)) return !1;
	return !0;
}
var W = class e {
	constructor(e, t) {
		this.comparator = e, this.root = t || eo.EMPTY;
	}
	insert(t, n) {
		return new e(this.comparator, this.root.insert(t, n, this.comparator).copy(null, null, eo.BLACK, null, null));
	}
	remove(t) {
		return new e(this.comparator, this.root.remove(t, this.comparator).copy(null, null, eo.BLACK, null, null));
	}
	get(e) {
		let t = this.root;
		for (; !t.isEmpty();) {
			let n = this.comparator(e, t.key);
			if (n === 0) return t.value;
			n < 0 ? t = t.left : n > 0 && (t = t.right);
		}
		return null;
	}
	indexOf(e) {
		let t = 0, n = this.root;
		for (; !n.isEmpty();) {
			let r = this.comparator(e, n.key);
			if (r === 0) return t + n.left.size;
			r < 0 ? n = n.left : (t += n.left.size + 1, n = n.right);
		}
		return -1;
	}
	isEmpty() {
		return this.root.isEmpty();
	}
	get size() {
		return this.root.size;
	}
	minKey() {
		return this.root.minKey();
	}
	maxKey() {
		return this.root.maxKey();
	}
	inorderTraversal(e) {
		return this.root.inorderTraversal(e);
	}
	forEach(e) {
		this.inorderTraversal(((t, n) => (e(t, n), !1)));
	}
	toString() {
		let e = [];
		return this.inorderTraversal(((t, n) => (e.push(`${t}:${n}`), !1))), `{${e.join(", ")}}`;
	}
	reverseTraversal(e) {
		return this.root.reverseTraversal(e);
	}
	getIterator() {
		return new $a(this.root, null, this.comparator, !1);
	}
	getIteratorFrom(e) {
		return new $a(this.root, e, this.comparator, !1);
	}
	getReverseIterator() {
		return new $a(this.root, null, this.comparator, !0);
	}
	getReverseIteratorFrom(e) {
		return new $a(this.root, e, this.comparator, !0);
	}
}, $a = class {
	constructor(e, t, n, r) {
		this.isReverse = r, this.nodeStack = [];
		let i = 1;
		for (; !e.isEmpty();) if (i = t ? n(e.key, t) : 1, t && r && (i *= -1), i < 0) e = this.isReverse ? e.left : e.right;
		else {
			if (i === 0) {
				this.nodeStack.push(e);
				break;
			}
			this.nodeStack.push(e), e = this.isReverse ? e.right : e.left;
		}
	}
	getNext() {
		let e = this.nodeStack.pop(), t = {
			key: e.key,
			value: e.value
		};
		if (this.isReverse) for (e = e.left; !e.isEmpty();) this.nodeStack.push(e), e = e.right;
		else for (e = e.right; !e.isEmpty();) this.nodeStack.push(e), e = e.left;
		return t;
	}
	hasNext() {
		return this.nodeStack.length > 0;
	}
	peek() {
		if (this.nodeStack.length === 0) return null;
		let e = this.nodeStack[this.nodeStack.length - 1];
		return {
			key: e.key,
			value: e.value
		};
	}
}, eo = class e {
	constructor(t, n, r, i, a) {
		this.key = t, this.value = n, this.color = r ?? e.RED, this.left = i ?? e.EMPTY, this.right = a ?? e.EMPTY, this.size = this.left.size + 1 + this.right.size;
	}
	copy(t, n, r, i, a) {
		return new e(t ?? this.key, n ?? this.value, r ?? this.color, i ?? this.left, a ?? this.right);
	}
	isEmpty() {
		return !1;
	}
	inorderTraversal(e) {
		return this.left.inorderTraversal(e) || e(this.key, this.value) || this.right.inorderTraversal(e);
	}
	reverseTraversal(e) {
		return this.right.reverseTraversal(e) || e(this.key, this.value) || this.left.reverseTraversal(e);
	}
	min() {
		return this.left.isEmpty() ? this : this.left.min();
	}
	minKey() {
		return this.min().key;
	}
	maxKey() {
		return this.right.isEmpty() ? this.key : this.right.maxKey();
	}
	insert(e, t, n) {
		let r = this, i = n(e, r.key);
		return r = i < 0 ? r.copy(null, null, null, r.left.insert(e, t, n), null) : i === 0 ? r.copy(null, t, null, null, null) : r.copy(null, null, null, null, r.right.insert(e, t, n)), r.fixUp();
	}
	removeMin() {
		if (this.left.isEmpty()) return e.EMPTY;
		let t = this;
		return t.left.isRed() || t.left.left.isRed() || (t = t.moveRedLeft()), t = t.copy(null, null, null, t.left.removeMin(), null), t.fixUp();
	}
	remove(t, n) {
		let r, i = this;
		if (n(t, i.key) < 0) i.left.isEmpty() || i.left.isRed() || i.left.left.isRed() || (i = i.moveRedLeft()), i = i.copy(null, null, null, i.left.remove(t, n), null);
		else {
			if (i.left.isRed() && (i = i.rotateRight()), i.right.isEmpty() || i.right.isRed() || i.right.left.isRed() || (i = i.moveRedRight()), n(t, i.key) === 0) {
				if (i.right.isEmpty()) return e.EMPTY;
				r = i.right.min(), i = i.copy(r.key, r.value, null, null, i.right.removeMin());
			}
			i = i.copy(null, null, null, null, i.right.remove(t, n));
		}
		return i.fixUp();
	}
	isRed() {
		return this.color;
	}
	fixUp() {
		let e = this;
		return e.right.isRed() && !e.left.isRed() && (e = e.rotateLeft()), e.left.isRed() && e.left.left.isRed() && (e = e.rotateRight()), e.left.isRed() && e.right.isRed() && (e = e.colorFlip()), e;
	}
	moveRedLeft() {
		let e = this.colorFlip();
		return e.right.left.isRed() && (e = e.copy(null, null, null, null, e.right.rotateRight()), e = e.rotateLeft(), e = e.colorFlip()), e;
	}
	moveRedRight() {
		let e = this.colorFlip();
		return e.left.left.isRed() && (e = e.rotateRight(), e = e.colorFlip()), e;
	}
	rotateLeft() {
		let t = this.copy(null, null, e.RED, null, this.right.left);
		return this.right.copy(null, null, this.color, t, null);
	}
	rotateRight() {
		let t = this.copy(null, null, e.RED, this.left.right, null);
		return this.left.copy(null, null, this.color, null, t);
	}
	colorFlip() {
		let e = this.left.copy(null, null, !this.left.color, null, null), t = this.right.copy(null, null, !this.right.color, null, null);
		return this.copy(null, null, !this.color, e, t);
	}
	checkMaxDepth() {
		return 2 ** this.check() <= this.size + 1;
	}
	check() {
		if (this.isRed() && this.left.isRed() || this.right.isRed()) throw P();
		let e = this.left.check();
		if (e !== this.right.check()) throw P();
		return e + +!this.isRed();
	}
};
eo.EMPTY = null, eo.RED = !0, eo.BLACK = !1, eo.EMPTY = new class {
	constructor() {
		this.size = 0;
	}
	get key() {
		throw P();
	}
	get value() {
		throw P();
	}
	get color() {
		throw P();
	}
	get left() {
		throw P();
	}
	get right() {
		throw P();
	}
	copy(e, t, n, r, i) {
		return this;
	}
	insert(e, t, n) {
		return new eo(e, t);
	}
	remove(e, t) {
		return this;
	}
	isEmpty() {
		return !0;
	}
	inorderTraversal(e) {
		return !1;
	}
	reverseTraversal(e) {
		return !1;
	}
	minKey() {
		return null;
	}
	maxKey() {
		return null;
	}
	isRed() {
		return !1;
	}
	checkMaxDepth() {
		return !0;
	}
	check() {
		return 0;
	}
}();
var to = class e {
	constructor(e) {
		this.comparator = e, this.data = new W(this.comparator);
	}
	has(e) {
		return this.data.get(e) !== null;
	}
	first() {
		return this.data.minKey();
	}
	last() {
		return this.data.maxKey();
	}
	get size() {
		return this.data.size;
	}
	indexOf(e) {
		return this.data.indexOf(e);
	}
	forEach(e) {
		this.data.inorderTraversal(((t, n) => (e(t), !1)));
	}
	forEachInRange(e, t) {
		let n = this.data.getIteratorFrom(e[0]);
		for (; n.hasNext();) {
			let r = n.getNext();
			if (this.comparator(r.key, e[1]) >= 0) return;
			t(r.key);
		}
	}
	forEachWhile(e, t) {
		let n;
		for (n = t === void 0 ? this.data.getIterator() : this.data.getIteratorFrom(t); n.hasNext();) if (!e(n.getNext().key)) return;
	}
	firstAfterOrEqual(e) {
		let t = this.data.getIteratorFrom(e);
		return t.hasNext() ? t.getNext().key : null;
	}
	getIterator() {
		return new no(this.data.getIterator());
	}
	getIteratorFrom(e) {
		return new no(this.data.getIteratorFrom(e));
	}
	add(e) {
		return this.copy(this.data.remove(e).insert(e, !0));
	}
	delete(e) {
		return this.has(e) ? this.copy(this.data.remove(e)) : this;
	}
	isEmpty() {
		return this.data.isEmpty();
	}
	unionWith(e) {
		let t = this;
		return t.size < e.size && (t = e, e = this), e.forEach(((e) => {
			t = t.add(e);
		})), t;
	}
	isEqual(t) {
		if (!(t instanceof e) || this.size !== t.size) return !1;
		let n = this.data.getIterator(), r = t.data.getIterator();
		for (; n.hasNext();) {
			let e = n.getNext().key, t = r.getNext().key;
			if (this.comparator(e, t) !== 0) return !1;
		}
		return !0;
	}
	toArray() {
		let e = [];
		return this.forEach(((t) => {
			e.push(t);
		})), e;
	}
	toString() {
		let e = [];
		return this.forEach(((t) => e.push(t))), "SortedSet(" + e.toString() + ")";
	}
	copy(t) {
		let n = new e(this.comparator);
		return n.data = t, n;
	}
}, no = class {
	constructor(e) {
		this.iter = e;
	}
	getNext() {
		return this.iter.getNext().key;
	}
	hasNext() {
		return this.iter.hasNext();
	}
}, ro = class e {
	constructor(e) {
		this.fields = e, e.sort(Ma.comparator);
	}
	static empty() {
		return new e([]);
	}
	unionWith(t) {
		let n = new to(Ma.comparator);
		for (let e of this.fields) n = n.add(e);
		for (let e of t) n = n.add(e);
		return new e(n.toArray());
	}
	covers(e) {
		for (let t of this.fields) if (t.isPrefixOf(e)) return !0;
		return !1;
	}
	isEqual(e) {
		return Oa(this.fields, e.fields, ((e, t) => e.isEqual(t)));
	}
}, io = class extends Error {
	constructor() {
		super(...arguments), this.name = "Base64DecodeError";
	}
}, ao = class e {
	constructor(e) {
		this.binaryString = e;
	}
	static fromBase64String(t) {
		return new e(function(e) {
			try {
				return atob(e);
			} catch (e) {
				throw typeof DOMException < "u" && e instanceof DOMException ? new io("Invalid base64 string: " + e) : e;
			}
		}(t));
	}
	static fromUint8Array(t) {
		return new e(function(e) {
			let t = "";
			for (let n = 0; n < e.length; ++n) t += String.fromCharCode(e[n]);
			return t;
		}(t));
	}
	[Symbol.iterator]() {
		let e = 0;
		return { next: () => e < this.binaryString.length ? {
			value: this.binaryString.charCodeAt(e++),
			done: !1
		} : {
			value: void 0,
			done: !0
		} };
	}
	toBase64() {
		return function(e) {
			return btoa(e);
		}(this.binaryString);
	}
	toUint8Array() {
		return function(e) {
			let t = new Uint8Array(e.length);
			for (let n = 0; n < e.length; n++) t[n] = e.charCodeAt(n);
			return t;
		}(this.binaryString);
	}
	approximateByteSize() {
		return 2 * this.binaryString.length;
	}
	compareTo(e) {
		return z(this.binaryString, e.binaryString);
	}
	isEqual(e) {
		return this.binaryString === e.binaryString;
	}
};
ao.EMPTY_BYTE_STRING = new ao("");
var oo = /* @__PURE__ */ new RegExp(/^\d{4}-\d\d-\d\dT\d\d:\d\d:\d\d(?:\.(\d+))?Z$/);
function so(e) {
	if (F(!!e), typeof e == "string") {
		let t = 0, n = oo.exec(e);
		if (F(!!n), n[1]) {
			let e = n[1];
			e = (e + "000000000").substr(0, 9), t = Number(e);
		}
		let r = new Date(e);
		return {
			seconds: Math.floor(r.getTime() / 1e3),
			nanos: t
		};
	}
	return {
		seconds: G(e.seconds),
		nanos: G(e.nanos)
	};
}
function G(e) {
	return typeof e == "number" ? e : typeof e == "string" ? Number(e) : 0;
}
function co(e) {
	return typeof e == "string" ? ao.fromBase64String(e) : ao.fromUint8Array(e);
}
function lo(e) {
	return (e?.mapValue?.fields || {}).__type__?.stringValue === "server_timestamp";
}
function uo(e) {
	let t = e.mapValue.fields.__previous_value__;
	return lo(t) ? uo(t) : t;
}
function fo(e) {
	let t = so(e.mapValue.fields.__local_write_time__.timestampValue);
	return new ka(t.seconds, t.nanos);
}
var po = class {
	constructor(e, t, n, r, i, a, o, s, c) {
		this.databaseId = e, this.appId = t, this.persistenceKey = n, this.host = r, this.ssl = i, this.forceLongPolling = a, this.autoDetectLongPolling = o, this.longPollingOptions = s, this.useFetchStreams = c;
	}
}, mo = class e {
	constructor(e, t) {
		this.projectId = e, this.database = t || "(default)";
	}
	static empty() {
		return new e("", "");
	}
	get isDefaultDatabase() {
		return this.database === "(default)";
	}
	isEqual(t) {
		return t instanceof e && t.projectId === this.projectId && t.database === this.database;
	}
}, ho = { mapValue: { fields: { __type__: { stringValue: "__max__" } } } };
function go(e) {
	return "nullValue" in e ? 0 : "booleanValue" in e ? 1 : "integerValue" in e || "doubleValue" in e ? 2 : "timestampValue" in e ? 3 : "stringValue" in e ? 5 : "bytesValue" in e ? 6 : "referenceValue" in e ? 7 : "geoPointValue" in e ? 8 : "arrayValue" in e ? 9 : "mapValue" in e ? lo(e) ? 4 : No(e) ? 9007199254740991 : jo(e) ? 10 : 11 : P();
}
function _o(e, t) {
	if (e === t) return !0;
	let n = go(e);
	if (n !== go(t)) return !1;
	switch (n) {
		case 0:
		case 9007199254740991: return !0;
		case 1: return e.booleanValue === t.booleanValue;
		case 4: return fo(e).isEqual(fo(t));
		case 3: return function(e, t) {
			if (typeof e.timestampValue == "string" && typeof t.timestampValue == "string" && e.timestampValue.length === t.timestampValue.length) return e.timestampValue === t.timestampValue;
			let n = so(e.timestampValue), r = so(t.timestampValue);
			return n.seconds === r.seconds && n.nanos === r.nanos;
		}(e, t);
		case 5: return e.stringValue === t.stringValue;
		case 6: return function(e, t) {
			return co(e.bytesValue).isEqual(co(t.bytesValue));
		}(e, t);
		case 7: return e.referenceValue === t.referenceValue;
		case 8: return function(e, t) {
			return G(e.geoPointValue.latitude) === G(t.geoPointValue.latitude) && G(e.geoPointValue.longitude) === G(t.geoPointValue.longitude);
		}(e, t);
		case 2: return function(e, t) {
			if ("integerValue" in e && "integerValue" in t) return G(e.integerValue) === G(t.integerValue);
			if ("doubleValue" in e && "doubleValue" in t) {
				let n = G(e.doubleValue), r = G(t.doubleValue);
				return n === r ? Ga(n) === Ga(r) : isNaN(n) && isNaN(r);
			}
			return !1;
		}(e, t);
		case 9: return Oa(e.arrayValue.values || [], t.arrayValue.values || [], _o);
		case 10:
		case 11: return function(e, t) {
			let n = e.mapValue.fields || {}, r = t.mapValue.fields || {};
			if (Xa(n) !== Xa(r)) return !1;
			for (let e in n) if (n.hasOwnProperty(e) && (r[e] === void 0 || !_o(n[e], r[e]))) return !1;
			return !0;
		}(e, t);
		default: return P();
	}
}
function vo(e, t) {
	return (e.values || []).find(((e) => _o(e, t))) !== void 0;
}
function yo(e, t) {
	if (e === t) return 0;
	let n = go(e), r = go(t);
	if (n !== r) return z(n, r);
	switch (n) {
		case 0:
		case 9007199254740991: return 0;
		case 1: return z(e.booleanValue, t.booleanValue);
		case 2: return function(e, t) {
			let n = G(e.integerValue || e.doubleValue), r = G(t.integerValue || t.doubleValue);
			return n < r ? -1 : n > r ? 1 : n === r ? 0 : isNaN(n) ? isNaN(r) ? 0 : -1 : 1;
		}(e, t);
		case 3: return bo(e.timestampValue, t.timestampValue);
		case 4: return bo(fo(e), fo(t));
		case 5: return z(e.stringValue, t.stringValue);
		case 6: return function(e, t) {
			let n = co(e), r = co(t);
			return n.compareTo(r);
		}(e.bytesValue, t.bytesValue);
		case 7: return function(e, t) {
			let n = e.split("/"), r = t.split("/");
			for (let e = 0; e < n.length && e < r.length; e++) {
				let t = z(n[e], r[e]);
				if (t !== 0) return t;
			}
			return z(n.length, r.length);
		}(e.referenceValue, t.referenceValue);
		case 8: return function(e, t) {
			let n = z(G(e.latitude), G(t.latitude));
			return n === 0 ? z(G(e.longitude), G(t.longitude)) : n;
		}(e.geoPointValue, t.geoPointValue);
		case 9: return xo(e.arrayValue, t.arrayValue);
		case 10: return function(e, t) {
			let n = e.fields || {}, r = t.fields || {}, i = n.value?.arrayValue, a = r.value?.arrayValue, o = z(i?.values?.length || 0, a?.values?.length || 0);
			return o === 0 ? xo(i, a) : o;
		}(e.mapValue, t.mapValue);
		case 11: return function(e, t) {
			if (e === ho.mapValue && t === ho.mapValue) return 0;
			if (e === ho.mapValue) return 1;
			if (t === ho.mapValue) return -1;
			let n = e.fields || {}, r = Object.keys(n), i = t.fields || {}, a = Object.keys(i);
			r.sort(), a.sort();
			for (let e = 0; e < r.length && e < a.length; ++e) {
				let t = z(r[e], a[e]);
				if (t !== 0) return t;
				let o = yo(n[r[e]], i[a[e]]);
				if (o !== 0) return o;
			}
			return z(r.length, a.length);
		}(e.mapValue, t.mapValue);
		default: throw P();
	}
}
function bo(e, t) {
	if (typeof e == "string" && typeof t == "string" && e.length === t.length) return z(e, t);
	let n = so(e), r = so(t), i = z(n.seconds, r.seconds);
	return i === 0 ? z(n.nanos, r.nanos) : i;
}
function xo(e, t) {
	let n = e.values || [], r = t.values || [];
	for (let e = 0; e < n.length && e < r.length; ++e) {
		let t = yo(n[e], r[e]);
		if (t) return t;
	}
	return z(n.length, r.length);
}
function So(e) {
	return Co(e);
}
function Co(e) {
	return "nullValue" in e ? "null" : "booleanValue" in e ? "" + e.booleanValue : "integerValue" in e ? "" + e.integerValue : "doubleValue" in e ? "" + e.doubleValue : "timestampValue" in e ? function(e) {
		let t = so(e);
		return `time(${t.seconds},${t.nanos})`;
	}(e.timestampValue) : "stringValue" in e ? e.stringValue : "bytesValue" in e ? function(e) {
		return co(e).toBase64();
	}(e.bytesValue) : "referenceValue" in e ? function(e) {
		return H.fromName(e).toString();
	}(e.referenceValue) : "geoPointValue" in e ? function(e) {
		return `geo(${e.latitude},${e.longitude})`;
	}(e.geoPointValue) : "arrayValue" in e ? function(e) {
		let t = "[", n = !0;
		for (let r of e.values || []) n ? n = !1 : t += ",", t += Co(r);
		return t + "]";
	}(e.arrayValue) : "mapValue" in e ? function(e) {
		let t = Object.keys(e.fields || {}).sort(), n = "{", r = !0;
		for (let i of t) r ? r = !1 : n += ",", n += `${i}:${Co(e.fields[i])}`;
		return n + "}";
	}(e.mapValue) : P();
}
function wo(e) {
	switch (go(e)) {
		case 0:
		case 1: return 4;
		case 2: return 8;
		case 3:
		case 8: return 16;
		case 4:
			let t = uo(e);
			return t ? 16 + wo(t) : 16;
		case 5: return 2 * e.stringValue.length;
		case 6: return co(e.bytesValue).approximateByteSize();
		case 7: return e.referenceValue.length;
		case 9: return function(e) {
			return (e.values || []).reduce(((e, t) => e + wo(t)), 0);
		}(e.arrayValue);
		case 10:
		case 11: return function(e) {
			let t = 0;
			return Za(e.fields, ((e, n) => {
				t += e.length + wo(n);
			})), t;
		}(e.mapValue);
		default: throw P();
	}
}
function To(e, t) {
	return { referenceValue: `projects/${e.projectId}/databases/${e.database}/documents/${t.path.canonicalString()}` };
}
function Eo(e) {
	return !!e && "integerValue" in e;
}
function Do(e) {
	return !!e && "arrayValue" in e;
}
function Oo(e) {
	return !!e && "nullValue" in e;
}
function ko(e) {
	return !!e && "doubleValue" in e && isNaN(Number(e.doubleValue));
}
function Ao(e) {
	return !!e && "mapValue" in e;
}
function jo(e) {
	return (e?.mapValue?.fields || {}).__type__?.stringValue === "__vector__";
}
function Mo(e) {
	if (e.geoPointValue) return { geoPointValue: Object.assign({}, e.geoPointValue) };
	if (e.timestampValue && typeof e.timestampValue == "object") return { timestampValue: Object.assign({}, e.timestampValue) };
	if (e.mapValue) {
		let t = { mapValue: { fields: {} } };
		return Za(e.mapValue.fields, ((e, n) => t.mapValue.fields[e] = Mo(n))), t;
	}
	if (e.arrayValue) {
		let t = { arrayValue: { values: [] } };
		for (let n = 0; n < (e.arrayValue.values || []).length; ++n) t.arrayValue.values[n] = Mo(e.arrayValue.values[n]);
		return t;
	}
	return Object.assign({}, e);
}
function No(e) {
	return (((e.mapValue || {}).fields || {}).__type__ || {}).stringValue === "__max__";
}
var Po = class e {
	constructor(e) {
		this.value = e;
	}
	static empty() {
		return new e({ mapValue: {} });
	}
	field(e) {
		if (e.isEmpty()) return this.value;
		{
			let t = this.value;
			for (let n = 0; n < e.length - 1; ++n) if (t = (t.mapValue.fields || {})[e.get(n)], !Ao(t)) return null;
			return t = (t.mapValue.fields || {})[e.lastSegment()], t || null;
		}
	}
	set(e, t) {
		this.getFieldsMap(e.popLast())[e.lastSegment()] = Mo(t);
	}
	setAll(e) {
		let t = Ma.emptyPath(), n = {}, r = [];
		e.forEach(((e, i) => {
			if (!t.isImmediateParentOf(i)) {
				let e = this.getFieldsMap(t);
				this.applyChanges(e, n, r), n = {}, r = [], t = i.popLast();
			}
			e ? n[i.lastSegment()] = Mo(e) : r.push(i.lastSegment());
		}));
		let i = this.getFieldsMap(t);
		this.applyChanges(i, n, r);
	}
	delete(e) {
		let t = this.field(e.popLast());
		Ao(t) && t.mapValue.fields && delete t.mapValue.fields[e.lastSegment()];
	}
	isEqual(e) {
		return _o(this.value, e.value);
	}
	getFieldsMap(e) {
		let t = this.value;
		t.mapValue.fields || (t.mapValue = { fields: {} });
		for (let n = 0; n < e.length; ++n) {
			let r = t.mapValue.fields[e.get(n)];
			Ao(r) && r.mapValue.fields || (r = { mapValue: { fields: {} } }, t.mapValue.fields[e.get(n)] = r), t = r;
		}
		return t.mapValue.fields;
	}
	applyChanges(e, t, n) {
		Za(t, ((t, n) => e[t] = n));
		for (let t of n) delete e[t];
	}
	clone() {
		return new e(Mo(this.value));
	}
};
function Fo(e) {
	let t = [];
	return Za(e.fields, ((e, n) => {
		let r = new Ma([e]);
		if (Ao(n)) {
			let e = Fo(n.mapValue).fields;
			if (e.length === 0) t.push(r);
			else for (let n of e) t.push(r.child(n));
		} else t.push(r);
	})), new ro(t);
}
var Io = class e {
	constructor(e, t, n, r, i, a, o) {
		this.key = e, this.documentType = t, this.version = n, this.readTime = r, this.createTime = i, this.data = a, this.documentState = o;
	}
	static newInvalidDocument(t) {
		return new e(t, 0, B.min(), B.min(), B.min(), Po.empty(), 0);
	}
	static newFoundDocument(t, n, r, i) {
		return new e(t, 1, n, B.min(), r, i, 0);
	}
	static newNoDocument(t, n) {
		return new e(t, 2, n, B.min(), B.min(), Po.empty(), 0);
	}
	static newUnknownDocument(t, n) {
		return new e(t, 3, n, B.min(), B.min(), Po.empty(), 2);
	}
	convertToFoundDocument(e, t) {
		return !this.createTime.isEqual(B.min()) || this.documentType !== 2 && this.documentType !== 0 || (this.createTime = e), this.version = e, this.documentType = 1, this.data = t, this.documentState = 0, this;
	}
	convertToNoDocument(e) {
		return this.version = e, this.documentType = 2, this.data = Po.empty(), this.documentState = 0, this;
	}
	convertToUnknownDocument(e) {
		return this.version = e, this.documentType = 3, this.data = Po.empty(), this.documentState = 2, this;
	}
	setHasCommittedMutations() {
		return this.documentState = 2, this;
	}
	setHasLocalMutations() {
		return this.documentState = 1, this.version = B.min(), this;
	}
	setReadTime(e) {
		return this.readTime = e, this;
	}
	get hasLocalMutations() {
		return this.documentState === 1;
	}
	get hasCommittedMutations() {
		return this.documentState === 2;
	}
	get hasPendingWrites() {
		return this.hasLocalMutations || this.hasCommittedMutations;
	}
	isValidDocument() {
		return this.documentType !== 0;
	}
	isFoundDocument() {
		return this.documentType === 1;
	}
	isNoDocument() {
		return this.documentType === 2;
	}
	isUnknownDocument() {
		return this.documentType === 3;
	}
	isEqual(t) {
		return t instanceof e && this.key.isEqual(t.key) && this.version.isEqual(t.version) && this.documentType === t.documentType && this.documentState === t.documentState && this.data.isEqual(t.data);
	}
	mutableCopy() {
		return new e(this.key, this.documentType, this.version, this.readTime, this.createTime, this.data.clone(), this.documentState);
	}
	toString() {
		return `Document(${this.key}, ${this.version}, ${JSON.stringify(this.data.value)}, {createTime: ${this.createTime}}), {documentType: ${this.documentType}}), {documentState: ${this.documentState}})`;
	}
}, Lo = class {
	constructor(e, t) {
		this.position = e, this.inclusive = t;
	}
};
function Ro(e, t, n) {
	let r = 0;
	for (let i = 0; i < e.position.length; i++) {
		let a = t[i], o = e.position[i];
		if (r = a.field.isKeyField() ? H.comparator(H.fromName(o.referenceValue), n.key) : yo(o, n.data.field(a.field)), a.dir === "desc" && (r *= -1), r !== 0) break;
	}
	return r;
}
function zo(e, t) {
	if (e === null) return t === null;
	if (t === null || e.inclusive !== t.inclusive || e.position.length !== t.position.length) return !1;
	for (let n = 0; n < e.position.length; n++) if (!_o(e.position[n], t.position[n])) return !1;
	return !0;
}
var Bo = class {
	constructor(e, t = "asc") {
		this.field = e, this.dir = t;
	}
};
function Vo(e, t) {
	return e.dir === t.dir && e.field.isEqual(t.field);
}
var Ho = class {}, K = class e extends Ho {
	constructor(e, t, n) {
		super(), this.field = e, this.op = t, this.value = n;
	}
	static create(t, n, r) {
		return t.isKeyField() ? n === "in" || n === "not-in" ? this.createKeyFieldInFilter(t, n, r) : new Xo(t, n, r) : n === "array-contains" ? new es(t, r) : n === "in" ? new ts(t, r) : n === "not-in" ? new ns(t, r) : n === "array-contains-any" ? new rs(t, r) : new e(t, n, r);
	}
	static createKeyFieldInFilter(e, t, n) {
		return t === "in" ? new Zo(e, n) : new Qo(e, n);
	}
	matches(e) {
		let t = e.data.field(this.field);
		return this.op === "!=" ? t !== null && this.matchesComparison(yo(t, this.value)) : t !== null && go(this.value) === go(t) && this.matchesComparison(yo(t, this.value));
	}
	matchesComparison(e) {
		switch (this.op) {
			case "<": return e < 0;
			case "<=": return e <= 0;
			case "==": return e === 0;
			case "!=": return e !== 0;
			case ">": return e > 0;
			case ">=": return e >= 0;
			default: return P();
		}
	}
	isInequality() {
		return [
			"<",
			"<=",
			">",
			">=",
			"!=",
			"not-in"
		].indexOf(this.op) >= 0;
	}
	getFlattenedFilters() {
		return [this];
	}
	getFilters() {
		return [this];
	}
}, Uo = class e extends Ho {
	constructor(e, t) {
		super(), this.filters = e, this.op = t, this.ae = null;
	}
	static create(t, n) {
		return new e(t, n);
	}
	matches(e) {
		return Wo(this) ? this.filters.find(((t) => !t.matches(e))) === void 0 : this.filters.find(((t) => t.matches(e))) !== void 0;
	}
	getFlattenedFilters() {
		return this.ae !== null || (this.ae = this.filters.reduce(((e, t) => e.concat(t.getFlattenedFilters())), [])), this.ae;
	}
	getFilters() {
		return Object.assign([], this.filters);
	}
};
function Wo(e) {
	return e.op === "and";
}
function Go(e) {
	return Ko(e) && Wo(e);
}
function Ko(e) {
	for (let t of e.filters) if (t instanceof Uo) return !1;
	return !0;
}
function qo(e) {
	if (e instanceof K) return e.field.canonicalString() + e.op.toString() + So(e.value);
	if (Go(e)) return e.filters.map(((e) => qo(e))).join(",");
	{
		let t = e.filters.map(((e) => qo(e))).join(",");
		return `${e.op}(${t})`;
	}
}
function Jo(e, t) {
	return e instanceof K ? function(e, t) {
		return t instanceof K && e.op === t.op && e.field.isEqual(t.field) && _o(e.value, t.value);
	}(e, t) : e instanceof Uo ? function(e, t) {
		return t instanceof Uo && e.op === t.op && e.filters.length === t.filters.length ? e.filters.reduce(((e, n, r) => e && Jo(n, t.filters[r])), !0) : !1;
	}(e, t) : void P();
}
function Yo(e) {
	return e instanceof K ? function(e) {
		return `${e.field.canonicalString()} ${e.op} ${So(e.value)}`;
	}(e) : e instanceof Uo ? function(e) {
		return e.op.toString() + " {" + e.getFilters().map(Yo).join(" ,") + "}";
	}(e) : "Filter";
}
var Xo = class extends K {
	constructor(e, t, n) {
		super(e, t, n), this.key = H.fromName(n.referenceValue);
	}
	matches(e) {
		let t = H.comparator(e.key, this.key);
		return this.matchesComparison(t);
	}
}, Zo = class extends K {
	constructor(e, t) {
		super(e, "in", t), this.keys = $o("in", t);
	}
	matches(e) {
		return this.keys.some(((t) => t.isEqual(e.key)));
	}
}, Qo = class extends K {
	constructor(e, t) {
		super(e, "not-in", t), this.keys = $o("not-in", t);
	}
	matches(e) {
		return !this.keys.some(((t) => t.isEqual(e.key)));
	}
};
function $o(e, t) {
	return (t.arrayValue?.values || []).map(((e) => H.fromName(e.referenceValue)));
}
var es = class extends K {
	constructor(e, t) {
		super(e, "array-contains", t);
	}
	matches(e) {
		let t = e.data.field(this.field);
		return Do(t) && vo(t.arrayValue, this.value);
	}
}, ts = class extends K {
	constructor(e, t) {
		super(e, "in", t);
	}
	matches(e) {
		let t = e.data.field(this.field);
		return t !== null && vo(this.value.arrayValue, t);
	}
}, ns = class extends K {
	constructor(e, t) {
		super(e, "not-in", t);
	}
	matches(e) {
		if (vo(this.value.arrayValue, { nullValue: "NULL_VALUE" })) return !1;
		let t = e.data.field(this.field);
		return t !== null && !vo(this.value.arrayValue, t);
	}
}, rs = class extends K {
	constructor(e, t) {
		super(e, "array-contains-any", t);
	}
	matches(e) {
		let t = e.data.field(this.field);
		return !(!Do(t) || !t.arrayValue.values) && t.arrayValue.values.some(((e) => vo(this.value.arrayValue, e)));
	}
}, is = class {
	constructor(e, t = null, n = [], r = [], i = null, a = null, o = null) {
		this.path = e, this.collectionGroup = t, this.orderBy = n, this.filters = r, this.limit = i, this.startAt = a, this.endAt = o, this.ue = null;
	}
};
function as(e, t = null, n = [], r = [], i = null, a = null, o = null) {
	return new is(e, t, n, r, i, a, o);
}
function os(e) {
	let t = I(e);
	if (t.ue === null) {
		let e = t.path.canonicalString();
		t.collectionGroup !== null && (e += "|cg:" + t.collectionGroup), e += "|f:", e += t.filters.map(((e) => qo(e))).join(","), e += "|ob:", e += t.orderBy.map(((e) => function(e) {
			return e.field.canonicalString() + e.dir;
		}(e))).join(","), Wa(t.limit) || (e += "|l:", e += t.limit), t.startAt && (e += "|lb:", e += t.startAt.inclusive ? "b:" : "a:", e += t.startAt.position.map(((e) => So(e))).join(",")), t.endAt && (e += "|ub:", e += t.endAt.inclusive ? "a:" : "b:", e += t.endAt.position.map(((e) => So(e))).join(",")), t.ue = e;
	}
	return t.ue;
}
function ss(e, t) {
	if (e.limit !== t.limit || e.orderBy.length !== t.orderBy.length) return !1;
	for (let n = 0; n < e.orderBy.length; n++) if (!Vo(e.orderBy[n], t.orderBy[n])) return !1;
	if (e.filters.length !== t.filters.length) return !1;
	for (let n = 0; n < e.filters.length; n++) if (!Jo(e.filters[n], t.filters[n])) return !1;
	return e.collectionGroup === t.collectionGroup && !!e.path.isEqual(t.path) && !!zo(e.startAt, t.startAt) && zo(e.endAt, t.endAt);
}
function cs(e) {
	return H.isDocumentKey(e.path) && e.collectionGroup === null && e.filters.length === 0;
}
var ls = class {
	constructor(e, t = null, n = [], r = [], i = null, a = "F", o = null, s = null) {
		this.path = e, this.collectionGroup = t, this.explicitOrderBy = n, this.filters = r, this.limit = i, this.limitType = a, this.startAt = o, this.endAt = s, this.ce = null, this.le = null, this.he = null, this.startAt, this.endAt;
	}
};
function us(e, t, n, r, i, a, o, s) {
	return new ls(e, t, n, r, i, a, o, s);
}
function ds(e) {
	return new ls(e);
}
function fs(e) {
	return e.filters.length === 0 && e.limit === null && e.startAt == null && e.endAt == null && (e.explicitOrderBy.length === 0 || e.explicitOrderBy.length === 1 && e.explicitOrderBy[0].field.isKeyField());
}
function ps(e) {
	return e.collectionGroup !== null;
}
function ms(e) {
	let t = I(e);
	if (t.ce === null) {
		t.ce = [];
		let e = /* @__PURE__ */ new Set();
		for (let n of t.explicitOrderBy) t.ce.push(n), e.add(n.field.canonicalString());
		let n = t.explicitOrderBy.length > 0 ? t.explicitOrderBy[t.explicitOrderBy.length - 1].dir : "asc";
		(function(e) {
			let t = new to(Ma.comparator);
			return e.filters.forEach(((e) => {
				e.getFlattenedFilters().forEach(((e) => {
					e.isInequality() && (t = t.add(e.field));
				}));
			})), t;
		})(t).forEach(((r) => {
			e.has(r.canonicalString()) || r.isKeyField() || t.ce.push(new Bo(r, n));
		})), e.has(Ma.keyField().canonicalString()) || t.ce.push(new Bo(Ma.keyField(), n));
	}
	return t.ce;
}
function hs(e) {
	let t = I(e);
	return t.le ||= gs(t, ms(e)), t.le;
}
function gs(e, t) {
	if (e.limitType === "F") return as(e.path, e.collectionGroup, t, e.filters, e.limit, e.startAt, e.endAt);
	{
		t = t.map(((e) => {
			let t = e.dir === "desc" ? "asc" : "desc";
			return new Bo(e.field, t);
		}));
		let n = e.endAt ? new Lo(e.endAt.position, e.endAt.inclusive) : null, r = e.startAt ? new Lo(e.startAt.position, e.startAt.inclusive) : null;
		return as(e.path, e.collectionGroup, t, e.filters, e.limit, n, r);
	}
}
function _s(e, t) {
	let n = e.filters.concat([t]);
	return new ls(e.path, e.collectionGroup, e.explicitOrderBy.slice(), n, e.limit, e.limitType, e.startAt, e.endAt);
}
function vs(e, t, n) {
	return new ls(e.path, e.collectionGroup, e.explicitOrderBy.slice(), e.filters.slice(), t, n, e.startAt, e.endAt);
}
function ys(e, t) {
	return ss(hs(e), hs(t)) && e.limitType === t.limitType;
}
function bs(e) {
	return `${os(hs(e))}|lt:${e.limitType}`;
}
function xs(e) {
	return `Query(target=${function(e) {
		let t = e.path.canonicalString();
		return e.collectionGroup !== null && (t += " collectionGroup=" + e.collectionGroup), e.filters.length > 0 && (t += `, filters: [${e.filters.map(((e) => Yo(e))).join(", ")}]`), Wa(e.limit) || (t += ", limit: " + e.limit), e.orderBy.length > 0 && (t += `, orderBy: [${e.orderBy.map(((e) => function(e) {
			return `${e.field.canonicalString()} (${e.dir})`;
		}(e))).join(", ")}]`), e.startAt && (t += ", startAt: ", t += e.startAt.inclusive ? "b:" : "a:", t += e.startAt.position.map(((e) => So(e))).join(",")), e.endAt && (t += ", endAt: ", t += e.endAt.inclusive ? "a:" : "b:", t += e.endAt.position.map(((e) => So(e))).join(",")), `Target(${t})`;
	}(hs(e))}; limitType=${e.limitType})`;
}
function Ss(e, t) {
	return t.isFoundDocument() && function(e, t) {
		let n = t.key.path;
		return e.collectionGroup === null ? H.isDocumentKey(e.path) ? e.path.isEqual(n) : e.path.isImmediateParentOf(n) : t.key.hasCollectionId(e.collectionGroup) && e.path.isPrefixOf(n);
	}(e, t) && function(e, t) {
		for (let n of ms(e)) if (!n.field.isKeyField() && t.data.field(n.field) === null) return !1;
		return !0;
	}(e, t) && function(e, t) {
		for (let n of e.filters) if (!n.matches(t)) return !1;
		return !0;
	}(e, t) && function(e, t) {
		return !(e.startAt && !function(e, t, n) {
			let r = Ro(e, t, n);
			return e.inclusive ? r <= 0 : r < 0;
		}(e.startAt, ms(e), t) || e.endAt && !function(e, t, n) {
			let r = Ro(e, t, n);
			return e.inclusive ? r >= 0 : r > 0;
		}(e.endAt, ms(e), t));
	}(e, t);
}
function Cs(e) {
	return e.collectionGroup || (e.path.length % 2 == 1 ? e.path.lastSegment() : e.path.get(e.path.length - 2));
}
function ws(e) {
	return (t, n) => {
		let r = !1;
		for (let i of ms(e)) {
			let e = Ts(i, t, n);
			if (e !== 0) return e;
			r ||= i.field.isKeyField();
		}
		return 0;
	};
}
function Ts(e, t, n) {
	let r = e.field.isKeyField() ? H.comparator(t.key, n.key) : function(e, t, n) {
		let r = t.data.field(e), i = n.data.field(e);
		return r !== null && i !== null ? yo(r, i) : P();
	}(e.field, t, n);
	switch (e.dir) {
		case "asc": return r;
		case "desc": return -1 * r;
		default: return P();
	}
}
var Es = class {
	constructor(e, t) {
		this.mapKeyFn = e, this.equalsFn = t, this.inner = {}, this.innerSize = 0;
	}
	get(e) {
		let t = this.mapKeyFn(e), n = this.inner[t];
		if (n !== void 0) {
			for (let [t, r] of n) if (this.equalsFn(t, e)) return r;
		}
	}
	has(e) {
		return this.get(e) !== void 0;
	}
	set(e, t) {
		let n = this.mapKeyFn(e), r = this.inner[n];
		if (r === void 0) return this.inner[n] = [[e, t]], void this.innerSize++;
		for (let n = 0; n < r.length; n++) if (this.equalsFn(r[n][0], e)) return void (r[n] = [e, t]);
		r.push([e, t]), this.innerSize++;
	}
	delete(e) {
		let t = this.mapKeyFn(e), n = this.inner[t];
		if (n === void 0) return !1;
		for (let r = 0; r < n.length; r++) if (this.equalsFn(n[r][0], e)) return n.length === 1 ? delete this.inner[t] : n.splice(r, 1), this.innerSize--, !0;
		return !1;
	}
	forEach(e) {
		Za(this.inner, ((t, n) => {
			for (let [t, r] of n) e(t, r);
		}));
	}
	isEmpty() {
		return Qa(this.inner);
	}
	size() {
		return this.innerSize;
	}
}, Ds = new W(H.comparator);
function Os() {
	return Ds;
}
var ks = new W(H.comparator);
function As(...e) {
	let t = ks;
	for (let n of e) t = t.insert(n.key, n);
	return t;
}
function js(e) {
	let t = ks;
	return e.forEach(((e, n) => t = t.insert(e, n.overlayedDocument))), t;
}
function Ms() {
	return Ps();
}
function Ns() {
	return Ps();
}
function Ps() {
	return new Es(((e) => e.toString()), ((e, t) => e.isEqual(t)));
}
var Fs = new W(H.comparator), Is = new to(H.comparator);
function q(...e) {
	let t = Is;
	for (let n of e) t = t.add(n);
	return t;
}
var Ls = new to(z);
function Rs() {
	return Ls;
}
function zs(e, t) {
	if (e.useProto3Json) {
		if (isNaN(t)) return { doubleValue: "NaN" };
		if (t === Infinity) return { doubleValue: "Infinity" };
		if (t === -Infinity) return { doubleValue: "-Infinity" };
	}
	return { doubleValue: Ga(t) ? "-0" : t };
}
function Bs(e) {
	return { integerValue: "" + e };
}
function Vs(e, t) {
	return Ka(t) ? Bs(t) : zs(e, t);
}
var Hs = class {
	constructor() {
		this._ = void 0;
	}
};
function Us(e, t, n) {
	return e instanceof Ks ? function(e, t) {
		let n = { fields: {
			__type__: { stringValue: "server_timestamp" },
			__local_write_time__: { timestampValue: {
				seconds: e.seconds,
				nanos: e.nanoseconds
			} }
		} };
		return t && lo(t) && (t = uo(t)), t && (n.fields.__previous_value__ = t), { mapValue: n };
	}(n, t) : e instanceof qs ? Js(e, t) : e instanceof Ys ? Xs(e, t) : function(e, t) {
		let n = Gs(e, t), r = Qs(n) + Qs(e.Pe);
		return Eo(n) && Eo(e.Pe) ? Bs(r) : zs(e.serializer, r);
	}(e, t);
}
function Ws(e, t, n) {
	return e instanceof qs ? Js(e, t) : e instanceof Ys ? Xs(e, t) : n;
}
function Gs(e, t) {
	return e instanceof Zs ? function(e) {
		return Eo(e) || function(e) {
			return !!e && "doubleValue" in e;
		}(e);
	}(t) ? t : { integerValue: 0 } : null;
}
var Ks = class extends Hs {}, qs = class extends Hs {
	constructor(e) {
		super(), this.elements = e;
	}
};
function Js(e, t) {
	let n = $s(t);
	for (let t of e.elements) n.some(((e) => _o(e, t))) || n.push(t);
	return { arrayValue: { values: n } };
}
var Ys = class extends Hs {
	constructor(e) {
		super(), this.elements = e;
	}
};
function Xs(e, t) {
	let n = $s(t);
	for (let t of e.elements) n = n.filter(((e) => !_o(e, t)));
	return { arrayValue: { values: n } };
}
var Zs = class extends Hs {
	constructor(e, t) {
		super(), this.serializer = e, this.Pe = t;
	}
};
function Qs(e) {
	return G(e.integerValue || e.doubleValue);
}
function $s(e) {
	return Do(e) && e.arrayValue.values ? e.arrayValue.values.slice() : [];
}
function ec(e, t) {
	return e.field.isEqual(t.field) && function(e, t) {
		return e instanceof qs && t instanceof qs || e instanceof Ys && t instanceof Ys ? Oa(e.elements, t.elements, _o) : e instanceof Zs && t instanceof Zs ? _o(e.Pe, t.Pe) : e instanceof Ks && t instanceof Ks;
	}(e.transform, t.transform);
}
var tc = class {
	constructor(e, t) {
		this.version = e, this.transformResults = t;
	}
}, nc = class e {
	constructor(e, t) {
		this.updateTime = e, this.exists = t;
	}
	static none() {
		return new e();
	}
	static exists(t) {
		return new e(void 0, t);
	}
	static updateTime(t) {
		return new e(t);
	}
	get isNone() {
		return this.updateTime === void 0 && this.exists === void 0;
	}
	isEqual(e) {
		return this.exists === e.exists && (this.updateTime ? !!e.updateTime && this.updateTime.isEqual(e.updateTime) : !e.updateTime);
	}
};
function rc(e, t) {
	return e.updateTime === void 0 ? e.exists === void 0 || e.exists === t.isFoundDocument() : t.isFoundDocument() && t.version.isEqual(e.updateTime);
}
var ic = class {};
function ac(e, t) {
	if (!e.hasLocalMutations || t && t.fields.length === 0) return null;
	if (t === null) return e.isNoDocument() ? new hc(e.key, nc.none()) : new uc(e.key, e.data, nc.none());
	{
		let n = e.data, r = Po.empty(), i = new to(Ma.comparator);
		for (let e of t.fields) if (!i.has(e)) {
			let t = n.field(e);
			t === null && e.length > 1 && (e = e.popLast(), t = n.field(e)), t === null ? r.delete(e) : r.set(e, t), i = i.add(e);
		}
		return new dc(e.key, r, new ro(i.toArray()), nc.none());
	}
}
function oc(e, t, n) {
	e instanceof uc ? function(e, t, n) {
		let r = e.value.clone(), i = pc(e.fieldTransforms, t, n.transformResults);
		r.setAll(i), t.convertToFoundDocument(n.version, r).setHasCommittedMutations();
	}(e, t, n) : e instanceof dc ? function(e, t, n) {
		if (!rc(e.precondition, t)) return void t.convertToUnknownDocument(n.version);
		let r = pc(e.fieldTransforms, t, n.transformResults), i = t.data;
		i.setAll(fc(e)), i.setAll(r), t.convertToFoundDocument(n.version, i).setHasCommittedMutations();
	}(e, t, n) : function(e, t, n) {
		t.convertToNoDocument(n.version).setHasCommittedMutations();
	}(0, t, n);
}
function sc(e, t, n, r) {
	return e instanceof uc ? function(e, t, n, r) {
		if (!rc(e.precondition, t)) return n;
		let i = e.value.clone(), a = mc(e.fieldTransforms, r, t);
		return i.setAll(a), t.convertToFoundDocument(t.version, i).setHasLocalMutations(), null;
	}(e, t, n, r) : e instanceof dc ? function(e, t, n, r) {
		if (!rc(e.precondition, t)) return n;
		let i = mc(e.fieldTransforms, r, t), a = t.data;
		return a.setAll(fc(e)), a.setAll(i), t.convertToFoundDocument(t.version, a).setHasLocalMutations(), n === null ? null : n.unionWith(e.fieldMask.fields).unionWith(e.fieldTransforms.map(((e) => e.field)));
	}(e, t, n, r) : function(e, t, n) {
		return rc(e.precondition, t) ? (t.convertToNoDocument(t.version).setHasLocalMutations(), null) : n;
	}(e, t, n);
}
function cc(e, t) {
	let n = null;
	for (let r of e.fieldTransforms) {
		let e = t.data.field(r.field), i = Gs(r.transform, e || null);
		i != null && (n === null && (n = Po.empty()), n.set(r.field, i));
	}
	return n || null;
}
function lc(e, t) {
	return e.type === t.type && !!e.key.isEqual(t.key) && !!e.precondition.isEqual(t.precondition) && !!function(e, t) {
		return e === void 0 && t === void 0 || !(!e || !t) && Oa(e, t, ((e, t) => ec(e, t)));
	}(e.fieldTransforms, t.fieldTransforms) && (e.type === 0 ? e.value.isEqual(t.value) : e.type !== 1 || e.data.isEqual(t.data) && e.fieldMask.isEqual(t.fieldMask));
}
var uc = class extends ic {
	constructor(e, t, n, r = []) {
		super(), this.key = e, this.value = t, this.precondition = n, this.fieldTransforms = r, this.type = 0;
	}
	getFieldMask() {
		return null;
	}
}, dc = class extends ic {
	constructor(e, t, n, r, i = []) {
		super(), this.key = e, this.data = t, this.fieldMask = n, this.precondition = r, this.fieldTransforms = i, this.type = 1;
	}
	getFieldMask() {
		return this.fieldMask;
	}
};
function fc(e) {
	let t = /* @__PURE__ */ new Map();
	return e.fieldMask.fields.forEach(((n) => {
		if (!n.isEmpty()) {
			let r = e.data.field(n);
			t.set(n, r);
		}
	})), t;
}
function pc(e, t, n) {
	let r = /* @__PURE__ */ new Map();
	F(e.length === n.length);
	for (let i = 0; i < n.length; i++) {
		let a = e[i], o = a.transform, s = t.data.field(a.field);
		r.set(a.field, Ws(o, s, n[i]));
	}
	return r;
}
function mc(e, t, n) {
	let r = /* @__PURE__ */ new Map();
	for (let i of e) {
		let e = i.transform, a = n.data.field(i.field);
		r.set(i.field, Us(e, a, t));
	}
	return r;
}
var hc = class extends ic {
	constructor(e, t) {
		super(), this.key = e, this.precondition = t, this.type = 2, this.fieldTransforms = [];
	}
	getFieldMask() {
		return null;
	}
}, gc = class extends ic {
	constructor(e, t) {
		super(), this.key = e, this.precondition = t, this.type = 3, this.fieldTransforms = [];
	}
	getFieldMask() {
		return null;
	}
}, _c = class {
	constructor(e, t, n, r) {
		this.batchId = e, this.localWriteTime = t, this.baseMutations = n, this.mutations = r;
	}
	applyToRemoteDocument(e, t) {
		let n = t.mutationResults;
		for (let t = 0; t < this.mutations.length; t++) {
			let r = this.mutations[t];
			r.key.isEqual(e.key) && oc(r, e, n[t]);
		}
	}
	applyToLocalView(e, t) {
		for (let n of this.baseMutations) n.key.isEqual(e.key) && (t = sc(n, e, t, this.localWriteTime));
		for (let n of this.mutations) n.key.isEqual(e.key) && (t = sc(n, e, t, this.localWriteTime));
		return t;
	}
	applyToLocalDocumentSet(e, t) {
		let n = Ns();
		return this.mutations.forEach(((r) => {
			let i = e.get(r.key), a = i.overlayedDocument, o = this.applyToLocalView(a, i.mutatedFields);
			o = t.has(r.key) ? null : o;
			let s = ac(a, o);
			s !== null && n.set(r.key, s), a.isValidDocument() || a.convertToNoDocument(B.min());
		})), n;
	}
	keys() {
		return this.mutations.reduce(((e, t) => e.add(t.key)), q());
	}
	isEqual(e) {
		return this.batchId === e.batchId && Oa(this.mutations, e.mutations, ((e, t) => lc(e, t))) && Oa(this.baseMutations, e.baseMutations, ((e, t) => lc(e, t)));
	}
}, vc = class e {
	constructor(e, t, n, r) {
		this.batch = e, this.commitVersion = t, this.mutationResults = n, this.docVersions = r;
	}
	static from(t, n, r) {
		F(t.mutations.length === r.length);
		let i = function() {
			return Fs;
		}(), a = t.mutations;
		for (let e = 0; e < a.length; e++) i = i.insert(a[e].key, r[e].version);
		return new e(t, n, r, i);
	}
}, yc = class {
	constructor(e, t) {
		this.largestBatchId = e, this.mutation = t;
	}
	getKey() {
		return this.mutation.key;
	}
	isEqual(e) {
		return e !== null && this.mutation === e.mutation;
	}
	toString() {
		return `Overlay{\n      largestBatchId: ${this.largestBatchId},\n      mutation: ${this.mutation.toString()}\n    }`;
	}
}, bc = class {
	constructor(e, t) {
		this.count = e, this.unchangedNames = t;
	}
}, J, Y;
function xc(e) {
	switch (e) {
		default: return P();
		case L.CANCELLED:
		case L.UNKNOWN:
		case L.DEADLINE_EXCEEDED:
		case L.RESOURCE_EXHAUSTED:
		case L.INTERNAL:
		case L.UNAVAILABLE:
		case L.UNAUTHENTICATED: return !1;
		case L.INVALID_ARGUMENT:
		case L.NOT_FOUND:
		case L.ALREADY_EXISTS:
		case L.PERMISSION_DENIED:
		case L.FAILED_PRECONDITION:
		case L.ABORTED:
		case L.OUT_OF_RANGE:
		case L.UNIMPLEMENTED:
		case L.DATA_LOSS: return !0;
	}
}
function Sc(e) {
	if (e === void 0) return ma("GRPC error has no .code"), L.UNKNOWN;
	switch (e) {
		case J.OK: return L.OK;
		case J.CANCELLED: return L.CANCELLED;
		case J.UNKNOWN: return L.UNKNOWN;
		case J.DEADLINE_EXCEEDED: return L.DEADLINE_EXCEEDED;
		case J.RESOURCE_EXHAUSTED: return L.RESOURCE_EXHAUSTED;
		case J.INTERNAL: return L.INTERNAL;
		case J.UNAVAILABLE: return L.UNAVAILABLE;
		case J.UNAUTHENTICATED: return L.UNAUTHENTICATED;
		case J.INVALID_ARGUMENT: return L.INVALID_ARGUMENT;
		case J.NOT_FOUND: return L.NOT_FOUND;
		case J.ALREADY_EXISTS: return L.ALREADY_EXISTS;
		case J.PERMISSION_DENIED: return L.PERMISSION_DENIED;
		case J.FAILED_PRECONDITION: return L.FAILED_PRECONDITION;
		case J.ABORTED: return L.ABORTED;
		case J.OUT_OF_RANGE: return L.OUT_OF_RANGE;
		case J.UNIMPLEMENTED: return L.UNIMPLEMENTED;
		case J.DATA_LOSS: return L.DATA_LOSS;
		default: return P();
	}
}
(Y = J ||= {})[Y.OK = 0] = "OK", Y[Y.CANCELLED = 1] = "CANCELLED", Y[Y.UNKNOWN = 2] = "UNKNOWN", Y[Y.INVALID_ARGUMENT = 3] = "INVALID_ARGUMENT", Y[Y.DEADLINE_EXCEEDED = 4] = "DEADLINE_EXCEEDED", Y[Y.NOT_FOUND = 5] = "NOT_FOUND", Y[Y.ALREADY_EXISTS = 6] = "ALREADY_EXISTS", Y[Y.PERMISSION_DENIED = 7] = "PERMISSION_DENIED", Y[Y.UNAUTHENTICATED = 16] = "UNAUTHENTICATED", Y[Y.RESOURCE_EXHAUSTED = 8] = "RESOURCE_EXHAUSTED", Y[Y.FAILED_PRECONDITION = 9] = "FAILED_PRECONDITION", Y[Y.ABORTED = 10] = "ABORTED", Y[Y.OUT_OF_RANGE = 11] = "OUT_OF_RANGE", Y[Y.UNIMPLEMENTED = 12] = "UNIMPLEMENTED", Y[Y.INTERNAL = 13] = "INTERNAL", Y[Y.UNAVAILABLE = 14] = "UNAVAILABLE", Y[Y.DATA_LOSS = 15] = "DATA_LOSS";
var Cc = null;
function wc() {
	return new TextEncoder();
}
var Tc = new Zi([4294967295, 4294967295], 0);
function Ec(e) {
	let t = wc().encode(e), n = new Qi();
	return n.update(t), new Uint8Array(n.digest());
}
function Dc(e) {
	let t = new DataView(e.buffer), n = t.getUint32(0, !0), r = t.getUint32(4, !0), i = t.getUint32(8, !0), a = t.getUint32(12, !0);
	return [new Zi([n, r], 0), new Zi([i, a], 0)];
}
var Oc = class e {
	constructor(e, t, n) {
		if (this.bitmap = e, this.padding = t, this.hashCount = n, t < 0 || t >= 8) throw new kc(`Invalid padding: ${t}`);
		if (n < 0 || e.length > 0 && this.hashCount === 0) throw new kc(`Invalid hash count: ${n}`);
		if (e.length === 0 && t !== 0) throw new kc(`Invalid padding when bitmap length is 0: ${t}`);
		this.Ie = 8 * e.length - t, this.Te = Zi.fromNumber(this.Ie);
	}
	Ee(e, t, n) {
		let r = e.add(t.multiply(Zi.fromNumber(n)));
		return r.compare(Tc) === 1 && (r = new Zi([r.getBits(0), r.getBits(1)], 0)), r.modulo(this.Te).toNumber();
	}
	de(e) {
		return (this.bitmap[Math.floor(e / 8)] & 1 << e % 8) != 0;
	}
	mightContain(e) {
		if (this.Ie === 0) return !1;
		let [t, n] = Dc(Ec(e));
		for (let e = 0; e < this.hashCount; e++) {
			let r = this.Ee(t, n, e);
			if (!this.de(r)) return !1;
		}
		return !0;
	}
	static create(t, n, r) {
		let i = t % 8 == 0 ? 0 : 8 - t % 8, a = new e(new Uint8Array(Math.ceil(t / 8)), i, n);
		return r.forEach(((e) => a.insert(e))), a;
	}
	insert(e) {
		if (this.Ie === 0) return;
		let [t, n] = Dc(Ec(e));
		for (let e = 0; e < this.hashCount; e++) {
			let r = this.Ee(t, n, e);
			this.Ae(r);
		}
	}
	Ae(e) {
		let t = Math.floor(e / 8), n = e % 8;
		this.bitmap[t] |= 1 << n;
	}
}, kc = class extends Error {
	constructor() {
		super(...arguments), this.name = "BloomFilterError";
	}
}, Ac = class e {
	constructor(e, t, n, r, i) {
		this.snapshotVersion = e, this.targetChanges = t, this.targetMismatches = n, this.documentUpdates = r, this.resolvedLimboDocuments = i;
	}
	static createSynthesizedRemoteEventForCurrentChange(t, n, r) {
		let i = /* @__PURE__ */ new Map();
		return i.set(t, jc.createSynthesizedTargetChangeForCurrentChange(t, n, r)), new e(B.min(), i, new W(z), Os(), q());
	}
}, jc = class e {
	constructor(e, t, n, r, i) {
		this.resumeToken = e, this.current = t, this.addedDocuments = n, this.modifiedDocuments = r, this.removedDocuments = i;
	}
	static createSynthesizedTargetChangeForCurrentChange(t, n, r) {
		return new e(r, n, q(), q(), q());
	}
}, Mc = class {
	constructor(e, t, n, r) {
		this.Re = e, this.removedTargetIds = t, this.key = n, this.Ve = r;
	}
}, Nc = class {
	constructor(e, t) {
		this.targetId = e, this.me = t;
	}
}, Pc = class {
	constructor(e, t, n = ao.EMPTY_BYTE_STRING, r = null) {
		this.state = e, this.targetIds = t, this.resumeToken = n, this.cause = r;
	}
}, Fc = class {
	constructor() {
		this.fe = 0, this.ge = Rc(), this.pe = ao.EMPTY_BYTE_STRING, this.ye = !1, this.we = !0;
	}
	get current() {
		return this.ye;
	}
	get resumeToken() {
		return this.pe;
	}
	get Se() {
		return this.fe !== 0;
	}
	get be() {
		return this.we;
	}
	De(e) {
		e.approximateByteSize() > 0 && (this.we = !0, this.pe = e);
	}
	ve() {
		let e = q(), t = q(), n = q();
		return this.ge.forEach(((r, i) => {
			switch (i) {
				case 0:
					e = e.add(r);
					break;
				case 2:
					t = t.add(r);
					break;
				case 1:
					n = n.add(r);
					break;
				default: P();
			}
		})), new jc(this.pe, this.ye, e, t, n);
	}
	Ce() {
		this.we = !1, this.ge = Rc();
	}
	Fe(e, t) {
		this.we = !0, this.ge = this.ge.insert(e, t);
	}
	Me(e) {
		this.we = !0, this.ge = this.ge.remove(e);
	}
	xe() {
		this.fe += 1;
	}
	Oe() {
		--this.fe, F(this.fe >= 0);
	}
	Ne() {
		this.we = !0, this.ye = !0;
	}
}, Ic = class {
	constructor(e) {
		this.Le = e, this.Be = /* @__PURE__ */ new Map(), this.ke = Os(), this.qe = Lc(), this.Qe = new W(z);
	}
	Ke(e) {
		for (let t of e.Re) e.Ve && e.Ve.isFoundDocument() ? this.$e(t, e.Ve) : this.Ue(t, e.key, e.Ve);
		for (let t of e.removedTargetIds) this.Ue(t, e.key, e.Ve);
	}
	We(e) {
		this.forEachTarget(e, ((t) => {
			let n = this.Ge(t);
			switch (e.state) {
				case 0:
					this.ze(t) && n.De(e.resumeToken);
					break;
				case 1:
					n.Oe(), n.Se || n.Ce(), n.De(e.resumeToken);
					break;
				case 2:
					n.Oe(), n.Se || this.removeTarget(t);
					break;
				case 3:
					this.ze(t) && (n.Ne(), n.De(e.resumeToken));
					break;
				case 4:
					this.ze(t) && (this.je(t), n.De(e.resumeToken));
					break;
				default: P();
			}
		}));
	}
	forEachTarget(e, t) {
		e.targetIds.length > 0 ? e.targetIds.forEach(t) : this.Be.forEach(((e, n) => {
			this.ze(n) && t(n);
		}));
	}
	He(e) {
		let t = e.targetId, n = e.me.count, r = this.Je(t);
		if (r) {
			let i = r.target;
			if (cs(i)) if (n === 0) {
				let e = new H(i.path);
				this.Ue(t, e, Io.newNoDocument(e, B.min()));
			} else F(n === 1);
			else {
				let r = this.Ye(t);
				if (r !== n) {
					let n = this.Ze(e), i = n ? this.Xe(n, e, r) : 1;
					if (i !== 0) {
						this.je(t);
						let e = i === 2 ? "TargetPurposeExistenceFilterMismatchBloom" : "TargetPurposeExistenceFilterMismatch";
						this.Qe = this.Qe.insert(t, e);
					}
					Cc?.et(function(e, t, n, r, i) {
						let a = {
							localCacheCount: e,
							existenceFilterCount: t.count,
							databaseId: n.database,
							projectId: n.projectId
						}, o = t.unchangedNames;
						return o && (a.bloomFilter = {
							applied: i === 0,
							hashCount: o?.hashCount ?? 0,
							bitmapLength: o?.bits?.bitmap?.length ?? 0,
							padding: o?.bits?.padding ?? 0,
							mightContain: (e) => {
								var t;
								return (t = r?.mightContain(e)) != null && t;
							}
						}), a;
					}(r, e.me, this.Le.tt(), n, i));
				}
			}
		}
	}
	Ze(e) {
		let t = e.me.unchangedNames;
		if (!t || !t.bits) return null;
		let { bits: { bitmap: n = "", padding: r = 0 }, hashCount: i = 0 } = t, a, o;
		try {
			a = co(n).toUint8Array();
		} catch (e) {
			if (e instanceof io) return ha("Decoding the base64 bloom filter in existence filter failed (" + e.message + "); ignoring the bloom filter and falling back to full re-query."), null;
			throw e;
		}
		try {
			o = new Oc(a, r, i);
		} catch (e) {
			return ha(e instanceof kc ? "BloomFilter error: " : "Applying bloom filter failed: ", e), null;
		}
		return o.Ie === 0 ? null : o;
	}
	Xe(e, t, n) {
		return t.me.count === n - this.nt(e, t.targetId) ? 0 : 2;
	}
	nt(e, t) {
		let n = this.Le.getRemoteKeysForTarget(t), r = 0;
		return n.forEach(((n) => {
			let i = this.Le.tt(), a = `projects/${i.projectId}/databases/${i.database}/documents/${n.path.canonicalString()}`;
			e.mightContain(a) || (this.Ue(t, n, null), r++);
		})), r;
	}
	rt(e) {
		let t = /* @__PURE__ */ new Map();
		this.Be.forEach(((n, r) => {
			let i = this.Je(r);
			if (i) {
				if (n.current && cs(i.target)) {
					let t = new H(i.target.path);
					this.ke.get(t) !== null || this.it(r, t) || this.Ue(r, t, Io.newNoDocument(t, e));
				}
				n.be && (t.set(r, n.ve()), n.Ce());
			}
		}));
		let n = q();
		this.qe.forEach(((e, t) => {
			let r = !0;
			t.forEachWhile(((e) => {
				let t = this.Je(e);
				return !t || t.purpose === "TargetPurposeLimboResolution" || (r = !1, !1);
			})), r && (n = n.add(e));
		})), this.ke.forEach(((t, n) => n.setReadTime(e)));
		let r = new Ac(e, t, this.Qe, this.ke, n);
		return this.ke = Os(), this.qe = Lc(), this.Qe = new W(z), r;
	}
	$e(e, t) {
		if (!this.ze(e)) return;
		let n = this.it(e, t.key) ? 2 : 0;
		this.Ge(e).Fe(t.key, n), this.ke = this.ke.insert(t.key, t), this.qe = this.qe.insert(t.key, this.st(t.key).add(e));
	}
	Ue(e, t, n) {
		if (!this.ze(e)) return;
		let r = this.Ge(e);
		this.it(e, t) ? r.Fe(t, 1) : r.Me(t), this.qe = this.qe.insert(t, this.st(t).delete(e)), n && (this.ke = this.ke.insert(t, n));
	}
	removeTarget(e) {
		this.Be.delete(e);
	}
	Ye(e) {
		let t = this.Ge(e).ve();
		return this.Le.getRemoteKeysForTarget(e).size + t.addedDocuments.size - t.removedDocuments.size;
	}
	xe(e) {
		this.Ge(e).xe();
	}
	Ge(e) {
		let t = this.Be.get(e);
		return t || (t = new Fc(), this.Be.set(e, t)), t;
	}
	st(e) {
		let t = this.qe.get(e);
		return t || (t = new to(z), this.qe = this.qe.insert(e, t)), t;
	}
	ze(e) {
		let t = this.Je(e) !== null;
		return t || N("WatchChangeAggregator", "Detected inactive target", e), t;
	}
	Je(e) {
		let t = this.Be.get(e);
		return t && t.Se ? null : this.Le.ot(e);
	}
	je(e) {
		this.Be.set(e, new Fc()), this.Le.getRemoteKeysForTarget(e).forEach(((t) => {
			this.Ue(e, t, null);
		}));
	}
	it(e, t) {
		return this.Le.getRemoteKeysForTarget(e).has(t);
	}
};
function Lc() {
	return new W(H.comparator);
}
function Rc() {
	return new W(H.comparator);
}
var zc = {
	asc: "ASCENDING",
	desc: "DESCENDING"
}, Bc = {
	"<": "LESS_THAN",
	"<=": "LESS_THAN_OR_EQUAL",
	">": "GREATER_THAN",
	">=": "GREATER_THAN_OR_EQUAL",
	"==": "EQUAL",
	"!=": "NOT_EQUAL",
	"array-contains": "ARRAY_CONTAINS",
	in: "IN",
	"not-in": "NOT_IN",
	"array-contains-any": "ARRAY_CONTAINS_ANY"
}, Vc = {
	and: "AND",
	or: "OR"
}, Hc = class {
	constructor(e, t) {
		this.databaseId = e, this.useProto3Json = t;
	}
};
function Uc(e, t) {
	return e.useProto3Json || Wa(t) ? t : { value: t };
}
function Wc(e, t) {
	return e.useProto3Json ? `${(/* @__PURE__ */ new Date(1e3 * t.seconds)).toISOString().replace(/\.\d*/, "").replace("Z", "")}.${("000000000" + t.nanoseconds).slice(-9)}Z` : {
		seconds: "" + t.seconds,
		nanos: t.nanoseconds
	};
}
function Gc(e, t) {
	return e.useProto3Json ? t.toBase64() : t.toUint8Array();
}
function Kc(e, t) {
	return Wc(e, t.toTimestamp());
}
function qc(e) {
	return F(!!e), B.fromTimestamp(function(e) {
		let t = so(e);
		return new ka(t.seconds, t.nanos);
	}(e));
}
function Jc(e, t) {
	return Yc(e, t).canonicalString();
}
function Yc(e, t) {
	let n = function(e) {
		return new V([
			"projects",
			e.projectId,
			"databases",
			e.database
		]);
	}(e).child("documents");
	return t === void 0 ? n : n.child(t);
}
function Xc(e) {
	let t = V.fromString(e);
	return F(yl(t)), t;
}
function Zc(e, t) {
	return Jc(e.databaseId, t.path);
}
function Qc(e, t) {
	let n = Xc(t);
	if (n.get(1) !== e.databaseId.projectId) throw new R(L.INVALID_ARGUMENT, "Tried to deserialize key from different project: " + n.get(1) + " vs " + e.databaseId.projectId);
	if (n.get(3) !== e.databaseId.database) throw new R(L.INVALID_ARGUMENT, "Tried to deserialize key from different database: " + n.get(3) + " vs " + e.databaseId.database);
	return new H(nl(n));
}
function $c(e, t) {
	return Jc(e.databaseId, t);
}
function el(e) {
	let t = Xc(e);
	return t.length === 4 ? V.emptyPath() : nl(t);
}
function tl(e) {
	return new V([
		"projects",
		e.databaseId.projectId,
		"databases",
		e.databaseId.database
	]).canonicalString();
}
function nl(e) {
	return F(e.length > 4 && e.get(4) === "documents"), e.popFirst(5);
}
function rl(e, t, n) {
	return {
		name: Zc(e, t),
		fields: n.value.mapValue.fields
	};
}
function il(e, t) {
	let n;
	if ("targetChange" in t) {
		t.targetChange;
		let r = function(e) {
			return e === "NO_CHANGE" ? 0 : e === "ADD" ? 1 : e === "REMOVE" ? 2 : e === "CURRENT" ? 3 : e === "RESET" ? 4 : P();
		}(t.targetChange.targetChangeType || "NO_CHANGE"), i = t.targetChange.targetIds || [], a = function(e, t) {
			return e.useProto3Json ? (F(t === void 0 || typeof t == "string"), ao.fromBase64String(t || "")) : (F(t === void 0 || t instanceof Buffer || t instanceof Uint8Array), ao.fromUint8Array(t || new Uint8Array()));
		}(e, t.targetChange.resumeToken), o = t.targetChange.cause;
		n = new Pc(r, i, a, o && function(e) {
			return new R(e.code === void 0 ? L.UNKNOWN : Sc(e.code), e.message || "");
		}(o) || null);
	} else if ("documentChange" in t) {
		t.documentChange;
		let r = t.documentChange;
		r.document, r.document.name, r.document.updateTime;
		let i = Qc(e, r.document.name), a = qc(r.document.updateTime), o = r.document.createTime ? qc(r.document.createTime) : B.min(), s = new Po({ mapValue: { fields: r.document.fields } }), c = Io.newFoundDocument(i, a, o, s);
		n = new Mc(r.targetIds || [], r.removedTargetIds || [], c.key, c);
	} else if ("documentDelete" in t) {
		t.documentDelete;
		let r = t.documentDelete;
		r.document;
		let i = Qc(e, r.document), a = r.readTime ? qc(r.readTime) : B.min(), o = Io.newNoDocument(i, a);
		n = new Mc([], r.removedTargetIds || [], o.key, o);
	} else if ("documentRemove" in t) {
		t.documentRemove;
		let r = t.documentRemove;
		r.document;
		let i = Qc(e, r.document);
		n = new Mc([], r.removedTargetIds || [], i, null);
	} else {
		if (!("filter" in t)) return P();
		{
			t.filter;
			let e = t.filter;
			e.targetId;
			let { count: r = 0, unchangedNames: i } = e, a = new bc(r, i), o = e.targetId;
			n = new Nc(o, a);
		}
	}
	return n;
}
function al(e, t) {
	let n;
	if (t instanceof uc) n = { update: rl(e, t.key, t.value) };
	else if (t instanceof hc) n = { delete: Zc(e, t.key) };
	else if (t instanceof dc) n = {
		update: rl(e, t.key, t.data),
		updateMask: vl(t.fieldMask)
	};
	else {
		if (!(t instanceof gc)) return P();
		n = { verify: Zc(e, t.key) };
	}
	return t.fieldTransforms.length > 0 && (n.updateTransforms = t.fieldTransforms.map(((e) => function(e, t) {
		let n = t.transform;
		if (n instanceof Ks) return {
			fieldPath: t.field.canonicalString(),
			setToServerValue: "REQUEST_TIME"
		};
		if (n instanceof qs) return {
			fieldPath: t.field.canonicalString(),
			appendMissingElements: { values: n.elements }
		};
		if (n instanceof Ys) return {
			fieldPath: t.field.canonicalString(),
			removeAllFromArray: { values: n.elements }
		};
		if (n instanceof Zs) return {
			fieldPath: t.field.canonicalString(),
			increment: n.Pe
		};
		throw P();
	}(0, e)))), t.precondition.isNone || (n.currentDocument = function(e, t) {
		return t.updateTime === void 0 ? t.exists === void 0 ? P() : { exists: t.exists } : { updateTime: Kc(e, t.updateTime) };
	}(e, t.precondition)), n;
}
function ol(e, t) {
	return e && e.length > 0 ? (F(t !== void 0), e.map(((e) => function(e, t) {
		let n = e.updateTime ? qc(e.updateTime) : qc(t);
		return n.isEqual(B.min()) && (n = qc(t)), new tc(n, e.transformResults || []);
	}(e, t)))) : [];
}
function sl(e, t) {
	return { documents: [$c(e, t.path)] };
}
function cl(e, t) {
	let n = { structuredQuery: {} }, r = t.path, i;
	t.collectionGroup === null ? (i = r.popLast(), n.structuredQuery.from = [{ collectionId: r.lastSegment() }]) : (i = r, n.structuredQuery.from = [{
		collectionId: t.collectionGroup,
		allDescendants: !0
	}]), n.parent = $c(e, i);
	let a = function(e) {
		if (e.length !== 0) return _l(Uo.create(e, "and"));
	}(t.filters);
	a && (n.structuredQuery.where = a);
	let o = function(e) {
		if (e.length !== 0) return e.map(((e) => function(e) {
			return {
				field: hl(e.field),
				direction: fl(e.dir)
			};
		}(e)));
	}(t.orderBy);
	o && (n.structuredQuery.orderBy = o);
	let s = Uc(e, t.limit);
	return s !== null && (n.structuredQuery.limit = s), t.startAt && (n.structuredQuery.startAt = function(e) {
		return {
			before: e.inclusive,
			values: e.position
		};
	}(t.startAt)), t.endAt && (n.structuredQuery.endAt = function(e) {
		return {
			before: !e.inclusive,
			values: e.position
		};
	}(t.endAt)), {
		_t: n,
		parent: i
	};
}
function ll(e) {
	let t = el(e.parent), n = e.structuredQuery, r = n.from ? n.from.length : 0, i = null;
	if (r > 0) {
		F(r === 1);
		let e = n.from[0];
		e.allDescendants ? i = e.collectionId : t = t.child(e.collectionId);
	}
	let a = [];
	n.where && (a = function(e) {
		let t = dl(e);
		return t instanceof Uo && Go(t) ? t.getFilters() : [t];
	}(n.where));
	let o = [];
	n.orderBy && (o = function(e) {
		return e.map(((e) => function(e) {
			return new Bo(gl(e.field), function(e) {
				switch (e) {
					case "ASCENDING": return "asc";
					case "DESCENDING": return "desc";
					default: return;
				}
			}(e.direction));
		}(e)));
	}(n.orderBy));
	let s = null;
	n.limit && (s = function(e) {
		let t;
		return t = typeof e == "object" ? e.value : e, Wa(t) ? null : t;
	}(n.limit));
	let c = null;
	n.startAt && (c = function(e) {
		let t = !!e.before;
		return new Lo(e.values || [], t);
	}(n.startAt));
	let l = null;
	return n.endAt && (l = function(e) {
		let t = !e.before;
		return new Lo(e.values || [], t);
	}(n.endAt)), us(t, i, o, a, s, "F", c, l);
}
function ul(e, t) {
	let n = function(e) {
		switch (e) {
			case "TargetPurposeListen": return null;
			case "TargetPurposeExistenceFilterMismatch": return "existence-filter-mismatch";
			case "TargetPurposeExistenceFilterMismatchBloom": return "existence-filter-mismatch-bloom";
			case "TargetPurposeLimboResolution": return "limbo-document";
			default: return P();
		}
	}(t.purpose);
	return n == null ? null : { "goog-listen-tags": n };
}
function dl(e) {
	return e.unaryFilter === void 0 ? e.fieldFilter === void 0 ? e.compositeFilter === void 0 ? P() : function(e) {
		return Uo.create(e.compositeFilter.filters.map(((e) => dl(e))), function(e) {
			switch (e) {
				case "AND": return "and";
				case "OR": return "or";
				default: return P();
			}
		}(e.compositeFilter.op));
	}(e) : function(e) {
		return K.create(gl(e.fieldFilter.field), function(e) {
			switch (e) {
				case "EQUAL": return "==";
				case "NOT_EQUAL": return "!=";
				case "GREATER_THAN": return ">";
				case "GREATER_THAN_OR_EQUAL": return ">=";
				case "LESS_THAN": return "<";
				case "LESS_THAN_OR_EQUAL": return "<=";
				case "ARRAY_CONTAINS": return "array-contains";
				case "IN": return "in";
				case "NOT_IN": return "not-in";
				case "ARRAY_CONTAINS_ANY": return "array-contains-any";
				default: return P();
			}
		}(e.fieldFilter.op), e.fieldFilter.value);
	}(e) : function(e) {
		switch (e.unaryFilter.op) {
			case "IS_NAN":
				let t = gl(e.unaryFilter.field);
				return K.create(t, "==", { doubleValue: NaN });
			case "IS_NULL":
				let n = gl(e.unaryFilter.field);
				return K.create(n, "==", { nullValue: "NULL_VALUE" });
			case "IS_NOT_NAN":
				let r = gl(e.unaryFilter.field);
				return K.create(r, "!=", { doubleValue: NaN });
			case "IS_NOT_NULL":
				let i = gl(e.unaryFilter.field);
				return K.create(i, "!=", { nullValue: "NULL_VALUE" });
			default: return P();
		}
	}(e);
}
function fl(e) {
	return zc[e];
}
function pl(e) {
	return Bc[e];
}
function ml(e) {
	return Vc[e];
}
function hl(e) {
	return { fieldPath: e.canonicalString() };
}
function gl(e) {
	return Ma.fromServerFormat(e.fieldPath);
}
function _l(e) {
	return e instanceof K ? function(e) {
		if (e.op === "==") {
			if (ko(e.value)) return { unaryFilter: {
				field: hl(e.field),
				op: "IS_NAN"
			} };
			if (Oo(e.value)) return { unaryFilter: {
				field: hl(e.field),
				op: "IS_NULL"
			} };
		} else if (e.op === "!=") {
			if (ko(e.value)) return { unaryFilter: {
				field: hl(e.field),
				op: "IS_NOT_NAN"
			} };
			if (Oo(e.value)) return { unaryFilter: {
				field: hl(e.field),
				op: "IS_NOT_NULL"
			} };
		}
		return { fieldFilter: {
			field: hl(e.field),
			op: pl(e.op),
			value: e.value
		} };
	}(e) : e instanceof Uo ? function(e) {
		let t = e.getFilters().map(((e) => _l(e)));
		return t.length === 1 ? t[0] : { compositeFilter: {
			op: ml(e.op),
			filters: t
		} };
	}(e) : P();
}
function vl(e) {
	let t = [];
	return e.fields.forEach(((e) => t.push(e.canonicalString()))), { fieldPaths: t };
}
function yl(e) {
	return e.length >= 4 && e.get(0) === "projects" && e.get(2) === "databases";
}
var bl = class e {
	constructor(e, t, n, r, i = B.min(), a = B.min(), o = ao.EMPTY_BYTE_STRING, s = null) {
		this.target = e, this.targetId = t, this.purpose = n, this.sequenceNumber = r, this.snapshotVersion = i, this.lastLimboFreeSnapshotVersion = a, this.resumeToken = o, this.expectedCount = s;
	}
	withSequenceNumber(t) {
		return new e(this.target, this.targetId, this.purpose, t, this.snapshotVersion, this.lastLimboFreeSnapshotVersion, this.resumeToken, this.expectedCount);
	}
	withResumeToken(t, n) {
		return new e(this.target, this.targetId, this.purpose, this.sequenceNumber, n, this.lastLimboFreeSnapshotVersion, t, null);
	}
	withExpectedCount(t) {
		return new e(this.target, this.targetId, this.purpose, this.sequenceNumber, this.snapshotVersion, this.lastLimboFreeSnapshotVersion, this.resumeToken, t);
	}
	withLastLimboFreeSnapshotVersion(t) {
		return new e(this.target, this.targetId, this.purpose, this.sequenceNumber, this.snapshotVersion, t, this.resumeToken, this.expectedCount);
	}
}, xl = class {
	constructor(e) {
		this.ct = e;
	}
};
function Sl(e) {
	let t = ll({
		parent: e.parent,
		structuredQuery: e.structuredQuery
	});
	return e.limitType === "LAST" ? vs(t, t.limit, "L") : t;
}
var Cl = class {
	constructor() {}
	It(e, t) {
		this.Tt(e, t), t.Et();
	}
	Tt(e, t) {
		if ("nullValue" in e) this.dt(t, 5);
		else if ("booleanValue" in e) this.dt(t, 10), t.At(+!!e.booleanValue);
		else if ("integerValue" in e) this.dt(t, 15), t.At(G(e.integerValue));
		else if ("doubleValue" in e) {
			let n = G(e.doubleValue);
			isNaN(n) ? this.dt(t, 13) : (this.dt(t, 15), Ga(n) ? t.At(0) : t.At(n));
		} else if ("timestampValue" in e) {
			let n = e.timestampValue;
			this.dt(t, 20), typeof n == "string" && (n = so(n)), t.Rt(`${n.seconds || ""}`), t.At(n.nanos || 0);
		} else if ("stringValue" in e) this.Vt(e.stringValue, t), this.ft(t);
		else if ("bytesValue" in e) this.dt(t, 30), t.gt(co(e.bytesValue)), this.ft(t);
		else if ("referenceValue" in e) this.yt(e.referenceValue, t);
		else if ("geoPointValue" in e) {
			let n = e.geoPointValue;
			this.dt(t, 45), t.At(n.latitude || 0), t.At(n.longitude || 0);
		} else "mapValue" in e ? No(e) ? this.dt(t, 2 ** 53 - 1) : jo(e) ? this.wt(e.mapValue, t) : (this.St(e.mapValue, t), this.ft(t)) : "arrayValue" in e ? (this.bt(e.arrayValue, t), this.ft(t)) : P();
	}
	Vt(e, t) {
		this.dt(t, 25), this.Dt(e, t);
	}
	Dt(e, t) {
		t.Rt(e);
	}
	St(e, t) {
		let n = e.fields || {};
		this.dt(t, 55);
		for (let e of Object.keys(n)) this.Vt(e, t), this.Tt(n[e], t);
	}
	wt(e, t) {
		let n = e.fields || {};
		this.dt(t, 53);
		let r = "value", i = n[r].arrayValue?.values?.length || 0;
		this.dt(t, 15), t.At(G(i)), this.Vt(r, t), this.Tt(n[r], t);
	}
	bt(e, t) {
		let n = e.values || [];
		this.dt(t, 50);
		for (let e of n) this.Tt(e, t);
	}
	yt(e, t) {
		this.dt(t, 37), H.fromName(e).path.forEach(((e) => {
			this.dt(t, 60), this.Dt(e, t);
		}));
	}
	dt(e, t) {
		e.At(t);
	}
	ft(e) {
		e.At(2);
	}
};
Cl.vt = new Cl();
var wl = class {
	constructor() {
		this.un = new Tl();
	}
	addToCollectionParentIndex(e, t) {
		return this.un.add(t), U.resolve();
	}
	getCollectionParents(e, t) {
		return U.resolve(this.un.getEntries(t));
	}
	addFieldIndex(e, t) {
		return U.resolve();
	}
	deleteFieldIndex(e, t) {
		return U.resolve();
	}
	deleteAllFieldIndexes(e) {
		return U.resolve();
	}
	createTargetIndexes(e, t) {
		return U.resolve();
	}
	getDocumentsMatchingTarget(e, t) {
		return U.resolve(null);
	}
	getIndexType(e, t) {
		return U.resolve(0);
	}
	getFieldIndexes(e, t) {
		return U.resolve([]);
	}
	getNextCollectionGroupToUpdate(e) {
		return U.resolve(null);
	}
	getMinOffset(e, t) {
		return U.resolve(Ia.min());
	}
	getMinOffsetFromCollectionGroup(e, t) {
		return U.resolve(Ia.min());
	}
	updateCollectionGroup(e, t, n) {
		return U.resolve();
	}
	updateIndexEntries(e, t) {
		return U.resolve();
	}
}, Tl = class {
	constructor() {
		this.index = {};
	}
	add(e) {
		let t = e.lastSegment(), n = e.popLast(), r = this.index[t] || new to(V.comparator), i = !r.has(n);
		return this.index[t] = r.add(n), i;
	}
	has(e) {
		let t = e.lastSegment(), n = e.popLast(), r = this.index[t];
		return r && r.has(n);
	}
	getEntries(e) {
		return (this.index[e] || new to(V.comparator)).toArray();
	}
}, El = {
	didRun: !1,
	sequenceNumbersCollected: 0,
	targetsRemoved: 0,
	documentsRemoved: 0
}, Dl = class e {
	constructor(e, t, n) {
		this.cacheSizeCollectionThreshold = e, this.percentileToCollect = t, this.maximumSequenceNumbersToCollect = n;
	}
	static withCacheSize(t) {
		return new e(t, e.DEFAULT_COLLECTION_PERCENTILE, e.DEFAULT_MAX_SEQUENCE_NUMBERS_TO_COLLECT);
	}
};
Dl.DEFAULT_COLLECTION_PERCENTILE = 10, Dl.DEFAULT_MAX_SEQUENCE_NUMBERS_TO_COLLECT = 1e3, Dl.DEFAULT = new Dl(41943040, Dl.DEFAULT_COLLECTION_PERCENTILE, Dl.DEFAULT_MAX_SEQUENCE_NUMBERS_TO_COLLECT), Dl.DISABLED = new Dl(-1, 0, 0);
var Ol = class e {
	constructor(e) {
		this.Ln = e;
	}
	next() {
		return this.Ln += 2, this.Ln;
	}
	static Bn() {
		return new e(0);
	}
	static kn() {
		return new e(-1);
	}
};
function kl([e, t], [n, r]) {
	let i = z(e, n);
	return i === 0 ? z(t, r) : i;
}
var Al = class {
	constructor(e) {
		this.Un = e, this.buffer = new to(kl), this.Wn = 0;
	}
	Gn() {
		return ++this.Wn;
	}
	zn(e) {
		let t = [e, this.Gn()];
		if (this.buffer.size < this.Un) this.buffer = this.buffer.add(t);
		else {
			let e = this.buffer.last();
			kl(t, e) < 0 && (this.buffer = this.buffer.delete(e).add(t));
		}
	}
	get maxValue() {
		return this.buffer.last()[0];
	}
}, jl = class {
	constructor(e, t, n) {
		this.garbageCollector = e, this.asyncQueue = t, this.localStore = n, this.jn = null;
	}
	start() {
		this.garbageCollector.params.cacheSizeCollectionThreshold !== -1 && this.Hn(6e4);
	}
	stop() {
		this.jn &&= (this.jn.cancel(), null);
	}
	get started() {
		return this.jn !== null;
	}
	Hn(e) {
		N("LruGarbageCollector", `Garbage collection scheduled in ${e}ms`), this.jn = this.asyncQueue.enqueueAfterDelay("lru_garbage_collection", e, (async () => {
			this.jn = null;
			try {
				await this.localStore.collectGarbage(this.garbageCollector);
			} catch (e) {
				Ha(e) ? N("LruGarbageCollector", "Ignoring IndexedDB error during garbage collection: ", e) : await Ba(e);
			}
			await this.Hn(3e5);
		}));
	}
}, Ml = class {
	constructor(e, t) {
		this.Jn = e, this.params = t;
	}
	calculateTargetCount(e, t) {
		return this.Jn.Yn(e).next(((e) => Math.floor(t / 100 * e)));
	}
	nthSequenceNumber(e, t) {
		if (t === 0) return U.resolve(Ua.oe);
		let n = new Al(t);
		return this.Jn.forEachTarget(e, ((e) => n.zn(e.sequenceNumber))).next((() => this.Jn.Zn(e, ((e) => n.zn(e))))).next((() => n.maxValue));
	}
	removeTargets(e, t, n) {
		return this.Jn.removeTargets(e, t, n);
	}
	removeOrphanedDocuments(e, t) {
		return this.Jn.removeOrphanedDocuments(e, t);
	}
	collect(e, t) {
		return this.params.cacheSizeCollectionThreshold === -1 ? (N("LruGarbageCollector", "Garbage collection skipped; disabled"), U.resolve(El)) : this.getCacheSize(e).next(((n) => n < this.params.cacheSizeCollectionThreshold ? (N("LruGarbageCollector", `Garbage collection skipped; Cache size ${n} is lower than threshold ${this.params.cacheSizeCollectionThreshold}`), El) : this.Xn(e, t)));
	}
	getCacheSize(e) {
		return this.Jn.getCacheSize(e);
	}
	Xn(e, t) {
		let n, r, i, a, o, s, c, l = Date.now();
		return this.calculateTargetCount(e, this.params.percentileToCollect).next(((t) => (t > this.params.maximumSequenceNumbersToCollect ? (N("LruGarbageCollector", `Capping sequence numbers to collect down to the maximum of ${this.params.maximumSequenceNumbersToCollect} from ${t}`), r = this.params.maximumSequenceNumbersToCollect) : r = t, a = Date.now(), this.nthSequenceNumber(e, r)))).next(((r) => (n = r, o = Date.now(), this.removeTargets(e, n, t)))).next(((t) => (i = t, s = Date.now(), this.removeOrphanedDocuments(e, n)))).next(((e) => (c = Date.now(), pa() <= M.DEBUG && N("LruGarbageCollector", `LRU Garbage Collection\n\tCounted targets in ${a - l}ms\n\tDetermined least recently used ${r} in ` + (o - a) + `ms
\tRemoved ${i} targets in ` + (s - o) + `ms
\tRemoved ${e} documents in ` + (c - s) + `ms
Total Duration: ${c - l}ms`), U.resolve({
			didRun: !0,
			sequenceNumbersCollected: r,
			targetsRemoved: i,
			documentsRemoved: e
		}))));
	}
};
function Nl(e, t) {
	return new Ml(e, t);
}
var Pl = class {
	constructor() {
		this.changes = new Es(((e) => e.toString()), ((e, t) => e.isEqual(t))), this.changesApplied = !1;
	}
	addEntry(e) {
		this.assertNotApplied(), this.changes.set(e.key, e);
	}
	removeEntry(e, t) {
		this.assertNotApplied(), this.changes.set(e, Io.newInvalidDocument(e).setReadTime(t));
	}
	getEntry(e, t) {
		this.assertNotApplied();
		let n = this.changes.get(t);
		return n === void 0 ? this.getFromCache(e, t) : U.resolve(n);
	}
	getEntries(e, t) {
		return this.getAllFromCache(e, t);
	}
	apply(e) {
		return this.assertNotApplied(), this.changesApplied = !0, this.applyChanges(e);
	}
	assertNotApplied() {}
}, Fl = class {
	constructor(e, t) {
		this.overlayedDocument = e, this.mutatedFields = t;
	}
}, Il = class {
	constructor(e, t, n, r) {
		this.remoteDocumentCache = e, this.mutationQueue = t, this.documentOverlayCache = n, this.indexManager = r;
	}
	getDocument(e, t) {
		let n = null;
		return this.documentOverlayCache.getOverlay(e, t).next(((r) => (n = r, this.remoteDocumentCache.getEntry(e, t)))).next(((e) => (n !== null && sc(n.mutation, e, ro.empty(), ka.now()), e)));
	}
	getDocuments(e, t) {
		return this.remoteDocumentCache.getEntries(e, t).next(((t) => this.getLocalViewOfDocuments(e, t, q()).next((() => t))));
	}
	getLocalViewOfDocuments(e, t, n = q()) {
		let r = Ms();
		return this.populateOverlays(e, r, t).next((() => this.computeViews(e, t, r, n).next(((e) => {
			let t = As();
			return e.forEach(((e, n) => {
				t = t.insert(e, n.overlayedDocument);
			})), t;
		}))));
	}
	getOverlayedDocuments(e, t) {
		let n = Ms();
		return this.populateOverlays(e, n, t).next((() => this.computeViews(e, t, n, q())));
	}
	populateOverlays(e, t, n) {
		let r = [];
		return n.forEach(((e) => {
			t.has(e) || r.push(e);
		})), this.documentOverlayCache.getOverlays(e, r).next(((e) => {
			e.forEach(((e, n) => {
				t.set(e, n);
			}));
		}));
	}
	computeViews(e, t, n, r) {
		let i = Os(), a = Ps(), o = function() {
			return Ps();
		}();
		return t.forEach(((e, t) => {
			let o = n.get(t.key);
			r.has(t.key) && (o === void 0 || o.mutation instanceof dc) ? i = i.insert(t.key, t) : o === void 0 ? a.set(t.key, ro.empty()) : (a.set(t.key, o.mutation.getFieldMask()), sc(o.mutation, t, o.mutation.getFieldMask(), ka.now()));
		})), this.recalculateAndSaveOverlays(e, i).next(((e) => (e.forEach(((e, t) => a.set(e, t))), t.forEach(((e, t) => o.set(e, new Fl(t, a.get(e) ?? null)))), o)));
	}
	recalculateAndSaveOverlays(e, t) {
		let n = Ps(), r = new W(((e, t) => e - t)), i = q();
		return this.mutationQueue.getAllMutationBatchesAffectingDocumentKeys(e, t).next(((e) => {
			for (let i of e) i.keys().forEach(((e) => {
				let a = t.get(e);
				if (a === null) return;
				let o = n.get(e) || ro.empty();
				o = i.applyToLocalView(a, o), n.set(e, o);
				let s = (r.get(i.batchId) || q()).add(e);
				r = r.insert(i.batchId, s);
			}));
		})).next((() => {
			let a = [], o = r.getReverseIterator();
			for (; o.hasNext();) {
				let r = o.getNext(), s = r.key, c = r.value, l = Ns();
				c.forEach(((e) => {
					if (!i.has(e)) {
						let r = ac(t.get(e), n.get(e));
						r !== null && l.set(e, r), i = i.add(e);
					}
				})), a.push(this.documentOverlayCache.saveOverlays(e, s, l));
			}
			return U.waitFor(a);
		})).next((() => n));
	}
	recalculateAndSaveOverlaysForDocumentKeys(e, t) {
		return this.remoteDocumentCache.getEntries(e, t).next(((t) => this.recalculateAndSaveOverlays(e, t)));
	}
	getDocumentsMatchingQuery(e, t, n, r) {
		return function(e) {
			return H.isDocumentKey(e.path) && e.collectionGroup === null && e.filters.length === 0;
		}(t) ? this.getDocumentsMatchingDocumentQuery(e, t.path) : ps(t) ? this.getDocumentsMatchingCollectionGroupQuery(e, t, n, r) : this.getDocumentsMatchingCollectionQuery(e, t, n, r);
	}
	getNextDocuments(e, t, n, r) {
		return this.remoteDocumentCache.getAllFromCollectionGroup(e, t, n, r).next(((i) => {
			let a = r - i.size > 0 ? this.documentOverlayCache.getOverlaysForCollectionGroup(e, t, n.largestBatchId, r - i.size) : U.resolve(Ms()), o = -1, s = i;
			return a.next(((t) => U.forEach(t, ((t, n) => (o < n.largestBatchId && (o = n.largestBatchId), i.get(t) ? U.resolve() : this.remoteDocumentCache.getEntry(e, t).next(((e) => {
				s = s.insert(t, e);
			}))))).next((() => this.populateOverlays(e, t, i))).next((() => this.computeViews(e, s, t, q()))).next(((e) => ({
				batchId: o,
				changes: js(e)
			})))));
		}));
	}
	getDocumentsMatchingDocumentQuery(e, t) {
		return this.getDocument(e, new H(t)).next(((e) => {
			let t = As();
			return e.isFoundDocument() && (t = t.insert(e.key, e)), t;
		}));
	}
	getDocumentsMatchingCollectionGroupQuery(e, t, n, r) {
		let i = t.collectionGroup, a = As();
		return this.indexManager.getCollectionParents(e, i).next(((o) => U.forEach(o, ((o) => {
			let s = function(e, t) {
				return new ls(t, null, e.explicitOrderBy.slice(), e.filters.slice(), e.limit, e.limitType, e.startAt, e.endAt);
			}(t, o.child(i));
			return this.getDocumentsMatchingCollectionQuery(e, s, n, r).next(((e) => {
				e.forEach(((e, t) => {
					a = a.insert(e, t);
				}));
			}));
		})).next((() => a))));
	}
	getDocumentsMatchingCollectionQuery(e, t, n, r) {
		let i;
		return this.documentOverlayCache.getOverlaysForCollection(e, t.path, n.largestBatchId).next(((a) => (i = a, this.remoteDocumentCache.getDocumentsMatchingQuery(e, t, n, i, r)))).next(((e) => {
			i.forEach(((t, n) => {
				let r = n.getKey();
				e.get(r) === null && (e = e.insert(r, Io.newInvalidDocument(r)));
			}));
			let n = As();
			return e.forEach(((e, r) => {
				let a = i.get(e);
				a !== void 0 && sc(a.mutation, r, ro.empty(), ka.now()), Ss(t, r) && (n = n.insert(e, r));
			})), n;
		}));
	}
}, Ll = class {
	constructor(e) {
		this.serializer = e, this.hr = /* @__PURE__ */ new Map(), this.Pr = /* @__PURE__ */ new Map();
	}
	getBundleMetadata(e, t) {
		return U.resolve(this.hr.get(t));
	}
	saveBundleMetadata(e, t) {
		return this.hr.set(t.id, function(e) {
			return {
				id: e.id,
				version: e.version,
				createTime: qc(e.createTime)
			};
		}(t)), U.resolve();
	}
	getNamedQuery(e, t) {
		return U.resolve(this.Pr.get(t));
	}
	saveNamedQuery(e, t) {
		return this.Pr.set(t.name, function(e) {
			return {
				name: e.name,
				query: Sl(e.bundledQuery),
				readTime: qc(e.readTime)
			};
		}(t)), U.resolve();
	}
}, Rl = class {
	constructor() {
		this.overlays = new W(H.comparator), this.Ir = /* @__PURE__ */ new Map();
	}
	getOverlay(e, t) {
		return U.resolve(this.overlays.get(t));
	}
	getOverlays(e, t) {
		let n = Ms();
		return U.forEach(t, ((t) => this.getOverlay(e, t).next(((e) => {
			e !== null && n.set(t, e);
		})))).next((() => n));
	}
	saveOverlays(e, t, n) {
		return n.forEach(((n, r) => {
			this.ht(e, t, r);
		})), U.resolve();
	}
	removeOverlaysForBatchId(e, t, n) {
		let r = this.Ir.get(n);
		return r !== void 0 && (r.forEach(((e) => this.overlays = this.overlays.remove(e))), this.Ir.delete(n)), U.resolve();
	}
	getOverlaysForCollection(e, t, n) {
		let r = Ms(), i = t.length + 1, a = new H(t.child("")), o = this.overlays.getIteratorFrom(a);
		for (; o.hasNext();) {
			let e = o.getNext().value, a = e.getKey();
			if (!t.isPrefixOf(a.path)) break;
			a.path.length === i && e.largestBatchId > n && r.set(e.getKey(), e);
		}
		return U.resolve(r);
	}
	getOverlaysForCollectionGroup(e, t, n, r) {
		let i = new W(((e, t) => e - t)), a = this.overlays.getIterator();
		for (; a.hasNext();) {
			let e = a.getNext().value;
			if (e.getKey().getCollectionGroup() === t && e.largestBatchId > n) {
				let t = i.get(e.largestBatchId);
				t === null && (t = Ms(), i = i.insert(e.largestBatchId, t)), t.set(e.getKey(), e);
			}
		}
		let o = Ms(), s = i.getIterator();
		for (; s.hasNext() && (s.getNext().value.forEach(((e, t) => o.set(e, t))), !(o.size() >= r)););
		return U.resolve(o);
	}
	ht(e, t, n) {
		let r = this.overlays.get(n.key);
		if (r !== null) {
			let e = this.Ir.get(r.largestBatchId).delete(n.key);
			this.Ir.set(r.largestBatchId, e);
		}
		this.overlays = this.overlays.insert(n.key, new yc(t, n));
		let i = this.Ir.get(t);
		i === void 0 && (i = q(), this.Ir.set(t, i)), this.Ir.set(t, i.add(n.key));
	}
}, zl = class {
	constructor() {
		this.sessionToken = ao.EMPTY_BYTE_STRING;
	}
	getSessionToken(e) {
		return U.resolve(this.sessionToken);
	}
	setSessionToken(e, t) {
		return this.sessionToken = t, U.resolve();
	}
}, Bl = class {
	constructor() {
		this.Tr = new to(X.Er), this.dr = new to(X.Ar);
	}
	isEmpty() {
		return this.Tr.isEmpty();
	}
	addReference(e, t) {
		let n = new X(e, t);
		this.Tr = this.Tr.add(n), this.dr = this.dr.add(n);
	}
	Rr(e, t) {
		e.forEach(((e) => this.addReference(e, t)));
	}
	removeReference(e, t) {
		this.Vr(new X(e, t));
	}
	mr(e, t) {
		e.forEach(((e) => this.removeReference(e, t)));
	}
	gr(e) {
		let t = new H(new V([])), n = new X(t, e), r = new X(t, e + 1), i = [];
		return this.dr.forEachInRange([n, r], ((e) => {
			this.Vr(e), i.push(e.key);
		})), i;
	}
	pr() {
		this.Tr.forEach(((e) => this.Vr(e)));
	}
	Vr(e) {
		this.Tr = this.Tr.delete(e), this.dr = this.dr.delete(e);
	}
	yr(e) {
		let t = new H(new V([])), n = new X(t, e), r = new X(t, e + 1), i = q();
		return this.dr.forEachInRange([n, r], ((e) => {
			i = i.add(e.key);
		})), i;
	}
	containsKey(e) {
		let t = new X(e, 0), n = this.Tr.firstAfterOrEqual(t);
		return n !== null && e.isEqual(n.key);
	}
}, X = class {
	constructor(e, t) {
		this.key = e, this.wr = t;
	}
	static Er(e, t) {
		return H.comparator(e.key, t.key) || z(e.wr, t.wr);
	}
	static Ar(e, t) {
		return z(e.wr, t.wr) || H.comparator(e.key, t.key);
	}
}, Vl = class {
	constructor(e, t) {
		this.indexManager = e, this.referenceDelegate = t, this.mutationQueue = [], this.Sr = 1, this.br = new to(X.Er);
	}
	checkEmpty(e) {
		return U.resolve(this.mutationQueue.length === 0);
	}
	addMutationBatch(e, t, n, r) {
		let i = this.Sr;
		this.Sr++, this.mutationQueue.length > 0 && this.mutationQueue[this.mutationQueue.length - 1];
		let a = new _c(i, t, n, r);
		this.mutationQueue.push(a);
		for (let t of r) this.br = this.br.add(new X(t.key, i)), this.indexManager.addToCollectionParentIndex(e, t.key.path.popLast());
		return U.resolve(a);
	}
	lookupMutationBatch(e, t) {
		return U.resolve(this.Dr(t));
	}
	getNextMutationBatchAfterBatchId(e, t) {
		let n = t + 1, r = this.vr(n), i = r < 0 ? 0 : r;
		return U.resolve(this.mutationQueue.length > i ? this.mutationQueue[i] : null);
	}
	getHighestUnacknowledgedBatchId() {
		return U.resolve(this.mutationQueue.length === 0 ? -1 : this.Sr - 1);
	}
	getAllMutationBatches(e) {
		return U.resolve(this.mutationQueue.slice());
	}
	getAllMutationBatchesAffectingDocumentKey(e, t) {
		let n = new X(t, 0), r = new X(t, Infinity), i = [];
		return this.br.forEachInRange([n, r], ((e) => {
			let t = this.Dr(e.wr);
			i.push(t);
		})), U.resolve(i);
	}
	getAllMutationBatchesAffectingDocumentKeys(e, t) {
		let n = new to(z);
		return t.forEach(((e) => {
			let t = new X(e, 0), r = new X(e, Infinity);
			this.br.forEachInRange([t, r], ((e) => {
				n = n.add(e.wr);
			}));
		})), U.resolve(this.Cr(n));
	}
	getAllMutationBatchesAffectingQuery(e, t) {
		let n = t.path, r = n.length + 1, i = n;
		H.isDocumentKey(i) || (i = i.child(""));
		let a = new X(new H(i), 0), o = new to(z);
		return this.br.forEachWhile(((e) => {
			let t = e.key.path;
			return !!n.isPrefixOf(t) && (t.length === r && (o = o.add(e.wr)), !0);
		}), a), U.resolve(this.Cr(o));
	}
	Cr(e) {
		let t = [];
		return e.forEach(((e) => {
			let n = this.Dr(e);
			n !== null && t.push(n);
		})), t;
	}
	removeMutationBatch(e, t) {
		F(this.Fr(t.batchId, "removed") === 0), this.mutationQueue.shift();
		let n = this.br;
		return U.forEach(t.mutations, ((r) => {
			let i = new X(r.key, t.batchId);
			return n = n.delete(i), this.referenceDelegate.markPotentiallyOrphaned(e, r.key);
		})).next((() => {
			this.br = n;
		}));
	}
	On(e) {}
	containsKey(e, t) {
		let n = new X(t, 0), r = this.br.firstAfterOrEqual(n);
		return U.resolve(t.isEqual(r && r.key));
	}
	performConsistencyCheck(e) {
		return this.mutationQueue.length, U.resolve();
	}
	Fr(e, t) {
		return this.vr(e);
	}
	vr(e) {
		return this.mutationQueue.length === 0 ? 0 : e - this.mutationQueue[0].batchId;
	}
	Dr(e) {
		let t = this.vr(e);
		return t < 0 || t >= this.mutationQueue.length ? null : this.mutationQueue[t];
	}
}, Hl = class {
	constructor(e) {
		this.Mr = e, this.docs = function() {
			return new W(H.comparator);
		}(), this.size = 0;
	}
	setIndexManager(e) {
		this.indexManager = e;
	}
	addEntry(e, t) {
		let n = t.key, r = this.docs.get(n), i = r ? r.size : 0, a = this.Mr(t);
		return this.docs = this.docs.insert(n, {
			document: t.mutableCopy(),
			size: a
		}), this.size += a - i, this.indexManager.addToCollectionParentIndex(e, n.path.popLast());
	}
	removeEntry(e) {
		let t = this.docs.get(e);
		t && (this.docs = this.docs.remove(e), this.size -= t.size);
	}
	getEntry(e, t) {
		let n = this.docs.get(t);
		return U.resolve(n ? n.document.mutableCopy() : Io.newInvalidDocument(t));
	}
	getEntries(e, t) {
		let n = Os();
		return t.forEach(((e) => {
			let t = this.docs.get(e);
			n = n.insert(e, t ? t.document.mutableCopy() : Io.newInvalidDocument(e));
		})), U.resolve(n);
	}
	getDocumentsMatchingQuery(e, t, n, r) {
		let i = Os(), a = t.path, o = new H(a.child("")), s = this.docs.getIteratorFrom(o);
		for (; s.hasNext();) {
			let { key: e, value: { document: o } } = s.getNext();
			if (!a.isPrefixOf(e.path)) break;
			e.path.length > a.length + 1 || La(Fa(o), n) <= 0 || (r.has(o.key) || Ss(t, o)) && (i = i.insert(o.key, o.mutableCopy()));
		}
		return U.resolve(i);
	}
	getAllFromCollectionGroup(e, t, n, r) {
		P();
	}
	Or(e, t) {
		return U.forEach(this.docs, ((e) => t(e)));
	}
	newChangeBuffer(e) {
		return new Ul(this);
	}
	getSize(e) {
		return U.resolve(this.size);
	}
}, Ul = class extends Pl {
	constructor(e) {
		super(), this.cr = e;
	}
	applyChanges(e) {
		let t = [];
		return this.changes.forEach(((n, r) => {
			r.isValidDocument() ? t.push(this.cr.addEntry(e, r)) : this.cr.removeEntry(n);
		})), U.waitFor(t);
	}
	getFromCache(e, t) {
		return this.cr.getEntry(e, t);
	}
	getAllFromCache(e, t) {
		return this.cr.getEntries(e, t);
	}
}, Wl = class {
	constructor(e) {
		this.persistence = e, this.Nr = new Es(((e) => os(e)), ss), this.lastRemoteSnapshotVersion = B.min(), this.highestTargetId = 0, this.Lr = 0, this.Br = new Bl(), this.targetCount = 0, this.kr = Ol.Bn();
	}
	forEachTarget(e, t) {
		return this.Nr.forEach(((e, n) => t(n))), U.resolve();
	}
	getLastRemoteSnapshotVersion(e) {
		return U.resolve(this.lastRemoteSnapshotVersion);
	}
	getHighestSequenceNumber(e) {
		return U.resolve(this.Lr);
	}
	allocateTargetId(e) {
		return this.highestTargetId = this.kr.next(), U.resolve(this.highestTargetId);
	}
	setTargetsMetadata(e, t, n) {
		return n && (this.lastRemoteSnapshotVersion = n), t > this.Lr && (this.Lr = t), U.resolve();
	}
	Kn(e) {
		this.Nr.set(e.target, e);
		let t = e.targetId;
		t > this.highestTargetId && (this.kr = new Ol(t), this.highestTargetId = t), e.sequenceNumber > this.Lr && (this.Lr = e.sequenceNumber);
	}
	addTargetData(e, t) {
		return this.Kn(t), this.targetCount += 1, U.resolve();
	}
	updateTargetData(e, t) {
		return this.Kn(t), U.resolve();
	}
	removeTargetData(e, t) {
		return this.Nr.delete(t.target), this.Br.gr(t.targetId), --this.targetCount, U.resolve();
	}
	removeTargets(e, t, n) {
		let r = 0, i = [];
		return this.Nr.forEach(((a, o) => {
			o.sequenceNumber <= t && n.get(o.targetId) === null && (this.Nr.delete(a), i.push(this.removeMatchingKeysForTargetId(e, o.targetId)), r++);
		})), U.waitFor(i).next((() => r));
	}
	getTargetCount(e) {
		return U.resolve(this.targetCount);
	}
	getTargetData(e, t) {
		let n = this.Nr.get(t) || null;
		return U.resolve(n);
	}
	addMatchingKeys(e, t, n) {
		return this.Br.Rr(t, n), U.resolve();
	}
	removeMatchingKeys(e, t, n) {
		this.Br.mr(t, n);
		let r = this.persistence.referenceDelegate, i = [];
		return r && t.forEach(((t) => {
			i.push(r.markPotentiallyOrphaned(e, t));
		})), U.waitFor(i);
	}
	removeMatchingKeysForTargetId(e, t) {
		return this.Br.gr(t), U.resolve();
	}
	getMatchingKeysForTargetId(e, t) {
		let n = this.Br.yr(t);
		return U.resolve(n);
	}
	containsKey(e, t) {
		return U.resolve(this.Br.containsKey(t));
	}
}, Gl = class {
	constructor(e, t) {
		this.qr = {}, this.overlays = {}, this.Qr = new Ua(0), this.Kr = !1, this.Kr = !0, this.$r = new zl(), this.referenceDelegate = e(this), this.Ur = new Wl(this), this.indexManager = new wl(), this.remoteDocumentCache = function(e) {
			return new Hl(e);
		}(((e) => this.referenceDelegate.Wr(e))), this.serializer = new xl(t), this.Gr = new Ll(this.serializer);
	}
	start() {
		return Promise.resolve();
	}
	shutdown() {
		return this.Kr = !1, Promise.resolve();
	}
	get started() {
		return this.Kr;
	}
	setDatabaseDeletedListener() {}
	setNetworkEnabled() {}
	getIndexManager(e) {
		return this.indexManager;
	}
	getDocumentOverlayCache(e) {
		let t = this.overlays[e.toKey()];
		return t || (t = new Rl(), this.overlays[e.toKey()] = t), t;
	}
	getMutationQueue(e, t) {
		let n = this.qr[e.toKey()];
		return n || (n = new Vl(t, this.referenceDelegate), this.qr[e.toKey()] = n), n;
	}
	getGlobalsCache() {
		return this.$r;
	}
	getTargetCache() {
		return this.Ur;
	}
	getRemoteDocumentCache() {
		return this.remoteDocumentCache;
	}
	getBundleCache() {
		return this.Gr;
	}
	runTransaction(e, t, n) {
		N("MemoryPersistence", "Starting transaction:", e);
		let r = new Kl(this.Qr.next());
		return this.referenceDelegate.zr(), n(r).next(((e) => this.referenceDelegate.jr(r).next((() => e)))).toPromise().then(((e) => (r.raiseOnCommittedEvent(), e)));
	}
	Hr(e, t) {
		return U.or(Object.values(this.qr).map(((n) => () => n.containsKey(e, t))));
	}
}, Kl = class extends za {
	constructor(e) {
		super(), this.currentSequenceNumber = e;
	}
}, ql = class e {
	constructor(e) {
		this.persistence = e, this.Jr = new Bl(), this.Yr = null;
	}
	static Zr(t) {
		return new e(t);
	}
	get Xr() {
		if (this.Yr) return this.Yr;
		throw P();
	}
	addReference(e, t, n) {
		return this.Jr.addReference(n, t), this.Xr.delete(n.toString()), U.resolve();
	}
	removeReference(e, t, n) {
		return this.Jr.removeReference(n, t), this.Xr.add(n.toString()), U.resolve();
	}
	markPotentiallyOrphaned(e, t) {
		return this.Xr.add(t.toString()), U.resolve();
	}
	removeTarget(e, t) {
		this.Jr.gr(t.targetId).forEach(((e) => this.Xr.add(e.toString())));
		let n = this.persistence.getTargetCache();
		return n.getMatchingKeysForTargetId(e, t.targetId).next(((e) => {
			e.forEach(((e) => this.Xr.add(e.toString())));
		})).next((() => n.removeTargetData(e, t)));
	}
	zr() {
		this.Yr = /* @__PURE__ */ new Set();
	}
	jr(e) {
		let t = this.persistence.getRemoteDocumentCache().newChangeBuffer();
		return U.forEach(this.Xr, ((n) => {
			let r = H.fromPath(n);
			return this.ei(e, r).next(((e) => {
				e || t.removeEntry(r, B.min());
			}));
		})).next((() => (this.Yr = null, t.apply(e))));
	}
	updateLimboDocument(e, t) {
		return this.ei(e, t).next(((e) => {
			e ? this.Xr.delete(t.toString()) : this.Xr.add(t.toString());
		}));
	}
	Wr(e) {
		return 0;
	}
	ei(e, t) {
		return U.or([
			() => U.resolve(this.Jr.containsKey(t)),
			() => this.persistence.getTargetCache().containsKey(e, t),
			() => this.persistence.Hr(e, t)
		]);
	}
}, Jl = class e {
	constructor(e, t) {
		this.persistence = e, this.ti = new Es(((e) => qa(e.path)), ((e, t) => e.isEqual(t))), this.garbageCollector = Nl(this, t);
	}
	static Zr(t, n) {
		return new e(t, n);
	}
	zr() {}
	jr(e) {
		return U.resolve();
	}
	forEachTarget(e, t) {
		return this.persistence.getTargetCache().forEachTarget(e, t);
	}
	Yn(e) {
		let t = this.er(e);
		return this.persistence.getTargetCache().getTargetCount(e).next(((e) => t.next(((t) => e + t))));
	}
	er(e) {
		let t = 0;
		return this.Zn(e, ((e) => {
			t++;
		})).next((() => t));
	}
	Zn(e, t) {
		return U.forEach(this.ti, ((n, r) => this.nr(e, n, r).next(((e) => e ? U.resolve() : t(r)))));
	}
	removeTargets(e, t, n) {
		return this.persistence.getTargetCache().removeTargets(e, t, n);
	}
	removeOrphanedDocuments(e, t) {
		let n = 0, r = this.persistence.getRemoteDocumentCache(), i = r.newChangeBuffer();
		return r.Or(e, ((r) => this.nr(e, r, t).next(((e) => {
			e || (n++, i.removeEntry(r, B.min()));
		})))).next((() => i.apply(e))).next((() => n));
	}
	markPotentiallyOrphaned(e, t) {
		return this.ti.set(t, e.currentSequenceNumber), U.resolve();
	}
	removeTarget(e, t) {
		let n = t.withSequenceNumber(e.currentSequenceNumber);
		return this.persistence.getTargetCache().updateTargetData(e, n);
	}
	addReference(e, t, n) {
		return this.ti.set(n, e.currentSequenceNumber), U.resolve();
	}
	removeReference(e, t, n) {
		return this.ti.set(n, e.currentSequenceNumber), U.resolve();
	}
	updateLimboDocument(e, t) {
		return this.ti.set(t, e.currentSequenceNumber), U.resolve();
	}
	Wr(e) {
		let t = e.key.toString().length;
		return e.isFoundDocument() && (t += wo(e.data.value)), t;
	}
	nr(e, t, n) {
		return U.or([
			() => this.persistence.Hr(e, t),
			() => this.persistence.getTargetCache().containsKey(e, t),
			() => {
				let e = this.ti.get(t);
				return U.resolve(e !== void 0 && e > n);
			}
		]);
	}
	getCacheSize(e) {
		return this.persistence.getRemoteDocumentCache().getSize(e);
	}
}, Yl = class e {
	constructor(e, t, n, r) {
		this.targetId = e, this.fromCache = t, this.$i = n, this.Ui = r;
	}
	static Wi(t, n) {
		let r = q(), i = q();
		for (let e of n.docChanges) switch (e.type) {
			case 0:
				r = r.add(e.doc.key);
				break;
			case 1: i = i.add(e.doc.key);
		}
		return new e(t, n.fromCache, r, i);
	}
}, Xl = class {
	constructor() {
		this._documentReadCount = 0;
	}
	get documentReadCount() {
		return this._documentReadCount;
	}
	incrementDocumentReadCount(e) {
		this._documentReadCount += e;
	}
}, Zl = class {
	constructor() {
		this.Gi = !1, this.zi = !1, this.ji = 100, this.Hi = function() {
			return Vn() ? 8 : Va(A()) > 0 ? 6 : 4;
		}();
	}
	initialize(e, t) {
		this.Ji = e, this.indexManager = t, this.Gi = !0;
	}
	getDocumentsMatchingQuery(e, t, n, r) {
		let i = { result: null };
		return this.Yi(e, t).next(((e) => {
			i.result = e;
		})).next((() => {
			if (!i.result) return this.Zi(e, t, r, n).next(((e) => {
				i.result = e;
			}));
		})).next((() => {
			if (i.result) return;
			let n = new Xl();
			return this.Xi(e, t, n).next(((r) => {
				if (i.result = r, this.zi) return this.es(e, t, n, r.size);
			}));
		})).next((() => i.result));
	}
	es(e, t, n, r) {
		return n.documentReadCount < this.ji ? (pa() <= M.DEBUG && N("QueryEngine", "SDK will not create cache indexes for query:", xs(t), "since it only creates cache indexes for collection contains", "more than or equal to", this.ji, "documents"), U.resolve()) : (pa() <= M.DEBUG && N("QueryEngine", "Query:", xs(t), "scans", n.documentReadCount, "local documents and returns", r, "documents as results."), n.documentReadCount > this.Hi * r ? (pa() <= M.DEBUG && N("QueryEngine", "The SDK decides to create cache indexes for query:", xs(t), "as using cache indexes may help improve performance."), this.indexManager.createTargetIndexes(e, hs(t))) : U.resolve());
	}
	Yi(e, t) {
		if (fs(t)) return U.resolve(null);
		let n = hs(t);
		return this.indexManager.getIndexType(e, n).next(((r) => r === 0 ? null : (t.limit !== null && r === 1 && (t = vs(t, null, "F"), n = hs(t)), this.indexManager.getDocumentsMatchingTarget(e, n).next(((r) => {
			let i = q(...r);
			return this.Ji.getDocuments(e, i).next(((r) => this.indexManager.getMinOffset(e, n).next(((n) => {
				let a = this.ts(t, r);
				return this.ns(t, a, i, n.readTime) ? this.Yi(e, vs(t, null, "F")) : this.rs(e, a, t, n);
			}))));
		})))));
	}
	Zi(e, t, n, r) {
		return fs(t) || r.isEqual(B.min()) ? U.resolve(null) : this.Ji.getDocuments(e, n).next(((i) => {
			let a = this.ts(t, i);
			return this.ns(t, a, n, r) ? U.resolve(null) : (pa() <= M.DEBUG && N("QueryEngine", "Re-using previous result from %s to execute query: %s", r.toString(), xs(t)), this.rs(e, a, t, Pa(r, -1)).next(((e) => e)));
		}));
	}
	ts(e, t) {
		let n = new to(ws(e));
		return t.forEach(((t, r) => {
			Ss(e, r) && (n = n.add(r));
		})), n;
	}
	ns(e, t, n, r) {
		if (e.limit === null) return !1;
		if (n.size !== t.size) return !0;
		let i = e.limitType === "F" ? t.last() : t.first();
		return !!i && (i.hasPendingWrites || i.version.compareTo(r) > 0);
	}
	Xi(e, t, n) {
		return pa() <= M.DEBUG && N("QueryEngine", "Using full collection scan to execute query:", xs(t)), this.Ji.getDocumentsMatchingQuery(e, t, Ia.min(), n);
	}
	rs(e, t, n, r) {
		return this.Ji.getDocumentsMatchingQuery(e, n, r).next(((e) => (t.forEach(((t) => {
			e = e.insert(t.key, t);
		})), e)));
	}
}, Ql = class {
	constructor(e, t, n, r) {
		this.persistence = e, this.ss = t, this.serializer = r, this.os = new W(z), this._s = new Es(((e) => os(e)), ss), this.us = /* @__PURE__ */ new Map(), this.cs = e.getRemoteDocumentCache(), this.Ur = e.getTargetCache(), this.Gr = e.getBundleCache(), this.ls(n);
	}
	ls(e) {
		this.documentOverlayCache = this.persistence.getDocumentOverlayCache(e), this.indexManager = this.persistence.getIndexManager(e), this.mutationQueue = this.persistence.getMutationQueue(e, this.indexManager), this.localDocuments = new Il(this.cs, this.mutationQueue, this.documentOverlayCache, this.indexManager), this.cs.setIndexManager(this.indexManager), this.ss.initialize(this.localDocuments, this.indexManager);
	}
	collectGarbage(e) {
		return this.persistence.runTransaction("Collect garbage", "readwrite-primary", ((t) => e.collect(t, this.os)));
	}
};
function $l(e, t, n, r) {
	return new Ql(e, t, n, r);
}
async function eu(e, t) {
	let n = I(e);
	return await n.persistence.runTransaction("Handle user change", "readonly", ((e) => {
		let r;
		return n.mutationQueue.getAllMutationBatches(e).next(((i) => (r = i, n.ls(t), n.mutationQueue.getAllMutationBatches(e)))).next(((t) => {
			let i = [], a = [], o = q();
			for (let e of r) {
				i.push(e.batchId);
				for (let t of e.mutations) o = o.add(t.key);
			}
			for (let e of t) {
				a.push(e.batchId);
				for (let t of e.mutations) o = o.add(t.key);
			}
			return n.localDocuments.getDocuments(e, o).next(((e) => ({
				hs: e,
				removedBatchIds: i,
				addedBatchIds: a
			})));
		}));
	}));
}
function tu(e, t) {
	let n = I(e);
	return n.persistence.runTransaction("Acknowledge batch", "readwrite-primary", ((e) => {
		let r = t.batch.keys(), i = n.cs.newChangeBuffer({ trackRemovals: !0 });
		return function(e, t, n, r) {
			let i = n.batch, a = i.keys(), o = U.resolve();
			return a.forEach(((e) => {
				o = o.next((() => r.getEntry(t, e))).next(((t) => {
					let a = n.docVersions.get(e);
					F(a !== null), t.version.compareTo(a) < 0 && (i.applyToRemoteDocument(t, n), t.isValidDocument() && (t.setReadTime(n.commitVersion), r.addEntry(t)));
				}));
			})), o.next((() => e.mutationQueue.removeMutationBatch(t, i)));
		}(n, e, t, i).next((() => i.apply(e))).next((() => n.mutationQueue.performConsistencyCheck(e))).next((() => n.documentOverlayCache.removeOverlaysForBatchId(e, r, t.batch.batchId))).next((() => n.localDocuments.recalculateAndSaveOverlaysForDocumentKeys(e, function(e) {
			let t = q();
			for (let n = 0; n < e.mutationResults.length; ++n) e.mutationResults[n].transformResults.length > 0 && (t = t.add(e.batch.mutations[n].key));
			return t;
		}(t)))).next((() => n.localDocuments.getDocuments(e, r)));
	}));
}
function nu(e) {
	let t = I(e);
	return t.persistence.runTransaction("Get last remote snapshot version", "readonly", ((e) => t.Ur.getLastRemoteSnapshotVersion(e)));
}
function ru(e, t) {
	let n = I(e), r = t.snapshotVersion, i = n.os;
	return n.persistence.runTransaction("Apply remote event", "readwrite-primary", ((e) => {
		let a = n.cs.newChangeBuffer({ trackRemovals: !0 });
		i = n.os;
		let o = [];
		t.targetChanges.forEach(((a, s) => {
			let c = i.get(s);
			if (!c) return;
			o.push(n.Ur.removeMatchingKeys(e, a.removedDocuments, s).next((() => n.Ur.addMatchingKeys(e, a.addedDocuments, s))));
			let l = c.withSequenceNumber(e.currentSequenceNumber);
			t.targetMismatches.get(s) === null ? a.resumeToken.approximateByteSize() > 0 && (l = l.withResumeToken(a.resumeToken, r)) : l = l.withResumeToken(ao.EMPTY_BYTE_STRING, B.min()).withLastLimboFreeSnapshotVersion(B.min()), i = i.insert(s, l), function(e, t, n) {
				return e.resumeToken.approximateByteSize() === 0 || t.snapshotVersion.toMicroseconds() - e.snapshotVersion.toMicroseconds() >= 3e8 ? !0 : n.addedDocuments.size + n.modifiedDocuments.size + n.removedDocuments.size > 0;
			}(c, l, a) && o.push(n.Ur.updateTargetData(e, l));
		}));
		let s = Os(), c = q();
		if (t.documentUpdates.forEach(((r) => {
			t.resolvedLimboDocuments.has(r) && o.push(n.persistence.referenceDelegate.updateLimboDocument(e, r));
		})), o.push(iu(e, a, t.documentUpdates).next(((e) => {
			s = e.Ps, c = e.Is;
		}))), !r.isEqual(B.min())) {
			let t = n.Ur.getLastRemoteSnapshotVersion(e).next(((t) => n.Ur.setTargetsMetadata(e, e.currentSequenceNumber, r)));
			o.push(t);
		}
		return U.waitFor(o).next((() => a.apply(e))).next((() => n.localDocuments.getLocalViewOfDocuments(e, s, c))).next((() => s));
	})).then(((e) => (n.os = i, e)));
}
function iu(e, t, n) {
	let r = q(), i = q();
	return n.forEach(((e) => r = r.add(e))), t.getEntries(e, r).next(((e) => {
		let r = Os();
		return n.forEach(((n, a) => {
			let o = e.get(n);
			a.isFoundDocument() !== o.isFoundDocument() && (i = i.add(n)), a.isNoDocument() && a.version.isEqual(B.min()) ? (t.removeEntry(n, a.readTime), r = r.insert(n, a)) : !o.isValidDocument() || a.version.compareTo(o.version) > 0 || a.version.compareTo(o.version) === 0 && o.hasPendingWrites ? (t.addEntry(a), r = r.insert(n, a)) : N("LocalStore", "Ignoring outdated watch update for ", n, ". Current version:", o.version, " Watch version:", a.version);
		})), {
			Ps: r,
			Is: i
		};
	}));
}
function au(e, t) {
	let n = I(e);
	return n.persistence.runTransaction("Get next mutation batch", "readonly", ((e) => (t === void 0 && (t = -1), n.mutationQueue.getNextMutationBatchAfterBatchId(e, t))));
}
function ou(e, t) {
	let n = I(e);
	return n.persistence.runTransaction("Allocate target", "readwrite", ((e) => {
		let r;
		return n.Ur.getTargetData(e, t).next(((i) => i ? (r = i, U.resolve(r)) : n.Ur.allocateTargetId(e).next(((i) => (r = new bl(t, i, "TargetPurposeListen", e.currentSequenceNumber), n.Ur.addTargetData(e, r).next((() => r)))))));
	})).then(((e) => {
		let r = n.os.get(e.targetId);
		return (r === null || e.snapshotVersion.compareTo(r.snapshotVersion) > 0) && (n.os = n.os.insert(e.targetId, e), n._s.set(t, e.targetId)), e;
	}));
}
async function su(e, t, n) {
	let r = I(e), i = r.os.get(t), a = n ? "readwrite" : "readwrite-primary";
	try {
		n || await r.persistence.runTransaction("Release target", a, ((e) => r.persistence.referenceDelegate.removeTarget(e, i)));
	} catch (e) {
		if (!Ha(e)) throw e;
		N("LocalStore", `Failed to update sequence numbers for target ${t}: ${e}`);
	}
	r.os = r.os.remove(t), r._s.delete(i.target);
}
function cu(e, t, n) {
	let r = I(e), i = B.min(), a = q();
	return r.persistence.runTransaction("Execute query", "readwrite", ((e) => function(e, t, n) {
		let r = I(e), i = r._s.get(n);
		return i === void 0 ? r.Ur.getTargetData(t, n) : U.resolve(r.os.get(i));
	}(r, e, hs(t)).next(((t) => {
		if (t) return i = t.lastLimboFreeSnapshotVersion, r.Ur.getMatchingKeysForTargetId(e, t.targetId).next(((e) => {
			a = e;
		}));
	})).next((() => r.ss.getDocumentsMatchingQuery(e, t, n ? i : B.min(), n ? a : q()))).next(((e) => (lu(r, Cs(t), e), {
		documents: e,
		Ts: a
	})))));
}
function lu(e, t, n) {
	let r = e.us.get(t) || B.min();
	n.forEach(((e, t) => {
		t.readTime.compareTo(r) > 0 && (r = t.readTime);
	})), e.us.set(t, r);
}
var uu = class {
	constructor() {
		this.activeTargetIds = Rs();
	}
	fs(e) {
		this.activeTargetIds = this.activeTargetIds.add(e);
	}
	gs(e) {
		this.activeTargetIds = this.activeTargetIds.delete(e);
	}
	Vs() {
		let e = {
			activeTargetIds: this.activeTargetIds.toArray(),
			updateTimeMs: Date.now()
		};
		return JSON.stringify(e);
	}
}, du = class {
	constructor() {
		this.so = new uu(), this.oo = {}, this.onlineStateHandler = null, this.sequenceNumberHandler = null;
	}
	addPendingMutation(e) {}
	updateMutationState(e, t, n) {}
	addLocalQueryTarget(e, t = !0) {
		return t && this.so.fs(e), this.oo[e] || "not-current";
	}
	updateQueryState(e, t, n) {
		this.oo[e] = t;
	}
	removeLocalQueryTarget(e) {
		this.so.gs(e);
	}
	isLocalQueryTarget(e) {
		return this.so.activeTargetIds.has(e);
	}
	clearQueryState(e) {
		delete this.oo[e];
	}
	getAllActiveQueryTargets() {
		return this.so.activeTargetIds;
	}
	isActiveQueryTarget(e) {
		return this.so.activeTargetIds.has(e);
	}
	start() {
		return this.so = new uu(), Promise.resolve();
	}
	handleUserChange(e, t, n) {}
	setOnlineState(e) {}
	shutdown() {}
	writeSequenceNumber(e) {}
	notifyBundleLoaded(e) {}
}, fu = class {
	_o(e) {}
	shutdown() {}
}, pu = class {
	constructor() {
		this.ao = () => this.uo(), this.co = () => this.lo(), this.ho = [], this.Po();
	}
	_o(e) {
		this.ho.push(e);
	}
	shutdown() {
		window.removeEventListener("online", this.ao), window.removeEventListener("offline", this.co);
	}
	Po() {
		window.addEventListener("online", this.ao), window.addEventListener("offline", this.co);
	}
	uo() {
		N("ConnectivityMonitor", "Network connectivity changed: AVAILABLE");
		for (let e of this.ho) e(0);
	}
	lo() {
		N("ConnectivityMonitor", "Network connectivity changed: UNAVAILABLE");
		for (let e of this.ho) e(1);
	}
	static D() {
		return typeof window < "u" && window.addEventListener !== void 0 && window.removeEventListener !== void 0;
	}
}, mu = null;
function hu() {
	return mu === null ? mu = function() {
		return 268435456 + Math.round(2147483648 * Math.random());
	}() : mu++, "0x" + mu.toString(16);
}
var gu = {
	BatchGetDocuments: "batchGet",
	Commit: "commit",
	RunQuery: "runQuery",
	RunAggregationQuery: "runAggregationQuery"
}, _u = class {
	constructor(e) {
		this.Io = e.Io, this.To = e.To;
	}
	Eo(e) {
		this.Ao = e;
	}
	Ro(e) {
		this.Vo = e;
	}
	mo(e) {
		this.fo = e;
	}
	onMessage(e) {
		this.po = e;
	}
	close() {
		this.To();
	}
	send(e) {
		this.Io(e);
	}
	yo() {
		this.Ao();
	}
	wo() {
		this.Vo();
	}
	So(e) {
		this.fo(e);
	}
	bo(e) {
		this.po(e);
	}
}, vu = "WebChannelConnection", yu = class extends class {
	constructor(e) {
		this.databaseInfo = e, this.databaseId = e.databaseId;
		let t = e.ssl ? "https" : "http", n = encodeURIComponent(this.databaseId.projectId), r = encodeURIComponent(this.databaseId.database);
		this.Do = t + "://" + e.host, this.vo = `projects/${n}/databases/${r}`, this.Co = this.databaseId.database === "(default)" ? `project_id=${n}` : `project_id=${n}&database_id=${r}`;
	}
	get Fo() {
		return !1;
	}
	Mo(e, t, n, r, i) {
		let a = hu(), o = this.xo(e, t.toUriEncodedString());
		N("RestConnection", `Sending RPC '${e}' ${a}:`, o, n);
		let s = {
			"google-cloud-resource-prefix": this.vo,
			"x-goog-request-params": this.Co
		};
		return this.Oo(s, r, i), this.No(e, o, s, n).then(((t) => (N("RestConnection", `Received RPC '${e}' ${a}: `, t), t)), ((t) => {
			throw ha("RestConnection", `RPC '${e}' ${a} failed with error: `, t, "url: ", o, "request:", n), t;
		}));
	}
	Lo(e, t, n, r, i, a) {
		return this.Mo(e, t, n, r, i);
	}
	Oo(e, t, n) {
		e["X-Goog-Api-Client"] = function() {
			return "gl-js/ fire/" + da;
		}(), e["Content-Type"] = "text/plain", this.databaseInfo.appId && (e["X-Firebase-GMPID"] = this.databaseInfo.appId), t && t.headers.forEach(((t, n) => e[n] = t)), n && n.headers.forEach(((t, n) => e[n] = t));
	}
	xo(e, t) {
		let n = gu[e];
		return `${this.Do}/v1/${t}:${n}`;
	}
	terminate() {}
} {
	constructor(e) {
		super(e), this.forceLongPolling = e.forceLongPolling, this.autoDetectLongPolling = e.autoDetectLongPolling, this.useFetchStreams = e.useFetchStreams, this.longPollingOptions = e.longPollingOptions;
	}
	No(e, t, n, r) {
		let i = hu();
		return new Promise(((a, o) => {
			let s = new ta();
			s.setWithCredentials(!0), s.listenOnce(ra.COMPLETE, (() => {
				try {
					switch (s.getLastErrorCode()) {
						case ia.NO_ERROR:
							let t = s.getResponseJson();
							N(vu, `XHR for RPC '${e}' ${i} received:`, JSON.stringify(t)), a(t);
							break;
						case ia.TIMEOUT:
							N(vu, `RPC '${e}' ${i} timed out`), o(new R(L.DEADLINE_EXCEEDED, "Request time out"));
							break;
						case ia.HTTP_ERROR:
							let n = s.getStatus();
							if (N(vu, `RPC '${e}' ${i} failed with status:`, n, "response text:", s.getResponseText()), n > 0) {
								let e = s.getResponseJson();
								Array.isArray(e) && (e = e[0]);
								let t = e?.error;
								t && t.status && t.message ? o(new R(function(e) {
									let t = e.toLowerCase().replace(/_/g, "-");
									return Object.values(L).indexOf(t) >= 0 ? t : L.UNKNOWN;
								}(t.status), t.message)) : o(new R(L.UNKNOWN, "Server responded with status " + s.getStatus()));
							} else o(new R(L.UNAVAILABLE, "Connection failed."));
							break;
						default: P();
					}
				} finally {
					N(vu, `RPC '${e}' ${i} completed.`);
				}
			}));
			let c = JSON.stringify(r);
			N(vu, `RPC '${e}' ${i} sending request:`, r), s.send(t, "POST", c, n, 15);
		}));
	}
	Bo(e, t, n) {
		let r = hu(), i = [
			this.Do,
			"/",
			"google.firestore.v1.Firestore",
			"/",
			e,
			"/channel"
		], a = ca(), o = sa(), s = {
			httpSessionIdParam: "gsessionid",
			initMessageHeaders: {},
			messageUrlParams: { database: `projects/${this.databaseId.projectId}/databases/${this.databaseId.database}` },
			sendRawJson: !0,
			supportsCrossDomainXhr: !0,
			internalChannelParams: { forwardChannelRequestTimeoutMs: 6e5 },
			forceLongPolling: this.forceLongPolling,
			detectBufferingProxy: this.autoDetectLongPolling
		}, c = this.longPollingOptions.timeoutSeconds;
		c !== void 0 && (s.longPollingTimeout = Math.round(1e3 * c)), this.useFetchStreams && (s.useFetchStreams = !0), this.Oo(s.initMessageHeaders, t, n), s.encodeInitMessageHeaders = !0;
		let l = i.join("");
		N(vu, `Creating RPC '${e}' stream ${r}: ${l}`, s);
		let u = a.createWebChannel(l, s), d = !1, f = !1, p = new _u({
			Io: (t) => {
				f ? N(vu, `Not sending because RPC '${e}' stream ${r} is closed:`, t) : (d ||= (N(vu, `Opening RPC '${e}' stream ${r} transport.`), u.open(), !0), N(vu, `RPC '${e}' stream ${r} sending:`, t), u.send(t));
			},
			To: () => u.close()
		}), m = (e, t, n) => {
			e.listen(t, ((e) => {
				try {
					n(e);
				} catch (e) {
					setTimeout((() => {
						throw e;
					}), 0);
				}
			}));
		};
		return m(u, na.EventType.OPEN, (() => {
			f || (N(vu, `RPC '${e}' stream ${r} transport opened.`), p.yo());
		})), m(u, na.EventType.CLOSE, (() => {
			f || (f = !0, N(vu, `RPC '${e}' stream ${r} transport closed`), p.So());
		})), m(u, na.EventType.ERROR, ((t) => {
			f || (f = !0, ha(vu, `RPC '${e}' stream ${r} transport errored:`, t), p.So(new R(L.UNAVAILABLE, "The operation could not be completed")));
		})), m(u, na.EventType.MESSAGE, ((t) => {
			if (!f) {
				let n = t.data[0];
				F(!!n);
				let i = n, a = i.error || i[0]?.error;
				if (a) {
					N(vu, `RPC '${e}' stream ${r} received error:`, a);
					let t = a.status, n = function(e) {
						let t = J[e];
						if (t !== void 0) return Sc(t);
					}(t), i = a.message;
					n === void 0 && (n = L.INTERNAL, i = "Unknown error status: " + t + " with message " + a.message), f = !0, p.So(new R(n, i)), u.close();
				} else N(vu, `RPC '${e}' stream ${r} received:`, n), p.bo(n);
			}
		})), m(o, oa.STAT_EVENT, ((t) => {
			t.stat === aa.PROXY ? N(vu, `RPC '${e}' stream ${r} detected buffering proxy`) : t.stat === aa.NOPROXY && N(vu, `RPC '${e}' stream ${r} detected no buffering proxy`);
		})), setTimeout((() => {
			p.wo();
		}), 0), p;
	}
};
function bu() {
	return typeof document < "u" ? document : null;
}
function xu(e) {
	return new Hc(e, !0);
}
var Su = class {
	constructor(e, t, n = 1e3, r = 1.5, i = 6e4) {
		this.ui = e, this.timerId = t, this.ko = n, this.qo = r, this.Qo = i, this.Ko = 0, this.$o = null, this.Uo = Date.now(), this.reset();
	}
	reset() {
		this.Ko = 0;
	}
	Wo() {
		this.Ko = this.Qo;
	}
	Go(e) {
		this.cancel();
		let t = Math.floor(this.Ko + this.zo()), n = Math.max(0, Date.now() - this.Uo), r = Math.max(0, t - n);
		r > 0 && N("ExponentialBackoff", `Backing off for ${r} ms (base delay: ${this.Ko} ms, delay with jitter: ${t} ms, last attempt: ${n} ms ago)`), this.$o = this.ui.enqueueAfterDelay(this.timerId, r, (() => (this.Uo = Date.now(), e()))), this.Ko *= this.qo, this.Ko < this.ko && (this.Ko = this.ko), this.Ko > this.Qo && (this.Ko = this.Qo);
	}
	jo() {
		this.$o !== null && (this.$o.skipDelay(), this.$o = null);
	}
	cancel() {
		this.$o !== null && (this.$o.cancel(), this.$o = null);
	}
	zo() {
		return (Math.random() - .5) * this.Ko;
	}
}, Cu = class {
	constructor(e, t, n, r, i, a, o, s) {
		this.ui = e, this.Ho = n, this.Jo = r, this.connection = i, this.authCredentialsProvider = a, this.appCheckCredentialsProvider = o, this.listener = s, this.state = 0, this.Yo = 0, this.Zo = null, this.Xo = null, this.stream = null, this.e_ = 0, this.t_ = new Su(e, t);
	}
	n_() {
		return this.state === 1 || this.state === 5 || this.r_();
	}
	r_() {
		return this.state === 2 || this.state === 3;
	}
	start() {
		this.e_ = 0, this.state === 4 ? this.i_() : this.auth();
	}
	async stop() {
		this.n_() && await this.close(0);
	}
	s_() {
		this.state = 0, this.t_.reset();
	}
	o_() {
		this.r_() && this.Zo === null && (this.Zo = this.ui.enqueueAfterDelay(this.Ho, 6e4, (() => this.__())));
	}
	a_(e) {
		this.u_(), this.stream.send(e);
	}
	async __() {
		if (this.r_()) return this.close(0);
	}
	u_() {
		this.Zo &&= (this.Zo.cancel(), null);
	}
	c_() {
		this.Xo &&= (this.Xo.cancel(), null);
	}
	async close(e, t) {
		this.u_(), this.c_(), this.t_.cancel(), this.Yo++, e === 4 ? t && t.code === L.RESOURCE_EXHAUSTED ? (ma(t.toString()), ma("Using maximum backoff delay to prevent overloading the backend."), this.t_.Wo()) : t && t.code === L.UNAUTHENTICATED && this.state !== 3 && (this.authCredentialsProvider.invalidateToken(), this.appCheckCredentialsProvider.invalidateToken()) : this.t_.reset(), this.stream !== null && (this.l_(), this.stream.close(), this.stream = null), this.state = e, await this.listener.mo(t);
	}
	l_() {}
	auth() {
		this.state = 1;
		let e = this.h_(this.Yo), t = this.Yo;
		Promise.all([this.authCredentialsProvider.getToken(), this.appCheckCredentialsProvider.getToken()]).then((([e, n]) => {
			this.Yo === t && this.P_(e, n);
		}), ((t) => {
			e((() => {
				let e = new R(L.UNKNOWN, "Fetching auth token failed: " + t.message);
				return this.I_(e);
			}));
		}));
	}
	P_(e, t) {
		let n = this.h_(this.Yo);
		this.stream = this.T_(e, t), this.stream.Eo((() => {
			n((() => this.listener.Eo()));
		})), this.stream.Ro((() => {
			n((() => (this.state = 2, this.Xo = this.ui.enqueueAfterDelay(this.Jo, 1e4, (() => (this.r_() && (this.state = 3), Promise.resolve()))), this.listener.Ro())));
		})), this.stream.mo(((e) => {
			n((() => this.I_(e)));
		})), this.stream.onMessage(((e) => {
			n((() => ++this.e_ == 1 ? this.E_(e) : this.onNext(e)));
		}));
	}
	i_() {
		this.state = 5, this.t_.Go((async () => {
			this.state = 0, this.start();
		}));
	}
	I_(e) {
		return N("PersistentStream", `close with error: ${e}`), this.stream = null, this.close(4, e);
	}
	h_(e) {
		return (t) => {
			this.ui.enqueueAndForget((() => this.Yo === e ? t() : (N("PersistentStream", "stream callback skipped by getCloseGuardedDispatcher."), Promise.resolve())));
		};
	}
}, wu = class extends Cu {
	constructor(e, t, n, r, i, a) {
		super(e, "listen_stream_connection_backoff", "listen_stream_idle", "health_check_timeout", t, n, r, a), this.serializer = i;
	}
	T_(e, t) {
		return this.connection.Bo("Listen", e, t);
	}
	E_(e) {
		return this.onNext(e);
	}
	onNext(e) {
		this.t_.reset();
		let t = il(this.serializer, e), n = function(e) {
			if (!("targetChange" in e)) return B.min();
			let t = e.targetChange;
			return t.targetIds && t.targetIds.length ? B.min() : t.readTime ? qc(t.readTime) : B.min();
		}(e);
		return this.listener.d_(t, n);
	}
	A_(e) {
		let t = {};
		t.database = tl(this.serializer), t.addTarget = function(e, t) {
			let n, r = t.target;
			if (n = cs(r) ? { documents: sl(e, r) } : { query: cl(e, r)._t }, n.targetId = t.targetId, t.resumeToken.approximateByteSize() > 0) {
				n.resumeToken = Gc(e, t.resumeToken);
				let r = Uc(e, t.expectedCount);
				r !== null && (n.expectedCount = r);
			} else if (t.snapshotVersion.compareTo(B.min()) > 0) {
				n.readTime = Wc(e, t.snapshotVersion.toTimestamp());
				let r = Uc(e, t.expectedCount);
				r !== null && (n.expectedCount = r);
			}
			return n;
		}(this.serializer, e);
		let n = ul(this.serializer, e);
		n && (t.labels = n), this.a_(t);
	}
	R_(e) {
		let t = {};
		t.database = tl(this.serializer), t.removeTarget = e, this.a_(t);
	}
}, Tu = class extends Cu {
	constructor(e, t, n, r, i, a) {
		super(e, "write_stream_connection_backoff", "write_stream_idle", "health_check_timeout", t, n, r, a), this.serializer = i;
	}
	get V_() {
		return this.e_ > 0;
	}
	start() {
		this.lastStreamToken = void 0, super.start();
	}
	l_() {
		this.V_ && this.m_([]);
	}
	T_(e, t) {
		return this.connection.Bo("Write", e, t);
	}
	E_(e) {
		return F(!!e.streamToken), this.lastStreamToken = e.streamToken, F(!e.writeResults || e.writeResults.length === 0), this.listener.f_();
	}
	onNext(e) {
		F(!!e.streamToken), this.lastStreamToken = e.streamToken, this.t_.reset();
		let t = ol(e.writeResults, e.commitTime), n = qc(e.commitTime);
		return this.listener.g_(n, t);
	}
	p_() {
		let e = {};
		e.database = tl(this.serializer), this.a_(e);
	}
	m_(e) {
		let t = {
			streamToken: this.lastStreamToken,
			writes: e.map(((e) => al(this.serializer, e)))
		};
		this.a_(t);
	}
}, Eu = class extends class {} {
	constructor(e, t, n, r) {
		super(), this.authCredentials = e, this.appCheckCredentials = t, this.connection = n, this.serializer = r, this.y_ = !1;
	}
	w_() {
		if (this.y_) throw new R(L.FAILED_PRECONDITION, "The client has already been terminated.");
	}
	Mo(e, t, n, r) {
		return this.w_(), Promise.all([this.authCredentials.getToken(), this.appCheckCredentials.getToken()]).then((([i, a]) => this.connection.Mo(e, Yc(t, n), r, i, a))).catch(((e) => {
			throw e.name === "FirebaseError" ? (e.code === L.UNAUTHENTICATED && (this.authCredentials.invalidateToken(), this.appCheckCredentials.invalidateToken()), e) : new R(L.UNKNOWN, e.toString());
		}));
	}
	Lo(e, t, n, r, i) {
		return this.w_(), Promise.all([this.authCredentials.getToken(), this.appCheckCredentials.getToken()]).then((([a, o]) => this.connection.Lo(e, Yc(t, n), r, a, o, i))).catch(((e) => {
			throw e.name === "FirebaseError" ? (e.code === L.UNAUTHENTICATED && (this.authCredentials.invalidateToken(), this.appCheckCredentials.invalidateToken()), e) : new R(L.UNKNOWN, e.toString());
		}));
	}
	terminate() {
		this.y_ = !0, this.connection.terminate();
	}
}, Du = class {
	constructor(e, t) {
		this.asyncQueue = e, this.onlineStateHandler = t, this.state = "Unknown", this.S_ = 0, this.b_ = null, this.D_ = !0;
	}
	v_() {
		this.S_ === 0 && (this.C_("Unknown"), this.b_ = this.asyncQueue.enqueueAfterDelay("online_state_timeout", 1e4, (() => (this.b_ = null, this.F_("Backend didn't respond within 10 seconds."), this.C_("Offline"), Promise.resolve()))));
	}
	M_(e) {
		this.state === "Online" ? this.C_("Unknown") : (this.S_++, this.S_ >= 1 && (this.x_(), this.F_(`Connection failed 1 times. Most recent error: ${e.toString()}`), this.C_("Offline")));
	}
	set(e) {
		this.x_(), this.S_ = 0, e === "Online" && (this.D_ = !1), this.C_(e);
	}
	C_(e) {
		e !== this.state && (this.state = e, this.onlineStateHandler(e));
	}
	F_(e) {
		let t = `Could not reach Cloud Firestore backend. ${e}\nThis typically indicates that your device does not have a healthy Internet connection at the moment. The client will operate in offline mode until it is able to successfully connect to the backend.`;
		this.D_ ? (ma(t), this.D_ = !1) : N("OnlineStateTracker", t);
	}
	x_() {
		this.b_ !== null && (this.b_.cancel(), this.b_ = null);
	}
}, Ou = class {
	constructor(e, t, n, r, i) {
		this.localStore = e, this.datastore = t, this.asyncQueue = n, this.remoteSyncer = {}, this.O_ = [], this.N_ = /* @__PURE__ */ new Map(), this.L_ = /* @__PURE__ */ new Set(), this.B_ = [], this.k_ = i, this.k_._o(((e) => {
			n.enqueueAndForget((async () => {
				Lu(this) && (N("RemoteStore", "Restarting streams for network reachability change."), await async function(e) {
					let t = I(e);
					t.L_.add(4), await Au(t), t.q_.set("Unknown"), t.L_.delete(4), await ku(t);
				}(this));
			}));
		})), this.q_ = new Du(n, r);
	}
};
async function ku(e) {
	if (Lu(e)) for (let t of e.B_) await t(!0);
}
async function Au(e) {
	for (let t of e.B_) await t(!1);
}
function ju(e, t) {
	let n = I(e);
	n.N_.has(t.targetId) || (n.N_.set(t.targetId, t), Iu(n) ? Fu(n) : nd(n).r_() && Nu(n, t));
}
function Mu(e, t) {
	let n = I(e), r = nd(n);
	n.N_.delete(t), r.r_() && Pu(n, t), n.N_.size === 0 && (r.r_() ? r.o_() : Lu(n) && n.q_.set("Unknown"));
}
function Nu(e, t) {
	if (e.Q_.xe(t.targetId), t.resumeToken.approximateByteSize() > 0 || t.snapshotVersion.compareTo(B.min()) > 0) {
		let n = e.remoteSyncer.getRemoteKeysForTarget(t.targetId).size;
		t = t.withExpectedCount(n);
	}
	nd(e).A_(t);
}
function Pu(e, t) {
	e.Q_.xe(t), nd(e).R_(t);
}
function Fu(e) {
	e.Q_ = new Ic({
		getRemoteKeysForTarget: (t) => e.remoteSyncer.getRemoteKeysForTarget(t),
		ot: (t) => e.N_.get(t) || null,
		tt: () => e.datastore.serializer.databaseId
	}), nd(e).start(), e.q_.v_();
}
function Iu(e) {
	return Lu(e) && !nd(e).n_() && e.N_.size > 0;
}
function Lu(e) {
	return I(e).L_.size === 0;
}
function Ru(e) {
	e.Q_ = void 0;
}
async function zu(e) {
	e.q_.set("Online");
}
async function Bu(e) {
	e.N_.forEach(((t, n) => {
		Nu(e, t);
	}));
}
async function Vu(e, t) {
	Ru(e), Iu(e) ? (e.q_.M_(t), Fu(e)) : e.q_.set("Unknown");
}
async function Hu(e, t, n) {
	if (e.q_.set("Online"), t instanceof Pc && t.state === 2 && t.cause) try {
		await async function(e, t) {
			let n = t.cause;
			for (let r of t.targetIds) e.N_.has(r) && (await e.remoteSyncer.rejectListen(r, n), e.N_.delete(r), e.Q_.removeTarget(r));
		}(e, t);
	} catch (n) {
		N("RemoteStore", "Failed to remove targets %s: %s ", t.targetIds.join(","), n), await Uu(e, n);
	}
	else if (t instanceof Mc ? e.Q_.Ke(t) : t instanceof Nc ? e.Q_.He(t) : e.Q_.We(t), !n.isEqual(B.min())) try {
		let t = await nu(e.localStore);
		n.compareTo(t) >= 0 && await function(e, t) {
			let n = e.Q_.rt(t);
			return n.targetChanges.forEach(((n, r) => {
				if (n.resumeToken.approximateByteSize() > 0) {
					let i = e.N_.get(r);
					i && e.N_.set(r, i.withResumeToken(n.resumeToken, t));
				}
			})), n.targetMismatches.forEach(((t, n) => {
				let r = e.N_.get(t);
				r && (e.N_.set(t, r.withResumeToken(ao.EMPTY_BYTE_STRING, r.snapshotVersion)), Pu(e, t), Nu(e, new bl(r.target, t, n, r.sequenceNumber)));
			})), e.remoteSyncer.applyRemoteEvent(n);
		}(e, n);
	} catch (t) {
		N("RemoteStore", "Failed to raise snapshot:", t), await Uu(e, t);
	}
}
async function Uu(e, t, n) {
	if (!Ha(t)) throw t;
	e.L_.add(1), await Au(e), e.q_.set("Offline"), n ||= () => nu(e.localStore), e.asyncQueue.enqueueRetryable((async () => {
		N("RemoteStore", "Retrying IndexedDB access"), await n(), e.L_.delete(1), await ku(e);
	}));
}
function Wu(e, t) {
	return t().catch(((n) => Uu(e, n, t)));
}
async function Gu(e) {
	let t = I(e), n = rd(t), r = t.O_.length > 0 ? t.O_[t.O_.length - 1].batchId : -1;
	for (; Ku(t);) try {
		let e = await au(t.localStore, r);
		if (e === null) {
			t.O_.length === 0 && n.o_();
			break;
		}
		r = e.batchId, qu(t, e);
	} catch (e) {
		await Uu(t, e);
	}
	Ju(t) && Yu(t);
}
function Ku(e) {
	return Lu(e) && e.O_.length < 10;
}
function qu(e, t) {
	e.O_.push(t);
	let n = rd(e);
	n.r_() && n.V_ && n.m_(t.mutations);
}
function Ju(e) {
	return Lu(e) && !rd(e).n_() && e.O_.length > 0;
}
function Yu(e) {
	rd(e).start();
}
async function Xu(e) {
	rd(e).p_();
}
async function Zu(e) {
	let t = rd(e);
	for (let n of e.O_) t.m_(n.mutations);
}
async function Qu(e, t, n) {
	let r = e.O_.shift(), i = vc.from(r, t, n);
	await Wu(e, (() => e.remoteSyncer.applySuccessfulWrite(i))), await Gu(e);
}
async function $u(e, t) {
	t && rd(e).V_ && await async function(e, t) {
		if (function(e) {
			return xc(e) && e !== L.ABORTED;
		}(t.code)) {
			let n = e.O_.shift();
			rd(e).s_(), await Wu(e, (() => e.remoteSyncer.rejectFailedWrite(n.batchId, t))), await Gu(e);
		}
	}(e, t), Ju(e) && Yu(e);
}
async function ed(e, t) {
	let n = I(e);
	n.asyncQueue.verifyOperationInProgress(), N("RemoteStore", "RemoteStore received new credentials");
	let r = Lu(n);
	n.L_.add(3), await Au(n), r && n.q_.set("Unknown"), await n.remoteSyncer.handleCredentialChange(t), n.L_.delete(3), await ku(n);
}
async function td(e, t) {
	let n = I(e);
	t ? (n.L_.delete(2), await ku(n)) : t || (n.L_.add(2), await Au(n), n.q_.set("Unknown"));
}
function nd(e) {
	return e.K_ || (e.K_ = function(e, t, n) {
		let r = I(e);
		return r.w_(), new wu(t, r.connection, r.authCredentials, r.appCheckCredentials, r.serializer, n);
	}(e.datastore, e.asyncQueue, {
		Eo: zu.bind(null, e),
		Ro: Bu.bind(null, e),
		mo: Vu.bind(null, e),
		d_: Hu.bind(null, e)
	}), e.B_.push((async (t) => {
		t ? (e.K_.s_(), Iu(e) ? Fu(e) : e.q_.set("Unknown")) : (await e.K_.stop(), Ru(e));
	}))), e.K_;
}
function rd(e) {
	return e.U_ || (e.U_ = function(e, t, n) {
		let r = I(e);
		return r.w_(), new Tu(t, r.connection, r.authCredentials, r.appCheckCredentials, r.serializer, n);
	}(e.datastore, e.asyncQueue, {
		Eo: () => Promise.resolve(),
		Ro: Xu.bind(null, e),
		mo: $u.bind(null, e),
		f_: Zu.bind(null, e),
		g_: Qu.bind(null, e)
	}), e.B_.push((async (t) => {
		t ? (e.U_.s_(), await Gu(e)) : (await e.U_.stop(), e.O_.length > 0 && (N("RemoteStore", `Stopping write stream with ${e.O_.length} pending writes`), e.O_ = []));
	}))), e.U_;
}
var id = class e {
	constructor(e, t, n, r, i) {
		this.asyncQueue = e, this.timerId = t, this.targetTimeMs = n, this.op = r, this.removalCallback = i, this.deferred = new _a(), this.then = this.deferred.promise.then.bind(this.deferred.promise), this.deferred.promise.catch(((e) => {}));
	}
	get promise() {
		return this.deferred.promise;
	}
	static createAndSchedule(t, n, r, i, a) {
		let o = new e(t, n, Date.now() + r, i, a);
		return o.start(r), o;
	}
	start(e) {
		this.timerHandle = setTimeout((() => this.handleDelayElapsed()), e);
	}
	skipDelay() {
		return this.handleDelayElapsed();
	}
	cancel(e) {
		this.timerHandle !== null && (this.clearTimeout(), this.deferred.reject(new R(L.CANCELLED, "Operation cancelled" + (e ? ": " + e : ""))));
	}
	handleDelayElapsed() {
		this.asyncQueue.enqueueAndForget((() => this.timerHandle === null ? Promise.resolve() : (this.clearTimeout(), this.op().then(((e) => this.deferred.resolve(e))))));
	}
	clearTimeout() {
		this.timerHandle !== null && (this.removalCallback(this), clearTimeout(this.timerHandle), this.timerHandle = null);
	}
};
function ad(e, t) {
	if (ma("AsyncQueue", `${t}: ${e}`), Ha(e)) return new R(L.UNAVAILABLE, `${t}: ${e}`);
	throw e;
}
var od = class e {
	constructor(e) {
		this.comparator = e ? (t, n) => e(t, n) || H.comparator(t.key, n.key) : (e, t) => H.comparator(e.key, t.key), this.keyedMap = As(), this.sortedSet = new W(this.comparator);
	}
	static emptySet(t) {
		return new e(t.comparator);
	}
	has(e) {
		return this.keyedMap.get(e) != null;
	}
	get(e) {
		return this.keyedMap.get(e);
	}
	first() {
		return this.sortedSet.minKey();
	}
	last() {
		return this.sortedSet.maxKey();
	}
	isEmpty() {
		return this.sortedSet.isEmpty();
	}
	indexOf(e) {
		let t = this.keyedMap.get(e);
		return t ? this.sortedSet.indexOf(t) : -1;
	}
	get size() {
		return this.sortedSet.size;
	}
	forEach(e) {
		this.sortedSet.inorderTraversal(((t, n) => (e(t), !1)));
	}
	add(e) {
		let t = this.delete(e.key);
		return t.copy(t.keyedMap.insert(e.key, e), t.sortedSet.insert(e, null));
	}
	delete(e) {
		let t = this.get(e);
		return t ? this.copy(this.keyedMap.remove(e), this.sortedSet.remove(t)) : this;
	}
	isEqual(t) {
		if (!(t instanceof e) || this.size !== t.size) return !1;
		let n = this.sortedSet.getIterator(), r = t.sortedSet.getIterator();
		for (; n.hasNext();) {
			let e = n.getNext().key, t = r.getNext().key;
			if (!e.isEqual(t)) return !1;
		}
		return !0;
	}
	toString() {
		let e = [];
		return this.forEach(((t) => {
			e.push(t.toString());
		})), e.length === 0 ? "DocumentSet ()" : "DocumentSet (\n  " + e.join("  \n") + "\n)";
	}
	copy(t, n) {
		let r = new e();
		return r.comparator = this.comparator, r.keyedMap = t, r.sortedSet = n, r;
	}
}, sd = class {
	constructor() {
		this.W_ = new W(H.comparator);
	}
	track(e) {
		let t = e.doc.key, n = this.W_.get(t);
		n ? e.type !== 0 && n.type === 3 ? this.W_ = this.W_.insert(t, e) : e.type === 3 && n.type !== 1 ? this.W_ = this.W_.insert(t, {
			type: n.type,
			doc: e.doc
		}) : e.type === 2 && n.type === 2 ? this.W_ = this.W_.insert(t, {
			type: 2,
			doc: e.doc
		}) : e.type === 2 && n.type === 0 ? this.W_ = this.W_.insert(t, {
			type: 0,
			doc: e.doc
		}) : e.type === 1 && n.type === 0 ? this.W_ = this.W_.remove(t) : e.type === 1 && n.type === 2 ? this.W_ = this.W_.insert(t, {
			type: 1,
			doc: n.doc
		}) : e.type === 0 && n.type === 1 ? this.W_ = this.W_.insert(t, {
			type: 2,
			doc: e.doc
		}) : P() : this.W_ = this.W_.insert(t, e);
	}
	G_() {
		let e = [];
		return this.W_.inorderTraversal(((t, n) => {
			e.push(n);
		})), e;
	}
}, cd = class e {
	constructor(e, t, n, r, i, a, o, s, c) {
		this.query = e, this.docs = t, this.oldDocs = n, this.docChanges = r, this.mutatedKeys = i, this.fromCache = a, this.syncStateChanged = o, this.excludesMetadataChanges = s, this.hasCachedResults = c;
	}
	static fromInitialDocuments(t, n, r, i, a) {
		let o = [];
		return n.forEach(((e) => {
			o.push({
				type: 0,
				doc: e
			});
		})), new e(t, n, od.emptySet(n), o, r, i, !0, !1, a);
	}
	get hasPendingWrites() {
		return !this.mutatedKeys.isEmpty();
	}
	isEqual(e) {
		if (!(this.fromCache === e.fromCache && this.hasCachedResults === e.hasCachedResults && this.syncStateChanged === e.syncStateChanged && this.mutatedKeys.isEqual(e.mutatedKeys) && ys(this.query, e.query) && this.docs.isEqual(e.docs) && this.oldDocs.isEqual(e.oldDocs))) return !1;
		let t = this.docChanges, n = e.docChanges;
		if (t.length !== n.length) return !1;
		for (let e = 0; e < t.length; e++) if (t[e].type !== n[e].type || !t[e].doc.isEqual(n[e].doc)) return !1;
		return !0;
	}
}, ld = class {
	constructor() {
		this.z_ = void 0, this.j_ = [];
	}
	H_() {
		return this.j_.some(((e) => e.J_()));
	}
}, ud = class {
	constructor() {
		this.queries = dd(), this.onlineState = "Unknown", this.Y_ = /* @__PURE__ */ new Set();
	}
	terminate() {
		(function(e, t) {
			let n = I(e), r = n.queries;
			n.queries = dd(), r.forEach(((e, n) => {
				for (let e of n.j_) e.onError(t);
			}));
		})(this, new R(L.ABORTED, "Firestore shutting down"));
	}
};
function dd() {
	return new Es(((e) => bs(e)), ys);
}
async function fd(e, t) {
	let n = I(e), r = 3, i = t.query, a = n.queries.get(i);
	a ? !a.H_() && t.J_() && (r = 2) : (a = new ld(), r = +!t.J_());
	try {
		switch (r) {
			case 0:
				a.z_ = await n.onListen(i, !0);
				break;
			case 1:
				a.z_ = await n.onListen(i, !1);
				break;
			case 2: await n.onFirstRemoteStoreListen(i);
		}
	} catch (e) {
		let n = ad(e, `Initialization of query '${xs(t.query)}' failed`);
		t.onError(n);
		return;
	}
	n.queries.set(i, a), a.j_.push(t), t.Z_(n.onlineState), a.z_ && t.X_(a.z_) && gd(n);
}
async function pd(e, t) {
	let n = I(e), r = t.query, i = 3, a = n.queries.get(r);
	if (a) {
		let e = a.j_.indexOf(t);
		e >= 0 && (a.j_.splice(e, 1), a.j_.length === 0 ? i = +!t.J_() : !a.H_() && t.J_() && (i = 2));
	}
	switch (i) {
		case 0: return n.queries.delete(r), n.onUnlisten(r, !0);
		case 1: return n.queries.delete(r), n.onUnlisten(r, !1);
		case 2: return n.onLastRemoteStoreUnlisten(r);
		default: return;
	}
}
function md(e, t) {
	let n = I(e), r = !1;
	for (let e of t) {
		let t = e.query, i = n.queries.get(t);
		if (i) {
			for (let t of i.j_) t.X_(e) && (r = !0);
			i.z_ = e;
		}
	}
	r && gd(n);
}
function hd(e, t, n) {
	let r = I(e), i = r.queries.get(t);
	if (i) for (let e of i.j_) e.onError(n);
	r.queries.delete(t);
}
function gd(e) {
	e.Y_.forEach(((e) => {
		e.next();
	}));
}
var _d, vd;
(vd = _d ||= {}).ea = "default", vd.Cache = "cache";
var yd = class {
	constructor(e, t, n) {
		this.query = e, this.ta = t, this.na = !1, this.ra = null, this.onlineState = "Unknown", this.options = n || {};
	}
	X_(e) {
		if (!this.options.includeMetadataChanges) {
			let t = [];
			for (let n of e.docChanges) n.type !== 3 && t.push(n);
			e = new cd(e.query, e.docs, e.oldDocs, t, e.mutatedKeys, e.fromCache, e.syncStateChanged, !0, e.hasCachedResults);
		}
		let t = !1;
		return this.na ? this.ia(e) && (this.ta.next(e), t = !0) : this.sa(e, this.onlineState) && (this.oa(e), t = !0), this.ra = e, t;
	}
	onError(e) {
		this.ta.error(e);
	}
	Z_(e) {
		this.onlineState = e;
		let t = !1;
		return this.ra && !this.na && this.sa(this.ra, e) && (this.oa(this.ra), t = !0), t;
	}
	sa(e, t) {
		if (!e.fromCache || !this.J_()) return !0;
		let n = t !== "Offline";
		return (!this.options._a || !n) && (!e.docs.isEmpty() || e.hasCachedResults || t === "Offline");
	}
	ia(e) {
		if (e.docChanges.length > 0) return !0;
		let t = this.ra && this.ra.hasPendingWrites !== e.hasPendingWrites;
		return !(!e.syncStateChanged && !t) && !0 === this.options.includeMetadataChanges;
	}
	oa(e) {
		e = cd.fromInitialDocuments(e.query, e.docs, e.mutatedKeys, e.fromCache, e.hasCachedResults), this.na = !0, this.ta.next(e);
	}
	J_() {
		return this.options.source !== _d.Cache;
	}
}, bd = class {
	constructor(e) {
		this.key = e;
	}
}, xd = class {
	constructor(e) {
		this.key = e;
	}
}, Sd = class {
	constructor(e, t) {
		this.query = e, this.Ta = t, this.Ea = null, this.hasCachedResults = !1, this.current = !1, this.da = q(), this.mutatedKeys = q(), this.Aa = ws(e), this.Ra = new od(this.Aa);
	}
	get Va() {
		return this.Ta;
	}
	ma(e, t) {
		let n = t ? t.fa : new sd(), r = t ? t.Ra : this.Ra, i = t ? t.mutatedKeys : this.mutatedKeys, a = r, o = !1, s = this.query.limitType === "F" && r.size === this.query.limit ? r.last() : null, c = this.query.limitType === "L" && r.size === this.query.limit ? r.first() : null;
		if (e.inorderTraversal(((e, t) => {
			let l = r.get(e), u = Ss(this.query, t) ? t : null, d = !!l && this.mutatedKeys.has(l.key), f = !!u && (u.hasLocalMutations || this.mutatedKeys.has(u.key) && u.hasCommittedMutations), p = !1;
			l && u ? l.data.isEqual(u.data) ? d !== f && (n.track({
				type: 3,
				doc: u
			}), p = !0) : this.ga(l, u) || (n.track({
				type: 2,
				doc: u
			}), p = !0, (s && this.Aa(u, s) > 0 || c && this.Aa(u, c) < 0) && (o = !0)) : !l && u ? (n.track({
				type: 0,
				doc: u
			}), p = !0) : l && !u && (n.track({
				type: 1,
				doc: l
			}), p = !0, (s || c) && (o = !0)), p && (u ? (a = a.add(u), i = f ? i.add(e) : i.delete(e)) : (a = a.delete(e), i = i.delete(e)));
		})), this.query.limit !== null) for (; a.size > this.query.limit;) {
			let e = this.query.limitType === "F" ? a.last() : a.first();
			a = a.delete(e.key), i = i.delete(e.key), n.track({
				type: 1,
				doc: e
			});
		}
		return {
			Ra: a,
			fa: n,
			ns: o,
			mutatedKeys: i
		};
	}
	ga(e, t) {
		return e.hasLocalMutations && t.hasCommittedMutations && !t.hasLocalMutations;
	}
	applyChanges(e, t, n, r) {
		let i = this.Ra;
		this.Ra = e.Ra, this.mutatedKeys = e.mutatedKeys;
		let a = e.fa.G_();
		a.sort(((e, t) => function(e, t) {
			let n = (e) => {
				switch (e) {
					case 0: return 1;
					case 2:
					case 3: return 2;
					case 1: return 0;
					default: return P();
				}
			};
			return n(e) - n(t);
		}(e.type, t.type) || this.Aa(e.doc, t.doc))), this.pa(n), r = r != null && r;
		let o = t && !r ? this.ya() : [], s = this.da.size === 0 && this.current && !r ? 1 : 0, c = s !== this.Ea;
		return this.Ea = s, a.length !== 0 || c ? {
			snapshot: new cd(this.query, e.Ra, i, a, e.mutatedKeys, s === 0, c, !1, !!n && n.resumeToken.approximateByteSize() > 0),
			wa: o
		} : { wa: o };
	}
	Z_(e) {
		return this.current && e === "Offline" ? (this.current = !1, this.applyChanges({
			Ra: this.Ra,
			fa: new sd(),
			mutatedKeys: this.mutatedKeys,
			ns: !1
		}, !1)) : { wa: [] };
	}
	Sa(e) {
		return !this.Ta.has(e) && !!this.Ra.has(e) && !this.Ra.get(e).hasLocalMutations;
	}
	pa(e) {
		e && (e.addedDocuments.forEach(((e) => this.Ta = this.Ta.add(e))), e.modifiedDocuments.forEach(((e) => {})), e.removedDocuments.forEach(((e) => this.Ta = this.Ta.delete(e))), this.current = e.current);
	}
	ya() {
		if (!this.current) return [];
		let e = this.da;
		this.da = q(), this.Ra.forEach(((e) => {
			this.Sa(e.key) && (this.da = this.da.add(e.key));
		}));
		let t = [];
		return e.forEach(((e) => {
			this.da.has(e) || t.push(new xd(e));
		})), this.da.forEach(((n) => {
			e.has(n) || t.push(new bd(n));
		})), t;
	}
	ba(e) {
		this.Ta = e.Ts, this.da = q();
		let t = this.ma(e.documents);
		return this.applyChanges(t, !0);
	}
	Da() {
		return cd.fromInitialDocuments(this.query, this.Ra, this.mutatedKeys, this.Ea === 0, this.hasCachedResults);
	}
}, Cd = class {
	constructor(e, t, n) {
		this.query = e, this.targetId = t, this.view = n;
	}
}, wd = class {
	constructor(e) {
		this.key = e, this.va = !1;
	}
}, Td = class {
	constructor(e, t, n, r, i, a) {
		this.localStore = e, this.remoteStore = t, this.eventManager = n, this.sharedClientState = r, this.currentUser = i, this.maxConcurrentLimboResolutions = a, this.Ca = {}, this.Fa = new Es(((e) => bs(e)), ys), this.Ma = /* @__PURE__ */ new Map(), this.xa = /* @__PURE__ */ new Set(), this.Oa = new W(H.comparator), this.Na = /* @__PURE__ */ new Map(), this.La = new Bl(), this.Ba = {}, this.ka = /* @__PURE__ */ new Map(), this.qa = Ol.kn(), this.onlineState = "Unknown", this.Qa = void 0;
	}
	get isPrimaryClient() {
		return !0 === this.Qa;
	}
};
async function Ed(e, t, n = !0) {
	let r = Jd(e), i, a = r.Fa.get(t);
	return a ? (r.sharedClientState.addLocalQueryTarget(a.targetId), i = a.view.Da()) : i = await Od(r, t, n, !0), i;
}
async function Dd(e, t) {
	await Od(Jd(e), t, !0, !1);
}
async function Od(e, t, n, r) {
	let i = await ou(e.localStore, hs(t)), a = i.targetId, o = e.sharedClientState.addLocalQueryTarget(a, n), s;
	return r && (s = await kd(e, t, a, o === "current", i.resumeToken)), e.isPrimaryClient && n && ju(e.remoteStore, i), s;
}
async function kd(e, t, n, r, i) {
	e.Ka = (t, n, r) => async function(e, t, n, r) {
		let i = t.view.ma(n);
		i.ns && (i = await cu(e.localStore, t.query, !1).then((({ documents: e }) => t.view.ma(e, i))));
		let a = r && r.targetChanges.get(t.targetId), o = r && r.targetMismatches.get(t.targetId) != null, s = t.view.applyChanges(i, e.isPrimaryClient, a, o);
		return Hd(e, t.targetId, s.wa), s.snapshot;
	}(e, t, n, r);
	let a = await cu(e.localStore, t, !0), o = new Sd(t, a.Ts), s = o.ma(a.documents), c = jc.createSynthesizedTargetChangeForCurrentChange(n, r && e.onlineState !== "Offline", i), l = o.applyChanges(s, e.isPrimaryClient, c);
	Hd(e, n, l.wa);
	let u = new Cd(t, n, o);
	return e.Fa.set(t, u), e.Ma.has(n) ? e.Ma.get(n).push(t) : e.Ma.set(n, [t]), l.snapshot;
}
async function Ad(e, t, n) {
	let r = I(e), i = r.Fa.get(t), a = r.Ma.get(i.targetId);
	if (a.length > 1) return r.Ma.set(i.targetId, a.filter(((e) => !ys(e, t)))), void r.Fa.delete(t);
	r.isPrimaryClient ? (r.sharedClientState.removeLocalQueryTarget(i.targetId), r.sharedClientState.isActiveQueryTarget(i.targetId) || await su(r.localStore, i.targetId, !1).then((() => {
		r.sharedClientState.clearQueryState(i.targetId), n && Mu(r.remoteStore, i.targetId), Bd(r, i.targetId);
	})).catch(Ba)) : (Bd(r, i.targetId), await su(r.localStore, i.targetId, !0));
}
async function jd(e, t) {
	let n = I(e), r = n.Fa.get(t), i = n.Ma.get(r.targetId);
	n.isPrimaryClient && i.length === 1 && (n.sharedClientState.removeLocalQueryTarget(r.targetId), Mu(n.remoteStore, r.targetId));
}
async function Md(e, t, n) {
	let r = Yd(e);
	try {
		let e = await function(e, t) {
			let n = I(e), r = ka.now(), i = t.reduce(((e, t) => e.add(t.key)), q()), a, o;
			return n.persistence.runTransaction("Locally write mutations", "readwrite", ((e) => {
				let s = Os(), c = q();
				return n.cs.getEntries(e, i).next(((e) => {
					s = e, s.forEach(((e, t) => {
						t.isValidDocument() || (c = c.add(e));
					}));
				})).next((() => n.localDocuments.getOverlayedDocuments(e, s))).next(((i) => {
					a = i;
					let o = [];
					for (let e of t) {
						let t = cc(e, a.get(e.key).overlayedDocument);
						t != null && o.push(new dc(e.key, t, Fo(t.value.mapValue), nc.exists(!0)));
					}
					return n.mutationQueue.addMutationBatch(e, r, o, t);
				})).next(((t) => {
					o = t;
					let r = t.applyToLocalDocumentSet(a, c);
					return n.documentOverlayCache.saveOverlays(e, t.batchId, r);
				}));
			})).then((() => ({
				batchId: o.batchId,
				changes: js(a)
			})));
		}(r.localStore, t);
		r.sharedClientState.addPendingMutation(e.batchId), function(e, t, n) {
			let r = e.Ba[e.currentUser.toKey()];
			r ||= new W(z), r = r.insert(t, n), e.Ba[e.currentUser.toKey()] = r;
		}(r, e.batchId, n), await Gd(r, e.changes), await Gu(r.remoteStore);
	} catch (e) {
		let t = ad(e, "Failed to persist write");
		n.reject(t);
	}
}
async function Nd(e, t) {
	let n = I(e);
	try {
		let e = await ru(n.localStore, t);
		t.targetChanges.forEach(((e, t) => {
			let r = n.Na.get(t);
			r && (F(e.addedDocuments.size + e.modifiedDocuments.size + e.removedDocuments.size <= 1), e.addedDocuments.size > 0 ? r.va = !0 : e.modifiedDocuments.size > 0 ? F(r.va) : e.removedDocuments.size > 0 && (F(r.va), r.va = !1));
		})), await Gd(n, e, t);
	} catch (e) {
		await Ba(e);
	}
}
function Pd(e, t, n) {
	let r = I(e);
	if (r.isPrimaryClient && n === 0 || !r.isPrimaryClient && n === 1) {
		let e = [];
		r.Fa.forEach(((n, r) => {
			let i = r.view.Z_(t);
			i.snapshot && e.push(i.snapshot);
		})), function(e, t) {
			let n = I(e);
			n.onlineState = t;
			let r = !1;
			n.queries.forEach(((e, n) => {
				for (let e of n.j_) e.Z_(t) && (r = !0);
			})), r && gd(n);
		}(r.eventManager, t), e.length && r.Ca.d_(e), r.onlineState = t, r.isPrimaryClient && r.sharedClientState.setOnlineState(t);
	}
}
async function Fd(e, t, n) {
	let r = I(e);
	r.sharedClientState.updateQueryState(t, "rejected", n);
	let i = r.Na.get(t), a = i && i.key;
	if (a) {
		let e = new W(H.comparator);
		e = e.insert(a, Io.newNoDocument(a, B.min()));
		let n = q().add(a);
		await Nd(r, new Ac(B.min(), /* @__PURE__ */ new Map(), new W(z), e, n)), r.Oa = r.Oa.remove(a), r.Na.delete(t), Wd(r);
	} else await su(r.localStore, t, !1).then((() => Bd(r, t, n))).catch(Ba);
}
async function Id(e, t) {
	let n = I(e), r = t.batch.batchId;
	try {
		let e = await tu(n.localStore, t);
		zd(n, r, null), Rd(n, r), n.sharedClientState.updateMutationState(r, "acknowledged"), await Gd(n, e);
	} catch (e) {
		await Ba(e);
	}
}
async function Ld(e, t, n) {
	let r = I(e);
	try {
		let e = await function(e, t) {
			let n = I(e);
			return n.persistence.runTransaction("Reject batch", "readwrite-primary", ((e) => {
				let r;
				return n.mutationQueue.lookupMutationBatch(e, t).next(((t) => (F(t !== null), r = t.keys(), n.mutationQueue.removeMutationBatch(e, t)))).next((() => n.mutationQueue.performConsistencyCheck(e))).next((() => n.documentOverlayCache.removeOverlaysForBatchId(e, r, t))).next((() => n.localDocuments.recalculateAndSaveOverlaysForDocumentKeys(e, r))).next((() => n.localDocuments.getDocuments(e, r)));
			}));
		}(r.localStore, t);
		zd(r, t, n), Rd(r, t), r.sharedClientState.updateMutationState(t, "rejected", n), await Gd(r, e);
	} catch (e) {
		await Ba(e);
	}
}
function Rd(e, t) {
	(e.ka.get(t) || []).forEach(((e) => {
		e.resolve();
	})), e.ka.delete(t);
}
function zd(e, t, n) {
	let r = I(e), i = r.Ba[r.currentUser.toKey()];
	if (i) {
		let e = i.get(t);
		e && (n ? e.reject(n) : e.resolve(), i = i.remove(t)), r.Ba[r.currentUser.toKey()] = i;
	}
}
function Bd(e, t, n = null) {
	e.sharedClientState.removeLocalQueryTarget(t);
	for (let r of e.Ma.get(t)) e.Fa.delete(r), n && e.Ca.$a(r, n);
	e.Ma.delete(t), e.isPrimaryClient && e.La.gr(t).forEach(((t) => {
		e.La.containsKey(t) || Vd(e, t);
	}));
}
function Vd(e, t) {
	e.xa.delete(t.path.canonicalString());
	let n = e.Oa.get(t);
	n !== null && (Mu(e.remoteStore, n), e.Oa = e.Oa.remove(t), e.Na.delete(n), Wd(e));
}
function Hd(e, t, n) {
	for (let r of n) r instanceof bd ? (e.La.addReference(r.key, t), Ud(e, r)) : r instanceof xd ? (N("SyncEngine", "Document no longer in limbo: " + r.key), e.La.removeReference(r.key, t), e.La.containsKey(r.key) || Vd(e, r.key)) : P();
}
function Ud(e, t) {
	let n = t.key, r = n.path.canonicalString();
	e.Oa.get(n) || e.xa.has(r) || (N("SyncEngine", "New document in limbo: " + n), e.xa.add(r), Wd(e));
}
function Wd(e) {
	for (; e.xa.size > 0 && e.Oa.size < e.maxConcurrentLimboResolutions;) {
		let t = e.xa.values().next().value;
		e.xa.delete(t);
		let n = new H(V.fromString(t)), r = e.qa.next();
		e.Na.set(r, new wd(n)), e.Oa = e.Oa.insert(n, r), ju(e.remoteStore, new bl(hs(ds(n.path)), r, "TargetPurposeLimboResolution", Ua.oe));
	}
}
async function Gd(e, t, n) {
	let r = I(e), i = [], a = [], o = [];
	r.Fa.isEmpty() || (r.Fa.forEach(((e, s) => {
		o.push(r.Ka(s, t, n).then(((e) => {
			if ((e || n) && r.isPrimaryClient) {
				let t = e ? !e.fromCache : n?.targetChanges.get(s.targetId)?.current;
				r.sharedClientState.updateQueryState(s.targetId, t ? "current" : "not-current");
			}
			if (e) {
				i.push(e);
				let t = Yl.Wi(s.targetId, e);
				a.push(t);
			}
		})));
	})), await Promise.all(o), r.Ca.d_(i), await async function(e, t) {
		let n = I(e);
		try {
			await n.persistence.runTransaction("notifyLocalViewChanges", "readwrite", ((e) => U.forEach(t, ((t) => U.forEach(t.$i, ((r) => n.persistence.referenceDelegate.addReference(e, t.targetId, r))).next((() => U.forEach(t.Ui, ((r) => n.persistence.referenceDelegate.removeReference(e, t.targetId, r)))))))));
		} catch (e) {
			if (!Ha(e)) throw e;
			N("LocalStore", "Failed to update sequence numbers: " + e);
		}
		for (let e of t) {
			let t = e.targetId;
			if (!e.fromCache) {
				let e = n.os.get(t), r = e.snapshotVersion, i = e.withLastLimboFreeSnapshotVersion(r);
				n.os = n.os.insert(t, i);
			}
		}
	}(r.localStore, a));
}
async function Kd(e, t) {
	let n = I(e);
	if (!n.currentUser.isEqual(t)) {
		N("SyncEngine", "User change. New user:", t.toKey());
		let e = await eu(n.localStore, t);
		n.currentUser = t, function(e, t) {
			e.ka.forEach(((e) => {
				e.forEach(((e) => {
					e.reject(new R(L.CANCELLED, t));
				}));
			})), e.ka.clear();
		}(n, "'waitForPendingWrites' promise is rejected due to a user change."), n.sharedClientState.handleUserChange(t, e.removedBatchIds, e.addedBatchIds), await Gd(n, e.hs);
	}
}
function qd(e, t) {
	let n = I(e), r = n.Na.get(t);
	if (r && r.va) return q().add(r.key);
	{
		let e = q(), r = n.Ma.get(t);
		if (!r) return e;
		for (let t of r) {
			let r = n.Fa.get(t);
			e = e.unionWith(r.view.Va);
		}
		return e;
	}
}
function Jd(e) {
	let t = I(e);
	return t.remoteStore.remoteSyncer.applyRemoteEvent = Nd.bind(null, t), t.remoteStore.remoteSyncer.getRemoteKeysForTarget = qd.bind(null, t), t.remoteStore.remoteSyncer.rejectListen = Fd.bind(null, t), t.Ca.d_ = md.bind(null, t.eventManager), t.Ca.$a = hd.bind(null, t.eventManager), t;
}
function Yd(e) {
	let t = I(e);
	return t.remoteStore.remoteSyncer.applySuccessfulWrite = Id.bind(null, t), t.remoteStore.remoteSyncer.rejectFailedWrite = Ld.bind(null, t), t;
}
var Xd = class {
	constructor() {
		this.kind = "memory", this.synchronizeTabs = !1;
	}
	async initialize(e) {
		this.serializer = xu(e.databaseInfo.databaseId), this.sharedClientState = this.Wa(e), this.persistence = this.Ga(e), await this.persistence.start(), this.localStore = this.za(e), this.gcScheduler = this.ja(e, this.localStore), this.indexBackfillerScheduler = this.Ha(e, this.localStore);
	}
	ja(e, t) {
		return null;
	}
	Ha(e, t) {
		return null;
	}
	za(e) {
		return $l(this.persistence, new Zl(), e.initialUser, this.serializer);
	}
	Ga(e) {
		return new Gl(ql.Zr, this.serializer);
	}
	Wa(e) {
		return new du();
	}
	async terminate() {
		var e, t;
		(e = this.gcScheduler) == null || e.stop(), (t = this.indexBackfillerScheduler) == null || t.stop(), this.sharedClientState.shutdown(), await this.persistence.shutdown();
	}
};
Xd.provider = { build: () => new Xd() };
var Zd = class extends Xd {
	constructor(e) {
		super(), this.cacheSizeBytes = e;
	}
	ja(e, t) {
		F(this.persistence.referenceDelegate instanceof Jl);
		let n = this.persistence.referenceDelegate.garbageCollector;
		return new jl(n, e.asyncQueue, t);
	}
	Ga(e) {
		let t = this.cacheSizeBytes === void 0 ? Dl.DEFAULT : Dl.withCacheSize(this.cacheSizeBytes);
		return new Gl(((e) => Jl.Zr(e, t)), this.serializer);
	}
}, Qd = class {
	async initialize(e, t) {
		this.localStore || (this.localStore = e.localStore, this.sharedClientState = e.sharedClientState, this.datastore = this.createDatastore(t), this.remoteStore = this.createRemoteStore(t), this.eventManager = this.createEventManager(t), this.syncEngine = this.createSyncEngine(t, !e.synchronizeTabs), this.sharedClientState.onlineStateHandler = (e) => Pd(this.syncEngine, e, 1), this.remoteStore.remoteSyncer.handleCredentialChange = Kd.bind(null, this.syncEngine), await td(this.remoteStore, this.syncEngine.isPrimaryClient));
	}
	createEventManager(e) {
		return function() {
			return new ud();
		}();
	}
	createDatastore(e) {
		let t = xu(e.databaseInfo.databaseId), n = function(e) {
			return new yu(e);
		}(e.databaseInfo);
		return function(e, t, n, r) {
			return new Eu(e, t, n, r);
		}(e.authCredentials, e.appCheckCredentials, n, t);
	}
	createRemoteStore(e) {
		return function(e, t, n, r, i) {
			return new Ou(e, t, n, r, i);
		}(this.localStore, this.datastore, e.asyncQueue, ((e) => Pd(this.syncEngine, e, 0)), function() {
			return pu.D() ? new pu() : new fu();
		}());
	}
	createSyncEngine(e, t) {
		return function(e, t, n, r, i, a, o) {
			let s = new Td(e, t, n, r, i, a);
			return o && (s.Qa = !0), s;
		}(this.localStore, this.remoteStore, this.eventManager, this.sharedClientState, e.initialUser, e.maxConcurrentLimboResolutions, t);
	}
	async terminate() {
		var e, t;
		await async function(e) {
			let t = I(e);
			N("RemoteStore", "RemoteStore shutting down."), t.L_.add(5), await Au(t), t.k_.shutdown(), t.q_.set("Unknown");
		}(this.remoteStore), (e = this.datastore) == null || e.terminate(), (t = this.eventManager) == null || t.terminate();
	}
};
Qd.provider = { build: () => new Qd() };
var $d = class {
	constructor(e) {
		this.observer = e, this.muted = !1;
	}
	next(e) {
		this.muted || this.observer.next && this.Ya(this.observer.next, e);
	}
	error(e) {
		this.muted || (this.observer.error ? this.Ya(this.observer.error, e) : ma("Uncaught Error in snapshot listener:", e.toString()));
	}
	Za() {
		this.muted = !0;
	}
	Ya(e, t) {
		setTimeout((() => {
			this.muted || e(t);
		}), 0);
	}
}, ef = class {
	constructor(e, t, n, r, i) {
		this.authCredentials = e, this.appCheckCredentials = t, this.asyncQueue = n, this.databaseInfo = r, this.user = ua.UNAUTHENTICATED, this.clientId = Da.newId(), this.authCredentialListener = () => Promise.resolve(), this.appCheckCredentialListener = () => Promise.resolve(), this._uninitializedComponentsProvider = i, this.authCredentials.start(n, (async (e) => {
			N("FirestoreClient", "Received user=", e.uid), await this.authCredentialListener(e), this.user = e;
		})), this.appCheckCredentials.start(n, ((e) => (N("FirestoreClient", "Received new app check token=", e), this.appCheckCredentialListener(e, this.user))));
	}
	get configuration() {
		return {
			asyncQueue: this.asyncQueue,
			databaseInfo: this.databaseInfo,
			clientId: this.clientId,
			authCredentials: this.authCredentials,
			appCheckCredentials: this.appCheckCredentials,
			initialUser: this.user,
			maxConcurrentLimboResolutions: 100
		};
	}
	setCredentialChangeListener(e) {
		this.authCredentialListener = e;
	}
	setAppCheckTokenChangeListener(e) {
		this.appCheckCredentialListener = e;
	}
	terminate() {
		this.asyncQueue.enterRestrictedMode();
		let e = new _a();
		return this.asyncQueue.enqueueAndForgetEvenWhileRestricted((async () => {
			try {
				this._onlineComponents && await this._onlineComponents.terminate(), this._offlineComponents && await this._offlineComponents.terminate(), this.authCredentials.shutdown(), this.appCheckCredentials.shutdown(), e.resolve();
			} catch (t) {
				let n = ad(t, "Failed to shutdown persistence");
				e.reject(n);
			}
		})), e.promise;
	}
};
async function tf(e, t) {
	e.asyncQueue.verifyOperationInProgress(), N("FirestoreClient", "Initializing OfflineComponentProvider");
	let n = e.configuration;
	await t.initialize(n);
	let r = n.initialUser;
	e.setCredentialChangeListener((async (e) => {
		r.isEqual(e) || (await eu(t.localStore, e), r = e);
	})), t.persistence.setDatabaseDeletedListener((() => e.terminate())), e._offlineComponents = t;
}
async function nf(e, t) {
	e.asyncQueue.verifyOperationInProgress();
	let n = await rf(e);
	N("FirestoreClient", "Initializing OnlineComponentProvider"), await t.initialize(n, e.configuration), e.setCredentialChangeListener(((e) => ed(t.remoteStore, e))), e.setAppCheckTokenChangeListener(((e, n) => ed(t.remoteStore, n))), e._onlineComponents = t;
}
async function rf(e) {
	if (!e._offlineComponents) if (e._uninitializedComponentsProvider) {
		N("FirestoreClient", "Using user provided OfflineComponentProvider");
		try {
			await tf(e, e._uninitializedComponentsProvider._offline);
		} catch (t) {
			let n = t;
			if (!function(e) {
				return e.name === "FirebaseError" ? e.code === L.FAILED_PRECONDITION || e.code === L.UNIMPLEMENTED : !(typeof DOMException < "u" && e instanceof DOMException) || e.code === 22 || e.code === 20 || e.code === 11;
			}(n)) throw n;
			ha("Error using user provided cache. Falling back to memory cache: " + n), await tf(e, new Xd());
		}
	} else N("FirestoreClient", "Using default OfflineComponentProvider"), await tf(e, new Zd(void 0));
	return e._offlineComponents;
}
async function af(e) {
	return e._onlineComponents || (e._uninitializedComponentsProvider ? (N("FirestoreClient", "Using user provided OnlineComponentProvider"), await nf(e, e._uninitializedComponentsProvider._online)) : (N("FirestoreClient", "Using default OnlineComponentProvider"), await nf(e, new Qd()))), e._onlineComponents;
}
function of(e) {
	return af(e).then(((e) => e.syncEngine));
}
async function sf(e) {
	let t = await af(e), n = t.eventManager;
	return n.onListen = Ed.bind(null, t.syncEngine), n.onUnlisten = Ad.bind(null, t.syncEngine), n.onFirstRemoteStoreListen = Dd.bind(null, t.syncEngine), n.onLastRemoteStoreUnlisten = jd.bind(null, t.syncEngine), n;
}
function cf(e, t, n = {}) {
	let r = new _a();
	return e.asyncQueue.enqueueAndForget((async () => function(e, t, n, r, i) {
		let a = new $d({
			next: (s) => {
				a.Za(), t.enqueueAndForget((() => pd(e, o)));
				let c = s.docs.has(n);
				!c && s.fromCache ? i.reject(new R(L.UNAVAILABLE, "Failed to get document because the client is offline.")) : c && s.fromCache && r && r.source === "server" ? i.reject(new R(L.UNAVAILABLE, "Failed to get document from server. (However, this document does exist in the local cache. Run again without setting source to \"server\" to retrieve the cached document.)")) : i.resolve(s);
			},
			error: (e) => i.reject(e)
		}), o = new yd(ds(n.path), a, {
			includeMetadataChanges: !0,
			_a: !0
		});
		return fd(e, o);
	}(await sf(e), e.asyncQueue, t, n, r))), r.promise;
}
function lf(e, t, n = {}) {
	let r = new _a();
	return e.asyncQueue.enqueueAndForget((async () => function(e, t, n, r, i) {
		let a = new $d({
			next: (n) => {
				a.Za(), t.enqueueAndForget((() => pd(e, o))), n.fromCache && r.source === "server" ? i.reject(new R(L.UNAVAILABLE, "Failed to get documents from server. (However, these documents may exist in the local cache. Run again without setting source to \"server\" to retrieve the cached documents.)")) : i.resolve(n);
			},
			error: (e) => i.reject(e)
		}), o = new yd(n, a, {
			includeMetadataChanges: !0,
			_a: !0
		});
		return fd(e, o);
	}(await sf(e), e.asyncQueue, t, n, r))), r.promise;
}
function uf(e) {
	let t = {};
	return e.timeoutSeconds !== void 0 && (t.timeoutSeconds = e.timeoutSeconds), t;
}
var df = /* @__PURE__ */ new Map();
function ff(e, t, n) {
	if (!n) throw new R(L.INVALID_ARGUMENT, `Function ${e}() cannot be called with an empty ${t}.`);
}
function pf(e, t, n, r) {
	if (!0 === t && !0 === r) throw new R(L.INVALID_ARGUMENT, `${e} and ${n} cannot be used together.`);
}
function mf(e) {
	if (!H.isDocumentKey(e)) throw new R(L.INVALID_ARGUMENT, `Invalid document reference. Document references must have an even number of segments, but ${e} has ${e.length}.`);
}
function hf(e) {
	if (H.isDocumentKey(e)) throw new R(L.INVALID_ARGUMENT, `Invalid collection reference. Collection references must have an odd number of segments, but ${e} has ${e.length}.`);
}
function gf(e) {
	if (e === void 0) return "undefined";
	if (e === null) return "null";
	if (typeof e == "string") return e.length > 20 && (e = `${e.substring(0, 20)}...`), JSON.stringify(e);
	if (typeof e == "number" || typeof e == "boolean") return "" + e;
	if (typeof e == "object") {
		if (e instanceof Array) return "an array";
		{
			let t = function(e) {
				return e.constructor ? e.constructor.name : null;
			}(e);
			return t ? `a custom ${t} object` : "an object";
		}
	}
	return typeof e == "function" ? "a function" : P();
}
function _f(e, t) {
	if ("_delegate" in e && (e = e._delegate), !(e instanceof t)) {
		if (t.name === e.constructor.name) throw new R(L.INVALID_ARGUMENT, "Type does not match the expected instance. Did you pass a reference from a different Firestore SDK?");
		{
			let n = gf(e);
			throw new R(L.INVALID_ARGUMENT, `Expected type '${t.name}', but it was: ${n}`);
		}
	}
	return e;
}
var vf = class {
	constructor(e) {
		var t;
		if (e.host === void 0) {
			if (e.ssl !== void 0) throw new R(L.INVALID_ARGUMENT, "Can't provide ssl option if host option is not set");
			this.host = "firestore.googleapis.com", this.ssl = !0;
		} else this.host = e.host, this.ssl = (t = e.ssl) == null || t;
		if (this.credentials = e.credentials, this.ignoreUndefinedProperties = !!e.ignoreUndefinedProperties, this.localCache = e.localCache, e.cacheSizeBytes === void 0) this.cacheSizeBytes = 41943040;
		else {
			if (e.cacheSizeBytes !== -1 && e.cacheSizeBytes < 1048576) throw new R(L.INVALID_ARGUMENT, "cacheSizeBytes must be at least 1048576");
			this.cacheSizeBytes = e.cacheSizeBytes;
		}
		pf("experimentalForceLongPolling", e.experimentalForceLongPolling, "experimentalAutoDetectLongPolling", e.experimentalAutoDetectLongPolling), this.experimentalForceLongPolling = !!e.experimentalForceLongPolling, this.experimentalForceLongPolling ? this.experimentalAutoDetectLongPolling = !1 : e.experimentalAutoDetectLongPolling === void 0 ? this.experimentalAutoDetectLongPolling = !0 : this.experimentalAutoDetectLongPolling = !!e.experimentalAutoDetectLongPolling, this.experimentalLongPollingOptions = uf(e.experimentalLongPollingOptions ?? {}), function(e) {
			if (e.timeoutSeconds !== void 0) {
				if (isNaN(e.timeoutSeconds)) throw new R(L.INVALID_ARGUMENT, `invalid long polling timeout: ${e.timeoutSeconds} (must not be NaN)`);
				if (e.timeoutSeconds < 5) throw new R(L.INVALID_ARGUMENT, `invalid long polling timeout: ${e.timeoutSeconds} (minimum allowed value is 5)`);
				if (e.timeoutSeconds > 30) throw new R(L.INVALID_ARGUMENT, `invalid long polling timeout: ${e.timeoutSeconds} (maximum allowed value is 30)`);
			}
		}(this.experimentalLongPollingOptions), this.useFetchStreams = !!e.useFetchStreams;
	}
	isEqual(e) {
		return this.host === e.host && this.ssl === e.ssl && this.credentials === e.credentials && this.cacheSizeBytes === e.cacheSizeBytes && this.experimentalForceLongPolling === e.experimentalForceLongPolling && this.experimentalAutoDetectLongPolling === e.experimentalAutoDetectLongPolling && function(e, t) {
			return e.timeoutSeconds === t.timeoutSeconds;
		}(this.experimentalLongPollingOptions, e.experimentalLongPollingOptions) && this.ignoreUndefinedProperties === e.ignoreUndefinedProperties && this.useFetchStreams === e.useFetchStreams;
	}
}, yf = class {
	constructor(e, t, n, r) {
		this._authCredentials = e, this._appCheckCredentials = t, this._databaseId = n, this._app = r, this.type = "firestore-lite", this._persistenceKey = "(lite)", this._settings = new vf({}), this._settingsFrozen = !1, this._terminateTask = "notTerminated";
	}
	get app() {
		if (!this._app) throw new R(L.FAILED_PRECONDITION, "Firestore was not initialized using the Firebase SDK. 'app' is not available");
		return this._app;
	}
	get _initialized() {
		return this._settingsFrozen;
	}
	get _terminated() {
		return this._terminateTask !== "notTerminated";
	}
	_setSettings(e) {
		if (this._settingsFrozen) throw new R(L.FAILED_PRECONDITION, "Firestore has already been started and its settings can no longer be changed. You can only modify settings before calling any other methods on a Firestore object.");
		this._settings = new vf(e), e.credentials !== void 0 && (this._authCredentials = function(e) {
			if (!e) return new ya();
			switch (e.type) {
				case "firstParty": return new Ca(e.sessionIndex || "0", e.iamToken || null, e.authTokenFactory || null);
				case "provider": return e.client;
				default: throw new R(L.INVALID_ARGUMENT, "makeAuthCredentialsProvider failed due to invalid credential type");
			}
		}(e.credentials));
	}
	_getSettings() {
		return this._settings;
	}
	_freezeSettings() {
		return this._settingsFrozen = !0, this._settings;
	}
	_delete() {
		return this._terminateTask === "notTerminated" && (this._terminateTask = this._terminate()), this._terminateTask;
	}
	async _restart() {
		this._terminateTask === "notTerminated" ? await this._terminate() : this._terminateTask = "notTerminated";
	}
	toJSON() {
		return {
			app: this._app,
			databaseId: this._databaseId,
			settings: this._settings
		};
	}
	_terminate() {
		return function(e) {
			let t = df.get(e);
			t && (N("ComponentProvider", "Removing Datastore"), df.delete(e), t.terminate());
		}(this), Promise.resolve();
	}
};
function bf(e, t, n, r = {}) {
	let i = (e = _f(e, yf))._getSettings(), a = `${t}:${n}`;
	if (i.host !== "firestore.googleapis.com" && i.host !== a && ha("Host has been set in both settings() and connectFirestoreEmulator(), emulator host will be used."), e._setSettings(Object.assign(Object.assign({}, i), {
		host: a,
		ssl: !1
	})), r.mockUserToken) {
		let t, n;
		if (typeof r.mockUserToken == "string") t = r.mockUserToken, n = ua.MOCK_USER;
		else {
			t = Pn(r.mockUserToken, e._app?.options.projectId);
			let i = r.mockUserToken.sub || r.mockUserToken.user_id;
			if (!i) throw new R(L.INVALID_ARGUMENT, "mockUserToken must contain 'sub' or 'user_id' field!");
			n = new ua(i);
		}
		e._authCredentials = new ba(new va(t, n));
	}
}
var xf = class e {
	constructor(e, t, n) {
		this.converter = t, this._query = n, this.type = "query", this.firestore = e;
	}
	withConverter(t) {
		return new e(this.firestore, t, this._query);
	}
}, Sf = class e {
	constructor(e, t, n) {
		this.converter = t, this._key = n, this.type = "document", this.firestore = e;
	}
	get _path() {
		return this._key.path;
	}
	get id() {
		return this._key.path.lastSegment();
	}
	get path() {
		return this._key.path.canonicalString();
	}
	get parent() {
		return new Cf(this.firestore, this.converter, this._key.path.popLast());
	}
	withConverter(t) {
		return new e(this.firestore, t, this._key);
	}
}, Cf = class e extends xf {
	constructor(e, t, n) {
		super(e, t, ds(n)), this._path = n, this.type = "collection";
	}
	get id() {
		return this._query.path.lastSegment();
	}
	get path() {
		return this._query.path.canonicalString();
	}
	get parent() {
		let e = this._path.popLast();
		return e.isEmpty() ? null : new Sf(this.firestore, null, new H(e));
	}
	withConverter(t) {
		return new e(this.firestore, t, this._path);
	}
};
function wf(e, t, ...n) {
	if (e = j(e), ff("collection", "path", t), e instanceof yf) {
		let r = V.fromString(t, ...n);
		return hf(r), new Cf(e, null, r);
	}
	{
		if (!(e instanceof Sf || e instanceof Cf)) throw new R(L.INVALID_ARGUMENT, "Expected first argument to collection() to be a CollectionReference, a DocumentReference or FirebaseFirestore");
		let r = e._path.child(V.fromString(t, ...n));
		return hf(r), new Cf(e.firestore, null, r);
	}
}
function Tf(e, t, ...n) {
	if (e = j(e), arguments.length === 1 && (t = Da.newId()), ff("doc", "path", t), e instanceof yf) {
		let r = V.fromString(t, ...n);
		return mf(r), new Sf(e, null, new H(r));
	}
	{
		if (!(e instanceof Sf || e instanceof Cf)) throw new R(L.INVALID_ARGUMENT, "Expected first argument to collection() to be a CollectionReference, a DocumentReference or FirebaseFirestore");
		let r = e._path.child(V.fromString(t, ...n));
		return mf(r), new Sf(e.firestore, e instanceof Cf ? e.converter : null, new H(r));
	}
}
var Ef = class {
	constructor(e = Promise.resolve()) {
		this.Pu = [], this.Iu = !1, this.Tu = [], this.Eu = null, this.du = !1, this.Au = !1, this.Ru = [], this.t_ = new Su(this, "async_queue_retry"), this.Vu = () => {
			let e = bu();
			e && N("AsyncQueue", "Visibility state changed to " + e.visibilityState), this.t_.jo();
		}, this.mu = e;
		let t = bu();
		t && typeof t.addEventListener == "function" && t.addEventListener("visibilitychange", this.Vu);
	}
	get isShuttingDown() {
		return this.Iu;
	}
	enqueueAndForget(e) {
		this.enqueue(e);
	}
	enqueueAndForgetEvenWhileRestricted(e) {
		this.fu(), this.gu(e);
	}
	enterRestrictedMode(e) {
		if (!this.Iu) {
			this.Iu = !0, this.Au = e || !1;
			let t = bu();
			t && typeof t.removeEventListener == "function" && t.removeEventListener("visibilitychange", this.Vu);
		}
	}
	enqueue(e) {
		if (this.fu(), this.Iu) return new Promise((() => {}));
		let t = new _a();
		return this.gu((() => this.Iu && this.Au ? Promise.resolve() : (e().then(t.resolve, t.reject), t.promise))).then((() => t.promise));
	}
	enqueueRetryable(e) {
		this.enqueueAndForget((() => (this.Pu.push(e), this.pu())));
	}
	async pu() {
		if (this.Pu.length !== 0) {
			try {
				await this.Pu[0](), this.Pu.shift(), this.t_.reset();
			} catch (e) {
				if (!Ha(e)) throw e;
				N("AsyncQueue", "Operation failed with retryable error: " + e);
			}
			this.Pu.length > 0 && this.t_.Go((() => this.pu()));
		}
	}
	gu(e) {
		let t = this.mu.then((() => (this.du = !0, e().catch(((e) => {
			throw this.Eu = e, this.du = !1, ma("INTERNAL UNHANDLED ERROR: ", function(e) {
				let t = e.message || "";
				return e.stack && (t = e.stack.includes(e.message) ? e.stack : e.message + "\n" + e.stack), t;
			}(e)), e;
		})).then(((e) => (this.du = !1, e))))));
		return this.mu = t, t;
	}
	enqueueAfterDelay(e, t, n) {
		this.fu(), this.Ru.indexOf(e) > -1 && (t = 0);
		let r = id.createAndSchedule(this, e, t, n, ((e) => this.yu(e)));
		return this.Tu.push(r), r;
	}
	fu() {
		this.Eu && P();
	}
	verifyOperationInProgress() {}
	async wu() {
		let e;
		do
			e = this.mu, await e;
		while (e !== this.mu);
	}
	Su(e) {
		for (let t of this.Tu) if (t.timerId === e) return !0;
		return !1;
	}
	bu(e) {
		return this.wu().then((() => {
			this.Tu.sort(((e, t) => e.targetTimeMs - t.targetTimeMs));
			for (let t of this.Tu) if (t.skipDelay(), e !== "all" && t.timerId === e) break;
			return this.wu();
		}));
	}
	Du(e) {
		this.Ru.push(e);
	}
	yu(e) {
		let t = this.Tu.indexOf(e);
		this.Tu.splice(t, 1);
	}
};
function Df(e) {
	return function(e, t) {
		if (typeof e != "object" || !e) return !1;
		let n = e;
		for (let e of t) if (e in n && typeof n[e] == "function") return !0;
		return !1;
	}(e, [
		"next",
		"error",
		"complete"
	]);
}
var Of = class extends yf {
	constructor(e, t, n, r) {
		super(e, t, n, r), this.type = "firestore", this._queue = new Ef(), this._persistenceKey = r?.name || "[DEFAULT]";
	}
	async _terminate() {
		if (this._firestoreClient) {
			let e = this._firestoreClient.terminate();
			this._queue = new Ef(e), this._firestoreClient = void 0, await e;
		}
	}
};
function kf(e, t, n) {
	n ||= "(default)";
	let r = Ti(e, "firestore");
	if (r.isInitialized(n)) {
		let e = r.getImmediate({ identifier: n });
		if (Xn(r.getOptions(n), t)) return e;
		throw new R(L.FAILED_PRECONDITION, "initializeFirestore() has already been called with different options. To avoid this error, call initializeFirestore() with the same options as when it was originally called, or call getFirestore() to return the already initialized instance.");
	}
	if (t.cacheSizeBytes !== void 0 && t.localCache !== void 0) throw new R(L.INVALID_ARGUMENT, "cache and cacheSizeBytes cannot be specified at the same time as cacheSizeBytes willbe deprecated. Instead, specify the cache size in the cache object");
	if (t.cacheSizeBytes !== void 0 && t.cacheSizeBytes !== -1 && t.cacheSizeBytes < 1048576) throw new R(L.INVALID_ARGUMENT, "cacheSizeBytes must be at least 1048576");
	return r.initialize({
		options: t,
		instanceIdentifier: n
	});
}
function Af(e, t) {
	let n = typeof e == "object" ? e : ji(), r = typeof e == "string" ? e : t || "(default)", i = Ti(n, "firestore").getImmediate({ identifier: r });
	if (!i._initialized) {
		let e = An("firestore");
		e && bf(i, ...e);
	}
	return i;
}
function jf(e) {
	if (e._terminated) throw new R(L.FAILED_PRECONDITION, "The client has already been terminated.");
	return e._firestoreClient || Mf(e), e._firestoreClient;
}
function Mf(e) {
	var t, n;
	let r = e._freezeSettings(), i = function(e, t, n, r) {
		return new po(e, t, n, r.host, r.ssl, r.experimentalForceLongPolling, r.experimentalAutoDetectLongPolling, uf(r.experimentalLongPollingOptions), r.useFetchStreams);
	}(e._databaseId, e._app?.options.appId || "", e._persistenceKey, r);
	e._componentsProvider || (t = r.localCache) != null && t._offlineComponentProvider && (n = r.localCache) != null && n._onlineComponentProvider && (e._componentsProvider = {
		_offline: r.localCache._offlineComponentProvider,
		_online: r.localCache._onlineComponentProvider
	}), e._firestoreClient = new ef(e._authCredentials, e._appCheckCredentials, e._queue, i, e._componentsProvider && function(e) {
		let t = e?._online.build();
		return {
			_offline: e?._offline.build(t),
			_online: t
		};
	}(e._componentsProvider));
}
var Nf = class e {
	constructor(e) {
		this._byteString = e;
	}
	static fromBase64String(t) {
		try {
			return new e(ao.fromBase64String(t));
		} catch (e) {
			throw new R(L.INVALID_ARGUMENT, "Failed to construct data from Base64 string: " + e);
		}
	}
	static fromUint8Array(t) {
		return new e(ao.fromUint8Array(t));
	}
	toBase64() {
		return this._byteString.toBase64();
	}
	toUint8Array() {
		return this._byteString.toUint8Array();
	}
	toString() {
		return "Bytes(base64: " + this.toBase64() + ")";
	}
	isEqual(e) {
		return this._byteString.isEqual(e._byteString);
	}
}, Pf = class {
	constructor(...e) {
		for (let t = 0; t < e.length; ++t) if (e[t].length === 0) throw new R(L.INVALID_ARGUMENT, "Invalid field name at argument $(i + 1). Field names must not be empty.");
		this._internalPath = new Ma(e);
	}
	isEqual(e) {
		return this._internalPath.isEqual(e._internalPath);
	}
}, Ff = class {
	constructor(e) {
		this._methodName = e;
	}
}, If = class {
	constructor(e, t) {
		if (!isFinite(e) || e < -90 || e > 90) throw new R(L.INVALID_ARGUMENT, "Latitude must be a number between -90 and 90, but was: " + e);
		if (!isFinite(t) || t < -180 || t > 180) throw new R(L.INVALID_ARGUMENT, "Longitude must be a number between -180 and 180, but was: " + t);
		this._lat = e, this._long = t;
	}
	get latitude() {
		return this._lat;
	}
	get longitude() {
		return this._long;
	}
	isEqual(e) {
		return this._lat === e._lat && this._long === e._long;
	}
	toJSON() {
		return {
			latitude: this._lat,
			longitude: this._long
		};
	}
	_compareTo(e) {
		return z(this._lat, e._lat) || z(this._long, e._long);
	}
}, Lf = class {
	constructor(e) {
		this._values = (e || []).map(((e) => e));
	}
	toArray() {
		return this._values.map(((e) => e));
	}
	isEqual(e) {
		return function(e, t) {
			if (e.length !== t.length) return !1;
			for (let n = 0; n < e.length; ++n) if (e[n] !== t[n]) return !1;
			return !0;
		}(this._values, e._values);
	}
}, Rf = /^__.*__$/, zf = class {
	constructor(e, t, n) {
		this.data = e, this.fieldMask = t, this.fieldTransforms = n;
	}
	toMutation(e, t) {
		return this.fieldMask === null ? new uc(e, this.data, t, this.fieldTransforms) : new dc(e, this.data, this.fieldMask, t, this.fieldTransforms);
	}
}, Bf = class {
	constructor(e, t, n) {
		this.data = e, this.fieldMask = t, this.fieldTransforms = n;
	}
	toMutation(e, t) {
		return new dc(e, this.data, this.fieldMask, t, this.fieldTransforms);
	}
};
function Vf(e) {
	switch (e) {
		case 0:
		case 2:
		case 1: return !0;
		case 3:
		case 4: return !1;
		default: throw P();
	}
}
var Hf = class e {
	constructor(e, t, n, r, i, a) {
		this.settings = e, this.databaseId = t, this.serializer = n, this.ignoreUndefinedProperties = r, i === void 0 && this.vu(), this.fieldTransforms = i || [], this.fieldMask = a || [];
	}
	get path() {
		return this.settings.path;
	}
	get Cu() {
		return this.settings.Cu;
	}
	Fu(t) {
		return new e(Object.assign(Object.assign({}, this.settings), t), this.databaseId, this.serializer, this.ignoreUndefinedProperties, this.fieldTransforms, this.fieldMask);
	}
	Mu(e) {
		let t = this.path?.child(e), n = this.Fu({
			path: t,
			xu: !1
		});
		return n.Ou(e), n;
	}
	Nu(e) {
		let t = this.path?.child(e), n = this.Fu({
			path: t,
			xu: !1
		});
		return n.vu(), n;
	}
	Lu(e) {
		return this.Fu({
			path: void 0,
			xu: !0
		});
	}
	Bu(e) {
		return rp(e, this.settings.methodName, this.settings.ku || !1, this.path, this.settings.qu);
	}
	contains(e) {
		return this.fieldMask.find(((t) => e.isPrefixOf(t))) !== void 0 || this.fieldTransforms.find(((t) => e.isPrefixOf(t.field))) !== void 0;
	}
	vu() {
		if (this.path) for (let e = 0; e < this.path.length; e++) this.Ou(this.path.get(e));
	}
	Ou(e) {
		if (e.length === 0) throw this.Bu("Document fields must not be empty");
		if (Vf(this.Cu) && Rf.test(e)) throw this.Bu("Document fields cannot begin and end with \"__\"");
	}
}, Uf = class {
	constructor(e, t, n) {
		this.databaseId = e, this.ignoreUndefinedProperties = t, this.serializer = n || xu(e);
	}
	Qu(e, t, n, r = !1) {
		return new Hf({
			Cu: e,
			methodName: t,
			qu: n,
			path: Ma.emptyPath(),
			xu: !1,
			ku: r
		}, this.databaseId, this.serializer, this.ignoreUndefinedProperties);
	}
};
function Wf(e) {
	let t = e._freezeSettings(), n = xu(e._databaseId);
	return new Uf(e._databaseId, !!t.ignoreUndefinedProperties, n);
}
function Gf(e, t, n, r, i, a = {}) {
	let o = e.Qu(a.merge || a.mergeFields ? 2 : 0, t, n, i);
	$f("Data must be an object, but it was:", o, r);
	let s = Zf(r, o), c, l;
	if (a.merge) c = new ro(o.fieldMask), l = o.fieldTransforms;
	else if (a.mergeFields) {
		let e = [];
		for (let r of a.mergeFields) {
			let i = ep(t, r, n);
			if (!o.contains(i)) throw new R(L.INVALID_ARGUMENT, `Field '${i}' is specified in your field mask but missing from your input data.`);
			ip(e, i) || e.push(i);
		}
		c = new ro(e), l = o.fieldTransforms.filter(((e) => c.covers(e.field)));
	} else c = null, l = o.fieldTransforms;
	return new zf(new Po(s), c, l);
}
var Kf = class e extends Ff {
	_toFieldTransform(e) {
		if (e.Cu !== 2) throw e.Cu === 1 ? e.Bu(`${this._methodName}() can only appear at the top level of your update data`) : e.Bu(`${this._methodName}() cannot be used with set() unless you pass {merge:true}`);
		return e.fieldMask.push(e.path), null;
	}
	isEqual(t) {
		return t instanceof e;
	}
};
function qf(e, t, n, r) {
	let i = e.Qu(1, t, n);
	$f("Data must be an object, but it was:", i, r);
	let a = [], o = Po.empty();
	return Za(r, ((e, r) => {
		let s = np(t, e, n);
		r = j(r);
		let c = i.Nu(s);
		if (r instanceof Kf) a.push(s);
		else {
			let e = Xf(r, c);
			e != null && (a.push(s), o.set(s, e));
		}
	})), new Bf(o, new ro(a), i.fieldTransforms);
}
function Jf(e, t, n, r, i, a) {
	let o = e.Qu(1, t, n), s = [ep(t, r, n)], c = [i];
	if (a.length % 2 != 0) throw new R(L.INVALID_ARGUMENT, `Function ${t}() needs to be called with an even number of arguments that alternate between field names and values.`);
	for (let e = 0; e < a.length; e += 2) s.push(ep(t, a[e])), c.push(a[e + 1]);
	let l = [], u = Po.empty();
	for (let e = s.length - 1; e >= 0; --e) if (!ip(l, s[e])) {
		let t = s[e], n = c[e];
		n = j(n);
		let r = o.Nu(t);
		if (n instanceof Kf) l.push(t);
		else {
			let e = Xf(n, r);
			e != null && (l.push(t), u.set(t, e));
		}
	}
	return new Bf(u, new ro(l), o.fieldTransforms);
}
function Yf(e, t, n, r = !1) {
	return Xf(n, e.Qu(r ? 4 : 3, t));
}
function Xf(e, t) {
	if (Qf(e = j(e))) return $f("Unsupported field value:", t, e), Zf(e, t);
	if (e instanceof Ff) return function(e, t) {
		if (!Vf(t.Cu)) throw t.Bu(`${e._methodName}() can only be used with update() and set()`);
		if (!t.path) throw t.Bu(`${e._methodName}() is not currently supported inside arrays`);
		let n = e._toFieldTransform(t);
		n && t.fieldTransforms.push(n);
	}(e, t), null;
	if (e === void 0 && t.ignoreUndefinedProperties) return null;
	if (t.path && t.fieldMask.push(t.path), e instanceof Array) {
		if (t.settings.xu && t.Cu !== 4) throw t.Bu("Nested arrays are not supported");
		return function(e, t) {
			let n = [], r = 0;
			for (let i of e) {
				let e = Xf(i, t.Lu(r));
				e ??= { nullValue: "NULL_VALUE" }, n.push(e), r++;
			}
			return { arrayValue: { values: n } };
		}(e, t);
	}
	return function(e, t) {
		if ((e = j(e)) === null) return { nullValue: "NULL_VALUE" };
		if (typeof e == "number") return Vs(t.serializer, e);
		if (typeof e == "boolean") return { booleanValue: e };
		if (typeof e == "string") return { stringValue: e };
		if (e instanceof Date) {
			let n = ka.fromDate(e);
			return { timestampValue: Wc(t.serializer, n) };
		}
		if (e instanceof ka) {
			let n = new ka(e.seconds, 1e3 * Math.floor(e.nanoseconds / 1e3));
			return { timestampValue: Wc(t.serializer, n) };
		}
		if (e instanceof If) return { geoPointValue: {
			latitude: e.latitude,
			longitude: e.longitude
		} };
		if (e instanceof Nf) return { bytesValue: Gc(t.serializer, e._byteString) };
		if (e instanceof Sf) {
			let n = t.databaseId, r = e.firestore._databaseId;
			if (!r.isEqual(n)) throw t.Bu(`Document reference is for database ${r.projectId}/${r.database} but should be for database ${n.projectId}/${n.database}`);
			return { referenceValue: Jc(e.firestore._databaseId || t.databaseId, e._key.path) };
		}
		if (e instanceof Lf) return function(e, t) {
			return { mapValue: { fields: {
				__type__: { stringValue: "__vector__" },
				value: { arrayValue: { values: e.toArray().map(((e) => {
					if (typeof e != "number") throw t.Bu("VectorValues must only contain numeric values.");
					return zs(t.serializer, e);
				})) } }
			} } };
		}(e, t);
		throw t.Bu(`Unsupported field value: ${gf(e)}`);
	}(e, t);
}
function Zf(e, t) {
	let n = {};
	return Qa(e) ? t.path && t.path.length > 0 && t.fieldMask.push(t.path) : Za(e, ((e, r) => {
		let i = Xf(r, t.Mu(e));
		i != null && (n[e] = i);
	})), { mapValue: { fields: n } };
}
function Qf(e) {
	return !(typeof e != "object" || !e || e instanceof Array || e instanceof Date || e instanceof ka || e instanceof If || e instanceof Nf || e instanceof Sf || e instanceof Ff || e instanceof Lf);
}
function $f(e, t, n) {
	if (!Qf(n) || !function(e) {
		return typeof e == "object" && !!e && (Object.getPrototypeOf(e) === Object.prototype || Object.getPrototypeOf(e) === null);
	}(n)) {
		let r = gf(n);
		throw r === "an object" ? t.Bu(e + " a custom object") : t.Bu(e + " " + r);
	}
}
function ep(e, t, n) {
	if ((t = j(t)) instanceof Pf) return t._internalPath;
	if (typeof t == "string") return np(e, t);
	throw rp("Field path arguments must be of type string or ", e, !1, void 0, n);
}
var tp = /* @__PURE__ */ RegExp("[~\\*/\\[\\]]");
function np(e, t, n) {
	if (t.search(tp) >= 0) throw rp(`Invalid field path (${t}). Paths must not contain '~', '*', '/', '[', or ']'`, e, !1, void 0, n);
	try {
		return new Pf(...t.split("."))._internalPath;
	} catch {
		throw rp(`Invalid field path (${t}). Paths must not be empty, begin with '.', end with '.', or contain '..'`, e, !1, void 0, n);
	}
}
function rp(e, t, n, r, i) {
	let a = r && !r.isEmpty(), o = i !== void 0, s = `Function ${t}() called with invalid data`;
	n && (s += " (via `toFirestore()`)"), s += ". ";
	let c = "";
	return (a || o) && (c += " (found", a && (c += ` in field ${r}`), o && (c += ` in document ${i}`), c += ")"), new R(L.INVALID_ARGUMENT, s + e + c);
}
function ip(e, t) {
	return e.some(((e) => e.isEqual(t)));
}
var ap = class {
	constructor(e, t, n, r, i) {
		this._firestore = e, this._userDataWriter = t, this._key = n, this._document = r, this._converter = i;
	}
	get id() {
		return this._key.path.lastSegment();
	}
	get ref() {
		return new Sf(this._firestore, this._converter, this._key);
	}
	exists() {
		return this._document !== null;
	}
	data() {
		if (this._document) {
			if (this._converter) {
				let e = new op(this._firestore, this._userDataWriter, this._key, this._document, null);
				return this._converter.fromFirestore(e);
			}
			return this._userDataWriter.convertValue(this._document.data.value);
		}
	}
	get(e) {
		if (this._document) {
			let t = this._document.data.field(sp("DocumentSnapshot.get", e));
			if (t !== null) return this._userDataWriter.convertValue(t);
		}
	}
}, op = class extends ap {
	data() {
		return super.data();
	}
};
function sp(e, t) {
	return typeof t == "string" ? np(e, t) : t instanceof Pf ? t._internalPath : t._delegate._internalPath;
}
function cp(e) {
	if (e.limitType === "L" && e.explicitOrderBy.length === 0) throw new R(L.UNIMPLEMENTED, "limitToLast() queries require specifying at least one orderBy() clause");
}
var lp = class {}, up = class extends lp {};
function dp(e, t, ...n) {
	let r = [];
	t instanceof lp && r.push(t), r = r.concat(n), function(e) {
		let t = e.filter(((e) => e instanceof mp)).length, n = e.filter(((e) => e instanceof fp)).length;
		if (t > 1 || t > 0 && n > 0) throw new R(L.INVALID_ARGUMENT, "InvalidQuery. When using composite filters, you cannot use more than one filter at the top level. Consider nesting the multiple filters within an `and(...)` statement. For example: change `query(query, where(...), or(...))` to `query(query, and(where(...), or(...)))`.");
	}(r);
	for (let t of r) e = t._apply(e);
	return e;
}
var fp = class e extends up {
	constructor(e, t, n) {
		super(), this._field = e, this._op = t, this._value = n, this.type = "where";
	}
	static _create(t, n, r) {
		return new e(t, n, r);
	}
	_apply(e) {
		let t = this._parse(e);
		return _p(e._query, t), new xf(e.firestore, e.converter, _s(e._query, t));
	}
	_parse(e) {
		let t = Wf(e.firestore);
		return function(e, t, n, r, i, a, o) {
			let s;
			if (i.isKeyField()) {
				if (a === "array-contains" || a === "array-contains-any") throw new R(L.INVALID_ARGUMENT, `Invalid Query. You can't perform '${a}' queries on documentId().`);
				if (a === "in" || a === "not-in") {
					gp(o, a);
					let t = [];
					for (let n of o) t.push(hp(r, e, n));
					s = { arrayValue: { values: t } };
				} else s = hp(r, e, o);
			} else a !== "in" && a !== "not-in" && a !== "array-contains-any" || gp(o, a), s = Yf(n, t, o, a === "in" || a === "not-in");
			return K.create(i, a, s);
		}(e._query, "where", t, e.firestore._databaseId, this._field, this._op, this._value);
	}
};
function pp(e, t, n) {
	let r = t, i = sp("where", e);
	return fp._create(i, r, n);
}
var mp = class e extends lp {
	constructor(e, t) {
		super(), this.type = e, this._queryConstraints = t;
	}
	static _create(t, n) {
		return new e(t, n);
	}
	_parse(e) {
		let t = this._queryConstraints.map(((t) => t._parse(e))).filter(((e) => e.getFilters().length > 0));
		return t.length === 1 ? t[0] : Uo.create(t, this._getOperator());
	}
	_apply(e) {
		let t = this._parse(e);
		return t.getFilters().length === 0 ? e : (function(e, t) {
			let n = e, r = t.getFlattenedFilters();
			for (let e of r) _p(n, e), n = _s(n, e);
		}(e._query, t), new xf(e.firestore, e.converter, _s(e._query, t)));
	}
	_getQueryConstraints() {
		return this._queryConstraints;
	}
	_getOperator() {
		return this.type === "and" ? "and" : "or";
	}
};
function hp(e, t, n) {
	if (typeof (n = j(n)) == "string") {
		if (n === "") throw new R(L.INVALID_ARGUMENT, "Invalid query. When querying with documentId(), you must provide a valid document ID, but it was an empty string.");
		if (!ps(t) && n.indexOf("/") !== -1) throw new R(L.INVALID_ARGUMENT, `Invalid query. When querying a collection by documentId(), you must provide a plain document ID, but '${n}' contains a '/' character.`);
		let r = t.path.child(V.fromString(n));
		if (!H.isDocumentKey(r)) throw new R(L.INVALID_ARGUMENT, `Invalid query. When querying a collection group by documentId(), the value provided must result in a valid document path, but '${r}' is not because it has an odd number of segments (${r.length}).`);
		return To(e, new H(r));
	}
	if (n instanceof Sf) return To(e, n._key);
	throw new R(L.INVALID_ARGUMENT, `Invalid query. When querying with documentId(), you must provide a valid string or a DocumentReference, but it was: ${gf(n)}.`);
}
function gp(e, t) {
	if (!Array.isArray(e) || e.length === 0) throw new R(L.INVALID_ARGUMENT, `Invalid Query. A non-empty array is required for '${t.toString()}' filters.`);
}
function _p(e, t) {
	let n = function(e, t) {
		for (let n of e) for (let e of n.getFlattenedFilters()) if (t.indexOf(e.op) >= 0) return e.op;
		return null;
	}(e.filters, function(e) {
		switch (e) {
			case "!=": return ["!=", "not-in"];
			case "array-contains-any":
			case "in": return ["not-in"];
			case "not-in": return [
				"array-contains-any",
				"in",
				"not-in",
				"!="
			];
			default: return [];
		}
	}(t.op));
	if (n !== null) throw n === t.op ? new R(L.INVALID_ARGUMENT, `Invalid query. You cannot use more than one '${t.op.toString()}' filter.`) : new R(L.INVALID_ARGUMENT, `Invalid query. You cannot use '${t.op.toString()}' filters with '${n.toString()}' filters.`);
}
var vp = class {
	convertValue(e, t = "none") {
		switch (go(e)) {
			case 0: return null;
			case 1: return e.booleanValue;
			case 2: return G(e.integerValue || e.doubleValue);
			case 3: return this.convertTimestamp(e.timestampValue);
			case 4: return this.convertServerTimestamp(e, t);
			case 5: return e.stringValue;
			case 6: return this.convertBytes(co(e.bytesValue));
			case 7: return this.convertReference(e.referenceValue);
			case 8: return this.convertGeoPoint(e.geoPointValue);
			case 9: return this.convertArray(e.arrayValue, t);
			case 11: return this.convertObject(e.mapValue, t);
			case 10: return this.convertVectorValue(e.mapValue);
			default: throw P();
		}
	}
	convertObject(e, t) {
		return this.convertObjectMap(e.fields, t);
	}
	convertObjectMap(e, t = "none") {
		let n = {};
		return Za(e, ((e, r) => {
			n[e] = this.convertValue(r, t);
		})), n;
	}
	convertVectorValue(e) {
		return new Lf((e.fields?.value.arrayValue?.values)?.map(((e) => G(e.doubleValue))));
	}
	convertGeoPoint(e) {
		return new If(G(e.latitude), G(e.longitude));
	}
	convertArray(e, t) {
		return (e.values || []).map(((e) => this.convertValue(e, t)));
	}
	convertServerTimestamp(e, t) {
		switch (t) {
			case "previous":
				let n = uo(e);
				return n == null ? null : this.convertValue(n, t);
			case "estimate": return this.convertTimestamp(fo(e));
			default: return null;
		}
	}
	convertTimestamp(e) {
		let t = so(e);
		return new ka(t.seconds, t.nanos);
	}
	convertDocumentKey(e, t) {
		let n = V.fromString(e);
		F(yl(n));
		let r = new mo(n.get(1), n.get(3)), i = new H(n.popFirst(5));
		return r.isEqual(t) || ma(`Document ${i} contains a document reference within a different database (${r.projectId}/${r.database}) which is not supported. It will be treated as a reference in the current database (${t.projectId}/${t.database}) instead.`), i;
	}
};
function yp(e, t, n) {
	let r;
	return r = e ? n && (n.merge || n.mergeFields) ? e.toFirestore(t, n) : e.toFirestore(t) : t, r;
}
var bp = class {
	constructor(e, t) {
		this.hasPendingWrites = e, this.fromCache = t;
	}
	isEqual(e) {
		return this.hasPendingWrites === e.hasPendingWrites && this.fromCache === e.fromCache;
	}
}, xp = class extends ap {
	constructor(e, t, n, r, i, a) {
		super(e, t, n, r, a), this._firestore = e, this._firestoreImpl = e, this.metadata = i;
	}
	exists() {
		return super.exists();
	}
	data(e = {}) {
		if (this._document) {
			if (this._converter) {
				let t = new Sp(this._firestore, this._userDataWriter, this._key, this._document, this.metadata, null);
				return this._converter.fromFirestore(t, e);
			}
			return this._userDataWriter.convertValue(this._document.data.value, e.serverTimestamps);
		}
	}
	get(e, t = {}) {
		if (this._document) {
			let n = this._document.data.field(sp("DocumentSnapshot.get", e));
			if (n !== null) return this._userDataWriter.convertValue(n, t.serverTimestamps);
		}
	}
}, Sp = class extends xp {
	data(e = {}) {
		return super.data(e);
	}
}, Cp = class {
	constructor(e, t, n, r) {
		this._firestore = e, this._userDataWriter = t, this._snapshot = r, this.metadata = new bp(r.hasPendingWrites, r.fromCache), this.query = n;
	}
	get docs() {
		let e = [];
		return this.forEach(((t) => e.push(t))), e;
	}
	get size() {
		return this._snapshot.docs.size;
	}
	get empty() {
		return this.size === 0;
	}
	forEach(e, t) {
		this._snapshot.docs.forEach(((n) => {
			e.call(t, new Sp(this._firestore, this._userDataWriter, n.key, n, new bp(this._snapshot.mutatedKeys.has(n.key), this._snapshot.fromCache), this.query.converter));
		}));
	}
	docChanges(e = {}) {
		let t = !!e.includeMetadataChanges;
		if (t && this._snapshot.excludesMetadataChanges) throw new R(L.INVALID_ARGUMENT, "To include metadata changes with your document changes, you must also pass { includeMetadataChanges:true } to onSnapshot().");
		return this._cachedChanges && this._cachedChangesIncludeMetadataChanges === t || (this._cachedChanges = function(e, t) {
			if (e._snapshot.oldDocs.isEmpty()) {
				let t = 0;
				return e._snapshot.docChanges.map(((n) => {
					let r = new Sp(e._firestore, e._userDataWriter, n.doc.key, n.doc, new bp(e._snapshot.mutatedKeys.has(n.doc.key), e._snapshot.fromCache), e.query.converter);
					return n.doc, {
						type: "added",
						doc: r,
						oldIndex: -1,
						newIndex: t++
					};
				}));
			}
			{
				let n = e._snapshot.oldDocs;
				return e._snapshot.docChanges.filter(((e) => t || e.type !== 3)).map(((t) => {
					let r = new Sp(e._firestore, e._userDataWriter, t.doc.key, t.doc, new bp(e._snapshot.mutatedKeys.has(t.doc.key), e._snapshot.fromCache), e.query.converter), i = -1, a = -1;
					return t.type !== 0 && (i = n.indexOf(t.doc.key), n = n.delete(t.doc.key)), t.type !== 1 && (n = n.add(t.doc), a = n.indexOf(t.doc.key)), {
						type: wp(t.type),
						doc: r,
						oldIndex: i,
						newIndex: a
					};
				}));
			}
		}(this, t), this._cachedChangesIncludeMetadataChanges = t), this._cachedChanges;
	}
};
function wp(e) {
	switch (e) {
		case 0: return "added";
		case 2:
		case 3: return "modified";
		case 1: return "removed";
		default: return P();
	}
}
function Tp(e) {
	e = _f(e, Sf);
	let t = _f(e.firestore, Of);
	return cf(jf(t), e._key).then(((n) => Np(t, e, n)));
}
var Ep = class extends vp {
	constructor(e) {
		super(), this.firestore = e;
	}
	convertBytes(e) {
		return new Nf(e);
	}
	convertReference(e) {
		let t = this.convertDocumentKey(e, this.firestore._databaseId);
		return new Sf(this.firestore, null, t);
	}
};
function Dp(e) {
	e = _f(e, xf);
	let t = _f(e.firestore, Of), n = jf(t), r = new Ep(t);
	return cp(e._query), lf(n, e._query).then(((n) => new Cp(t, r, e, n)));
}
function Op(e, t, n) {
	e = _f(e, Sf);
	let r = _f(e.firestore, Of), i = yp(e.converter, t, n);
	return Mp(r, [Gf(Wf(r), "setDoc", e._key, i, e.converter !== null, n).toMutation(e._key, nc.none())]);
}
function kp(e, t, n, ...r) {
	e = _f(e, Sf);
	let i = _f(e.firestore, Of), a = Wf(i), o;
	return o = typeof (t = j(t)) == "string" || t instanceof Pf ? Jf(a, "updateDoc", e._key, t, n, r) : qf(a, "updateDoc", e._key, t), Mp(i, [o.toMutation(e._key, nc.exists(!0))]);
}
function Ap(e) {
	return Mp(_f(e.firestore, Of), [new hc(e._key, nc.none())]);
}
function jp(e, ...t) {
	e = j(e);
	let n = {
		includeMetadataChanges: !1,
		source: "default"
	}, r = 0;
	typeof t[r] != "object" || Df(t[r]) || (n = t[r], r++);
	let i = {
		includeMetadataChanges: n.includeMetadataChanges,
		source: n.source
	};
	if (Df(t[r])) {
		let e = t[r];
		t[r] = e.next?.bind(e), t[r + 1] = e.error?.bind(e), t[r + 2] = e.complete?.bind(e);
	}
	let a, o, s;
	if (e instanceof Sf) o = _f(e.firestore, Of), s = ds(e._key.path), a = {
		next: (n) => {
			t[r] && t[r](Np(o, e, n));
		},
		error: t[r + 1],
		complete: t[r + 2]
	};
	else {
		let n = _f(e, xf);
		o = _f(n.firestore, Of), s = n._query;
		let i = new Ep(o);
		a = {
			next: (e) => {
				t[r] && t[r](new Cp(o, i, n, e));
			},
			error: t[r + 1],
			complete: t[r + 2]
		}, cp(e._query);
	}
	return function(e, t, n, r) {
		let i = new $d(r), a = new yd(t, i, n);
		return e.asyncQueue.enqueueAndForget((async () => fd(await sf(e), a))), () => {
			i.Za(), e.asyncQueue.enqueueAndForget((async () => pd(await sf(e), a)));
		};
	}(jf(o), s, i, a);
}
function Mp(e, t) {
	return function(e, t) {
		let n = new _a();
		return e.asyncQueue.enqueueAndForget((async () => Md(await of(e), t, n))), n.promise;
	}(jf(e), t);
}
function Np(e, t, n) {
	let r = n.docs.get(t._key);
	return new xp(e, new Ep(e), t._key, r, new bp(n.hasPendingWrites, n.fromCache), t.converter);
}
(function(e, t = !0) {
	(function(e) {
		da = e;
	})(ki), wi(new ar("firestore", ((e, { instanceIdentifier: n, options: r }) => {
		let i = e.getProvider("app").getImmediate(), a = new Of(new xa(e.getProvider("auth-internal")), new Ta(e.getProvider("app-check-internal")), function(e, t) {
			if (!Object.prototype.hasOwnProperty.apply(e.options, ["projectId"])) throw new R(L.INVALID_ARGUMENT, "\"projectId\" not provided in firebase.initializeApp.");
			return new mo(e.options.projectId, t);
		}(i, n), i);
		return r = Object.assign({ useFetchStreams: t }, r), a._setSettings(r), a;
	}), "PUBLIC").setMultipleInstances(!0)), Mi(la, "4.7.4", e), Mi(la, "4.7.4", "esm2017");
})();
//#endregion
//#region src/firestore/firestore.constant.ts
var Z = /* @__PURE__ */ function(e) {
	return e.Plans = "Plans", e.Audit = "Audit", e.CustomGeoboundaries = "CustomGeoboundaries", e.Clients = "Clients", e.Brands = "Brands", e.SharedPlans = "SharedPlans", e.Subscriptions = "Subscriptions", e.AdvanceOptionsExportColumns = "AdvanceOptions_ExportColumns", e;
}({}), Pp = /* @__PURE__ */ function(e) {
	return e.Plans = "Plans", e;
}({});
//#endregion
//#region ../node_modules/tslib/tslib.es6.js
function Fp(e, t) {
	var n = {};
	for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
	if (e != null && typeof Object.getOwnPropertySymbols == "function") for (var i = 0, r = Object.getOwnPropertySymbols(e); i < r.length; i++) t.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[i]) && (n[r[i]] = e[r[i]]);
	return n;
}
//#endregion
//#region ../node_modules/@firebase/auth/dist/esm2017/index-a7d5cfcc.js
function Ip() {
	return { "dependent-sdk-initialized-before-auth": "Another Firebase SDK was initialized and is trying to use Auth before Auth is initialized. Please be sure to call `initializeAuth` or `getAuth` before starting any other Firebase SDK." };
}
var Lp = Ip, Rp = new Kn("auth", "Firebase", Ip()), zp = new gr("@firebase/auth");
function Bp(e, ...t) {
	zp.logLevel <= M.WARN && zp.warn(`Auth (${ki}): ${e}`, ...t);
}
function Vp(e, ...t) {
	zp.logLevel <= M.ERROR && zp.error(`Auth (${ki}): ${e}`, ...t);
}
function Hp(e, ...t) {
	throw Kp(e, ...t);
}
function Up(e, ...t) {
	return Kp(e, ...t);
}
function Wp(e, t, n) {
	return new Kn("auth", "Firebase", Object.assign(Object.assign({}, Lp()), { [t]: n })).create(t, { appName: e.name });
}
function Gp(e) {
	return Wp(e, "operation-not-supported-in-this-environment", "Operations that alter the current user are not supported in conjunction with FirebaseServerApp");
}
function Kp(e, ...t) {
	if (typeof e != "string") {
		let n = t[0], r = [...t.slice(1)];
		return r[0] && (r[0].appName = e.name), e._errorFactory.create(n, ...r);
	}
	return Rp.create(e, ...t);
}
function Q(e, t, ...n) {
	if (!e) throw Kp(t, ...n);
}
function qp(e) {
	let t = "INTERNAL ASSERTION FAILED: " + e;
	throw Vp(t), Error(t);
}
function Jp(e, t) {
	e || qp(t);
}
function Yp() {
	return typeof self < "u" && self.location?.href || "";
}
function Xp() {
	return Zp() === "http:" || Zp() === "https:";
}
function Zp() {
	return typeof self < "u" && self.location?.protocol || null;
}
function Qp() {
	return typeof navigator < "u" && navigator && "onLine" in navigator && typeof navigator.onLine == "boolean" && (Xp() || Rn() || "connection" in navigator) ? navigator.onLine : !0;
}
function $p() {
	if (typeof navigator > "u") return null;
	let e = navigator;
	return e.languages && e.languages[0] || e.language || null;
}
var em = class {
	constructor(e, t) {
		this.shortDelay = e, this.longDelay = t, Jp(t > e, "Short delay should be less than long delay!"), this.isMobile = Fn() || zn();
	}
	get() {
		return Qp() ? this.isMobile ? this.longDelay : this.shortDelay : Math.min(5e3, this.shortDelay);
	}
};
function tm(e, t) {
	Jp(e.emulator, "Emulator should always be set here");
	let { url: n } = e.emulator;
	return t ? `${n}${t.startsWith("/") ? t.slice(1) : t}` : n;
}
var nm = class {
	static initialize(e, t, n) {
		this.fetchImpl = e, t && (this.headersImpl = t), n && (this.responseImpl = n);
	}
	static fetch() {
		if (this.fetchImpl) return this.fetchImpl;
		if (typeof self < "u" && "fetch" in self) return self.fetch;
		if (typeof globalThis < "u" && globalThis.fetch) return globalThis.fetch;
		if (typeof fetch < "u") return fetch;
		qp("Could not find fetch implementation, make sure you call FetchProvider.initialize() with an appropriate polyfill");
	}
	static headers() {
		if (this.headersImpl) return this.headersImpl;
		if (typeof self < "u" && "Headers" in self) return self.Headers;
		if (typeof globalThis < "u" && globalThis.Headers) return globalThis.Headers;
		if (typeof Headers < "u") return Headers;
		qp("Could not find Headers implementation, make sure you call FetchProvider.initialize() with an appropriate polyfill");
	}
	static response() {
		if (this.responseImpl) return this.responseImpl;
		if (typeof self < "u" && "Response" in self) return self.Response;
		if (typeof globalThis < "u" && globalThis.Response) return globalThis.Response;
		if (typeof Response < "u") return Response;
		qp("Could not find Response implementation, make sure you call FetchProvider.initialize() with an appropriate polyfill");
	}
}, rm = {
	CREDENTIAL_MISMATCH: "custom-token-mismatch",
	MISSING_CUSTOM_TOKEN: "internal-error",
	INVALID_IDENTIFIER: "invalid-email",
	MISSING_CONTINUE_URI: "internal-error",
	INVALID_PASSWORD: "wrong-password",
	MISSING_PASSWORD: "missing-password",
	INVALID_LOGIN_CREDENTIALS: "invalid-credential",
	EMAIL_EXISTS: "email-already-in-use",
	PASSWORD_LOGIN_DISABLED: "operation-not-allowed",
	INVALID_IDP_RESPONSE: "invalid-credential",
	INVALID_PENDING_TOKEN: "invalid-credential",
	FEDERATED_USER_ID_ALREADY_LINKED: "credential-already-in-use",
	MISSING_REQ_TYPE: "internal-error",
	EMAIL_NOT_FOUND: "user-not-found",
	RESET_PASSWORD_EXCEED_LIMIT: "too-many-requests",
	EXPIRED_OOB_CODE: "expired-action-code",
	INVALID_OOB_CODE: "invalid-action-code",
	MISSING_OOB_CODE: "internal-error",
	CREDENTIAL_TOO_OLD_LOGIN_AGAIN: "requires-recent-login",
	INVALID_ID_TOKEN: "invalid-user-token",
	TOKEN_EXPIRED: "user-token-expired",
	USER_NOT_FOUND: "user-token-expired",
	TOO_MANY_ATTEMPTS_TRY_LATER: "too-many-requests",
	PASSWORD_DOES_NOT_MEET_REQUIREMENTS: "password-does-not-meet-requirements",
	INVALID_CODE: "invalid-verification-code",
	INVALID_SESSION_INFO: "invalid-verification-id",
	INVALID_TEMPORARY_PROOF: "invalid-credential",
	MISSING_SESSION_INFO: "missing-verification-id",
	SESSION_EXPIRED: "code-expired",
	MISSING_ANDROID_PACKAGE_NAME: "missing-android-pkg-name",
	UNAUTHORIZED_DOMAIN: "unauthorized-continue-uri",
	INVALID_OAUTH_CLIENT_ID: "invalid-oauth-client-id",
	ADMIN_ONLY_OPERATION: "admin-restricted-operation",
	INVALID_MFA_PENDING_CREDENTIAL: "invalid-multi-factor-session",
	MFA_ENROLLMENT_NOT_FOUND: "multi-factor-info-not-found",
	MISSING_MFA_ENROLLMENT_ID: "missing-multi-factor-info",
	MISSING_MFA_PENDING_CREDENTIAL: "missing-multi-factor-session",
	SECOND_FACTOR_EXISTS: "second-factor-already-in-use",
	SECOND_FACTOR_LIMIT_EXCEEDED: "maximum-second-factor-count-exceeded",
	BLOCKING_FUNCTION_ERROR_RESPONSE: "internal-error",
	RECAPTCHA_NOT_ENABLED: "recaptcha-not-enabled",
	MISSING_RECAPTCHA_TOKEN: "missing-recaptcha-token",
	INVALID_RECAPTCHA_TOKEN: "invalid-recaptcha-token",
	INVALID_RECAPTCHA_ACTION: "invalid-recaptcha-action",
	MISSING_CLIENT_TYPE: "missing-client-type",
	MISSING_RECAPTCHA_VERSION: "missing-recaptcha-version",
	INVALID_RECAPTCHA_VERSION: "invalid-recaptcha-version",
	INVALID_REQ_TYPE: "invalid-req-type"
}, im = new em(3e4, 6e4);
function $(e, t) {
	return e.tenantId && !t.tenantId ? Object.assign(Object.assign({}, t), { tenantId: e.tenantId }) : t;
}
async function am(e, t, n, r, i = {}) {
	return om(e, i, async () => {
		let i = {}, a = {};
		r && (t === "GET" ? a = r : i = { body: JSON.stringify(r) });
		let o = Qn(Object.assign({ key: e.config.apiKey }, a)).slice(1), s = await e._getAdditionalHeaders();
		s["Content-Type"] = "application/json", e.languageCode && (s["X-Firebase-Locale"] = e.languageCode);
		let c = Object.assign({
			method: t,
			headers: s
		}, i);
		return Ln() || (c.referrerPolicy = "no-referrer"), nm.fetch()(cm(e, e.config.apiHost, n, o), c);
	});
}
async function om(e, t, n) {
	e._canInitEmulator = !1;
	let r = Object.assign(Object.assign({}, rm), t);
	try {
		let t = new um(e), i = await Promise.race([n(), t.promise]);
		t.clearNetworkTimeout();
		let a = await i.json();
		if ("needConfirmation" in a) throw dm(e, "account-exists-with-different-credential", a);
		if (i.ok && !("errorMessage" in a)) return a;
		{
			let [t, n] = (i.ok ? a.errorMessage : a.error.message).split(" : ");
			if (t === "FEDERATED_USER_ID_ALREADY_LINKED") throw dm(e, "credential-already-in-use", a);
			if (t === "EMAIL_EXISTS") throw dm(e, "email-already-in-use", a);
			if (t === "USER_DISABLED") throw dm(e, "user-disabled", a);
			let o = r[t] || t.toLowerCase().replace(/[_\s]+/g, "-");
			if (n) throw Wp(e, o, n);
			Hp(e, o);
		}
	} catch (t) {
		if (t instanceof Gn) throw t;
		Hp(e, "network-request-failed", { message: String(t) });
	}
}
async function sm(e, t, n, r, i = {}) {
	let a = await am(e, t, n, r, i);
	return "mfaPendingCredential" in a && Hp(e, "multi-factor-auth-required", { _serverResponse: a }), a;
}
function cm(e, t, n, r) {
	let i = `${t}${n}?${r}`;
	return e.config.emulator ? tm(e.config, i) : `${e.config.apiScheme}://${i}`;
}
function lm(e) {
	switch (e) {
		case "ENFORCE": return "ENFORCE";
		case "AUDIT": return "AUDIT";
		case "OFF": return "OFF";
		default: return "ENFORCEMENT_STATE_UNSPECIFIED";
	}
}
var um = class {
	constructor(e) {
		this.auth = e, this.timer = null, this.promise = new Promise((e, t) => {
			this.timer = setTimeout(() => t(Up(this.auth, "network-request-failed")), im.get());
		});
	}
	clearNetworkTimeout() {
		clearTimeout(this.timer);
	}
};
function dm(e, t, n) {
	let r = { appName: e.name };
	n.email && (r.email = n.email), n.phoneNumber && (r.phoneNumber = n.phoneNumber);
	let i = Up(e, t, r);
	return i.customData._tokenResponse = n, i;
}
function fm(e) {
	return e !== void 0 && e.enterprise !== void 0;
}
var pm = class {
	constructor(e) {
		if (this.siteKey = "", this.recaptchaEnforcementState = [], e.recaptchaKey === void 0) throw Error("recaptchaKey undefined");
		this.siteKey = e.recaptchaKey.split("/")[3], this.recaptchaEnforcementState = e.recaptchaEnforcementState;
	}
	getProviderEnforcementState(e) {
		if (!this.recaptchaEnforcementState || this.recaptchaEnforcementState.length === 0) return null;
		for (let t of this.recaptchaEnforcementState) if (t.provider && t.provider === e) return lm(t.enforcementState);
		return null;
	}
	isProviderEnabled(e) {
		return this.getProviderEnforcementState(e) === "ENFORCE" || this.getProviderEnforcementState(e) === "AUDIT";
	}
	isAnyProviderEnabled() {
		return this.isProviderEnabled("EMAIL_PASSWORD_PROVIDER") || this.isProviderEnabled("PHONE_PROVIDER");
	}
};
async function mm(e, t) {
	return am(e, "GET", "/v2/recaptchaConfig", $(e, t));
}
async function hm(e, t) {
	return am(e, "POST", "/v1/accounts:delete", t);
}
async function gm(e, t) {
	return am(e, "POST", "/v1/accounts:lookup", t);
}
function _m(e) {
	if (e) try {
		let t = new Date(Number(e));
		if (!isNaN(t.getTime())) return t.toUTCString();
	} catch {}
}
async function vm(e, t = !1) {
	let n = j(e), r = await n.getIdToken(t), i = bm(r);
	Q(i && i.exp && i.auth_time && i.iat, n.auth, "internal-error");
	let a = typeof i.firebase == "object" ? i.firebase : void 0, o = a?.sign_in_provider;
	return {
		claims: i,
		token: r,
		authTime: _m(ym(i.auth_time)),
		issuedAtTime: _m(ym(i.iat)),
		expirationTime: _m(ym(i.exp)),
		signInProvider: o || null,
		signInSecondFactor: a?.sign_in_second_factor || null
	};
}
function ym(e) {
	return Number(e) * 1e3;
}
function bm(e) {
	let [t, n, r] = e.split(".");
	if (t === void 0 || n === void 0 || r === void 0) return Vp("JWT malformed, contained fewer than 3 sections"), null;
	try {
		let e = wn(n);
		return e ? JSON.parse(e) : (Vp("Failed to decode base64 JWT payload"), null);
	} catch (e) {
		return Vp("Caught error parsing JWT payload as JSON", e?.toString()), null;
	}
}
function xm(e) {
	let t = bm(e);
	return Q(t, "internal-error"), Q(t.exp !== void 0, "internal-error"), Q(t.iat !== void 0, "internal-error"), Number(t.exp) - Number(t.iat);
}
async function Sm(e, t, n = !1) {
	if (n) return t;
	try {
		return await t;
	} catch (t) {
		throw t instanceof Gn && Cm(t) && e.auth.currentUser === e && await e.auth.signOut(), t;
	}
}
function Cm({ code: e }) {
	return e === "auth/user-disabled" || e === "auth/user-token-expired";
}
var wm = class {
	constructor(e) {
		this.user = e, this.isRunning = !1, this.timerId = null, this.errorBackoff = 3e4;
	}
	_start() {
		this.isRunning || (this.isRunning = !0, this.schedule());
	}
	_stop() {
		this.isRunning && (this.isRunning = !1, this.timerId !== null && clearTimeout(this.timerId));
	}
	getInterval(e) {
		if (e) {
			let e = this.errorBackoff;
			return this.errorBackoff = Math.min(this.errorBackoff * 2, 96e4), e;
		} else {
			this.errorBackoff = 3e4;
			let e = (this.user.stsTokenManager.expirationTime ?? 0) - Date.now() - 3e5;
			return Math.max(0, e);
		}
	}
	schedule(e = !1) {
		if (!this.isRunning) return;
		let t = this.getInterval(e);
		this.timerId = setTimeout(async () => {
			await this.iteration();
		}, t);
	}
	async iteration() {
		try {
			await this.user.getIdToken(!0);
		} catch (e) {
			e?.code === "auth/network-request-failed" && this.schedule(!0);
			return;
		}
		this.schedule();
	}
}, Tm = class {
	constructor(e, t) {
		this.createdAt = e, this.lastLoginAt = t, this._initializeTime();
	}
	_initializeTime() {
		this.lastSignInTime = _m(this.lastLoginAt), this.creationTime = _m(this.createdAt);
	}
	_copy(e) {
		this.createdAt = e.createdAt, this.lastLoginAt = e.lastLoginAt, this._initializeTime();
	}
	toJSON() {
		return {
			createdAt: this.createdAt,
			lastLoginAt: this.lastLoginAt
		};
	}
};
async function Em(e) {
	let t = e.auth, n = await Sm(e, gm(t, { idToken: await e.getIdToken() }));
	Q(n?.users.length, t, "internal-error");
	let r = n.users[0];
	e._notifyReloadListener(r);
	let i = r.providerUserInfo?.length ? km(r.providerUserInfo) : [], a = Om(e.providerData, i), o = e.isAnonymous, s = !(e.email && r.passwordHash) && !a?.length, c = o ? s : !1, l = {
		uid: r.localId,
		displayName: r.displayName || null,
		photoURL: r.photoUrl || null,
		email: r.email || null,
		emailVerified: r.emailVerified || !1,
		phoneNumber: r.phoneNumber || null,
		tenantId: r.tenantId || null,
		providerData: a,
		metadata: new Tm(r.createdAt, r.lastLoginAt),
		isAnonymous: c
	};
	Object.assign(e, l);
}
async function Dm(e) {
	let t = j(e);
	await Em(t), await t.auth._persistUserIfCurrent(t), t.auth._notifyListenersIfCurrent(t);
}
function Om(e, t) {
	return [...e.filter((e) => !t.some((t) => t.providerId === e.providerId)), ...t];
}
function km(e) {
	return e.map((e) => {
		var { providerId: t } = e, n = Fp(e, ["providerId"]);
		return {
			providerId: t,
			uid: n.rawId || "",
			displayName: n.displayName || null,
			email: n.email || null,
			phoneNumber: n.phoneNumber || null,
			photoURL: n.photoUrl || null
		};
	});
}
async function Am(e, t) {
	let n = await om(e, {}, async () => {
		let n = Qn({
			grant_type: "refresh_token",
			refresh_token: t
		}).slice(1), { tokenApiHost: r, apiKey: i } = e.config, a = cm(e, r, "/v1/token", `key=${i}`), o = await e._getAdditionalHeaders();
		return o["Content-Type"] = "application/x-www-form-urlencoded", nm.fetch()(a, {
			method: "POST",
			headers: o,
			body: n
		});
	});
	return {
		accessToken: n.access_token,
		expiresIn: n.expires_in,
		refreshToken: n.refresh_token
	};
}
async function jm(e, t) {
	return am(e, "POST", "/v2/accounts:revokeToken", $(e, t));
}
var Mm = class e {
	constructor() {
		this.refreshToken = null, this.accessToken = null, this.expirationTime = null;
	}
	get isExpired() {
		return !this.expirationTime || Date.now() > this.expirationTime - 3e4;
	}
	updateFromServerResponse(e) {
		Q(e.idToken, "internal-error"), Q(e.idToken !== void 0, "internal-error"), Q(e.refreshToken !== void 0, "internal-error");
		let t = "expiresIn" in e && e.expiresIn !== void 0 ? Number(e.expiresIn) : xm(e.idToken);
		this.updateTokensAndExpiration(e.idToken, e.refreshToken, t);
	}
	updateFromIdToken(e) {
		Q(e.length !== 0, "internal-error");
		let t = xm(e);
		this.updateTokensAndExpiration(e, null, t);
	}
	async getToken(e, t = !1) {
		return !t && this.accessToken && !this.isExpired ? this.accessToken : (Q(this.refreshToken, e, "user-token-expired"), this.refreshToken ? (await this.refresh(e, this.refreshToken), this.accessToken) : null);
	}
	clearRefreshToken() {
		this.refreshToken = null;
	}
	async refresh(e, t) {
		let { accessToken: n, refreshToken: r, expiresIn: i } = await Am(e, t);
		this.updateTokensAndExpiration(n, r, Number(i));
	}
	updateTokensAndExpiration(e, t, n) {
		this.refreshToken = t || null, this.accessToken = e || null, this.expirationTime = Date.now() + n * 1e3;
	}
	static fromJSON(t, n) {
		let { refreshToken: r, accessToken: i, expirationTime: a } = n, o = new e();
		return r && (Q(typeof r == "string", "internal-error", { appName: t }), o.refreshToken = r), i && (Q(typeof i == "string", "internal-error", { appName: t }), o.accessToken = i), a && (Q(typeof a == "number", "internal-error", { appName: t }), o.expirationTime = a), o;
	}
	toJSON() {
		return {
			refreshToken: this.refreshToken,
			accessToken: this.accessToken,
			expirationTime: this.expirationTime
		};
	}
	_assign(e) {
		this.accessToken = e.accessToken, this.refreshToken = e.refreshToken, this.expirationTime = e.expirationTime;
	}
	_clone() {
		return Object.assign(new e(), this.toJSON());
	}
	_performRefresh() {
		return qp("not implemented");
	}
};
function Nm(e, t) {
	Q(typeof e == "string" || e === void 0, "internal-error", { appName: t });
}
var Pm = class e {
	constructor(e) {
		var { uid: t, auth: n, stsTokenManager: r } = e, i = Fp(e, [
			"uid",
			"auth",
			"stsTokenManager"
		]);
		this.providerId = "firebase", this.proactiveRefresh = new wm(this), this.reloadUserInfo = null, this.reloadListener = null, this.uid = t, this.auth = n, this.stsTokenManager = r, this.accessToken = r.accessToken, this.displayName = i.displayName || null, this.email = i.email || null, this.emailVerified = i.emailVerified || !1, this.phoneNumber = i.phoneNumber || null, this.photoURL = i.photoURL || null, this.isAnonymous = i.isAnonymous || !1, this.tenantId = i.tenantId || null, this.providerData = i.providerData ? [...i.providerData] : [], this.metadata = new Tm(i.createdAt || void 0, i.lastLoginAt || void 0);
	}
	async getIdToken(e) {
		let t = await Sm(this, this.stsTokenManager.getToken(this.auth, e));
		return Q(t, this.auth, "internal-error"), this.accessToken !== t && (this.accessToken = t, await this.auth._persistUserIfCurrent(this), this.auth._notifyListenersIfCurrent(this)), t;
	}
	getIdTokenResult(e) {
		return vm(this, e);
	}
	reload() {
		return Dm(this);
	}
	_assign(e) {
		this !== e && (Q(this.uid === e.uid, this.auth, "internal-error"), this.displayName = e.displayName, this.photoURL = e.photoURL, this.email = e.email, this.emailVerified = e.emailVerified, this.phoneNumber = e.phoneNumber, this.isAnonymous = e.isAnonymous, this.tenantId = e.tenantId, this.providerData = e.providerData.map((e) => Object.assign({}, e)), this.metadata._copy(e.metadata), this.stsTokenManager._assign(e.stsTokenManager));
	}
	_clone(t) {
		let n = new e(Object.assign(Object.assign({}, this), {
			auth: t,
			stsTokenManager: this.stsTokenManager._clone()
		}));
		return n.metadata._copy(this.metadata), n;
	}
	_onReload(e) {
		Q(!this.reloadListener, this.auth, "internal-error"), this.reloadListener = e, this.reloadUserInfo &&= (this._notifyReloadListener(this.reloadUserInfo), null);
	}
	_notifyReloadListener(e) {
		this.reloadListener ? this.reloadListener(e) : this.reloadUserInfo = e;
	}
	_startProactiveRefresh() {
		this.proactiveRefresh._start();
	}
	_stopProactiveRefresh() {
		this.proactiveRefresh._stop();
	}
	async _updateTokensIfNecessary(e, t = !1) {
		let n = !1;
		e.idToken && e.idToken !== this.stsTokenManager.accessToken && (this.stsTokenManager.updateFromServerResponse(e), n = !0), t && await Em(this), await this.auth._persistUserIfCurrent(this), n && this.auth._notifyListenersIfCurrent(this);
	}
	async delete() {
		if (Ei(this.auth.app)) return Promise.reject(Gp(this.auth));
		let e = await this.getIdToken();
		return await Sm(this, hm(this.auth, { idToken: e })), this.stsTokenManager.clearRefreshToken(), this.auth.signOut();
	}
	toJSON() {
		return Object.assign(Object.assign({
			uid: this.uid,
			email: this.email || void 0,
			emailVerified: this.emailVerified,
			displayName: this.displayName || void 0,
			isAnonymous: this.isAnonymous,
			photoURL: this.photoURL || void 0,
			phoneNumber: this.phoneNumber || void 0,
			tenantId: this.tenantId || void 0,
			providerData: this.providerData.map((e) => Object.assign({}, e)),
			stsTokenManager: this.stsTokenManager.toJSON(),
			_redirectEventId: this._redirectEventId
		}, this.metadata.toJSON()), {
			apiKey: this.auth.config.apiKey,
			appName: this.auth.name
		});
	}
	get refreshToken() {
		return this.stsTokenManager.refreshToken || "";
	}
	static _fromJSON(t, n) {
		let r = n.displayName ?? void 0, i = n.email ?? void 0, a = n.phoneNumber ?? void 0, o = n.photoURL ?? void 0, s = n.tenantId ?? void 0, c = n._redirectEventId ?? void 0, l = n.createdAt ?? void 0, u = n.lastLoginAt ?? void 0, { uid: d, emailVerified: f, isAnonymous: p, providerData: m, stsTokenManager: h } = n;
		Q(d && h, t, "internal-error");
		let g = Mm.fromJSON(this.name, h);
		Q(typeof d == "string", t, "internal-error"), Nm(r, t.name), Nm(i, t.name), Q(typeof f == "boolean", t, "internal-error"), Q(typeof p == "boolean", t, "internal-error"), Nm(a, t.name), Nm(o, t.name), Nm(s, t.name), Nm(c, t.name), Nm(l, t.name), Nm(u, t.name);
		let ee = new e({
			uid: d,
			auth: t,
			email: i,
			emailVerified: f,
			displayName: r,
			isAnonymous: p,
			photoURL: o,
			phoneNumber: a,
			tenantId: s,
			stsTokenManager: g,
			createdAt: l,
			lastLoginAt: u
		});
		return m && Array.isArray(m) && (ee.providerData = m.map((e) => Object.assign({}, e))), c && (ee._redirectEventId = c), ee;
	}
	static async _fromIdTokenResponse(t, n, r = !1) {
		let i = new Mm();
		i.updateFromServerResponse(n);
		let a = new e({
			uid: n.localId,
			auth: t,
			stsTokenManager: i,
			isAnonymous: r
		});
		return await Em(a), a;
	}
	static async _fromGetAccountInfoResponse(t, n, r) {
		let i = n.users[0];
		Q(i.localId !== void 0, "internal-error");
		let a = i.providerUserInfo === void 0 ? [] : km(i.providerUserInfo), o = !(i.email && i.passwordHash) && !a?.length, s = new Mm();
		s.updateFromIdToken(r);
		let c = new e({
			uid: i.localId,
			auth: t,
			stsTokenManager: s,
			isAnonymous: o
		}), l = {
			uid: i.localId,
			displayName: i.displayName || null,
			photoURL: i.photoUrl || null,
			email: i.email || null,
			emailVerified: i.emailVerified || !1,
			phoneNumber: i.phoneNumber || null,
			tenantId: i.tenantId || null,
			providerData: a,
			metadata: new Tm(i.createdAt, i.lastLoginAt),
			isAnonymous: !(i.email && i.passwordHash) && !a?.length
		};
		return Object.assign(c, l), c;
	}
}, Fm = /* @__PURE__ */ new Map();
function Im(e) {
	Jp(e instanceof Function, "Expected a class definition");
	let t = Fm.get(e);
	return t ? (Jp(t instanceof e, "Instance stored in cache mismatched with class"), t) : (t = new e(), Fm.set(e, t), t);
}
var Lm = class {
	constructor() {
		this.type = "NONE", this.storage = {};
	}
	async _isAvailable() {
		return !0;
	}
	async _set(e, t) {
		this.storage[e] = t;
	}
	async _get(e) {
		let t = this.storage[e];
		return t === void 0 ? null : t;
	}
	async _remove(e) {
		delete this.storage[e];
	}
	_addListener(e, t) {}
	_removeListener(e, t) {}
};
Lm.type = "NONE";
var Rm = Lm;
function zm(e, t, n) {
	return `firebase:${e}:${t}:${n}`;
}
var Bm = class e {
	constructor(e, t, n) {
		this.persistence = e, this.auth = t, this.userKey = n;
		let { config: r, name: i } = this.auth;
		this.fullUserKey = zm(this.userKey, r.apiKey, i), this.fullPersistenceKey = zm("persistence", r.apiKey, i), this.boundEventHandler = t._onStorageEvent.bind(t), this.persistence._addListener(this.fullUserKey, this.boundEventHandler);
	}
	setCurrentUser(e) {
		return this.persistence._set(this.fullUserKey, e.toJSON());
	}
	async getCurrentUser() {
		let e = await this.persistence._get(this.fullUserKey);
		return e ? Pm._fromJSON(this.auth, e) : null;
	}
	removeCurrentUser() {
		return this.persistence._remove(this.fullUserKey);
	}
	savePersistenceForRedirect() {
		return this.persistence._set(this.fullPersistenceKey, this.persistence.type);
	}
	async setPersistence(e) {
		if (this.persistence === e) return;
		let t = await this.getCurrentUser();
		if (await this.removeCurrentUser(), this.persistence = e, t) return this.setCurrentUser(t);
	}
	delete() {
		this.persistence._removeListener(this.fullUserKey, this.boundEventHandler);
	}
	static async create(t, n, r = "authUser") {
		if (!n.length) return new e(Im(Rm), t, r);
		let i = (await Promise.all(n.map(async (e) => {
			if (await e._isAvailable()) return e;
		}))).filter((e) => e), a = i[0] || Im(Rm), o = zm(r, t.config.apiKey, t.name), s = null;
		for (let e of n) try {
			let n = await e._get(o);
			if (n) {
				let r = Pm._fromJSON(t, n);
				e !== a && (s = r), a = e;
				break;
			}
		} catch {}
		let c = i.filter((e) => e._shouldAllowMigration);
		return !a._shouldAllowMigration || !c.length ? new e(a, t, r) : (a = c[0], s && await a._set(o, s.toJSON()), await Promise.all(n.map(async (e) => {
			if (e !== a) try {
				await e._remove(o);
			} catch {}
		})), new e(a, t, r));
	}
};
function Vm(e) {
	let t = e.toLowerCase();
	if (t.includes("opera/") || t.includes("opr/") || t.includes("opios/")) return "Opera";
	if (Gm(t)) return "IEMobile";
	if (t.includes("msie") || t.includes("trident/")) return "IE";
	if (t.includes("edge/")) return "Edge";
	if (Hm(t)) return "Firefox";
	if (t.includes("silk/")) return "Silk";
	if (qm(t)) return "Blackberry";
	if (Jm(t)) return "Webos";
	if (Um(t)) return "Safari";
	if ((t.includes("chrome/") || Wm(t)) && !t.includes("edge/")) return "Chrome";
	if (Km(t)) return "Android";
	{
		let t = e.match(/([a-zA-Z\d\.]+)\/[a-zA-Z\d\.]*$/);
		if (t?.length === 2) return t[1];
	}
	return "Other";
}
function Hm(e = A()) {
	return /firefox\//i.test(e);
}
function Um(e = A()) {
	let t = e.toLowerCase();
	return t.includes("safari/") && !t.includes("chrome/") && !t.includes("crios/") && !t.includes("android");
}
function Wm(e = A()) {
	return /crios\//i.test(e);
}
function Gm(e = A()) {
	return /iemobile/i.test(e);
}
function Km(e = A()) {
	return /android/i.test(e);
}
function qm(e = A()) {
	return /blackberry/i.test(e);
}
function Jm(e = A()) {
	return /webos/i.test(e);
}
function Ym(e = A()) {
	return /iphone|ipad|ipod/i.test(e) || /macintosh/i.test(e) && /mobile/i.test(e);
}
function Xm(e = A()) {
	return Ym(e) && !!window.navigator?.standalone;
}
function Zm() {
	return Bn() && document.documentMode === 10;
}
function Qm(e = A()) {
	return Ym(e) || Km(e) || Jm(e) || qm(e) || /windows phone/i.test(e) || Gm(e);
}
function $m(e, t = []) {
	let n;
	switch (e) {
		case "Browser":
			n = Vm(A());
			break;
		case "Worker":
			n = `${Vm(A())}-${e}`;
			break;
		default: n = e;
	}
	let r = t.length ? t.join(",") : "FirebaseCore-web";
	return `${n}/JsCore/${ki}/${r}`;
}
var eh = class {
	constructor(e) {
		this.auth = e, this.queue = [];
	}
	pushCallback(e, t) {
		let n = (t) => new Promise((n, r) => {
			try {
				n(e(t));
			} catch (e) {
				r(e);
			}
		});
		n.onAbort = t, this.queue.push(n);
		let r = this.queue.length - 1;
		return () => {
			this.queue[r] = () => Promise.resolve();
		};
	}
	async runMiddleware(e) {
		if (this.auth.currentUser === e) return;
		let t = [];
		try {
			for (let n of this.queue) await n(e), n.onAbort && t.push(n.onAbort);
		} catch (e) {
			t.reverse();
			for (let e of t) try {
				e();
			} catch {}
			throw this.auth._errorFactory.create("login-blocked", { originalMessage: e?.message });
		}
	}
};
async function th(e, t = {}) {
	return am(e, "GET", "/v2/passwordPolicy", $(e, t));
}
var nh = 6, rh = class {
	constructor(e) {
		let t = e.customStrengthOptions;
		this.customStrengthOptions = {}, this.customStrengthOptions.minPasswordLength = t.minPasswordLength ?? nh, t.maxPasswordLength && (this.customStrengthOptions.maxPasswordLength = t.maxPasswordLength), t.containsLowercaseCharacter !== void 0 && (this.customStrengthOptions.containsLowercaseLetter = t.containsLowercaseCharacter), t.containsUppercaseCharacter !== void 0 && (this.customStrengthOptions.containsUppercaseLetter = t.containsUppercaseCharacter), t.containsNumericCharacter !== void 0 && (this.customStrengthOptions.containsNumericCharacter = t.containsNumericCharacter), t.containsNonAlphanumericCharacter !== void 0 && (this.customStrengthOptions.containsNonAlphanumericCharacter = t.containsNonAlphanumericCharacter), this.enforcementState = e.enforcementState, this.enforcementState === "ENFORCEMENT_STATE_UNSPECIFIED" && (this.enforcementState = "OFF"), this.allowedNonAlphanumericCharacters = e.allowedNonAlphanumericCharacters?.join("") ?? "", this.forceUpgradeOnSignin = e.forceUpgradeOnSignin ?? !1, this.schemaVersion = e.schemaVersion;
	}
	validatePassword(e) {
		let t = {
			isValid: !0,
			passwordPolicy: this
		};
		return this.validatePasswordLengthOptions(e, t), this.validatePasswordCharacterOptions(e, t), t.isValid &&= t.meetsMinPasswordLength ?? !0, t.isValid &&= t.meetsMaxPasswordLength ?? !0, t.isValid &&= t.containsLowercaseLetter ?? !0, t.isValid &&= t.containsUppercaseLetter ?? !0, t.isValid &&= t.containsNumericCharacter ?? !0, t.isValid &&= t.containsNonAlphanumericCharacter ?? !0, t;
	}
	validatePasswordLengthOptions(e, t) {
		let n = this.customStrengthOptions.minPasswordLength, r = this.customStrengthOptions.maxPasswordLength;
		n && (t.meetsMinPasswordLength = e.length >= n), r && (t.meetsMaxPasswordLength = e.length <= r);
	}
	validatePasswordCharacterOptions(e, t) {
		this.updatePasswordCharacterOptionsStatuses(t, !1, !1, !1, !1);
		let n;
		for (let r = 0; r < e.length; r++) n = e.charAt(r), this.updatePasswordCharacterOptionsStatuses(t, n >= "a" && n <= "z", n >= "A" && n <= "Z", n >= "0" && n <= "9", this.allowedNonAlphanumericCharacters.includes(n));
	}
	updatePasswordCharacterOptionsStatuses(e, t, n, r, i) {
		this.customStrengthOptions.containsLowercaseLetter && (e.containsLowercaseLetter ||= t), this.customStrengthOptions.containsUppercaseLetter && (e.containsUppercaseLetter ||= n), this.customStrengthOptions.containsNumericCharacter && (e.containsNumericCharacter ||= r), this.customStrengthOptions.containsNonAlphanumericCharacter && (e.containsNonAlphanumericCharacter ||= i);
	}
}, ih = class {
	constructor(e, t, n, r) {
		this.app = e, this.heartbeatServiceProvider = t, this.appCheckServiceProvider = n, this.config = r, this.currentUser = null, this.emulatorConfig = null, this.operations = Promise.resolve(), this.authStateSubscription = new oh(this), this.idTokenSubscription = new oh(this), this.beforeStateQueue = new eh(this), this.redirectUser = null, this.isProactiveRefreshEnabled = !1, this.EXPECTED_PASSWORD_POLICY_SCHEMA_VERSION = 1, this._canInitEmulator = !0, this._isInitialized = !1, this._deleted = !1, this._initializationPromise = null, this._popupRedirectResolver = null, this._errorFactory = Rp, this._agentRecaptchaConfig = null, this._tenantRecaptchaConfigs = {}, this._projectPasswordPolicy = null, this._tenantPasswordPolicies = {}, this.lastNotifiedUid = void 0, this.languageCode = null, this.tenantId = null, this.settings = { appVerificationDisabledForTesting: !1 }, this.frameworks = [], this.name = e.name, this.clientVersion = r.sdkClientVersion;
	}
	_initializeWithPersistence(e, t) {
		return t && (this._popupRedirectResolver = Im(t)), this._initializationPromise = this.queue(async () => {
			if (!this._deleted && (this.persistenceManager = await Bm.create(this, e), !this._deleted)) {
				if (this._popupRedirectResolver?._shouldInitProactively) try {
					await this._popupRedirectResolver._initialize(this);
				} catch {}
				await this.initializeCurrentUser(t), this.lastNotifiedUid = this.currentUser?.uid || null, !this._deleted && (this._isInitialized = !0);
			}
		}), this._initializationPromise;
	}
	async _onStorageEvent() {
		if (this._deleted) return;
		let e = await this.assertedPersistence.getCurrentUser();
		if (!(!this.currentUser && !e)) {
			if (this.currentUser && e && this.currentUser.uid === e.uid) {
				this._currentUser._assign(e), await this.currentUser.getIdToken();
				return;
			}
			await this._updateCurrentUser(e, !0);
		}
	}
	async initializeCurrentUserFromIdToken(e) {
		try {
			let t = await gm(this, { idToken: e }), n = await Pm._fromGetAccountInfoResponse(this, t, e);
			await this.directlySetCurrentUser(n);
		} catch (e) {
			console.warn("FirebaseServerApp could not login user with provided authIdToken: ", e), await this.directlySetCurrentUser(null);
		}
	}
	async initializeCurrentUser(e) {
		if (Ei(this.app)) {
			let e = this.app.settings.authIdToken;
			return e ? new Promise((t) => {
				setTimeout(() => this.initializeCurrentUserFromIdToken(e).then(t, t));
			}) : this.directlySetCurrentUser(null);
		}
		let t = await this.assertedPersistence.getCurrentUser(), n = t, r = !1;
		if (e && this.config.authDomain) {
			await this.getOrInitRedirectPersistenceManager();
			let t = this.redirectUser?._redirectEventId, i = n?._redirectEventId, a = await this.tryRedirectSignIn(e);
			(!t || t === i) && a?.user && (n = a.user, r = !0);
		}
		if (!n) return this.directlySetCurrentUser(null);
		if (!n._redirectEventId) {
			if (r) try {
				await this.beforeStateQueue.runMiddleware(n);
			} catch (e) {
				n = t, this._popupRedirectResolver._overrideRedirectResult(this, () => Promise.reject(e));
			}
			return n ? this.reloadAndSetCurrentUserOrClear(n) : this.directlySetCurrentUser(null);
		}
		return Q(this._popupRedirectResolver, this, "argument-error"), await this.getOrInitRedirectPersistenceManager(), this.redirectUser && this.redirectUser._redirectEventId === n._redirectEventId ? this.directlySetCurrentUser(n) : this.reloadAndSetCurrentUserOrClear(n);
	}
	async tryRedirectSignIn(e) {
		let t = null;
		try {
			t = await this._popupRedirectResolver._completeRedirectFn(this, e, !0);
		} catch {
			await this._setRedirectUser(null);
		}
		return t;
	}
	async reloadAndSetCurrentUserOrClear(e) {
		try {
			await Em(e);
		} catch (e) {
			if (e?.code !== "auth/network-request-failed") return this.directlySetCurrentUser(null);
		}
		return this.directlySetCurrentUser(e);
	}
	useDeviceLanguage() {
		this.languageCode = $p();
	}
	async _delete() {
		this._deleted = !0;
	}
	async updateCurrentUser(e) {
		if (Ei(this.app)) return Promise.reject(Gp(this));
		let t = e ? j(e) : null;
		return t && Q(t.auth.config.apiKey === this.config.apiKey, this, "invalid-user-token"), this._updateCurrentUser(t && t._clone(this));
	}
	async _updateCurrentUser(e, t = !1) {
		if (!this._deleted) return e && Q(this.tenantId === e.tenantId, this, "tenant-id-mismatch"), t || await this.beforeStateQueue.runMiddleware(e), this.queue(async () => {
			await this.directlySetCurrentUser(e), this.notifyAuthListeners();
		});
	}
	async signOut() {
		return Ei(this.app) ? Promise.reject(Gp(this)) : (await this.beforeStateQueue.runMiddleware(null), (this.redirectPersistenceManager || this._popupRedirectResolver) && await this._setRedirectUser(null), this._updateCurrentUser(null, !0));
	}
	setPersistence(e) {
		return Ei(this.app) ? Promise.reject(Gp(this)) : this.queue(async () => {
			await this.assertedPersistence.setPersistence(Im(e));
		});
	}
	_getRecaptchaConfig() {
		return this.tenantId == null ? this._agentRecaptchaConfig : this._tenantRecaptchaConfigs[this.tenantId];
	}
	async validatePassword(e) {
		this._getPasswordPolicyInternal() || await this._updatePasswordPolicy();
		let t = this._getPasswordPolicyInternal();
		return t.schemaVersion === this.EXPECTED_PASSWORD_POLICY_SCHEMA_VERSION ? t.validatePassword(e) : Promise.reject(this._errorFactory.create("unsupported-password-policy-schema-version", {}));
	}
	_getPasswordPolicyInternal() {
		return this.tenantId === null ? this._projectPasswordPolicy : this._tenantPasswordPolicies[this.tenantId];
	}
	async _updatePasswordPolicy() {
		let e = new rh(await th(this));
		this.tenantId === null ? this._projectPasswordPolicy = e : this._tenantPasswordPolicies[this.tenantId] = e;
	}
	_getPersistence() {
		return this.assertedPersistence.persistence.type;
	}
	_updateErrorMap(e) {
		this._errorFactory = new Kn("auth", "Firebase", e());
	}
	onAuthStateChanged(e, t, n) {
		return this.registerStateListener(this.authStateSubscription, e, t, n);
	}
	beforeAuthStateChanged(e, t) {
		return this.beforeStateQueue.pushCallback(e, t);
	}
	onIdTokenChanged(e, t, n) {
		return this.registerStateListener(this.idTokenSubscription, e, t, n);
	}
	authStateReady() {
		return new Promise((e, t) => {
			if (this.currentUser) e();
			else {
				let n = this.onAuthStateChanged(() => {
					n(), e();
				}, t);
			}
		});
	}
	async revokeAccessToken(e) {
		if (this.currentUser) {
			let t = {
				providerId: "apple.com",
				tokenType: "ACCESS_TOKEN",
				token: e,
				idToken: await this.currentUser.getIdToken()
			};
			this.tenantId != null && (t.tenantId = this.tenantId), await jm(this, t);
		}
	}
	toJSON() {
		return {
			apiKey: this.config.apiKey,
			authDomain: this.config.authDomain,
			appName: this.name,
			currentUser: this._currentUser?.toJSON()
		};
	}
	async _setRedirectUser(e, t) {
		let n = await this.getOrInitRedirectPersistenceManager(t);
		return e === null ? n.removeCurrentUser() : n.setCurrentUser(e);
	}
	async getOrInitRedirectPersistenceManager(e) {
		if (!this.redirectPersistenceManager) {
			let t = e && Im(e) || this._popupRedirectResolver;
			Q(t, this, "argument-error"), this.redirectPersistenceManager = await Bm.create(this, [Im(t._redirectPersistence)], "redirectUser"), this.redirectUser = await this.redirectPersistenceManager.getCurrentUser();
		}
		return this.redirectPersistenceManager;
	}
	async _redirectUserForId(e) {
		return this._isInitialized && await this.queue(async () => {}), this._currentUser?._redirectEventId === e ? this._currentUser : this.redirectUser?._redirectEventId === e ? this.redirectUser : null;
	}
	async _persistUserIfCurrent(e) {
		if (e === this.currentUser) return this.queue(async () => this.directlySetCurrentUser(e));
	}
	_notifyListenersIfCurrent(e) {
		e === this.currentUser && this.notifyAuthListeners();
	}
	_key() {
		return `${this.config.authDomain}:${this.config.apiKey}:${this.name}`;
	}
	_startProactiveRefresh() {
		this.isProactiveRefreshEnabled = !0, this.currentUser && this._currentUser._startProactiveRefresh();
	}
	_stopProactiveRefresh() {
		this.isProactiveRefreshEnabled = !1, this.currentUser && this._currentUser._stopProactiveRefresh();
	}
	get _currentUser() {
		return this.currentUser;
	}
	notifyAuthListeners() {
		if (!this._isInitialized) return;
		this.idTokenSubscription.next(this.currentUser);
		let e = this.currentUser?.uid ?? null;
		this.lastNotifiedUid !== e && (this.lastNotifiedUid = e, this.authStateSubscription.next(this.currentUser));
	}
	registerStateListener(e, t, n, r) {
		if (this._deleted) return () => {};
		let i = typeof t == "function" ? t : t.next.bind(t), a = !1, o = this._isInitialized ? Promise.resolve() : this._initializationPromise;
		if (Q(o, this, "internal-error"), o.then(() => {
			a || i(this.currentUser);
		}), typeof t == "function") {
			let i = e.addObserver(t, n, r);
			return () => {
				a = !0, i();
			};
		} else {
			let n = e.addObserver(t);
			return () => {
				a = !0, n();
			};
		}
	}
	async directlySetCurrentUser(e) {
		this.currentUser && this.currentUser !== e && this._currentUser._stopProactiveRefresh(), e && this.isProactiveRefreshEnabled && e._startProactiveRefresh(), this.currentUser = e, e ? await this.assertedPersistence.setCurrentUser(e) : await this.assertedPersistence.removeCurrentUser();
	}
	queue(e) {
		return this.operations = this.operations.then(e, e), this.operations;
	}
	get assertedPersistence() {
		return Q(this.persistenceManager, this, "internal-error"), this.persistenceManager;
	}
	_logFramework(e) {
		!e || this.frameworks.includes(e) || (this.frameworks.push(e), this.frameworks.sort(), this.clientVersion = $m(this.config.clientPlatform, this._getFrameworks()));
	}
	_getFrameworks() {
		return this.frameworks;
	}
	async _getAdditionalHeaders() {
		let e = { "X-Client-Version": this.clientVersion };
		this.app.options.appId && (e["X-Firebase-gmpid"] = this.app.options.appId);
		let t = await this.heartbeatServiceProvider.getImmediate({ optional: !0 })?.getHeartbeatsHeader();
		t && (e["X-Firebase-Client"] = t);
		let n = await this._getAppCheckToken();
		return n && (e["X-Firebase-AppCheck"] = n), e;
	}
	async _getAppCheckToken() {
		let e = await this.appCheckServiceProvider.getImmediate({ optional: !0 })?.getToken();
		return e?.error && Bp(`Error while retrieving App Check token: ${e.error}`), e?.token;
	}
};
function ah(e) {
	return j(e);
}
var oh = class {
	constructor(e) {
		this.auth = e, this.observer = null, this.addObserver = tr((e) => this.observer = e);
	}
	get next() {
		return Q(this.observer, this.auth, "internal-error"), this.observer.next.bind(this.observer);
	}
}, sh = {
	async loadJS() {
		throw Error("Unable to load external scripts");
	},
	recaptchaV2Script: "",
	recaptchaEnterpriseScript: "",
	gapiScript: ""
};
function ch(e) {
	sh = e;
}
function lh(e) {
	return sh.loadJS(e);
}
function uh() {
	return sh.recaptchaEnterpriseScript;
}
function dh() {
	return sh.gapiScript;
}
function fh(e) {
	return `__${e}${Math.floor(Math.random() * 1e6)}`;
}
var ph = class {
	constructor() {
		this.enterprise = new mh();
	}
	ready(e) {
		e();
	}
	execute(e, t) {
		return Promise.resolve("token");
	}
	render(e, t) {
		return "";
	}
}, mh = class {
	ready(e) {
		e();
	}
	execute(e, t) {
		return Promise.resolve("token");
	}
	render(e, t) {
		return "";
	}
}, hh = "recaptcha-enterprise", gh = "NO_RECAPTCHA", _h = class {
	constructor(e) {
		this.type = hh, this.auth = ah(e);
	}
	async verify(e = "verify", t = !1) {
		async function n(e) {
			if (!t) {
				if (e.tenantId == null && e._agentRecaptchaConfig != null) return e._agentRecaptchaConfig.siteKey;
				if (e.tenantId != null && e._tenantRecaptchaConfigs[e.tenantId] !== void 0) return e._tenantRecaptchaConfigs[e.tenantId].siteKey;
			}
			return new Promise(async (t, n) => {
				mm(e, {
					clientType: "CLIENT_TYPE_WEB",
					version: "RECAPTCHA_ENTERPRISE"
				}).then((r) => {
					if (r.recaptchaKey === void 0) n(/* @__PURE__ */ Error("recaptcha Enterprise site key undefined"));
					else {
						let n = new pm(r);
						return e.tenantId == null ? e._agentRecaptchaConfig = n : e._tenantRecaptchaConfigs[e.tenantId] = n, t(n.siteKey);
					}
				}).catch((e) => {
					n(e);
				});
			});
		}
		function r(t, n, r) {
			let i = window.grecaptcha;
			fm(i) ? i.enterprise.ready(() => {
				i.enterprise.execute(t, { action: e }).then((e) => {
					n(e);
				}).catch(() => {
					n(gh);
				});
			}) : r(Error("No reCAPTCHA enterprise script loaded."));
		}
		return this.auth.settings.appVerificationDisabledForTesting ? new ph().execute("siteKey", { action: "verify" }) : new Promise((e, i) => {
			n(this.auth).then((n) => {
				if (!t && fm(window.grecaptcha)) r(n, e, i);
				else {
					if (typeof window > "u") {
						i(/* @__PURE__ */ Error("RecaptchaVerifier is only supported in browser"));
						return;
					}
					let t = uh();
					t.length !== 0 && (t += n), lh(t).then(() => {
						r(n, e, i);
					}).catch((e) => {
						i(e);
					});
				}
			}).catch((e) => {
				i(e);
			});
		});
	}
};
async function vh(e, t, n, r = !1, i = !1) {
	let a = new _h(e), o;
	if (i) o = gh;
	else try {
		o = await a.verify(n);
	} catch {
		o = await a.verify(n, !0);
	}
	let s = Object.assign({}, t);
	if (n === "mfaSmsEnrollment" || n === "mfaSmsSignIn") {
		if ("phoneEnrollmentInfo" in s) {
			let e = s.phoneEnrollmentInfo.phoneNumber, t = s.phoneEnrollmentInfo.recaptchaToken;
			Object.assign(s, { phoneEnrollmentInfo: {
				phoneNumber: e,
				recaptchaToken: t,
				captchaResponse: o,
				clientType: "CLIENT_TYPE_WEB",
				recaptchaVersion: "RECAPTCHA_ENTERPRISE"
			} });
		} else if ("phoneSignInInfo" in s) {
			let e = s.phoneSignInInfo.recaptchaToken;
			Object.assign(s, { phoneSignInInfo: {
				recaptchaToken: e,
				captchaResponse: o,
				clientType: "CLIENT_TYPE_WEB",
				recaptchaVersion: "RECAPTCHA_ENTERPRISE"
			} });
		}
		return s;
	}
	return r ? Object.assign(s, { captchaResp: o }) : Object.assign(s, { captchaResponse: o }), Object.assign(s, { clientType: "CLIENT_TYPE_WEB" }), Object.assign(s, { recaptchaVersion: "RECAPTCHA_ENTERPRISE" }), s;
}
async function yh(e, t, n, r, i) {
	return i === "EMAIL_PASSWORD_PROVIDER" ? e._getRecaptchaConfig()?.isProviderEnabled("EMAIL_PASSWORD_PROVIDER") ? r(e, await vh(e, t, n, n === "getOobCode")) : r(e, t).catch(async (i) => i.code === "auth/missing-recaptcha-token" ? (console.log(`${n} is protected by reCAPTCHA Enterprise for this project. Automatically triggering the reCAPTCHA flow and restarting the flow.`), r(e, await vh(e, t, n, n === "getOobCode"))) : Promise.reject(i)) : i === "PHONE_PROVIDER" ? e._getRecaptchaConfig()?.isProviderEnabled("PHONE_PROVIDER") ? r(e, await vh(e, t, n)).catch(async (i) => e._getRecaptchaConfig()?.getProviderEnforcementState("PHONE_PROVIDER") === "AUDIT" && (i.code === "auth/missing-recaptcha-token" || i.code === "auth/invalid-app-credential") ? (console.log(`Failed to verify with reCAPTCHA Enterprise. Automatically triggering the reCAPTCHA v2 flow to complete the ${n} flow.`), r(e, await vh(e, t, n, !1, !0))) : Promise.reject(i)) : r(e, await vh(e, t, n, !1, !0)) : Promise.reject(i + " provider is not supported.");
}
async function bh(e) {
	let t = ah(e), n = new pm(await mm(t, {
		clientType: "CLIENT_TYPE_WEB",
		version: "RECAPTCHA_ENTERPRISE"
	}));
	t.tenantId == null ? t._agentRecaptchaConfig = n : t._tenantRecaptchaConfigs[t.tenantId] = n, n.isAnyProviderEnabled() && new _h(t).verify();
}
function xh(e, t) {
	let n = Ti(e, "auth");
	if (n.isInitialized()) {
		let e = n.getImmediate();
		if (Xn(n.getOptions(), t ?? {})) return e;
		Hp(e, "already-initialized");
	}
	return n.initialize({ options: t });
}
function Sh(e, t) {
	let n = t?.persistence || [], r = (Array.isArray(n) ? n : [n]).map(Im);
	t?.errorMap && e._updateErrorMap(t.errorMap), e._initializeWithPersistence(r, t?.popupRedirectResolver);
}
function Ch(e, t, n) {
	let r = ah(e);
	Q(r._canInitEmulator, r, "emulator-config-failed"), Q(/^https?:\/\//.test(t), r, "invalid-emulator-scheme");
	let i = !!n?.disableWarnings, a = wh(t), { host: o, port: s } = Th(t), c = s === null ? "" : `:${s}`;
	r.config.emulator = { url: `${a}//${o}${c}/` }, r.settings.appVerificationDisabledForTesting = !0, r.emulatorConfig = Object.freeze({
		host: o,
		port: s,
		protocol: a.replace(":", ""),
		options: Object.freeze({ disableWarnings: i })
	}), i || Dh();
}
function wh(e) {
	let t = e.indexOf(":");
	return t < 0 ? "" : e.substr(0, t + 1);
}
function Th(e) {
	let t = wh(e), n = /(\/\/)?([^?#/]+)/.exec(e.substr(t.length));
	if (!n) return {
		host: "",
		port: null
	};
	let r = n[2].split("@").pop() || "", i = /^(\[[^\]]+\])(:|$)/.exec(r);
	if (i) {
		let e = i[1];
		return {
			host: e,
			port: Eh(r.substr(e.length + 1))
		};
	} else {
		let [e, t] = r.split(":");
		return {
			host: e,
			port: Eh(t)
		};
	}
}
function Eh(e) {
	if (!e) return null;
	let t = Number(e);
	return isNaN(t) ? null : t;
}
function Dh() {
	function e() {
		let e = document.createElement("p"), t = e.style;
		e.innerText = "Running in emulator mode. Do not use with production credentials.", t.position = "fixed", t.width = "100%", t.backgroundColor = "#ffffff", t.border = ".1em solid #000000", t.color = "#b50000", t.bottom = "0px", t.left = "0px", t.margin = "0px", t.zIndex = "10000", t.textAlign = "center", e.classList.add("firebase-emulator-warning"), document.body.appendChild(e);
	}
	typeof console < "u" && typeof console.info == "function" && console.info("WARNING: You are using the Auth Emulator, which is intended for local testing only.  Do not use with production credentials."), typeof window < "u" && typeof document < "u" && (document.readyState === "loading" ? window.addEventListener("DOMContentLoaded", e) : e());
}
var Oh = class {
	constructor(e, t) {
		this.providerId = e, this.signInMethod = t;
	}
	toJSON() {
		return qp("not implemented");
	}
	_getIdTokenResponse(e) {
		return qp("not implemented");
	}
	_linkToIdToken(e, t) {
		return qp("not implemented");
	}
	_getReauthenticationResolver(e) {
		return qp("not implemented");
	}
};
async function kh(e, t) {
	return am(e, "POST", "/v1/accounts:signUp", t);
}
async function Ah(e, t) {
	return sm(e, "POST", "/v1/accounts:signInWithPassword", $(e, t));
}
async function jh(e, t) {
	return sm(e, "POST", "/v1/accounts:signInWithEmailLink", $(e, t));
}
async function Mh(e, t) {
	return sm(e, "POST", "/v1/accounts:signInWithEmailLink", $(e, t));
}
var Nh = class e extends Oh {
	constructor(e, t, n, r = null) {
		super("password", n), this._email = e, this._password = t, this._tenantId = r;
	}
	static _fromEmailAndPassword(t, n) {
		return new e(t, n, "password");
	}
	static _fromEmailAndCode(t, n, r = null) {
		return new e(t, n, "emailLink", r);
	}
	toJSON() {
		return {
			email: this._email,
			password: this._password,
			signInMethod: this.signInMethod,
			tenantId: this._tenantId
		};
	}
	static fromJSON(e) {
		let t = typeof e == "string" ? JSON.parse(e) : e;
		if (t?.email && t?.password) {
			if (t.signInMethod === "password") return this._fromEmailAndPassword(t.email, t.password);
			if (t.signInMethod === "emailLink") return this._fromEmailAndCode(t.email, t.password, t.tenantId);
		}
		return null;
	}
	async _getIdTokenResponse(e) {
		switch (this.signInMethod) {
			case "password": return yh(e, {
				returnSecureToken: !0,
				email: this._email,
				password: this._password,
				clientType: "CLIENT_TYPE_WEB"
			}, "signInWithPassword", Ah, "EMAIL_PASSWORD_PROVIDER");
			case "emailLink": return jh(e, {
				email: this._email,
				oobCode: this._password
			});
			default: Hp(e, "internal-error");
		}
	}
	async _linkToIdToken(e, t) {
		switch (this.signInMethod) {
			case "password": return yh(e, {
				idToken: t,
				returnSecureToken: !0,
				email: this._email,
				password: this._password,
				clientType: "CLIENT_TYPE_WEB"
			}, "signUpPassword", kh, "EMAIL_PASSWORD_PROVIDER");
			case "emailLink": return Mh(e, {
				idToken: t,
				email: this._email,
				oobCode: this._password
			});
			default: Hp(e, "internal-error");
		}
	}
	_getReauthenticationResolver(e) {
		return this._getIdTokenResponse(e);
	}
};
async function Ph(e, t) {
	return sm(e, "POST", "/v1/accounts:signInWithIdp", $(e, t));
}
var Fh = "http://localhost", Ih = class e extends Oh {
	constructor() {
		super(...arguments), this.pendingToken = null;
	}
	static _fromParams(t) {
		let n = new e(t.providerId, t.signInMethod);
		return t.idToken || t.accessToken ? (t.idToken && (n.idToken = t.idToken), t.accessToken && (n.accessToken = t.accessToken), t.nonce && !t.pendingToken && (n.nonce = t.nonce), t.pendingToken && (n.pendingToken = t.pendingToken)) : t.oauthToken && t.oauthTokenSecret ? (n.accessToken = t.oauthToken, n.secret = t.oauthTokenSecret) : Hp("argument-error"), n;
	}
	toJSON() {
		return {
			idToken: this.idToken,
			accessToken: this.accessToken,
			secret: this.secret,
			nonce: this.nonce,
			pendingToken: this.pendingToken,
			providerId: this.providerId,
			signInMethod: this.signInMethod
		};
	}
	static fromJSON(t) {
		let n = typeof t == "string" ? JSON.parse(t) : t, { providerId: r, signInMethod: i } = n, a = Fp(n, ["providerId", "signInMethod"]);
		if (!r || !i) return null;
		let o = new e(r, i);
		return o.idToken = a.idToken || void 0, o.accessToken = a.accessToken || void 0, o.secret = a.secret, o.nonce = a.nonce, o.pendingToken = a.pendingToken || null, o;
	}
	_getIdTokenResponse(e) {
		return Ph(e, this.buildRequest());
	}
	_linkToIdToken(e, t) {
		let n = this.buildRequest();
		return n.idToken = t, Ph(e, n);
	}
	_getReauthenticationResolver(e) {
		let t = this.buildRequest();
		return t.autoCreate = !1, Ph(e, t);
	}
	buildRequest() {
		let e = {
			requestUri: Fh,
			returnSecureToken: !0
		};
		if (this.pendingToken) e.pendingToken = this.pendingToken;
		else {
			let t = {};
			this.idToken && (t.id_token = this.idToken), this.accessToken && (t.access_token = this.accessToken), this.secret && (t.oauth_token_secret = this.secret), t.providerId = this.providerId, this.nonce && !this.pendingToken && (t.nonce = this.nonce), e.postBody = Qn(t);
		}
		return e;
	}
};
async function Lh(e, t) {
	return am(e, "POST", "/v1/accounts:sendVerificationCode", $(e, t));
}
async function Rh(e, t) {
	return sm(e, "POST", "/v1/accounts:signInWithPhoneNumber", $(e, t));
}
async function zh(e, t) {
	let n = await sm(e, "POST", "/v1/accounts:signInWithPhoneNumber", $(e, t));
	if (n.temporaryProof) throw dm(e, "account-exists-with-different-credential", n);
	return n;
}
var Bh = { USER_NOT_FOUND: "user-not-found" };
async function Vh(e, t) {
	return sm(e, "POST", "/v1/accounts:signInWithPhoneNumber", $(e, Object.assign(Object.assign({}, t), { operation: "REAUTH" })), Bh);
}
var Hh = class e extends Oh {
	constructor(e) {
		super("phone", "phone"), this.params = e;
	}
	static _fromVerification(t, n) {
		return new e({
			verificationId: t,
			verificationCode: n
		});
	}
	static _fromTokenResponse(t, n) {
		return new e({
			phoneNumber: t,
			temporaryProof: n
		});
	}
	_getIdTokenResponse(e) {
		return Rh(e, this._makeVerificationRequest());
	}
	_linkToIdToken(e, t) {
		return zh(e, Object.assign({ idToken: t }, this._makeVerificationRequest()));
	}
	_getReauthenticationResolver(e) {
		return Vh(e, this._makeVerificationRequest());
	}
	_makeVerificationRequest() {
		let { temporaryProof: e, phoneNumber: t, verificationId: n, verificationCode: r } = this.params;
		return e && t ? {
			temporaryProof: e,
			phoneNumber: t
		} : {
			sessionInfo: n,
			code: r
		};
	}
	toJSON() {
		let e = { providerId: this.providerId };
		return this.params.phoneNumber && (e.phoneNumber = this.params.phoneNumber), this.params.temporaryProof && (e.temporaryProof = this.params.temporaryProof), this.params.verificationCode && (e.verificationCode = this.params.verificationCode), this.params.verificationId && (e.verificationId = this.params.verificationId), e;
	}
	static fromJSON(t) {
		typeof t == "string" && (t = JSON.parse(t));
		let { verificationId: n, verificationCode: r, phoneNumber: i, temporaryProof: a } = t;
		return !r && !n && !i && !a ? null : new e({
			verificationId: n,
			verificationCode: r,
			phoneNumber: i,
			temporaryProof: a
		});
	}
};
function Uh(e) {
	switch (e) {
		case "recoverEmail": return "RECOVER_EMAIL";
		case "resetPassword": return "PASSWORD_RESET";
		case "signIn": return "EMAIL_SIGNIN";
		case "verifyEmail": return "VERIFY_EMAIL";
		case "verifyAndChangeEmail": return "VERIFY_AND_CHANGE_EMAIL";
		case "revertSecondFactorAddition": return "REVERT_SECOND_FACTOR_ADDITION";
		default: return null;
	}
}
function Wh(e) {
	let t = $n(er(e)).link, n = t ? $n(er(t)).deep_link_id : null, r = $n(er(e)).deep_link_id;
	return (r ? $n(er(r)).link : null) || r || n || t || e;
}
var Gh = class e {
	constructor(e) {
		let t = $n(er(e)), n = t.apiKey ?? null, r = t.oobCode ?? null, i = Uh(t.mode ?? null);
		Q(n && r && i, "argument-error"), this.apiKey = n, this.operation = i, this.code = r, this.continueUrl = t.continueUrl ?? null, this.languageCode = t.languageCode ?? null, this.tenantId = t.tenantId ?? null;
	}
	static parseLink(t) {
		let n = Wh(t);
		try {
			return new e(n);
		} catch {
			return null;
		}
	}
}, Kh = class e {
	constructor() {
		this.providerId = e.PROVIDER_ID;
	}
	static credential(e, t) {
		return Nh._fromEmailAndPassword(e, t);
	}
	static credentialWithLink(e, t) {
		let n = Gh.parseLink(t);
		return Q(n, "argument-error"), Nh._fromEmailAndCode(e, n.code, n.tenantId);
	}
};
Kh.PROVIDER_ID = "password", Kh.EMAIL_PASSWORD_SIGN_IN_METHOD = "password", Kh.EMAIL_LINK_SIGN_IN_METHOD = "emailLink";
var qh = class {
	constructor(e) {
		this.providerId = e, this.defaultLanguageCode = null, this.customParameters = {};
	}
	setDefaultLanguage(e) {
		this.defaultLanguageCode = e;
	}
	setCustomParameters(e) {
		return this.customParameters = e, this;
	}
	getCustomParameters() {
		return this.customParameters;
	}
}, Jh = class extends qh {
	constructor() {
		super(...arguments), this.scopes = [];
	}
	addScope(e) {
		return this.scopes.includes(e) || this.scopes.push(e), this;
	}
	getScopes() {
		return [...this.scopes];
	}
}, Yh = class e extends Jh {
	constructor() {
		super("facebook.com");
	}
	static credential(t) {
		return Ih._fromParams({
			providerId: e.PROVIDER_ID,
			signInMethod: e.FACEBOOK_SIGN_IN_METHOD,
			accessToken: t
		});
	}
	static credentialFromResult(t) {
		return e.credentialFromTaggedObject(t);
	}
	static credentialFromError(t) {
		return e.credentialFromTaggedObject(t.customData || {});
	}
	static credentialFromTaggedObject({ _tokenResponse: t }) {
		if (!t || !("oauthAccessToken" in t) || !t.oauthAccessToken) return null;
		try {
			return e.credential(t.oauthAccessToken);
		} catch {
			return null;
		}
	}
};
Yh.FACEBOOK_SIGN_IN_METHOD = "facebook.com", Yh.PROVIDER_ID = "facebook.com";
var Xh = class e extends Jh {
	constructor() {
		super("google.com"), this.addScope("profile");
	}
	static credential(t, n) {
		return Ih._fromParams({
			providerId: e.PROVIDER_ID,
			signInMethod: e.GOOGLE_SIGN_IN_METHOD,
			idToken: t,
			accessToken: n
		});
	}
	static credentialFromResult(t) {
		return e.credentialFromTaggedObject(t);
	}
	static credentialFromError(t) {
		return e.credentialFromTaggedObject(t.customData || {});
	}
	static credentialFromTaggedObject({ _tokenResponse: t }) {
		if (!t) return null;
		let { oauthIdToken: n, oauthAccessToken: r } = t;
		if (!n && !r) return null;
		try {
			return e.credential(n, r);
		} catch {
			return null;
		}
	}
};
Xh.GOOGLE_SIGN_IN_METHOD = "google.com", Xh.PROVIDER_ID = "google.com";
var Zh = class e extends Jh {
	constructor() {
		super("github.com");
	}
	static credential(t) {
		return Ih._fromParams({
			providerId: e.PROVIDER_ID,
			signInMethod: e.GITHUB_SIGN_IN_METHOD,
			accessToken: t
		});
	}
	static credentialFromResult(t) {
		return e.credentialFromTaggedObject(t);
	}
	static credentialFromError(t) {
		return e.credentialFromTaggedObject(t.customData || {});
	}
	static credentialFromTaggedObject({ _tokenResponse: t }) {
		if (!t || !("oauthAccessToken" in t) || !t.oauthAccessToken) return null;
		try {
			return e.credential(t.oauthAccessToken);
		} catch {
			return null;
		}
	}
};
Zh.GITHUB_SIGN_IN_METHOD = "github.com", Zh.PROVIDER_ID = "github.com";
var Qh = class e extends Jh {
	constructor() {
		super("twitter.com");
	}
	static credential(t, n) {
		return Ih._fromParams({
			providerId: e.PROVIDER_ID,
			signInMethod: e.TWITTER_SIGN_IN_METHOD,
			oauthToken: t,
			oauthTokenSecret: n
		});
	}
	static credentialFromResult(t) {
		return e.credentialFromTaggedObject(t);
	}
	static credentialFromError(t) {
		return e.credentialFromTaggedObject(t.customData || {});
	}
	static credentialFromTaggedObject({ _tokenResponse: t }) {
		if (!t) return null;
		let { oauthAccessToken: n, oauthTokenSecret: r } = t;
		if (!n || !r) return null;
		try {
			return e.credential(n, r);
		} catch {
			return null;
		}
	}
};
Qh.TWITTER_SIGN_IN_METHOD = "twitter.com", Qh.PROVIDER_ID = "twitter.com";
var $h = class e {
	constructor(e) {
		this.user = e.user, this.providerId = e.providerId, this._tokenResponse = e._tokenResponse, this.operationType = e.operationType;
	}
	static async _fromIdTokenResponse(t, n, r, i = !1) {
		return new e({
			user: await Pm._fromIdTokenResponse(t, r, i),
			providerId: eg(r),
			_tokenResponse: r,
			operationType: n
		});
	}
	static async _forOperation(t, n, r) {
		return await t._updateTokensIfNecessary(r, !0), new e({
			user: t,
			providerId: eg(r),
			_tokenResponse: r,
			operationType: n
		});
	}
};
function eg(e) {
	return e.providerId ? e.providerId : "phoneNumber" in e ? "phone" : null;
}
var tg = class e extends Gn {
	constructor(t, n, r, i) {
		super(n.code, n.message), this.operationType = r, this.user = i, Object.setPrototypeOf(this, e.prototype), this.customData = {
			appName: t.name,
			tenantId: t.tenantId ?? void 0,
			_serverResponse: n.customData._serverResponse,
			operationType: r
		};
	}
	static _fromErrorAndOperation(t, n, r, i) {
		return new e(t, n, r, i);
	}
};
function ng(e, t, n, r) {
	return (t === "reauthenticate" ? n._getReauthenticationResolver(e) : n._getIdTokenResponse(e)).catch((n) => {
		throw n.code === "auth/multi-factor-auth-required" ? tg._fromErrorAndOperation(e, n, t, r) : n;
	});
}
async function rg(e, t, n = !1) {
	let r = await Sm(e, t._linkToIdToken(e.auth, await e.getIdToken()), n);
	return $h._forOperation(e, "link", r);
}
async function ig(e, t, n = !1) {
	let { auth: r } = e;
	if (Ei(r.app)) return Promise.reject(Gp(r));
	let i = "reauthenticate";
	try {
		let a = await Sm(e, ng(r, i, t, e), n);
		Q(a.idToken, r, "internal-error");
		let o = bm(a.idToken);
		Q(o, r, "internal-error");
		let { sub: s } = o;
		return Q(e.uid === s, r, "user-mismatch"), $h._forOperation(e, i, a);
	} catch (e) {
		throw e?.code === "auth/user-not-found" && Hp(r, "user-mismatch"), e;
	}
}
async function ag(e, t, n = !1) {
	if (Ei(e.app)) return Promise.reject(Gp(e));
	let r = "signIn", i = await ng(e, r, t), a = await $h._fromIdTokenResponse(e, r, i);
	return n || await e._updateCurrentUser(a.user), a;
}
async function og(e, t) {
	return sm(e, "POST", "/v1/accounts:signInWithCustomToken", $(e, t));
}
async function sg(e, t) {
	if (Ei(e.app)) return Promise.reject(Gp(e));
	let n = ah(e), r = await og(n, {
		token: t,
		returnSecureToken: !0
	}), i = await $h._fromIdTokenResponse(n, "signIn", r);
	return await n._updateCurrentUser(i.user), i;
}
function cg(e, t, n, r) {
	return j(e).onIdTokenChanged(t, n, r);
}
function lg(e, t, n) {
	return j(e).beforeAuthStateChanged(t, n);
}
function ug(e, t) {
	return am(e, "POST", "/v2/accounts/mfaEnrollment:start", $(e, t));
}
function dg(e, t) {
	return am(e, "POST", "/v2/accounts/mfaEnrollment:finalize", $(e, t));
}
function fg(e, t) {
	return am(e, "POST", "/v2/accounts/mfaEnrollment:start", $(e, t));
}
function pg(e, t) {
	return am(e, "POST", "/v2/accounts/mfaEnrollment:finalize", $(e, t));
}
var mg = "__sak", hg = class {
	constructor(e, t) {
		this.storageRetriever = e, this.type = t;
	}
	_isAvailable() {
		try {
			return this.storage ? (this.storage.setItem(mg, "1"), this.storage.removeItem(mg), Promise.resolve(!0)) : Promise.resolve(!1);
		} catch {
			return Promise.resolve(!1);
		}
	}
	_set(e, t) {
		return this.storage.setItem(e, JSON.stringify(t)), Promise.resolve();
	}
	_get(e) {
		let t = this.storage.getItem(e);
		return Promise.resolve(t ? JSON.parse(t) : null);
	}
	_remove(e) {
		return this.storage.removeItem(e), Promise.resolve();
	}
	get storage() {
		return this.storageRetriever();
	}
}, gg = 1e3, _g = 10, vg = class extends hg {
	constructor() {
		super(() => window.localStorage, "LOCAL"), this.boundEventHandler = (e, t) => this.onStorageEvent(e, t), this.listeners = {}, this.localCache = {}, this.pollTimer = null, this.fallbackToPolling = Qm(), this._shouldAllowMigration = !0;
	}
	forAllChangedKeys(e) {
		for (let t of Object.keys(this.listeners)) {
			let n = this.storage.getItem(t), r = this.localCache[t];
			n !== r && e(t, r, n);
		}
	}
	onStorageEvent(e, t = !1) {
		if (!e.key) {
			this.forAllChangedKeys((e, t, n) => {
				this.notifyListeners(e, n);
			});
			return;
		}
		let n = e.key;
		t ? this.detachListener() : this.stopPolling();
		let r = () => {
			let e = this.storage.getItem(n);
			!t && this.localCache[n] === e || this.notifyListeners(n, e);
		}, i = this.storage.getItem(n);
		Zm() && i !== e.newValue && e.newValue !== e.oldValue ? setTimeout(r, _g) : r();
	}
	notifyListeners(e, t) {
		this.localCache[e] = t;
		let n = this.listeners[e];
		if (n) for (let e of Array.from(n)) e(t && JSON.parse(t));
	}
	startPolling() {
		this.stopPolling(), this.pollTimer = setInterval(() => {
			this.forAllChangedKeys((e, t, n) => {
				this.onStorageEvent(new StorageEvent("storage", {
					key: e,
					oldValue: t,
					newValue: n
				}), !0);
			});
		}, gg);
	}
	stopPolling() {
		this.pollTimer &&= (clearInterval(this.pollTimer), null);
	}
	attachListener() {
		window.addEventListener("storage", this.boundEventHandler);
	}
	detachListener() {
		window.removeEventListener("storage", this.boundEventHandler);
	}
	_addListener(e, t) {
		Object.keys(this.listeners).length === 0 && (this.fallbackToPolling ? this.startPolling() : this.attachListener()), this.listeners[e] || (this.listeners[e] = /* @__PURE__ */ new Set(), this.localCache[e] = this.storage.getItem(e)), this.listeners[e].add(t);
	}
	_removeListener(e, t) {
		this.listeners[e] && (this.listeners[e].delete(t), this.listeners[e].size === 0 && delete this.listeners[e]), Object.keys(this.listeners).length === 0 && (this.detachListener(), this.stopPolling());
	}
	async _set(e, t) {
		await super._set(e, t), this.localCache[e] = JSON.stringify(t);
	}
	async _get(e) {
		let t = await super._get(e);
		return this.localCache[e] = JSON.stringify(t), t;
	}
	async _remove(e) {
		await super._remove(e), delete this.localCache[e];
	}
};
vg.type = "LOCAL";
var yg = vg, bg = class extends hg {
	constructor() {
		super(() => window.sessionStorage, "SESSION");
	}
	_addListener(e, t) {}
	_removeListener(e, t) {}
};
bg.type = "SESSION";
var xg = bg;
function Sg(e) {
	return Promise.all(e.map(async (e) => {
		try {
			return {
				fulfilled: !0,
				value: await e
			};
		} catch (e) {
			return {
				fulfilled: !1,
				reason: e
			};
		}
	}));
}
var Cg = class e {
	constructor(e) {
		this.eventTarget = e, this.handlersMap = {}, this.boundEventHandler = this.handleEvent.bind(this);
	}
	static _getInstance(t) {
		let n = this.receivers.find((e) => e.isListeningto(t));
		if (n) return n;
		let r = new e(t);
		return this.receivers.push(r), r;
	}
	isListeningto(e) {
		return this.eventTarget === e;
	}
	async handleEvent(e) {
		let t = e, { eventId: n, eventType: r, data: i } = t.data, a = this.handlersMap[r];
		if (!a?.size) return;
		t.ports[0].postMessage({
			status: "ack",
			eventId: n,
			eventType: r
		});
		let o = await Sg(Array.from(a).map(async (e) => e(t.origin, i)));
		t.ports[0].postMessage({
			status: "done",
			eventId: n,
			eventType: r,
			response: o
		});
	}
	_subscribe(e, t) {
		Object.keys(this.handlersMap).length === 0 && this.eventTarget.addEventListener("message", this.boundEventHandler), this.handlersMap[e] || (this.handlersMap[e] = /* @__PURE__ */ new Set()), this.handlersMap[e].add(t);
	}
	_unsubscribe(e, t) {
		this.handlersMap[e] && t && this.handlersMap[e].delete(t), (!t || this.handlersMap[e].size === 0) && delete this.handlersMap[e], Object.keys(this.handlersMap).length === 0 && this.eventTarget.removeEventListener("message", this.boundEventHandler);
	}
};
Cg.receivers = [];
function wg(e = "", t = 10) {
	let n = "";
	for (let e = 0; e < t; e++) n += Math.floor(Math.random() * 10);
	return e + n;
}
var Tg = class {
	constructor(e) {
		this.target = e, this.handlers = /* @__PURE__ */ new Set();
	}
	removeMessageHandler(e) {
		e.messageChannel && (e.messageChannel.port1.removeEventListener("message", e.onMessage), e.messageChannel.port1.close()), this.handlers.delete(e);
	}
	async _send(e, t, n = 50) {
		let r = typeof MessageChannel < "u" ? new MessageChannel() : null;
		if (!r) throw Error("connection_unavailable");
		let i, a;
		return new Promise((o, s) => {
			let c = wg("", 20);
			r.port1.start();
			let l = setTimeout(() => {
				s(/* @__PURE__ */ Error("unsupported_event"));
			}, n);
			a = {
				messageChannel: r,
				onMessage(e) {
					let t = e;
					if (t.data.eventId === c) switch (t.data.status) {
						case "ack":
							clearTimeout(l), i = setTimeout(() => {
								s(/* @__PURE__ */ Error("timeout"));
							}, 3e3);
							break;
						case "done":
							clearTimeout(i), o(t.data.response);
							break;
						default:
							clearTimeout(l), clearTimeout(i), s(/* @__PURE__ */ Error("invalid_response"));
							break;
					}
				}
			}, this.handlers.add(a), r.port1.addEventListener("message", a.onMessage), this.target.postMessage({
				eventType: e,
				eventId: c,
				data: t
			}, [r.port2]);
		}).finally(() => {
			a && this.removeMessageHandler(a);
		});
	}
};
function Eg() {
	return window;
}
function Dg(e) {
	Eg().location.href = e;
}
function Og() {
	return Eg().WorkerGlobalScope !== void 0 && typeof Eg().importScripts == "function";
}
async function kg() {
	if (!(navigator != null && navigator.serviceWorker)) return null;
	try {
		return (await navigator.serviceWorker.ready).active;
	} catch {
		return null;
	}
}
function Ag() {
	return (navigator == null ? void 0 : navigator.serviceWorker)?.controller || null;
}
function jg() {
	return Og() ? self : null;
}
var Mg = "firebaseLocalStorageDb", Ng = 1, Pg = "firebaseLocalStorage", Fg = "fbase_key", Ig = class {
	constructor(e) {
		this.request = e;
	}
	toPromise() {
		return new Promise((e, t) => {
			this.request.addEventListener("success", () => {
				e(this.request.result);
			}), this.request.addEventListener("error", () => {
				t(this.request.error);
			});
		});
	}
};
function Lg(e, t) {
	return e.transaction([Pg], t ? "readwrite" : "readonly").objectStore(Pg);
}
function Rg() {
	return new Ig(indexedDB.deleteDatabase(Mg)).toPromise();
}
function zg() {
	let e = indexedDB.open(Mg, Ng);
	return new Promise((t, n) => {
		e.addEventListener("error", () => {
			n(e.error);
		}), e.addEventListener("upgradeneeded", () => {
			let t = e.result;
			try {
				t.createObjectStore(Pg, { keyPath: Fg });
			} catch (e) {
				n(e);
			}
		}), e.addEventListener("success", async () => {
			let n = e.result;
			n.objectStoreNames.contains(Pg) ? t(n) : (n.close(), await Rg(), t(await zg()));
		});
	});
}
async function Bg(e, t, n) {
	return new Ig(Lg(e, !0).put({
		[Fg]: t,
		value: n
	})).toPromise();
}
async function Vg(e, t) {
	let n = await new Ig(Lg(e, !1).get(t)).toPromise();
	return n === void 0 ? null : n.value;
}
function Hg(e, t) {
	return new Ig(Lg(e, !0).delete(t)).toPromise();
}
var Ug = 800, Wg = 3, Gg = class {
	constructor() {
		this.type = "LOCAL", this._shouldAllowMigration = !0, this.listeners = {}, this.localCache = {}, this.pollTimer = null, this.pendingWrites = 0, this.receiver = null, this.sender = null, this.serviceWorkerReceiverAvailable = !1, this.activeServiceWorker = null, this._workerInitializationPromise = this.initializeServiceWorkerMessaging().then(() => {}, () => {});
	}
	async _openDb() {
		return this.db ||= await zg(), this.db;
	}
	async _withRetries(e) {
		let t = 0;
		for (;;) try {
			return await e(await this._openDb());
		} catch (e) {
			if (t++ > Wg) throw e;
			this.db &&= (this.db.close(), void 0);
		}
	}
	async initializeServiceWorkerMessaging() {
		return Og() ? this.initializeReceiver() : this.initializeSender();
	}
	async initializeReceiver() {
		this.receiver = Cg._getInstance(jg()), this.receiver._subscribe("keyChanged", async (e, t) => ({ keyProcessed: (await this._poll()).includes(t.key) })), this.receiver._subscribe("ping", async (e, t) => ["keyChanged"]);
	}
	async initializeSender() {
		if (this.activeServiceWorker = await kg(), !this.activeServiceWorker) return;
		this.sender = new Tg(this.activeServiceWorker);
		let e = await this.sender._send("ping", {}, 800);
		e && e[0]?.fulfilled && e[0]?.value.includes("keyChanged") && (this.serviceWorkerReceiverAvailable = !0);
	}
	async notifyServiceWorker(e) {
		if (!(!this.sender || !this.activeServiceWorker || Ag() !== this.activeServiceWorker)) try {
			await this.sender._send("keyChanged", { key: e }, this.serviceWorkerReceiverAvailable ? 800 : 50);
		} catch {}
	}
	async _isAvailable() {
		try {
			if (!indexedDB) return !1;
			let e = await zg();
			return await Bg(e, mg, "1"), await Hg(e, mg), !0;
		} catch {}
		return !1;
	}
	async _withPendingWrite(e) {
		this.pendingWrites++;
		try {
			await e();
		} finally {
			this.pendingWrites--;
		}
	}
	async _set(e, t) {
		return this._withPendingWrite(async () => (await this._withRetries((n) => Bg(n, e, t)), this.localCache[e] = t, this.notifyServiceWorker(e)));
	}
	async _get(e) {
		let t = await this._withRetries((t) => Vg(t, e));
		return this.localCache[e] = t, t;
	}
	async _remove(e) {
		return this._withPendingWrite(async () => (await this._withRetries((t) => Hg(t, e)), delete this.localCache[e], this.notifyServiceWorker(e)));
	}
	async _poll() {
		let e = await this._withRetries((e) => new Ig(Lg(e, !1).getAll()).toPromise());
		if (!e || this.pendingWrites !== 0) return [];
		let t = [], n = /* @__PURE__ */ new Set();
		if (e.length !== 0) for (let { fbase_key: r, value: i } of e) n.add(r), JSON.stringify(this.localCache[r]) !== JSON.stringify(i) && (this.notifyListeners(r, i), t.push(r));
		for (let e of Object.keys(this.localCache)) this.localCache[e] && !n.has(e) && (this.notifyListeners(e, null), t.push(e));
		return t;
	}
	notifyListeners(e, t) {
		this.localCache[e] = t;
		let n = this.listeners[e];
		if (n) for (let e of Array.from(n)) e(t);
	}
	startPolling() {
		this.stopPolling(), this.pollTimer = setInterval(async () => this._poll(), Ug);
	}
	stopPolling() {
		this.pollTimer &&= (clearInterval(this.pollTimer), null);
	}
	_addListener(e, t) {
		Object.keys(this.listeners).length === 0 && this.startPolling(), this.listeners[e] || (this.listeners[e] = /* @__PURE__ */ new Set(), this._get(e)), this.listeners[e].add(t);
	}
	_removeListener(e, t) {
		this.listeners[e] && (this.listeners[e].delete(t), this.listeners[e].size === 0 && delete this.listeners[e]), Object.keys(this.listeners).length === 0 && this.stopPolling();
	}
};
Gg.type = "LOCAL";
var Kg = Gg;
function qg(e, t) {
	return am(e, "POST", "/v2/accounts/mfaSignIn:start", $(e, t));
}
function Jg(e, t) {
	return am(e, "POST", "/v2/accounts/mfaSignIn:finalize", $(e, t));
}
function Yg(e, t) {
	return am(e, "POST", "/v2/accounts/mfaSignIn:finalize", $(e, t));
}
fh("rcb"), new em(3e4, 6e4);
var Xg = "recaptcha";
async function Zg(e, t, n) {
	if (!e._getRecaptchaConfig()) try {
		await bh(e);
	} catch {
		console.log("Failed to initialize reCAPTCHA Enterprise config. Triggering the reCAPTCHA v2 verification.");
	}
	try {
		let r;
		if (r = typeof t == "string" ? { phoneNumber: t } : t, "session" in r) {
			let t = r.session;
			if ("phoneNumber" in r) return Q(t.type === "enroll", e, "internal-error"), (await yh(e, {
				idToken: t.credential,
				phoneEnrollmentInfo: {
					phoneNumber: r.phoneNumber,
					clientType: "CLIENT_TYPE_WEB"
				}
			}, "mfaSmsEnrollment", async (e, t) => t.phoneEnrollmentInfo.captchaResponse === gh ? (Q(n?.type === Xg, e, "argument-error"), ug(e, await Qg(e, t, n))) : ug(e, t), "PHONE_PROVIDER").catch((e) => Promise.reject(e))).phoneSessionInfo.sessionInfo;
			{
				Q(t.type === "signin", e, "internal-error");
				let i = r.multiFactorHint?.uid || r.multiFactorUid;
				return Q(i, e, "missing-multi-factor-info"), (await yh(e, {
					mfaPendingCredential: t.credential,
					mfaEnrollmentId: i,
					phoneSignInInfo: { clientType: "CLIENT_TYPE_WEB" }
				}, "mfaSmsSignIn", async (e, t) => t.phoneSignInInfo.captchaResponse === gh ? (Q(n?.type === Xg, e, "argument-error"), qg(e, await Qg(e, t, n))) : qg(e, t), "PHONE_PROVIDER").catch((e) => Promise.reject(e))).phoneResponseInfo.sessionInfo;
			}
		} else return (await yh(e, {
			phoneNumber: r.phoneNumber,
			clientType: "CLIENT_TYPE_WEB"
		}, "sendVerificationCode", async (e, t) => t.captchaResponse === gh ? (Q(n?.type === Xg, e, "argument-error"), Lh(e, await Qg(e, t, n))) : Lh(e, t), "PHONE_PROVIDER").catch((e) => Promise.reject(e))).sessionInfo;
	} finally {
		n?._reset();
	}
}
async function Qg(e, t, n) {
	Q(n.type === Xg, e, "argument-error");
	let r = await n.verify();
	Q(typeof r == "string", e, "argument-error");
	let i = Object.assign({}, t);
	if ("phoneEnrollmentInfo" in i) {
		let e = i.phoneEnrollmentInfo.phoneNumber, t = i.phoneEnrollmentInfo.captchaResponse, n = i.phoneEnrollmentInfo.clientType, a = i.phoneEnrollmentInfo.recaptchaVersion;
		return Object.assign(i, { phoneEnrollmentInfo: {
			phoneNumber: e,
			recaptchaToken: r,
			captchaResponse: t,
			clientType: n,
			recaptchaVersion: a
		} }), i;
	} else if ("phoneSignInInfo" in i) {
		let e = i.phoneSignInInfo.captchaResponse, t = i.phoneSignInInfo.clientType, n = i.phoneSignInInfo.recaptchaVersion;
		return Object.assign(i, { phoneSignInInfo: {
			recaptchaToken: r,
			captchaResponse: e,
			clientType: t,
			recaptchaVersion: n
		} }), i;
	} else return Object.assign(i, { recaptchaToken: r }), i;
}
var $g = class e {
	constructor(t) {
		this.providerId = e.PROVIDER_ID, this.auth = ah(t);
	}
	verifyPhoneNumber(e, t) {
		return Zg(this.auth, e, j(t));
	}
	static credential(e, t) {
		return Hh._fromVerification(e, t);
	}
	static credentialFromResult(t) {
		let n = t;
		return e.credentialFromTaggedObject(n);
	}
	static credentialFromError(t) {
		return e.credentialFromTaggedObject(t.customData || {});
	}
	static credentialFromTaggedObject({ _tokenResponse: e }) {
		if (!e) return null;
		let { phoneNumber: t, temporaryProof: n } = e;
		return t && n ? Hh._fromTokenResponse(t, n) : null;
	}
};
$g.PROVIDER_ID = "phone", $g.PHONE_SIGN_IN_METHOD = "phone";
function e_(e, t) {
	return t ? Im(t) : (Q(e._popupRedirectResolver, e, "argument-error"), e._popupRedirectResolver);
}
var t_ = class extends Oh {
	constructor(e) {
		super("custom", "custom"), this.params = e;
	}
	_getIdTokenResponse(e) {
		return Ph(e, this._buildIdpRequest());
	}
	_linkToIdToken(e, t) {
		return Ph(e, this._buildIdpRequest(t));
	}
	_getReauthenticationResolver(e) {
		return Ph(e, this._buildIdpRequest());
	}
	_buildIdpRequest(e) {
		let t = {
			requestUri: this.params.requestUri,
			sessionId: this.params.sessionId,
			postBody: this.params.postBody,
			tenantId: this.params.tenantId,
			pendingToken: this.params.pendingToken,
			returnSecureToken: !0,
			returnIdpCredential: !0
		};
		return e && (t.idToken = e), t;
	}
};
function n_(e) {
	return ag(e.auth, new t_(e), e.bypassAuthState);
}
function r_(e) {
	let { auth: t, user: n } = e;
	return Q(n, t, "internal-error"), ig(n, new t_(e), e.bypassAuthState);
}
async function i_(e) {
	let { auth: t, user: n } = e;
	return Q(n, t, "internal-error"), rg(n, new t_(e), e.bypassAuthState);
}
var a_ = class {
	constructor(e, t, n, r, i = !1) {
		this.auth = e, this.resolver = n, this.user = r, this.bypassAuthState = i, this.pendingPromise = null, this.eventManager = null, this.filter = Array.isArray(t) ? t : [t];
	}
	execute() {
		return new Promise(async (e, t) => {
			this.pendingPromise = {
				resolve: e,
				reject: t
			};
			try {
				this.eventManager = await this.resolver._initialize(this.auth), await this.onExecution(), this.eventManager.registerConsumer(this);
			} catch (e) {
				this.reject(e);
			}
		});
	}
	async onAuthEvent(e) {
		let { urlResponse: t, sessionId: n, postBody: r, tenantId: i, error: a, type: o } = e;
		if (a) {
			this.reject(a);
			return;
		}
		let s = {
			auth: this.auth,
			requestUri: t,
			sessionId: n,
			tenantId: i || void 0,
			postBody: r || void 0,
			user: this.user,
			bypassAuthState: this.bypassAuthState
		};
		try {
			this.resolve(await this.getIdpTask(o)(s));
		} catch (e) {
			this.reject(e);
		}
	}
	onError(e) {
		this.reject(e);
	}
	getIdpTask(e) {
		switch (e) {
			case "signInViaPopup":
			case "signInViaRedirect": return n_;
			case "linkViaPopup":
			case "linkViaRedirect": return i_;
			case "reauthViaPopup":
			case "reauthViaRedirect": return r_;
			default: Hp(this.auth, "internal-error");
		}
	}
	resolve(e) {
		Jp(this.pendingPromise, "Pending promise was never set"), this.pendingPromise.resolve(e), this.unregisterAndCleanUp();
	}
	reject(e) {
		Jp(this.pendingPromise, "Pending promise was never set"), this.pendingPromise.reject(e), this.unregisterAndCleanUp();
	}
	unregisterAndCleanUp() {
		this.eventManager && this.eventManager.unregisterConsumer(this), this.pendingPromise = null, this.cleanUp();
	}
}, o_ = new em(2e3, 1e4), s_ = class e extends a_ {
	constructor(t, n, r, i, a) {
		super(t, n, i, a), this.provider = r, this.authWindow = null, this.pollId = null, e.currentPopupAction && e.currentPopupAction.cancel(), e.currentPopupAction = this;
	}
	async executeNotNull() {
		let e = await this.execute();
		return Q(e, this.auth, "internal-error"), e;
	}
	async onExecution() {
		Jp(this.filter.length === 1, "Popup operations only handle one event");
		let e = wg();
		this.authWindow = await this.resolver._openPopup(this.auth, this.provider, this.filter[0], e), this.authWindow.associatedEvent = e, this.resolver._originValidation(this.auth).catch((e) => {
			this.reject(e);
		}), this.resolver._isIframeWebStorageSupported(this.auth, (e) => {
			e || this.reject(Up(this.auth, "web-storage-unsupported"));
		}), this.pollUserCancellation();
	}
	get eventId() {
		return this.authWindow?.associatedEvent || null;
	}
	cancel() {
		this.reject(Up(this.auth, "cancelled-popup-request"));
	}
	cleanUp() {
		this.authWindow && this.authWindow.close(), this.pollId && window.clearTimeout(this.pollId), this.authWindow = null, this.pollId = null, e.currentPopupAction = null;
	}
	pollUserCancellation() {
		let e = () => {
			if (this.authWindow?.window?.closed) {
				this.pollId = window.setTimeout(() => {
					this.pollId = null, this.reject(Up(this.auth, "popup-closed-by-user"));
				}, 8e3);
				return;
			}
			this.pollId = window.setTimeout(e, o_.get());
		};
		e();
	}
};
s_.currentPopupAction = null;
var c_ = "pendingRedirect", l_ = /* @__PURE__ */ new Map(), u_ = class extends a_ {
	constructor(e, t, n = !1) {
		super(e, [
			"signInViaRedirect",
			"linkViaRedirect",
			"reauthViaRedirect",
			"unknown"
		], t, void 0, n), this.eventId = null;
	}
	async execute() {
		let e = l_.get(this.auth._key());
		if (!e) {
			try {
				let t = await d_(this.resolver, this.auth) ? await super.execute() : null;
				e = () => Promise.resolve(t);
			} catch (t) {
				e = () => Promise.reject(t);
			}
			l_.set(this.auth._key(), e);
		}
		return this.bypassAuthState || l_.set(this.auth._key(), () => Promise.resolve(null)), e();
	}
	async onAuthEvent(e) {
		if (e.type === "signInViaRedirect") return super.onAuthEvent(e);
		if (e.type === "unknown") {
			this.resolve(null);
			return;
		}
		if (e.eventId) {
			let t = await this.auth._redirectUserForId(e.eventId);
			if (t) return this.user = t, super.onAuthEvent(e);
			this.resolve(null);
		}
	}
	async onExecution() {}
	cleanUp() {}
};
async function d_(e, t) {
	let n = m_(t), r = p_(e);
	if (!await r._isAvailable()) return !1;
	let i = await r._get(n) === "true";
	return await r._remove(n), i;
}
function f_(e, t) {
	l_.set(e._key(), t);
}
function p_(e) {
	return Im(e._redirectPersistence);
}
function m_(e) {
	return zm(c_, e.config.apiKey, e.name);
}
async function h_(e, t, n = !1) {
	if (Ei(e.app)) return Promise.reject(Gp(e));
	let r = ah(e), i = await new u_(r, e_(r, t), n).execute();
	return i && !n && (delete i.user._redirectEventId, await r._persistUserIfCurrent(i.user), await r._setRedirectUser(null, t)), i;
}
var g_ = 600 * 1e3, __ = class {
	constructor(e) {
		this.auth = e, this.cachedEventUids = /* @__PURE__ */ new Set(), this.consumers = /* @__PURE__ */ new Set(), this.queuedRedirectEvent = null, this.hasHandledPotentialRedirect = !1, this.lastProcessedEventTime = Date.now();
	}
	registerConsumer(e) {
		this.consumers.add(e), this.queuedRedirectEvent && this.isEventForConsumer(this.queuedRedirectEvent, e) && (this.sendToConsumer(this.queuedRedirectEvent, e), this.saveEventToCache(this.queuedRedirectEvent), this.queuedRedirectEvent = null);
	}
	unregisterConsumer(e) {
		this.consumers.delete(e);
	}
	onEvent(e) {
		if (this.hasEventBeenHandled(e)) return !1;
		let t = !1;
		return this.consumers.forEach((n) => {
			this.isEventForConsumer(e, n) && (t = !0, this.sendToConsumer(e, n), this.saveEventToCache(e));
		}), this.hasHandledPotentialRedirect || !b_(e) ? t : (this.hasHandledPotentialRedirect = !0, t ||= (this.queuedRedirectEvent = e, !0), t);
	}
	sendToConsumer(e, t) {
		if (e.error && !y_(e)) {
			let n = e.error.code?.split("auth/")[1] || "internal-error";
			t.onError(Up(this.auth, n));
		} else t.onAuthEvent(e);
	}
	isEventForConsumer(e, t) {
		let n = t.eventId === null || !!e.eventId && e.eventId === t.eventId;
		return t.filter.includes(e.type) && n;
	}
	hasEventBeenHandled(e) {
		return Date.now() - this.lastProcessedEventTime >= g_ && this.cachedEventUids.clear(), this.cachedEventUids.has(v_(e));
	}
	saveEventToCache(e) {
		this.cachedEventUids.add(v_(e)), this.lastProcessedEventTime = Date.now();
	}
};
function v_(e) {
	return [
		e.type,
		e.eventId,
		e.sessionId,
		e.tenantId
	].filter((e) => e).join("-");
}
function y_({ type: e, error: t }) {
	return e === "unknown" && t?.code === "auth/no-auth-event";
}
function b_(e) {
	switch (e.type) {
		case "signInViaRedirect":
		case "linkViaRedirect":
		case "reauthViaRedirect": return !0;
		case "unknown": return y_(e);
		default: return !1;
	}
}
async function x_(e, t = {}) {
	return am(e, "GET", "/v1/projects", t);
}
var S_ = /^\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}$/, C_ = /^https?/;
async function w_(e) {
	if (e.config.emulator) return;
	let { authorizedDomains: t } = await x_(e);
	for (let e of t) try {
		if (T_(e)) return;
	} catch {}
	Hp(e, "unauthorized-domain");
}
function T_(e) {
	let t = Yp(), { protocol: n, hostname: r } = new URL(t);
	if (e.startsWith("chrome-extension://")) {
		let i = new URL(e);
		return i.hostname === "" && r === "" ? n === "chrome-extension:" && e.replace("chrome-extension://", "") === t.replace("chrome-extension://", "") : n === "chrome-extension:" && i.hostname === r;
	}
	if (!C_.test(n)) return !1;
	if (S_.test(e)) return r === e;
	let i = e.replace(/\./g, "\\.");
	return RegExp("^(.+\\." + i + "|" + i + ")$", "i").test(r);
}
var E_ = new em(3e4, 6e4);
function D_() {
	let e = Eg().___jsl;
	if (e?.H) {
		for (let t of Object.keys(e.H)) if (e.H[t].r = e.H[t].r || [], e.H[t].L = e.H[t].L || [], e.H[t].r = [...e.H[t].L], e.CP) for (let t = 0; t < e.CP.length; t++) e.CP[t] = null;
	}
}
function O_(e) {
	return new Promise((t, n) => {
		function r() {
			D_(), gapi.load("gapi.iframes", {
				callback: () => {
					t(gapi.iframes.getContext());
				},
				ontimeout: () => {
					D_(), n(Up(e, "network-request-failed"));
				},
				timeout: E_.get()
			});
		}
		if (Eg().gapi?.iframes?.Iframe) t(gapi.iframes.getContext());
		else if (Eg().gapi?.load) r();
		else {
			let t = fh("iframefcb");
			return Eg()[t] = () => {
				gapi.load ? r() : n(Up(e, "network-request-failed"));
			}, lh(`${dh()}?onload=${t}`).catch((e) => n(e));
		}
	}).catch((e) => {
		throw k_ = null, e;
	});
}
var k_ = null;
function A_(e) {
	return k_ ||= O_(e), k_;
}
var j_ = new em(5e3, 15e3), M_ = "__/auth/iframe", N_ = "emulator/auth/iframe", P_ = {
	style: {
		position: "absolute",
		top: "-100px",
		width: "1px",
		height: "1px"
	},
	"aria-hidden": "true",
	tabindex: "-1"
}, F_ = new Map([
	["identitytoolkit.googleapis.com", "p"],
	["staging-identitytoolkit.sandbox.googleapis.com", "s"],
	["test-identitytoolkit.sandbox.googleapis.com", "t"]
]);
function I_(e) {
	let t = e.config;
	Q(t.authDomain, e, "auth-domain-config-required");
	let n = t.emulator ? tm(t, N_) : `https://${e.config.authDomain}/${M_}`, r = {
		apiKey: t.apiKey,
		appName: e.name,
		v: ki
	}, i = F_.get(e.config.apiHost);
	i && (r.eid = i);
	let a = e._getFrameworks();
	return a.length && (r.fw = a.join(",")), `${n}?${Qn(r).slice(1)}`;
}
async function L_(e) {
	let t = await A_(e), n = Eg().gapi;
	return Q(n, e, "internal-error"), t.open({
		where: document.body,
		url: I_(e),
		messageHandlersFilter: n.iframes.CROSS_ORIGIN_IFRAMES_FILTER,
		attributes: P_,
		dontclear: !0
	}, (t) => new Promise(async (n, r) => {
		await t.restyle({ setHideOnLeave: !1 });
		let i = Up(e, "network-request-failed"), a = Eg().setTimeout(() => {
			r(i);
		}, j_.get());
		function o() {
			Eg().clearTimeout(a), n(t);
		}
		t.ping(o).then(o, () => {
			r(i);
		});
	}));
}
var R_ = {
	location: "yes",
	resizable: "yes",
	statusbar: "yes",
	toolbar: "no"
}, z_ = 500, B_ = 600, V_ = "_blank", H_ = "http://localhost", U_ = class {
	constructor(e) {
		this.window = e, this.associatedEvent = null;
	}
	close() {
		if (this.window) try {
			this.window.close();
		} catch {}
	}
};
function W_(e, t, n, r = z_, i = B_) {
	let a = Math.max((window.screen.availHeight - i) / 2, 0).toString(), o = Math.max((window.screen.availWidth - r) / 2, 0).toString(), s = "", c = Object.assign(Object.assign({}, R_), {
		width: r.toString(),
		height: i.toString(),
		top: a,
		left: o
	}), l = A().toLowerCase();
	n && (s = Wm(l) ? V_ : n), Hm(l) && (t ||= H_, c.scrollbars = "yes");
	let u = Object.entries(c).reduce((e, [t, n]) => `${e}${t}=${n},`, "");
	if (Xm(l) && s !== "_self") return G_(t || "", s), new U_(null);
	let d = window.open(t || "", s, u);
	Q(d, e, "popup-blocked");
	try {
		d.focus();
	} catch {}
	return new U_(d);
}
function G_(e, t) {
	let n = document.createElement("a");
	n.href = e, n.target = t;
	let r = document.createEvent("MouseEvent");
	r.initMouseEvent("click", !0, !0, window, 1, 0, 0, 0, 0, !1, !1, !1, !1, 1, null), n.dispatchEvent(r);
}
var K_ = "__/auth/handler", q_ = "emulator/auth/handler", J_ = "fac";
async function Y_(e, t, n, r, i, a) {
	Q(e.config.authDomain, e, "auth-domain-config-required"), Q(e.config.apiKey, e, "invalid-api-key");
	let o = {
		apiKey: e.config.apiKey,
		appName: e.name,
		authType: n,
		redirectUrl: r,
		v: ki,
		eventId: i
	};
	if (t instanceof qh) {
		t.setDefaultLanguage(e.languageCode), o.providerId = t.providerId || "", Yn(t.getCustomParameters()) || (o.customParameters = JSON.stringify(t.getCustomParameters()));
		for (let [e, t] of Object.entries(a || {})) o[e] = t;
	}
	if (t instanceof Jh) {
		let e = t.getScopes().filter((e) => e !== "");
		e.length > 0 && (o.scopes = e.join(","));
	}
	e.tenantId && (o.tid = e.tenantId);
	let s = o;
	for (let e of Object.keys(s)) s[e] === void 0 && delete s[e];
	let c = await e._getAppCheckToken(), l = c ? `#${J_}=${encodeURIComponent(c)}` : "";
	return `${X_(e)}?${Qn(s).slice(1)}${l}`;
}
function X_({ config: e }) {
	return e.emulator ? tm(e, q_) : `https://${e.authDomain}/${K_}`;
}
var Z_ = "webStorageSupport", Q_ = class {
	constructor() {
		this.eventManagers = {}, this.iframes = {}, this.originValidationPromises = {}, this._redirectPersistence = xg, this._completeRedirectFn = h_, this._overrideRedirectResult = f_;
	}
	async _openPopup(e, t, n, r) {
		return Jp(this.eventManagers[e._key()]?.manager, "_initialize() not called before _openPopup()"), W_(e, await Y_(e, t, n, Yp(), r), wg());
	}
	async _openRedirect(e, t, n, r) {
		return await this._originValidation(e), Dg(await Y_(e, t, n, Yp(), r)), new Promise(() => {});
	}
	_initialize(e) {
		let t = e._key();
		if (this.eventManagers[t]) {
			let { manager: e, promise: n } = this.eventManagers[t];
			return e ? Promise.resolve(e) : (Jp(n, "If manager is not set, promise should be"), n);
		}
		let n = this.initAndGetManager(e);
		return this.eventManagers[t] = { promise: n }, n.catch(() => {
			delete this.eventManagers[t];
		}), n;
	}
	async initAndGetManager(e) {
		let t = await L_(e), n = new __(e);
		return t.register("authEvent", (t) => (Q(t?.authEvent, e, "invalid-auth-event"), { status: n.onEvent(t.authEvent) ? "ACK" : "ERROR" }), gapi.iframes.CROSS_ORIGIN_IFRAMES_FILTER), this.eventManagers[e._key()] = { manager: n }, this.iframes[e._key()] = t, n;
	}
	_isIframeWebStorageSupported(e, t) {
		this.iframes[e._key()].send(Z_, { type: Z_ }, (n) => {
			let r = n?.[0]?.[Z_];
			r !== void 0 && t(!!r), Hp(e, "internal-error");
		}, gapi.iframes.CROSS_ORIGIN_IFRAMES_FILTER);
	}
	_originValidation(e) {
		let t = e._key();
		return this.originValidationPromises[t] || (this.originValidationPromises[t] = w_(e)), this.originValidationPromises[t];
	}
	get _shouldInitProactively() {
		return Qm() || Um() || Ym();
	}
}, $_ = class {
	constructor(e) {
		this.factorId = e;
	}
	_process(e, t, n) {
		switch (t.type) {
			case "enroll": return this._finalizeEnroll(e, t.credential, n);
			case "signin": return this._finalizeSignIn(e, t.credential);
			default: return qp("unexpected MultiFactorSessionType");
		}
	}
}, ev = class e extends $_ {
	constructor(e) {
		super("phone"), this.credential = e;
	}
	static _fromCredential(t) {
		return new e(t);
	}
	_finalizeEnroll(e, t, n) {
		return dg(e, {
			idToken: t,
			displayName: n,
			phoneVerificationInfo: this.credential._makeVerificationRequest()
		});
	}
	_finalizeSignIn(e, t) {
		return Jg(e, {
			mfaPendingCredential: t,
			phoneVerificationInfo: this.credential._makeVerificationRequest()
		});
	}
}, tv = class {
	constructor() {}
	static assertion(e) {
		return ev._fromCredential(e);
	}
};
tv.FACTOR_ID = "phone";
var nv = class {
	static assertionForEnrollment(e, t) {
		return rv._fromSecret(e, t);
	}
	static assertionForSignIn(e, t) {
		return rv._fromEnrollmentId(e, t);
	}
	static async generateSecret(e) {
		let t = e;
		Q(t.user?.auth !== void 0, "internal-error");
		let n = await fg(t.user.auth, {
			idToken: t.credential,
			totpEnrollmentInfo: {}
		});
		return iv._fromStartTotpMfaEnrollmentResponse(n, t.user.auth);
	}
};
nv.FACTOR_ID = "totp";
var rv = class e extends $_ {
	constructor(e, t, n) {
		super("totp"), this.otp = e, this.enrollmentId = t, this.secret = n;
	}
	static _fromSecret(t, n) {
		return new e(n, void 0, t);
	}
	static _fromEnrollmentId(t, n) {
		return new e(n, t);
	}
	async _finalizeEnroll(e, t, n) {
		return Q(this.secret !== void 0, e, "argument-error"), pg(e, {
			idToken: t,
			displayName: n,
			totpVerificationInfo: this.secret._makeTotpVerificationInfo(this.otp)
		});
	}
	async _finalizeSignIn(e, t) {
		Q(this.enrollmentId !== void 0 && this.otp !== void 0, e, "argument-error");
		let n = { verificationCode: this.otp };
		return Yg(e, {
			mfaPendingCredential: t,
			mfaEnrollmentId: this.enrollmentId,
			totpVerificationInfo: n
		});
	}
}, iv = class e {
	constructor(e, t, n, r, i, a, o) {
		this.sessionInfo = a, this.auth = o, this.secretKey = e, this.hashingAlgorithm = t, this.codeLength = n, this.codeIntervalSeconds = r, this.enrollmentCompletionDeadline = i;
	}
	static _fromStartTotpMfaEnrollmentResponse(t, n) {
		return new e(t.totpSessionInfo.sharedSecretKey, t.totpSessionInfo.hashingAlgorithm, t.totpSessionInfo.verificationCodeLength, t.totpSessionInfo.periodSec, new Date(t.totpSessionInfo.finalizeEnrollmentTime).toUTCString(), t.totpSessionInfo.sessionInfo, n);
	}
	_makeTotpVerificationInfo(e) {
		return {
			sessionInfo: this.sessionInfo,
			verificationCode: e
		};
	}
	generateQrCodeUrl(e, t) {
		let n = !1;
		return (av(e) || av(t)) && (n = !0), n && (av(e) && (e = this.auth.currentUser?.email || "unknownuser"), av(t) && (t = this.auth.name)), `otpauth://totp/${t}:${e}?secret=${this.secretKey}&issuer=${t}&algorithm=${this.hashingAlgorithm}&digits=${this.codeLength}`;
	}
};
function av(e) {
	return e === void 0 || e?.length === 0;
}
var ov = "@firebase/auth", sv = "1.8.0", cv = class {
	constructor(e) {
		this.auth = e, this.internalListeners = /* @__PURE__ */ new Map();
	}
	getUid() {
		return this.assertAuthConfigured(), this.auth.currentUser?.uid || null;
	}
	async getToken(e) {
		return this.assertAuthConfigured(), await this.auth._initializationPromise, this.auth.currentUser ? { accessToken: await this.auth.currentUser.getIdToken(e) } : null;
	}
	addAuthTokenListener(e) {
		if (this.assertAuthConfigured(), this.internalListeners.has(e)) return;
		let t = this.auth.onIdTokenChanged((t) => {
			e(t?.stsTokenManager.accessToken || null);
		});
		this.internalListeners.set(e, t), this.updateProactiveRefresh();
	}
	removeAuthTokenListener(e) {
		this.assertAuthConfigured();
		let t = this.internalListeners.get(e);
		t && (this.internalListeners.delete(e), t(), this.updateProactiveRefresh());
	}
	assertAuthConfigured() {
		Q(this.auth._initializationPromise, "dependent-sdk-initialized-before-auth");
	}
	updateProactiveRefresh() {
		this.internalListeners.size > 0 ? this.auth._startProactiveRefresh() : this.auth._stopProactiveRefresh();
	}
};
function lv(e) {
	switch (e) {
		case "Node": return "node";
		case "ReactNative": return "rn";
		case "Worker": return "webworker";
		case "Cordova": return "cordova";
		case "WebExtension": return "web-extension";
		default: return;
	}
}
function uv(e) {
	wi(new ar("auth", (t, { options: n }) => {
		let r = t.getProvider("app").getImmediate(), i = t.getProvider("heartbeat"), a = t.getProvider("app-check-internal"), { apiKey: o, authDomain: s } = r.options;
		Q(o && !o.includes(":"), "invalid-api-key", { appName: r.name });
		let c = new ih(r, i, a, {
			apiKey: o,
			authDomain: s,
			clientPlatform: e,
			apiHost: "identitytoolkit.googleapis.com",
			tokenApiHost: "securetoken.googleapis.com",
			apiScheme: "https",
			sdkClientVersion: $m(e)
		});
		return Sh(c, n), c;
	}, "PUBLIC").setInstantiationMode("EXPLICIT").setInstanceCreatedCallback((e, t, n) => {
		e.getProvider("auth-internal").initialize();
	})), wi(new ar("auth-internal", (e) => ((e) => new cv(e))(ah(e.getProvider("auth").getImmediate())), "PRIVATE").setInstantiationMode("EXPLICIT")), Mi(ov, sv, lv(e)), Mi(ov, sv, "esm2017");
}
var dv = Mn("authIdTokenMaxAge") || 300, fv = null, pv = (e) => async (t) => {
	let n = t && await t.getIdTokenResult(), r = n && ((/* @__PURE__ */ new Date()).getTime() - Date.parse(n.issuedAtTime)) / 1e3;
	if (r && r > dv) return;
	let i = n?.token;
	fv !== i && (fv = i, await fetch(e, {
		method: i ? "POST" : "DELETE",
		headers: i ? { Authorization: `Bearer ${i}` } : {}
	}));
};
function mv(e = ji()) {
	let t = Ti(e, "auth");
	if (t.isInitialized()) return t.getImmediate();
	let n = xh(e, {
		popupRedirectResolver: Q_,
		persistence: [
			Kg,
			yg,
			xg
		]
	}), r = Mn("authTokenSyncURL");
	if (r && typeof isSecureContext == "boolean" && isSecureContext) {
		let e = new URL(r, location.origin);
		if (location.origin === e.origin) {
			let t = pv(e.toString());
			lg(n, t, () => t(n.currentUser)), cg(n, (e) => t(e));
		}
	}
	let i = kn("auth");
	return i && Ch(n, `http://${i}`), n;
}
function hv() {
	return document.getElementsByTagName("head")?.[0] ?? document;
}
//#endregion
//#region ../node_modules/firebase/app/dist/esm/index.esm.js
ch({
	loadJS(e) {
		return new Promise((t, n) => {
			let r = document.createElement("script");
			r.setAttribute("src", e), r.onload = t, r.onerror = (e) => {
				let t = Up("internal-error");
				t.customData = e, n(t);
			}, r.type = "text/javascript", r.charset = "UTF-8", hv().appendChild(r);
		});
	},
	gapiScript: "https://apis.google.com/js/api.js",
	recaptchaV2Script: "https://www.google.com/recaptcha/api.js",
	recaptchaEnterpriseScript: "https://www.google.com/recaptcha/enterprise.js?render="
}), uv("Browser"), Mi("firebase", "11.0.1", "app");
//#endregion
//#region src/helpers/common.helper.ts
async function gv(e) {
	return new Promise((t) => setTimeout(t, e));
}
function _v(e, t) {
	let n;
	return (...r) => (clearTimeout(n), new Promise((i) => {
		n = setTimeout(() => i(e(...r)), t);
	}));
}
//#endregion
//#region src/firestore/firestore.helper.ts
async function vv(e, t, n) {
	let r = `Bearer ${n}`;
	try {
		let n = C(e, t, h.FirebaseToken);
		if (!n) throw Error("⭕️ Firebase ERROR: No cloud function url define for getting firebase token. Check metadata file");
		let i = await (await fetch(n, { headers: { Authorization: r } })).json();
		if (!i || !i.firebase_token) throw Error("⭕️ Firebase ERROR: No token returned");
		return i.firebase_token;
	} catch (e) {
		throw Error(`⭕️ Firebase ERROR: Cloud function error ${D(e)}`);
	}
}
function yv(e) {
	let n = t(e);
	return {
		expiration: n.exp,
		userId: n.uid,
		userAccountId: n.claims.user_account_id
	};
}
function bv(e) {
	if (e === void 0 || e.length < 15) return !1;
	let { expiration: t } = yv(e);
	return t > (/* @__PURE__ */ new Date()).getTime() / 1e3;
}
async function xv(e, t, n) {
	let r = [
		300,
		600,
		1200,
		2400,
		4800
	], i = "", a = 0;
	for (; a < 5;) try {
		return i = await vv(e, t, n), i;
	} catch {
		let e = r[a];
		a++, console.warn(`⭕️ Firebase: Had to retry calling cloud function for retreiving a firebase token. Attempt ${a} of 5. Waitting ${e}ms before retrying.`), await gv(e);
	}
	throw Error(`⭕️ Firebase ERROR: Not able to retrieve token for firebase after ${a} attemps`);
}
function Sv(e) {
	let t = localStorage.getItem(Ze(e));
	if (t !== null) return t;
}
function Cv(e, t) {
	localStorage.setItem(Ze(e), t);
}
function wv(e) {
	let t = Sv(e);
	return t === void 0 ? !1 : bv(t);
}
function Tv(e, t) {
	kf(Ai(nt(e, t)), { experimentalForceLongPolling: !0 });
}
async function Ev(e, t, n, r) {
	let i = "";
	return !r && wv(e) ? i = Sv(e) : (i = await xv(e, t, n), Cv(e, i)), i;
}
async function Dv(e, t, n) {
	try {
		Tv(e, t);
		let r = ji(), i = await Ev(e, t, n, !1), a = mv(r), o = a.currentUser;
		if (o) return console.debug("⭕️ Firebase: Already logged in, Reusing user's credentials"), o.uid;
		let s = await sg(a, i);
		if (console.debug("⭕️ Firebase: User not logged --> Signning in"), !s) throw Error("⭕️ Firebase ERROR: No user credentials");
		return s.user.uid;
	} catch (e) {
		throw Error(`⭕️ Firebase ERROR: Error signing in with custom token ${D(e)}`);
	}
}
async function Ov(e, t, n) {
	return await Ev(e, t, n, !1);
}
async function kv(e, t) {
	let n = y.getInstance().getToken();
	if (n === void 0 || n.length < 15) throw Error("⭕️ Firebase ERROR: Trying to get DB Firestore, but no Carto3 token provided");
	return await Dv(e, t, n), Af(ji());
}
async function Av(e, n, r) {
	let i = t(await Ev(e, n, r, !0)).claims.role, a = Object.values(v), o = a.find((e) => i === e);
	if (!o) {
		let e = `Unexpected role value: Role ${i} not found in roles: ${a}`;
		throw console.error(`👩🏻‍🦰 ${e}`), Error(e);
	}
	return o;
}
//#endregion
//#region src/helpers/auth.helper.ts
function jv(e) {
	let n = t(y.getInstance().getToken()), r = n[e.auth0_user_key], i = n.sub;
	if (!r) throw Error("No user email found in token");
	if (!i) throw Error("No user id found in token");
	return {
		userEmail: r,
		userId: i
	};
}
//#endregion
//#region src/firestore/firestore.service.ts
function Mv(e, t, n, r) {
	let i = t.isTesting() ? "Test_" : "", a = Ye(e), o = [...n], s = `${i}${a}_${o[0]}`;
	return o.shift(), r && o.push(r), {
		collectionPath: s,
		collectionPathSegments: o
	};
}
function Nv(e) {
	let t = Object.keys(e).filter((t) => e[t] === void 0);
	if (t.length > 0) {
		let e = `Object properties with undefined values cannot be persisted on Firestore.Invalid object properties: ${t.join(", ")}`;
		throw console.error(e), Error(e);
	}
}
function Pv(e, t, n = !1) {
	let { userEmail: r, userId: i } = jv(e), a = ka.now();
	return n && (t.created_at = a), t.modified_at = a, t.modified_by = r, t.modified_by_auth0_id = i, { ...t };
}
function Fv(e) {
	let t = { ...e };
	return t.created_at = e.created_at?.toDate(), t.modified_at = e.modified_at?.toDate(), t;
}
function Iv(e) {
	let t = [];
	return e.forEach((e) => {
		let n = e.data();
		n = Fv(n), n.id = e.id, t.push(n);
	}), t;
}
async function Lv(e, t, ...n) {
	try {
		let r = await kv(e, t), { collectionPath: i, collectionPathSegments: a } = Mv(e, t, n);
		return Iv(await Dp(wf(r, i, ...a)));
	} catch (e) {
		throw Error(`Error getting elemnts ${D(e)}`);
	}
}
async function Rv(e, t, n, ...r) {
	try {
		let i = await kv(e, t), { collectionPath: a, collectionPathSegments: o } = Mv(e, t, r, n), s = (await Tp(Tf(i, a, ...o))).data();
		return s = Fv(s), s.id = n, s;
	} catch (e) {
		throw Error(`Error getting element with id: ${n} ${D(e)}`);
	}
}
async function zv(e, t, { collectionFullPath: n, queryConstraints: r }) {
	try {
		let i = await kv(e, t), { collectionPath: a, collectionPathSegments: o } = Mv(e, t, n);
		return Iv(await Dp(dp(wf(i, a, ...o), ...r)));
	} catch (e) {
		throw Error(`Error getting elements using queries ${D(e)}`);
	}
}
async function Bv(e, t, r, ...i) {
	try {
		let a = await kv(e, t), o = Pv(e, r, !0), { collectionPath: s, collectionPathSegments: c } = Mv(e, t, i), l = wf(a, s, ...c), u = n(), d = Tf(l, u), f = o;
		return f.id = u, Nv(f), await Op(d, f), u;
	} catch (e) {
		throw Error(`Error creating element\n ${D(e)}`);
	}
}
async function Vv(e, t, n, r, ...i) {
	try {
		let a = await kv(e, t), o = Pv(e, n);
		delete o.id;
		let { collectionPath: s, collectionPathSegments: c } = Mv(e, t, i, r), l = o;
		Nv(l), await kp(Tf(a, s, ...c), l);
	} catch (e) {
		throw Error(`Error updating element with id: ${r} ${D(e)}`);
	}
}
async function Hv(e, t, n, ...r) {
	try {
		let i = await kv(e, t), { collectionPath: a, collectionPathSegments: o } = Mv(e, t, r, n);
		await Ap(Tf(i, a, ...o));
	} catch (e) {
		throw Error(`Error deleting element with id: ${n} ${D(e)}`);
	}
}
//#endregion
//#region src/plan.service.ts
var Uv = /* @__PURE__ */ u({
	createPlan: () => Kv,
	deletePlan: () => Jv,
	getFirebaseToken: () => Qv,
	getPlan: () => Gv,
	getPlanByAidaId: () => Zv,
	getPlans: () => Wv,
	getPlansByCustomGeoboundaryId: () => $v,
	getPlansByCustomPoiId: () => ey,
	getPlansByUserId: () => Xv,
	getPublicPlans: () => Yv,
	initFirebase: () => ty,
	updatePlan: () => qv
});
async function Wv(e, t) {
	return await Lv(e, t, Z.Plans);
}
async function Gv(e, t, n) {
	return await Rv(e, t, n, Z.Plans);
}
async function Kv(e, t, n) {
	return await Bv(e, t, n, Z.Plans);
}
async function qv(e, t, n, r) {
	await Vv(e, t, r, n, Z.Plans);
}
async function Jv(e, t, n) {
	let r = C(e, t, h.SharedPlan);
	if (!r) throw Error("🔴🔴🔴 No cloud function url define for managing plans. Check .metadata file 🔴🔴🔴");
	let i = new URLSearchParams({
		action: g.DeletePlan,
		planId: n,
		appVersion: t.isTesting() ? e.flavour_testing : e.flavour
	}).toString(), a = y.getInstance().getToken(), o = await fetch(`${r}?${i}`, {
		method: "GET",
		headers: { Authorization: `Bearer ${a}` }
	});
	if (!o.ok) throw Error(`Failed to delete plan ${n}: ${o.statusText}`);
}
async function Yv(e, t) {
	let n = [pp("is_public", "==", !0)];
	return await zv(e, t, {
		collectionFullPath: [Z.Plans],
		queryConstraints: n
	});
}
async function Xv(e, t, n) {
	return await zv(e, t, {
		collectionFullPath: [Z.Plans],
		queryConstraints: [pp("created_by", "==", n)]
	});
}
async function Zv(e, t, n) {
	return (await zv(e, t, {
		collectionFullPath: [Z.Plans],
		queryConstraints: [pp("aida_id", "==", n)]
	}))[0] || null;
}
async function Qv(e, t, n) {
	return await Ov(e, t, n);
}
async function $v(e, t, n) {
	return await zv(e, t, {
		collectionFullPath: [Z.Plans],
		queryConstraints: [pp("custom_geoboundaries", "array-contains", n)]
	});
}
async function ey(e, t, n) {
	return await zv(e, t, {
		collectionFullPath: [Z.Plans],
		queryConstraints: [pp("custom_pois", "array-contains", n)]
	});
}
async function ty(e, t) {
	await kv(e, t);
}
//#endregion
//#region src/audience.service.ts
var ny = /* @__PURE__ */ u({
	getAudienceIndexByAssetAndAudienceClasses: () => sy,
	getClasses: () => ay,
	getClassesV2: () => oy,
	getDeliveries: () => iy
});
function ry(e, t) {
	switch (Xe(e)) {
		case p.Month: return t.map((e) => {
			let t = e.year_month_or_week;
			return {
				dateFormat: t,
				humanFormat: t.substring(0, 7)
			};
		});
		case p.Week: return t.map((e) => {
			let t = e.year_month_or_week, { year: n, week: r } = lt(new Date(t));
			return {
				dateFormat: `${t}`,
				humanFormat: `${r}, ${n}`
			};
		});
		default: throw Error("Invalid year_month_week provided data");
	}
}
async function iy(e, t, n) {
	let r = S(e, t, e.data_model.audiences_classes), i = "";
	return n && n.country_ids && (i = E({
		columnName: "country_id",
		ids: n.country_ids,
		equalityOperator: w.EQUALS,
		logicalOperator: T.WHERE
	})), ry(e, await b(`
  SELECT DISTINCT(year_month_or_week)
  FROM ${r}
  ${i}
  ORDER BY year_month_or_week DESC`, e, t));
}
async function ay(e, t, n) {
	let r = S(e, t, e.data_model.audiences_classes), i = n;
	return await b(`SELECT
  ${Ue(e.data_model.audiences_classes.columns, Ve.Filterable)}
  FROM ${r}
  WHERE
    year_month_or_week = "${i}"
  ORDER BY audience ASC`, e, t);
}
async function oy(e, t, n) {
	let r = S(e, t, e.data_model.audiences_classes), i = "";
	n.country_ids && n.country_ids.length > 0 && (i = E({
		columnName: "country_id",
		ids: n.country_ids,
		equalityOperator: w.EQUALS,
		logicalOperator: T.AND
	}));
	let { joinClause: a, whereCondition: o } = st(e, t, n.delivery, n.country_ids);
	return await b(`SELECT
    attr1, attr2, attr3, attr4, attr5, attr6, name, uid
  FROM ${r}
  ${a}
  WHERE ${o || "1=1"}
  ${i}
  group by attr1, attr2, attr3, attr4, attr5, attr6, name, uid
  order by attr1, attr2, attr3, attr4, attr5, attr6, name`, e, t);
}
async function sy(e, t, n, r, i) {
	return await b(`
  SELECT
    c.name as name,
    index as value
  FROM  ${S(e, t, e.data_model.audiences)} a
  JOIN  ${S(e, t, e.data_model.audiences_classes)} c
  ON a.class_uid = c.uid
  WHERE a.year_month_or_week = "${n}"
  AND c.year_month_or_week = "${n}"
  ${E({
		columnName: "class_uid",
		ids: i,
		equalityOperator: w.EQUALS,
		logicalOperator: T.AND
	})}
  ${E({
		columnName: "asset_id",
		ids: [r],
		equalityOperator: w.EQUALS,
		logicalOperator: T.AND
	})}`, e, t);
}
//#endregion
//#region src/poi.helper.ts
function cy(e, t) {
	return e.countries.length === 1 ? " 1 = 1 " : ` country_id IN (${e.countries.filter((e) => t.includes(e.id)).map((e) => e.id).join(",")}) `;
}
function ly(e, t, n, r, i, a = "") {
	let o = `pois_from_categories${a}`, s = n.categories;
	if (s.length === 0) return {
		cteName: o,
		cte: ""
	};
	let c = i.length > 0 ? i : [
		"p.geoid",
		"p.location_name as name",
		"p.street_address as address",
		"p.geom",
		"p.country_id as country_id"
	], l = S(e, t, e.data_model.pois), u = `( ${it("sub_category", s, w.EQUALS, T.NONE)} OR ( sub_category IS NULL AND ${it("top_category", s, w.EQUALS, T.NONE)} ) ) `;
	return {
		cteName: o,
		cte: `${o} AS (
    SELECT ${c.join(", ")}
    FROM ${l} p
    WHERE ${cy(e, r)}
      AND ${u}
    ),
    `
	};
}
function uy(e, t, n, r, i, a = "") {
	let o = `pois_from_brands${a}`, s = n.brands, c = i.length > 0 ? i : [
		"p.geoid",
		"p.location_name as name",
		"p.street_address as address",
		"p.geom",
		"p.country_id as country_id"
	];
	if (s.length === 0) return {
		cteName: o,
		cte: ""
	};
	let l = S(e, t, e.data_model.pois), u = it("brands", s, w.EQUALS, T.NONE);
	return {
		cteName: o,
		cte: `${o} AS (
    SELECT ${c.join(", ")}
    FROM ${l} p
    WHERE ${cy(e, r)}
      AND ${u}
    ),
    `
	};
}
function dy(e, t, n, r, i, a = "") {
	let o = `pois_from_tags${a}`, s = n.tags, c = i.length > 0 ? i : [
		"p.geoid",
		"p.location_name as name",
		"p.street_address as address",
		"p.geom",
		"p.country_id as country_id"
	];
	if (s.length === 0) return {
		cteName: o,
		cte: ""
	};
	let l = S(e, t, e.data_model.pois), u = at("category_tags", s);
	return {
		cteName: o,
		cte: `${o} AS (
    SELECT ${c.join(", ")}
    FROM ${l} p
    WHERE ${cy(e, r)}
      AND ${u}
    ),
    `
	};
}
function fy(e, t, n, r, i, a = "") {
	let o = `pois_from_locations${a}`, s = n.locations;
	if (s.length === 0) return {
		cteName: o,
		cte: ""
	};
	let c = S(e, t, e.data_model.pois), l = i.length > 0 ? i : [
		"p.geoid",
		"p.location_name as name",
		"p.street_address as address",
		"p.geom",
		"p.country_id as country_id"
	], u = `(${s.map((e) => `NORMALIZE_AND_CASEFOLD(location_name) = NORMALIZE_AND_CASEFOLD("${e}")`).join(" OR ")})`;
	return {
		cteName: o,
		cte: `${o} AS (
    SELECT ${l.join(", ")}
    FROM ${c} p
    WHERE ${cy(e, r)}
      AND ${u}
    ),
    `
	};
}
function py(e, t, n, r = "") {
	let i = `pois_from_custom_pois_groups${r}`, a = n.custom_POIs;
	if (a.length === 0) return {
		cteName: i,
		cte: ""
	};
	let o = "", s = "";
	if (e.countries.length > 1) {
		let n = S(e, t, e.data_model.regions);
		o = ", regions.country_id as country_id", s = `LEFT JOIN ${n} regions
    ON type_id = 2 AND ST_INTERSECTS(regions.geom, pois_unnested.geom)
    `;
	} else o = `, ${e.countries[0].id} as country_id`;
	let c = S(e, t, e.data_model.custom_pois), l = E({
		columnName: "custom_pois.id",
		ids: a,
		equalityOperator: w.EQUALS,
		logicalOperator: T.AND
	});
	return {
		cteName: i,
		cte: `${i} AS (
    SELECT
      CONCAT(custom_pois.name, '-',pois_unnested.name) as id,
      pois_unnested.geom as geom,
      pois_unnested.name as name,
      SPLIT(pois_unnested.address, '#%%#')[SAFE_OFFSET(0)] as address,
      SPLIT(pois_unnested.address, '#%%#')[SAFE_OFFSET(2)] as zip_code,
      SPLIT(pois_unnested.address, '#%%#')[SAFE_OFFSET(1)] as city,
      ST_ASTEXT(pois_unnested.geom) as geoid
      ${o}
    FROM ${c} custom_pois,
    UNNEST(pois) as pois_unnested
    ${s}
    WHERE
      deleted = false
      ${l}
    ),
    `
	};
}
function my(e, t, n, r, i, a = "", ...o) {
	let s = `all_pois${a}`, c = "all_pois_isochrones", l = "", u = o.filter((e) => e.cte !== ""), d = u.length, f = r.length > 0 ? r : [
		"geoid",
		"name",
		"geom",
		"address",
		"country_id"
	];
	for (let t = 0; t < d; t++) {
		let n = u[t];
		n.cteName === "pois_from_custom_pois_groups" && i && (f = e.features.export.columnsCustomPOIs), l += `
      SELECT ${f.join(", ")}
      FROM ${n.cteName}
    `, f.includes("geom") && (l += " WHERE geom IS NOT NULL"), t < d - 1 && (l += " UNION ALL ");
	}
	let p = `
    ${s} AS (
      ${l}
    )
  `;
	if (n.method !== "RADIUS" && !i) {
		let r = S(e, t, e.data_model.pois_isochrones);
		p = `
      ${p},

      ${c} AS (
        SELECT
          p.*,
          i.geom as isochrone
        FROM ${s} p
        LEFT JOIN ${r} i
          ON ${l.includes("geoid") ? "p.geoid" : "p.id"} = i.geoid
            AND i.method = '${n.method}'
            AND i.time = ${n.distance}
      )
    `;
	}
	let m = "";
	return m = n.method === "RADIUS" || i ? `
      JOIN ${s}
        ON ST_DISTANCE(assets.geom,  ${s}.geom) < ${n.max_distance}
        AND ST_DISTANCE(assets.geom,  ${s}.geom) >= ${n.min_distance}
    ` : `
      JOIN ${c} i
        ON ST_INTERSECTS(assets.geom,  i.isochrone)
    `, {
		cte: p,
		join: m
	};
}
function hy(e) {
	return e.categories.length > 0 || e.brands.length > 0 || e.tags.length > 0 || e.locations.length > 0 || e.custom_POIs.length > 0;
}
function gy(e, t, n, r, i = [], a = [], o = !1, s = "") {
	let c = s, l = ly(e, t, n, r, i, c), u = uy(e, t, n, r, i, c), d = dy(e, t, n, r, i, c), f = fy(e, t, n, r, i, c), p = py(e, t, n, c), { cte: m, join: h } = my(e, t, n, a, o, c, l, u, d, f, p);
	return {
		partialQuery: `WITH
  ${l.cte}
  ${u.cte}
  ${d.cte}
  ${f.cte}
  ${p.cte}
  ${m}`,
		allPoisJoin: h
	};
}
function _y(e, t, n, r, i) {
	if (!hy(n)) return "";
	if (n.method === "RADIUS") {
		let a = S(e, t, e.data_model.assets), o = a, { partialQuery: s, allPoisJoin: c } = gy(e, t, n, r), l = "", u = "", d = "";
		return n.max_assets_per_poi > 0 && (o = "assetsPreFiltered", d = `
        ${o} AS (
          SELECT id, geom
          FROM ${a}
          WHERE id IN ('${i.join("','")}')
        ),
      `, l = ", rank() over (partition by all_pois.geoid order by ST_DISTANCE(all_pois.geom, assets.geom), id) as rank", u = ` WHERE rank <= ${n.max_assets_per_poi}`), `
      ${s},
      ${d}
      pre_assets AS (
        SELECT
          distinct(assets.id) as asset_id
          ${l}
        FROM ${o} assets
        ${c}
      )

      SELECT distinct(asset_id)
      FROM pre_assets
      ${u}
    `;
	} else {
		let i = S(e, t, e.data_model.assets), { partialQuery: a, allPoisJoin: o } = gy(e, t, n, r, [
			"p.geoid",
			"p.geom",
			"p.country_id"
		], [
			"geoid",
			"geom",
			"country_id"
		]);
		return `
    ${a}

    SELECT distinct(id) as asset_id
    FROM ${i} assets
    ${o}
    `;
	}
}
//#endregion
//#region src/poi.service.ts
var vy = /* @__PURE__ */ u({
	filterAssetsByPois: () => yy,
	getFilterPOIsPartialQuery: () => by
});
async function yy(e, t, n, r, i) {
	let a = _y(e, t, n, r, i);
	return a === "" ? [] : (await b(a, e, t)).map((e) => e.asset_id);
}
function by(e, t, n, r, i = [], a = [], o = !1, s = ee.GeoboundariesWithOutGeometry) {
	return gy(e, t, n, r, i, a, o, s);
}
//#endregion
//#region src/helpers/escape.helper.ts
function xy(e, t = !1) {
	return (t ? e.toLocaleLowerCase() : e).trim().replaceAll("'", "\\'").replaceAll("`", "\\`").replaceAll("´", "\\'");
}
//#endregion
//#region src/poi-browser.service.ts
var Sy = /* @__PURE__ */ u({
	checkStatusCustomPoisAddressJob: () => zy,
	deleteCustomPOIsGroup: () => Iy,
	fetchCustomPOIsLayerSource: () => Ry,
	getActiveCustomPoisGroups: () => Ny,
	getBrands: () => Dy,
	getCategories: () => Ey,
	getCountCustomPOISGeocoded: () => By,
	getCustomPOIsUnableToGeocode: () => Vy,
	getCustomPois: () => Cy,
	getCustomPoisDataset: () => Ty,
	getCustomPoisList: () => wy,
	getLocationsByPattern: () => ky,
	getTags: () => Oy,
	reactivateCustomPOIsGroup: () => Ly,
	updateCustomPOIsGroup: () => Fy,
	uploadCustomPOIsAddressGroupJob: () => Py,
	uploadCustomPOIsGroup: () => My
});
async function Cy(e, t, n, r = !1) {
	let i = et(e), a = S(e, t, e.data_model.custom_pois), { userEmail: o } = jv(e), s = r ? (/* @__PURE__ */ new Date()).getTime() : 0, c = e.features.manage_pois.custom_pois_expiration.enable, l = `(user_email = '${o}' OR shared = true) AND (deleted = false) `;
	return c && (l = `${l} AND (expired = false OR expired IS NULL) `), i && n && n.length > 0 && (l = `${l} AND EXISTS (
      SELECT *
      FROM UNNEST(countries) AS c
      WHERE c in (${n.join(",")}))`), await b(`SELECT id, name, ARRAY_LENGTH(pois) as occurrences, shared, expired, user_email, sub_category, NULL as top_category
  FROM ${a} t1
  LEFT JOIN
    UNNEST(sub_categories) as sub_category
  WHERE ${l}
  order by sub_category
  /* ${s} */`, e, t, !0);
}
async function wy(e, t, n = !1, r = !1) {
	let i = S(e, t, e.data_model.custom_pois), { userEmail: a } = jv(e), o = r ? (/* @__PURE__ */ new Date()).getTime() : 0, s = "";
	et(e) && (s = ", countries");
	let c = e.features.manage_pois.custom_pois_expiration.days, l = `(user_email = '${a}' OR shared = true) AND (deleted = false)`;
	return n && (l = `${l} AND (expired = true)`), await b(`SELECT
    id,
    name,
    shared,
    ARRAY_LENGTH(pois) as occurrences,
    expired,
    user_email,
    description,
    TIMESTAMP(DATE_ADD(DATE(modified), INTERVAL ${c} DAY)) AS expiration,
    modified
    ${s}
  FROM ${i} t1
  WHERE ${l}
  ORDER BY modified DESC
  /* ${o} */`, e, t, !0);
}
async function Ty(e, t, n) {
	let r = S(e, t, e.data_model.custom_pois), { userEmail: i } = jv(e);
	return await b(`
    WITH pois AS (
      SELECT
        pois
      FROM
        ${r}
      WHERE (user_email = '${i}' OR shared = true)
      ${E({
		columnName: "id",
		ids: [n.id],
		equalityOperator: w.EQUALS,
		logicalOperator: T.AND
	})}
    )
    SELECT
      name, geom, address
    FROM pois as p
    CROSS JOIN UNNEST(p.pois)
    ORDER BY name
  `, e, t, !0);
}
async function Ey(e, t, n) {
	let r = await b(`SELECT top_category, sub_category, count(*) as occurrences
  FROM ${Ke(e, t, e.data_model.pois, !1)}
  WHERE ${cy(e, n)}
  AND top_category IS NOT NULL
  group by top_category, sub_category
  order by top_category, sub_category`, e, t);
	if (r.length === 0) return [];
	r[0].sub_category === null && r.shift();
	let i = r.map((e) => e.sub_category === null ? {
		...e,
		sub_category: e.top_category
	} : e);
	return [...new Map(i.map((e) => [`${e.top_category}||${e.sub_category}`, e])).values()];
}
async function Dy(e, t, n) {
	return await b(`SELECT brands, count(*) as occurrences
  FROM ${Ke(e, t, e.data_model.pois, !1)}
  WHERE ${cy(e, n)}
  AND brands IS NOT NULL
  GROUP BY brands
  ORDER BY brands`, e, t);
}
async function Oy(e, t, n) {
	return await b(`SELECT category_tags as tags, count(*) as occurrences
  FROM ${S(e, t, e.data_model.pois)}
  WHERE ${cy(e, n)}
  AND category_tags IS NOT NULL
  GROUP BY category_tags
  ORDER BY category_tags`, e, t);
}
async function ky(e, t, n, r) {
	let i = Ke(t, n, t.data_model.pois, !0), a = xy(e, !0);
	return await b(`SELECT *
  FROM ${i}
  WHERE ${cy(t, r)}
  AND normalized_location_name LIKE '%${a}%'
  order by occurrences desc
  limit 100`, t, n);
}
function Ay(e, t, n) {
	let { userEmail: r } = jv(e), i = {};
	return n.countries && n.countries.length > 0 && (i = { countries: n.countries }), JSON.stringify({
		id: n.id,
		name: n.name,
		shared: n.shared,
		user_email: r,
		pois: n.customPOIs,
		sub_categories: n.sub_categories,
		description: n.description,
		action: n.action,
		...i
	});
}
function jy(e, t, n) {
	let { userEmail: r } = jv(e), i = { apiBaseUrl: e.base_url }, a = {
		...n,
		user_email: r,
		meta: i,
		action: "geocoding"
	};
	return JSON.stringify(a);
}
async function My(e, t, n) {
	let r = `Bearer ${y.getInstance().getToken()}`;
	n.action = "create";
	let i = Ay(e, t, n);
	try {
		let n = C(e, t, h.BigQueryCustomPOIS);
		if (!n) throw Error("🔴🔴🔴 No cloud function url define for getting managing custom POIs in BQ. Check .env file 🔴🔴🔴");
		return await (await fetch(n, {
			method: "POST",
			body: i,
			headers: { Authorization: r }
		})).json();
	} catch (e) {
		throw Error(`Cloud function error ${D(e)}`);
	}
}
async function Ny(e, t, n) {
	return await b(`SELECT
    id
  FROM ${S(e, t, e.data_model.custom_pois)} t1
  WHERE id IN ('${n.join("','")}') AND (expired = false) AND (deleted = false)`, e, t, !0);
}
async function Py(e, t, n) {
	let r = `Bearer ${y.getInstance().getToken()}`, i = jy(e, t, n);
	try {
		let n = C(e, t, h.BigQueryCustomPOIS);
		if (!n) throw Error("🔴🔴🔴 No cloud function url define for getting managing custom POIs Address in BQ. Check .env file 🔴🔴🔴");
		return (await (await fetch(n, {
			method: "POST",
			body: i,
			headers: { Authorization: r }
		})).json()).job;
	} catch (e) {
		throw Error(`Cloud function error ${D(e)}`);
	}
}
async function Fy(e, t, n) {
	let r = `Bearer ${y.getInstance().getToken()}`;
	n.action = "update";
	let i = Ay(e, t, n);
	try {
		let n = C(e, t, h.BigQueryCustomPOIS);
		if (!n) throw Error("🔴🔴🔴 No cloud function url define for getting managing custom POIs in BQ. Check .env file 🔴🔴🔴");
		return await (await fetch(n, {
			method: "POST",
			body: i,
			headers: { Authorization: r }
		})).json();
	} catch (e) {
		throw Error(`Cloud function error ${D(e)}`);
	}
}
async function Iy(e, t, n) {
	let r = `Bearer ${y.getInstance().getToken()}`, i = JSON.stringify({
		id: n,
		action: "delete"
	});
	try {
		let n = C(e, t, h.BigQueryCustomPOIS);
		if (!n) throw Error("🔴🔴🔴 No cloud function url define for getting managing custom POIs in BQ. Check .env file 🔴🔴🔴");
		return await (await fetch(n, {
			method: "POST",
			body: i,
			headers: { Authorization: r }
		})).json();
	} catch (e) {
		throw Error(`Cloud function error ${D(e)}`);
	}
}
async function Ly(e, t, n) {
	let r = `Bearer ${y.getInstance().getToken()}`, i = JSON.stringify({
		id: n,
		action: "reactivate"
	});
	try {
		let n = C(e, t, h.BigQueryCustomPOIS);
		if (!n) throw Error("🔴🔴🔴 No cloud function url define for getting managing custom POIs in BQ. Check .env file 🔴🔴🔴");
		return await (await fetch(n, {
			method: "POST",
			body: i,
			headers: { Authorization: r }
		})).json();
	} catch (e) {
		throw Error(`Cloud function error ${D(e)}`);
	}
}
function Ry(e, t, n) {
	return `
    SELECT
      custom_pois.name as id,
      pois_unnested.geom as geom,
      pois_unnested.name as location_name,
      REPLACE(pois_unnested.address,'#%%#',' ') as street_address
    FROM ${S(e, t, e.data_model.custom_pois)} custom_pois,
    UNNEST(pois) as pois_unnested
    WHERE
      deleted = false
      ${E({
		columnName: "id",
		ids: n,
		equalityOperator: w.EQUALS,
		logicalOperator: T.AND
	})}
  `;
}
async function zy(e, t, n) {
	let r = `Bearer ${y.getInstance().getToken()}`, i = {
		jobId: n,
		action: "status_geocoding_job"
	};
	try {
		let n = C(e, t, h.BigQueryCustomPOIS);
		if (!n) throw Error("🔴🔴🔴 No cloud function url define for getting managing custom POIs Address in BQ. Check .env file 🔴🔴🔴");
		return await (await fetch(n, {
			method: "POST",
			body: JSON.stringify(i),
			headers: { Authorization: r }
		})).json();
	} catch (e) {
		throw Error(`Cloud function error ${D(e)}`);
	}
}
async function By(e, t, n) {
	return (await b(`SELECT count(*) as total
  FROM ${S(e, t, e.data_model.custom_pois_address_tmp)}
  WHERE ${E({
		columnName: "id",
		ids: [n],
		equalityOperator: w.EQUALS,
		logicalOperator: T.NONE
	})}`, e, t))[0].total;
}
async function Vy(e, t, n) {
	return await b(`SELECT ${Ue(e.data_model.custom_pois_address_tmp.columns, Ve.Filterable)}
  FROM ${S(e, t, e.data_model.custom_pois_address_tmp)}
  WHERE ${E({
		columnName: "id",
		ids: [n],
		equalityOperator: w.EQUALS,
		logicalOperator: T.NONE
	})}
  AND geom IS NULL`, e, t);
}
//#endregion
//#region src/audiences.helper.ts
var Hy = "year_month_or_week > '1900-01-01'";
function Uy(e, t, n) {
	return `latest_deliveries AS (
    SELECT
      MAX(year_month_or_week) AS year_month_or_week,
      source_id
    FROM ${S(e, t, e.data_model.audiences_classes)}
    WHERE ${Hy}
      ${n}
    GROUP BY source_id
  )`;
}
function Wy(e, t = "ld") {
	return `INNER JOIN latest_deliveries ${t}
    ON ${e}.year_month_or_week = ${t}.year_month_or_week
   AND ${e}.source_id = ${t}.source_id`;
}
function Gy(e, t, n, r) {
	return n === null ? {
		join: Wy(e, t),
		where: r ? `AND ${e}.${Hy}` : ""
	} : {
		join: "",
		where: `AND ${e}.year_month_or_week = "${n}"`
	};
}
//#endregion
//#region src/insight.helper.ts
var Ky = new Map([
	[0, [1]],
	[1, [
		0,
		2,
		3
	]],
	[2, [
		0,
		1,
		2,
		3
	]]
]);
function qy(e, t, n, r, i) {
	return `
    SELECT
      ac.uid AS class_id,
      ac.source_id,
      ac.attr1,
      ac.attr2,
      ac.attr3,
      ac.attr4,
      ac.attr5,
      ac.attr6,
      ac.name,
      ac.audience
    FROM ${e} ac
    ${t}
    WHERE 1 = 1
      ${n}
      ${i}
      ${r}
    ORDER BY
      ac.attr1,
      ac.attr2,
      ac.attr3,
      ac.attr4,
      ac.attr5,
      ac.attr6,
      ac.name
  `;
}
function Jy(e, t, n, r) {
	return qy(e, t, n, r, E({
		columnName: "type",
		ids: Ky.get(0) ?? [],
		equalityOperator: w.EQUALS,
		logicalOperator: T.AND
	}));
}
function Yy(e, t, n, r) {
	return qy(e, t, n, r, "");
}
function Xy(e, t, n, r) {
	return qy(e, t, n, r, `AND ( type IS NULL ${E({
		columnName: "type",
		ids: Ky.get(1) ?? [],
		equalityOperator: w.EQUALS,
		logicalOperator: T.OR
	})} )`);
}
function Zy(e, t, n) {
	let r = S(e, t, e.data_model.audiences), i = S(e, t, e.data_model.audiences_classes), a = E({
		columnName: "asset_id",
		ids: n.assets_id,
		equalityOperator: w.EQUALS,
		logicalOperator: T.AND
	}), o = E({
		columnName: "country_id",
		ids: n.country_ids,
		equalityOperator: w.EQUALS,
		logicalOperator: T.AND,
		normalizedStringSearch: !1,
		returnEmptyIfIdsEmpty: !0
	}), s = n.delivery, c = Gy("ac", "ld", s, !1), l = Gy("audiences", "ld", s, !0);
	return {
		tableName: r,
		audiencesClassesTableName: i,
		latestDeliveriesCtePrefix: s === null ? `${Uy(e, t, o)},` : "",
		classesDelivery: c,
		audiencesDelivery: l,
		assetsWhere: a,
		countriesWhere: o
	};
}
function Qy(e, t) {
	let { tableName: n, latestDeliveriesCtePrefix: r, audiencesDelivery: i, assetsWhere: a, countriesWhere: o } = e;
	return `WITH
  ${r}
  audiences_classes AS (
    ${t}
  )
  SELECT
    dac.audience AS name,
    AVG(index) AS index,
    AVG(market) AS market,
    AVG(panel) AS panel
  FROM ${n} audiences
  ${i.join}
  JOIN audiences_classes dac
    ON dac.class_id = audiences.class_uid
   AND dac.source_id = audiences.source_id
  WHERE 1 = 1
    ${i.where}
    ${a}
    ${o}
  GROUP BY dac.audience
  ORDER BY dac.audience
  `;
}
function $y(e, t, n) {
	let r = Zy(e, t, n);
	return Qy(r, Jy(r.audiencesClassesTableName, r.classesDelivery.join, r.classesDelivery.where, r.countriesWhere));
}
function eb(e, t, n) {
	let r = Zy(e, t, n);
	return Qy(r, Yy(r.audiencesClassesTableName, r.classesDelivery.join, r.classesDelivery.where, r.countriesWhere));
}
function tb(e, t, n) {
	let r = Zy(e, t, n);
	return Qy(r, Xy(r.audiencesClassesTableName, r.classesDelivery.join, r.classesDelivery.where, r.countriesWhere));
}
function nb(e, t, n) {
	let r = S(e, t, e.data_model.panelcounts), i = E({
		columnName: "asset_id",
		ids: n.assets_id,
		equalityOperator: w.EQUALS,
		logicalOperator: T.AND
	}), a = E({
		columnName: "country_id",
		ids: n.country_ids,
		equalityOperator: w.EQUALS,
		logicalOperator: T.AND,
		normalizedStringSearch: !1,
		returnEmptyIfIdsEmpty: !0
	});
	return `WITH
  deliveries AS (
    select distinct (year_month_or_week)
    from ${r}
    where
     true
     ${a}
  )
  select
    EXTRACT(YEAR FROM year_month_or_week) as year,
    EXTRACT(WEEK FROM year_month_or_week) as week,
    coalesce(sum(week_contacts),0) as impressions,
    coalesce(sum(week_uniques),0) as uniques
  from ${r}
  WHERE
    year_month_or_week in (select * from deliveries)
    ${i}
    ${a}
  GROUP BY year_month_or_week
  ORDER BY year_month_or_week
  `;
}
//#endregion
//#region src/insight.service.ts
var rb = /* @__PURE__ */ u({
	getDemographics: () => ib,
	getImpressions: () => sb,
	getOverview: () => ab,
	getTopIndex: () => ob
});
async function ib(e, t, n) {
	return await b($y(e, t, n), e, t);
}
async function ab(e, t, n) {
	return await b(eb(e, t, n), e, t);
}
async function ob(e, t, n) {
	return await b(tb(e, t, n), e, t);
}
async function sb(e, t, n) {
	return await b(nb(e, t, n), e, t);
}
//#endregion
//#region src/custom-geoboundary.helper.ts
function cb(e, t) {
	let n = C(e, t, h.CustomGeoboundaries);
	if (!n) throw Error("🔴🔴🔴 No cloud function url define for uploading custom geoboundaries files 🔴🔴🔴");
	return n;
}
async function lb(e, t, n) {
	let r = `Bearer ${y.getInstance().getToken()}`, i = cb(e, t), a = {
		fileName: n,
		action: ie.GetSignedUrl
	};
	return (await (await fetch(i, {
		method: "POST",
		body: JSON.stringify(a),
		headers: { Authorization: r }
	})).json()).signed_url;
}
async function ub(e, t) {
	await fetch(e, {
		method: "PUT",
		body: t,
		headers: { "content-type": "application/octet-stream" }
	});
}
async function db(e, t, n, r) {
	let i = `Bearer ${y.getInstance().getToken()}`, a = cb(e, t), o = {
		fileName: r,
		fileId: n,
		action: ie.StoreFileData
	};
	return await (await fetch(a, {
		method: "POST",
		body: JSON.stringify(o),
		headers: { Authorization: i }
	})).json();
}
async function fb(e, t, n) {
	let r = `Bearer ${y.getInstance().getToken()}`, i = cb(e, t), a = {
		jobId: n,
		action: ie.CheckStatusStoreFileData
	};
	return await (await fetch(i, {
		method: "POST",
		body: JSON.stringify(a),
		headers: { Authorization: r }
	})).json();
}
async function pb(e, t, n, r) {
	let i = `Bearer ${y.getInstance().getToken()}`, a = cb(e, t), o = {
		fileId: n,
		fileName: r,
		action: ie.ProcessFileData
	};
	return await (await fetch(a, {
		method: "POST",
		body: JSON.stringify(o),
		headers: { Authorization: i }
	})).json();
}
async function mb(e, t, n) {
	let r = `Bearer ${y.getInstance().getToken()}`, i = cb(e, t), a = {
		fileId: n,
		action: ie.DeleteFileData
	};
	return await (await fetch(i, {
		method: "POST",
		body: JSON.stringify(a),
		headers: { Authorization: r }
	})).json();
}
function hb(e, t, n) {
	return `
    SELECT
      geoms as geom
    FROM ${S(e, t, e.data_model.custom_geoboundaries)} , UNNEST(geom) as geoms
    WHERE id IN (${n.map((e) => `'${e}'`).join(",")})
  `;
}
function gb(e, t, n) {
	return `
    SELECT COUNT(*) as occurrences FROM ${S(e, t, e.data_model.custom_geoboundaries)}
    WHERE id = '${n}' AND ARRAY_LENGTH(geom) > 0
  `;
}
//#endregion
//#region src/custom-geoboundary.service.ts
var _b = /* @__PURE__ */ u({
	checkStatusStoreFileDataJob: () => Eb,
	createCustomGeoboundary: () => bb,
	deleteCustomGeoboundary: () => Sb,
	deleteStoredFileData: () => Ob,
	getCustomGeoboundaries: () => vb,
	getCustomGeoboundary: () => yb,
	getGeometriesCustomFileGeometries: () => kb,
	getSignedURLUploadFile: () => Cb,
	isGeometryForFileIdAvailable: () => Ab,
	moveStoredRawDataAndClean: () => Db,
	storeFileDataJob: () => Tb,
	updateCustomGeoboundary: () => xb,
	uploadFileWithSignedURL: () => wb
});
async function vb(e, t, n) {
	let r = await zv(e, t, {
		collectionFullPath: [Z.CustomGeoboundaries],
		queryConstraints: [pp("is_public", "==", !0)]
	}), i = await zv(e, t, {
		collectionFullPath: [Z.CustomGeoboundaries],
		queryConstraints: [pp("created_by", "==", n), pp("is_public", "==", !1)]
	});
	return [...r, ...i];
}
async function yb(e, t, n) {
	return await Rv(e, t, n, Z.CustomGeoboundaries);
}
async function bb(e, t, n) {
	return await Bv(e, t, n, Z.CustomGeoboundaries);
}
async function xb(e, t, n, r) {
	await Vv(e, t, r, n, Z.CustomGeoboundaries);
}
async function Sb(e, t, n) {
	await Hv(e, t, n, Z.CustomGeoboundaries);
}
async function Cb(e, t, n) {
	return await lb(e, t, n);
}
async function wb(e, t) {
	await ub(e, t);
}
async function Tb(e, t, n, r) {
	return await db(e, t, n, r);
}
async function Eb(e, t, n) {
	return await fb(e, t, n);
}
async function Db(e, t, n, r) {
	return await pb(e, t, n, r);
}
async function Ob(e, t, n) {
	return await mb(e, t, n);
}
async function kb(e, t, n) {
	return (await b(hb(e, t, n), e, t)).map((e) => e.geom);
}
async function Ab(e, t, n) {
	return (await b(gb(e, t, n), e, t, !0))[0].occurrences === 1;
}
//#endregion
//#region src/export-custom-geoboundaries.helper.ts
var jb = [
	"region_16",
	"region_17",
	"region_18"
], Mb = {
	miles: 1609.344,
	kilometers: 1e3,
	meters: 1
};
function Nb(e) {
	return e.geometry.type === "Point" && !!e.properties?.radius;
}
function Pb(e) {
	if (Nb(e)) {
		let t = e.properties, n = t?.center, r = n?.lng ?? e.geometry.coordinates[0], i = n?.lat ?? e.geometry.coordinates[1], a = Mb[t?.units] ?? Mb.kilometers;
		return `ST_BUFFER(ST_GEOGPOINT(${r}, ${i}), ${t?.radius * a})`;
	}
	return `ST_GEOGFROM('${JSON.stringify(e.geometry)}')`;
}
function Fb(e) {
	if (!e) return [];
	let t = typeof e == "string" ? JSON.parse(e) : e;
	return Array.isArray(t) ? t : [];
}
function Ib(e) {
	if (!e) return [];
	let t = typeof e == "string" ? JSON.parse(e) : e;
	if (Array.isArray(t)) return t;
	let n = t.features;
	return Array.isArray(n) ? n : [];
}
function Lb(e, t) {
	t && Object.keys(t).forEach((n) => {
		if (jb.includes(n)) {
			let e = t[n];
			Array.isArray(e) && e.length > 0 && console.warn(`Skipping ${e.length} entries from ${n} of a custom geoboundary dataset during POI export; nested datasets and file geoboundaries are not expanded.`);
			return;
		}
		let r = t[n];
		!Array.isArray(r) || r.length === 0 || (e[n] = [...e[n] ?? [], ...r]);
	});
}
async function Rb(e, t, n) {
	let r = n.geoboundaries;
	if (!r) return n;
	let i = [...r.region_16 ?? [], ...r.region_17 ?? []];
	if (nn(i)) return n;
	let a = { ...r };
	delete a.region_16, delete a.region_17;
	let o = [...n.polygonGeom?.features ?? []];
	for (let n of i) {
		if (n.exclude === !0) continue;
		let [r] = Fb((await yb(e, t, String(n.id))).filters);
		if (!r) continue;
		Lb(a, r.geoboundaries);
		let i = Ib(r.polygon_geom);
		i.length > 0 && o.push(...i);
	}
	return {
		...n,
		geoboundaries: a,
		polygonGeom: {
			type: "FeatureCollection",
			features: o
		}
	};
}
//#endregion
//#region src/export.service.ts
var zb = /* @__PURE__ */ u({
	getAllPOIsValuesForRegions: () => qb,
	getAudiencesIndexValuesForAssests: () => Vb,
	getClosestPOIsValuesForAssets: () => Ub,
	getClosestPOIsValuesForSharedAssets: () => Wb,
	getMappingAssetPOIDistance: () => ax,
	getQueryAudiencesIndexValuesForAssests: () => Yb,
	getQueryClosestPOIsValuesForAssets: () => Zb,
	getSharedAllPOIsValuesForRegions: () => Jb,
	getSharedAudiencesIndexValuesForAssests: () => Hb,
	getSharedMappingAssetPOIDistance: () => ox
});
function Bb(e, t) {
	let n = C(e, t, h.SharedPlan);
	if (!n) throw Error("🔴🔴🔴 No cloud function url define for managing shared plans. Check .metadata file 🔴🔴🔴");
	return n;
}
async function Vb(e, t, n) {
	return await b(Yb(e, t, n), e, t);
}
async function Hb(e, t, n, r) {
	try {
		let i = new URLSearchParams(window.location.search).get("appVersion") || e.flavour, a = new URLSearchParams({
			action: _.SharedExportAudiencesAssets,
			appVersion: i,
			planId: n
		});
		r && a.set("password", r);
		let o = Bb(e, t);
		return o += `?${a.toString()}`, await (await fetch(o, { method: "POST" })).json();
	} catch (e) {
		throw Error(`Cloud function error ${D(e)}`);
	}
}
async function Ub(e, t, n, r, i) {
	if (!i) {
		let a = 5e4, o = await b(Zb(e, t, n, r, i, !0, null), e, t), s = parseInt(o[0].total_rows, 10);
		console.debug("Total rows expected for fetching POIs for assets:", s);
		let c = [];
		for (let o = 0; o < s; o += a) {
			let l = Math.min(o + a, s);
			console.debug(`     Fetching POIs for assets: ${o} - ${l}`);
			let u = await b(Zb(e, t, n, r, i, !1, {
				startRow: o,
				endRow: l
			}), e, t);
			console.debug(`     Chunk of ${u.length} POIs fetched`), c = c.concat(u), console.debug(`     Accumulated POIs fetched: ${c.length}`);
		}
		return console.debug(`Total POIs fetched: ${c.length}`), c;
	}
	return await b(Zb(e, t, n, r, i, !1, null), e, t);
}
async function Wb(e, t, n, r) {
	try {
		let i = new URLSearchParams(window.location.search).get("appVersion") || e.flavour, a = new URLSearchParams({
			action: _.SharedExportPoisAssets,
			appVersion: i,
			planId: n
		});
		r && a.set("password", r);
		let o = Bb(e, t);
		return o += `?${a.toString()}`, await (await fetch(o, { method: "POST" })).json();
	} catch (e) {
		throw Error(`Cloud function error ${D(e)}`);
	}
}
function Gb(e, t, n) {
	return nn(n) ? "" : `,
    filter_region_geoboundaries_with_geometry AS (
      ${`
      SELECT geom
      FROM ${S(e, t, e.data_model.regions)}
      WHERE id IN (${n.join(",")})
    `}
    ),
    ${te.GeoboundaryWithGeometry} AS (
      SELECT *
      from all_pois_geoboundaries_with_geometry t1
      JOIN filter_region_geoboundaries_with_geometry t2
        ON ST_INTERSECTS(t1.geom, t2.geom)
    ),
  `;
}
function Kb(e, t, n) {
	return !n.polygonGeom || n.polygonGeom.features.length === 0 ? "" : `,
    filter_region_custom_geoboundaries AS (
      ${`
    SELECT *
    FROM
      UNNEST([${n.polygonGeom.features.map((e) => Nb(e) ? Pb(e) : `ST_GEOGFROM('${JSON.stringify(e.geometry)}')`).join(",")}]) as geom
  `}
    ),
    ${te.CustomGeoboundaries} AS (
      SELECT *
      from all_pois_custom_geoboundaries t1
      JOIN filter_region_custom_geoboundaries t2
        ON ST_INTERSECTS(t1.geom, t2.geom)
    ),
  `;
}
async function qb(e, t, n, r) {
	return await b(await rx(e, t, n, r), e, t);
}
async function Jb(e, t, n, r, i, a) {
	try {
		let o = new URLSearchParams(window.location.search).get("appVersion") || e.flavour, s = new URLSearchParams({
			action: _.SharedExportAllPois,
			appVersion: o,
			planId: i
		});
		a && s.set("password", a);
		let c = Bb(e, t);
		return c += `?${s.toString()}`, await (await fetch(c, {
			method: "POST",
			body: JSON.stringify({
				filter: n,
				countryIds: r
			})
		})).json();
	} catch (e) {
		throw Error(`Cloud function error ${D(e)}`);
	}
}
function Yb(e, t, n) {
	let r = S(e, t, e.data_model.audiences), i = S(e, t, e.data_model.audiences_classes), a = n.countries ? E({
		columnName: "country_id",
		ids: n.countries,
		equalityOperator: w.EQUALS,
		logicalOperator: T.AND
	}) : "", o = n.delivery, s = Gy("audiences", "ld_audiences", o, !0), c = Gy("classes", "ld_classes", o, !1), l = o === null ? `WITH ${Uy(e, t, a)}` : "", u = E({
		columnName: "class_uid",
		ids: n.audience_ids,
		equalityOperator: w.EQUALS,
		logicalOperator: T.AND
	}), d = E({
		columnName: "asset_id",
		ids: n.asset_ids,
		equalityOperator: w.EQUALS,
		logicalOperator: T.AND,
		returnEmptyIfIdsEmpty: !0
	});
	return `
  ${l}
  SELECT audiences.asset_id,
    ARRAY_AGG(STRUCT(classes.audience as class, audiences.index as index) ORDER BY classes.audience) as audiences_values
  FROM ${r} audiences
  ${s.join}
  JOIN ${i} classes
    ON audiences.class_uid = classes.uid
   AND audiences.source_id = classes.source_id
  ${c.join}
  WHERE 1 = 1
  ${s.where}
  ${c.where}
  ${u}
  ${d}
  GROUP BY audiences.asset_id
  `;
}
function Xb(e, t, n) {
	let r = S(e, t, e.data_model.assets), i = S(e, t, e.data_model.pois_isochrones);
	return `
    total_area_assets AS (
      SELECT
        ST_CONVEXHULL(ST_UNION_AGG(geom)) AS total_area_assets
      FROM ${r}
      WHERE ${E({
		columnName: "id",
		ids: n.asset_ids,
		equalityOperator: w.EQUALS,
		logicalOperator: T.NONE,
		returnEmptyIfIdsEmpty: !0
	})}
    ),
    isochrones AS (
      SELECT
        geoid, geom
      FROM ${i} isochrones, total_area_assets taa
      WHERE
        geoid in (SELECT id from all_pois)
        AND method = '${n.method}'
        AND time = ${n.distance}
        AND ST_INTERSECTS(geom, taa.total_area_assets)
    ),
  `;
}
function Zb(e, t, n, r, i, a, o) {
	let s = S(e, t, e.data_model.assets), { partialQuery: c } = by(e, t, n, r, Qe(e), $e(e), i), l = E({
		columnName: "assets.id",
		ids: n.asset_ids,
		equalityOperator: w.EQUALS,
		logicalOperator: T.NONE,
		returnEmptyIfIdsEmpty: !0
	}), u = "", d = "", f = "";
	n.method === "RADIUS" ? u = ` WHERE distance <= ${n.max_distance} AND distance >= ${n.min_distance}` : (f = Xb(e, t, n), d = " AND pois_filtered.id IN (SELECT geoid FROM isochrones)");
	let p = "";
	i && (p = " WHERE rn = 1");
	let m = "*", h = "ORDER BY asset_id, rn";
	a && (m = "COUNT(*) as total_rows", h = "");
	let g = "";
	return o && (g = `LIMIT ${o.endRow - o.startRow}
    OFFSET ${o.startRow}`), `
    ${c},
    ${f}

    distances_between_assets_and_pois AS (
      SELECT
          assets.id as asset_id,
          pois_filtered.* except(geom),
          ST_DISTANCE(assets.geom, pois_filtered.geom) as distance
      FROM ${s} assets, all_pois pois_filtered
      WHERE ${l} ${d}
    ),

    distances_between_assets_and_pois_filtered_distance AS (
      SELECT
        *
      FROM distances_between_assets_and_pois
      ${u}
    ),

    ranked_distances AS (
      SELECT
        *,
        ROW_NUMBER() OVER (PARTITION BY asset_id ORDER BY distance ASC) AS rn
      FROM distances_between_assets_and_pois_filtered_distance
    )

    SELECT
    ${m}
    FROM ranked_distances
    ${p}
    ${h}
    ${g}
  `;
}
function Qb(e, t, n) {
	let r = [], i = "SELECT id, name, address, zip_code, city, geoid";
	e && r.push(`${i} FROM ${te.GeoboundaryWithOutGeometry}`), t && r.push(`${i} FROM ${te.GeoboundaryWithGeometry}`), n && r.push(`${i} FROM ${te.CustomGeoboundaries}`);
	let a = r.join("\n UNION DISTINCT\n");
	return `
    ${te.CombinateGeoboundaries} AS (
      ${a}
    )
  `;
}
async function $b(e, t, n, r) {
	let i = await b(`
    SELECT id, name
    FROM ${S(e, t, e.data_model.regions)}
    ${E({
		columnName: "name",
		ids: n,
		equalityOperator: w.EQUALS,
		logicalOperator: T.WHERE
	})}
    ${E({
		columnName: "country_id",
		ids: [r],
		equalityOperator: w.EQUALS,
		logicalOperator: T.AND
	})}
    AND type_id = 10
    `, e, t), a = /* @__PURE__ */ new Map();
	return i.forEach((e) => {
		a.set(e.name, e.id);
	}), a;
}
async function ex(e, t, n, r) {
	if (!n) return n;
	let i = r[0], a = n.region_15;
	if (!a || a.length === 0) return n;
	if (r.length !== 1) throw Error("🔴🔴🔴 When using geoboundaries from file, only one country is allowed in the filter 🔴🔴🔴");
	let o = { ...n };
	for (let n of a) if (n.entities) {
		let r = await $b(e, t, n.entities, i), a = n.entities.map((e) => ({
			countryId: n.countryId || i,
			has_geometry: n.has_geometry,
			id: r.get(e) || -1,
			name: e,
			type: "zip_code",
			exclude: n.exclude,
			type_id: 10
		}));
		o.region_10 = [...o.region_10 ?? [], ...a];
	}
	return o.region_15 = [], o;
}
async function tx(e, t, n, r) {
	let i = [], a = await ex(e, t, n.geoboundaries, r);
	if (a && (i = Object.values(a).flat()), nn(i)) {
		let e = r;
		return n.polygonGeom && !nn(n.polygonGeom.features) && (e = []), {
			countryIdsForGeoboundariesWithOutGeometry: e,
			countryIdsForGeoboundariesWithGeometry: [],
			geoboundariesWithGeometry: []
		};
	}
	let o = /* @__PURE__ */ new Set(), s = /* @__PURE__ */ new Set(), c = [];
	i.forEach((e) => {
		if (e.has_geometry) {
			if (e.countryId === void 0) if (r.length === 1) e.countryId = r[0];
			else throw Error("🔴🔴🔴 Region countryId is undefined and there are multiple countries in the filter. Cannot proceed 🔴🔴🔴");
			o.add(e.countryId), c.push(e);
		} else s.add(e.countryId);
	});
	let l = Array.from(o), u = Array.from(s), d = l.filter((e) => !u.includes(e));
	return {
		countryIdsForGeoboundariesWithGeometry: d,
		countryIdsForGeoboundariesWithOutGeometry: u,
		geoboundariesWithGeometry: c.filter((e) => d.includes(e.countryId)).map((e) => e.id)
	};
}
function nx(e) {
	return !!(e.polygonGeom && e.polygonGeom.features.length > 0);
}
async function rx(e, t, n, r) {
	let i = await Rb(e, t, n), a = Qe(e), o = $e(e), s = nx(i), c = "", l = "", u = "", d = "", f = "", { countryIdsForGeoboundariesWithOutGeometry: p, countryIdsForGeoboundariesWithGeometry: m, geoboundariesWithGeometry: h } = await tx(e, t, i, r);
	if (rn(p)) {
		let { partialQuery: n } = by(e, t, i, p, a, o, !0, ee.GeoboundariesWithOutGeometry);
		c = `${n},`;
	}
	if (rn(m)) {
		let { partialQuery: n } = by(e, t, i, m, a, o, !0, ee.GeoboundariesWithGeometry);
		l = n, u = Gb(e, t, h);
	}
	if (s) {
		let { partialQuery: n } = by(e, t, i, r, a, o, !0, ee.CustomGeoboundaries);
		d = n, f = Kb(e, t, i);
	}
	c.length > 0 && (l = l.substring(4)), (c.length > 0 || l.length > 0) && (d = d.substring(4));
	let g = Qb(c.length > 10, u.length > 10, d.length > 10), _ = te.CombinateGeoboundaries;
	return `
    /* POIs with Country scope because there are geoboundaries without geometry */
    ${c}

    /* POIs with Geoboundaries with geometry */
    ${l}
    ${u}

    /* POIs from custom geoboundaries */
    ${d}
    ${f}

    /* Union distinct for all queries to get all POIs */
    ${g}

    SELECT
     id,
     name,
     address,
     zip_code,
     city,
     geoid
    FROM ${_}
    ORDER BY id
  `;
}
function ix(e, t, n, r, i, a, o, s, c) {
	let l = S(e, t, e.data_model.assets), u = S(e, t, e.data_model.pois), d = S(e, t, e.data_model.custom_pois), f = `
  pois AS (
    SELECT
      assets.internal_panel_id as internalPanelId,
      assets.external_panel_id as externalPanelId,
      pois.geoid as poiId,
      pois.location_name as poiName,
      COALESCE(pois.street_address, '') as poiAddress,
      COALESCE(pois.city, '') as poiCity,
      COALESCE(pois.postal_code, '') as poiPostalCode,
      ROUND(ST_DISTANCE(assets.geom, pois.geom)) as distance
    FROM assets
    JOIN ${u} pois
    ON (
      ST_DISTANCE(assets.geom, pois.geom) <= ${o} AND
      ST_DISTANCE(assets.geom, pois.geom) >= ${a}
    )
    WHERE pois.geoid IN ('${r.map((e) => e.replaceAll("'", "\\'")).join("','")}')
    AND pois.country_id <> -1
  ),`, p = `
      custom_pois_data AS (
        SELECT
          pois_unnested.geom as geom,
          pois_unnested.name as poiName,
          SPLIT(pois_unnested.address, '#%%#')[SAFE_OFFSET(0)] as poiAddress,
          SPLIT(pois_unnested.address, '#%%#')[SAFE_OFFSET(1)] as poiCity,
          SPLIT(pois_unnested.address, '#%%#')[SAFE_OFFSET(2)] as poiPostalCode,
          CONCAT(cp.name, '-',pois_unnested.name) as id
        FROM ${d} cp,
        UNNEST(pois) as pois_unnested
        where cp.id IN ('${i.map((e) => e.replaceAll("'", "\\'")).join("','")}')
      ),
      custom_pois AS (
        SELECT
          assets.internal_panel_id as internalPanelId,
          assets.external_panel_id as externalPanelId,
          custom_pois_data.id as poiId,
          custom_pois_data.poiName as poiName,
          COALESCE(custom_pois_data.poiAddress, '') as poiAddress,
          COALESCE(custom_pois_data.poiCity, '') as poiCity,
          COALESCE(custom_pois_data.poiPostalCode, '') as poiPostalCode,
          ROUND(ST_DISTANCE(assets.geom, custom_pois_data.geom)) as distance
        FROM assets
        JOIN custom_pois_data
        ON (
          ST_DISTANCE(assets.geom, custom_pois_data.geom) <= ${o} AND
          ST_DISTANCE(assets.geom, custom_pois_data.geom) >= ${a}
        )
      ),`, m = s ? "COUNT(*) as total_rows" : "*", h = "", g = "";
	return c && (h = "ORDER BY internalPanelId, distance, poiId", g = `LIMIT ${c.endRow - c.startRow} OFFSET ${c.startRow}`), `
  WITH assets AS (
    SELECT
      id,
      internal_panel_id,
      external_panel_id,
      geom
    FROM ${l} assets
    WHERE assets.id IN ('${n.join("','")}')
  ),
  ${f}
  ${p}
  
    union_all AS (
      SELECT * FROM pois
      UNION DISTINCT
      SELECT * FROM custom_pois
    )
  SELECT ${m} FROM union_all
  ${h}
  ${g}
  `;
}
async function ax(e, t, n, r, i, a, o) {
	let s = 5e4, c = await b(ix(e, t, n, r, i, a, o, !0, null), e, t), l = parseInt(c[0].total_rows, 10);
	console.debug("Total rows expected for fetching combination of assets and POIs distance:", l);
	let u = [];
	for (let c = 0; c < l; c += s) {
		let d = Math.min(c + s, l);
		console.debug(`     Fetching asset-POI distances: ${c} - ${d}`);
		let f = await b(ix(e, t, n, r, i, a, o, !1, {
			startRow: c,
			endRow: d
		}), e, t);
		console.debug(`     Chunk of ${f.length} distances fetched`), u = u.concat(f), console.debug(`     Accumulated distances fetched: ${u.length}`);
	}
	return console.debug(`Total asset-POI distances fetched: ${u.length}`), u;
}
async function ox(e, t, n, r, i) {
	console.debug("getSharedMappingAssetPOIDistance, poisIds length:", r.length);
	try {
		let a = new URLSearchParams(window.location.search).get("appVersion") || e.flavour, o = new URLSearchParams({
			action: _.SharedExportAssetsPOIsDistance,
			appVersion: a,
			planId: n
		});
		i && o.set("password", i);
		let s = Bb(e, t);
		return s += `?${o.toString()}`, await (await fetch(s, {
			method: "POST",
			body: JSON.stringify({ poisIds: r })
		})).json();
	} catch (e) {
		throw Error(`Cloud function error ${D(e)}`);
	}
}
//#endregion
//#region src/geocoding.service.ts
var sx = /* @__PURE__ */ u({ geocoding: () => lx });
function cx(e, t) {
	let n = C(e, t, h.Geocoding);
	if (!n) throw Error("🔴🔴🔴 No cloud function url define for geocoding in shared plans. Check .metadata file 🔴🔴🔴");
	return n;
}
async function lx(e, t, n, r, i, a, o, s, c) {
	let l = i.length ? `&country=${i}` : "", u = Le(e, t), d = `${n}/v3/lds/geocoding/geocode`;
	if (d += `?address=${encodeURIComponent(r)}`, d += l, d += `&limit=${a}`, d += `&client=${encodeURIComponent(u)}`, !o) {
		let e = { Authorization: `Bearer ${y.getInstance().getToken()}` }, t = await (await fetch(d, {
			method: "GET",
			headers: e
		})).json();
		if (t[0].error) throw Error(t[0].error);
		return t[0].value;
	}
	try {
		let n = cx(e, t), r = new URLSearchParams({
			appVersion: e.flavour,
			planId: s,
			geocodingUrl: encodeURIComponent(d),
			password: c
		});
		return n += `?${r.toString()}`, await (await fetch(n, { method: "GET" })).json();
	} catch (e) {
		throw Error(`Cloud function error ${D(e)}`);
	}
}
//#endregion
//#region src/audit.service.ts
var ux = /* @__PURE__ */ u({ createEvent: () => dx });
async function dx(e, t, n) {
	return await Bv(e, t, n, Z.Audit);
}
//#endregion
//#region src/isochrone.service.ts
var fx = /* @__PURE__ */ u({
	checkStatusPoisIsochronesJob: () => vx,
	createPoisIsochronesJob: () => _x,
	getLdsStats: () => gx,
	getPoisWithIsochrone: () => hx,
	getPoisWithoutIsochrone: () => mx
});
function px(e, t, n) {
	let r = "";
	return n.length > 0 && (r = `
    join ${S(e, t, e.data_model.regions)} r
      on p.country_id = r.country_id
        and r.id in (${n.join(",")})
        and ST_INTERSECTS(p.geom, r.geom)
    `), `
  , all_pois_geoboundaries AS (
    select p.*
    from all_pois_isochrones p
    ${r}
  ), `;
}
async function mx(e, t, n) {
	let r = S(e, t, e.data_model.pois_isochrones), i = e.plan_filters.widget_proximity.pois_isochrones_fields.map((e) => `p.${e}`), a = e.plan_filters.widget_proximity.pois_isochrones_fields, { partialQuery: o } = by(e, t, n.proximity, n.countryIds, i, a), s = `
    ${o}
    ${px(e, t, n.geoboundaries)}

    isochrones AS (
        SELECT geoid, country_id, geom
        FROM  ${r}
        WHERE country_id in (${n.countryIds.join(",")})
        AND method = '${n.proximity.method}'
        AND time = ${n.proximity.distance}
    )

    SELECT
      t1.geoid,
      t1.country_id,
      t1.geom
    FROM all_pois_geoboundaries t1
    LEFT JOIN isochrones t2
    ON t1.geoid = t2.geoid AND t1.country_id = t2.country_id
    WHERE
      t2.geom IS NULL
      AND ST_Y(t1.geom) BETWEEN -90 AND 90
      AND ST_X(t1.geom) BETWEEN -180 AND 180
  `;
	return {
		count: (await b(s, e, t, !0)).length,
		query: s
	};
}
async function hx(e, t, n) {
	let r = S(e, t, e.data_model.pois_isochrones), i = [], a = e.plan_filters.widget_proximity.pois_isochrones_fields, { partialQuery: o } = by(e, t, n.proximity, n.countryIds, i, a);
	return await b(`
    ${o}
    ${px(e, t, n.geoboundaries)}

    isochrones AS (
        SELECT geoid, country_id, geom
        FROM  ${r}
        WHERE country_id in (${n.countryIds.join(",")})
        AND method = '${n.proximity.method}'
        AND time = ${n.proximity.distance}
    )

    SELECT
      t2.geom as geometry
    FROM all_pois_geoboundaries t1
    LEFT JOIN isochrones t2
    ON t1.geoid = t2.geoid AND t1.country_id = t2.country_id
    WHERE
      t2.geom IS NOT NULL
      AND ST_Y(t1.geom) BETWEEN -90 AND 90
      AND ST_X(t1.geom) BETWEEN -180 AND 180
  `, e, t, !0);
}
async function gx(e, t) {
	let n = y.getInstance().getToken(), r = Le(e, t), i = `${e.base_url}/v3/lds/stats?client=${encodeURIComponent(r)}`, a = { Authorization: `Bearer ${n}` }, o = await (await fetch(i, {
		method: "GET",
		headers: a
	})).json();
	if (o[0].error) throw Error(o[0].error);
	return o[0];
}
async function _x(e, t, n, r) {
	let i = `Bearer ${y.getInstance().getToken()}`;
	try {
		let a = C(e, t, h.Isochrones);
		if (!a) throw Error("🔴🔴🔴 No cloud function url define for calculating isochrones 🔴🔴🔴");
		let o = {
			bq_project: Ge(e, t),
			base_url: e.base_url,
			method: n.proximity.method,
			distance: n.proximity.distance,
			pois_query: r,
			action: "create"
		};
		return (await (await fetch(a, {
			method: "POST",
			body: JSON.stringify(o),
			headers: { Authorization: i }
		})).json()).job;
	} catch (e) {
		throw Error(`Cloud function error ${D(e)}`);
	}
}
async function vx(e, t, n) {
	let r = `Bearer ${y.getInstance().getToken()}`, i = {
		jobId: n,
		action: "status"
	};
	try {
		let n = C(e, t, h.Isochrones);
		if (!n) throw Error("🔴🔴🔴 No cloud function url define for calculating isochrones 🔴🔴🔴");
		return await (await fetch(n, {
			method: "POST",
			body: JSON.stringify(i),
			headers: { Authorization: r }
		})).json();
	} catch (e) {
		throw Error(`Cloud function error ${D(e)}`);
	}
}
//#endregion
//#region src/sharePlan.service.ts
var yx = /* @__PURE__ */ u({
	createSharePlan: () => Sx,
	genericCallToCloudFunction: () => Ix,
	getAssetById: () => kx,
	getAssets: () => wx,
	getCustomPOIs: () => Ox,
	getGeometries: () => Tx,
	getInsights: () => Ax,
	getPlan: () => Cx,
	getSharedActiveCustomPoisGroups: () => Dx,
	getSharedPlanAdvanceOptions: () => Fx,
	getSharedPlanAudiencesQuintiles: () => Px,
	getSharedPlanContent: () => jx,
	getSharedPlanContentFromPlanId: () => Mx,
	getSharedPlanInfo: () => xx,
	getSharedPlanPoisWithIsochrone: () => Ex,
	updateSharedPlanContent: () => Nx
});
function bx(e, t) {
	let n = C(e, t, h.SharedPlan);
	if (!n) throw Error("🔴🔴🔴 No cloud function url define for managin shared plans. Check .metadata file 🔴🔴🔴");
	return n;
}
async function xx(e, t, n, r) {
	let i = new URLSearchParams({
		action: _.GetSharedPlanInfo,
		planId: n,
		appVersion: r
	}), a = !1, o = !0, s = !1, c = !1;
	try {
		let n = bx(e, t);
		n += `?${i.toString()}`;
		let r = await fetch(n, { method: "GET" }), l = await r.json();
		if (r.ok) return a = !0, o = l.passwordRequired, {
			isActive: a,
			isPasswordRequired: o,
			isPlanNotFound: s,
			isExpired: c
		};
		if (r.status === 401 && l.code) switch (l.code) {
			case ne.PlanNotFound:
				s = !0;
				break;
			case ne.SharedPlanExpired:
				c = !0;
				break;
			case ne.SharedPlanNotEnabled:
				a = !1;
				break;
			case ne.SharedPlanInvalidPassword:
				a = !0, o = !0;
				break;
		}
		return {
			isActive: a,
			isPasswordRequired: o,
			isPlanNotFound: s,
			isExpired: c
		};
	} catch (e) {
		throw Error(`Cloud function error ${D(e)}`);
	}
}
async function Sx(e, t, n) {
	let r = `Bearer ${y.getInstance().getToken()}`, i = new URLSearchParams({
		action: _.Share,
		planId: n.planId
	}), a = { expiracyDate: n.expiracyDate };
	n.password && (a.password = n.password);
	try {
		let n = bx(e, t);
		return n += `?${i.toString()}`, await (await fetch(n, {
			method: "POST",
			headers: { Authorization: r },
			body: JSON.stringify(a)
		})).json();
	} catch (e) {
		throw Error(`Cloud function error ${D(e)}`);
	}
}
async function Cx(e, t, n) {
	let r = new URLSearchParams({
		action: _.Plan,
		planId: n.planId,
		appVersion: n.appVersion
	});
	n.password && r.append("password", n.password);
	try {
		let n = bx(e, t);
		n += `?${r.toString()}`;
		let i = await fetch(n, { method: "GET" });
		if (i.status >= 400) throw Error(`Cloud function error ${i.statusText}`);
		return await i.json();
	} catch (e) {
		throw Error(`Cloud function error ${D(e)}`);
	}
}
async function wx(e, t, n) {
	let r = new URLSearchParams({
		action: _.Assets,
		planId: n.planId,
		appVersion: n.appVersion
	});
	n.password && r.append("password", n.password), n.assetsOffset !== void 0 && (r.delete("action"), r.append("action", _.AssetsPagination), r.append("assetsOffset", n.assetsOffset.toString()), r.append("token", n.token || ""), r.append("iv", n.iv || ""));
	try {
		let n = bx(e, t);
		n += `?${r.toString()}`;
		let i = await fetch(n, { method: "GET" }), a = await i.json();
		if (i.ok) return a;
		throw Error(a);
	} catch (e) {
		throw Error(`Cloud function error ${D(e)}`);
	}
}
async function Tx(e, t, n) {
	let r = new URLSearchParams({
		action: _.Geoboundary,
		planId: n.planId,
		appVersion: n.appVersion
	});
	n.password && r.append("password", n.password);
	try {
		let n = bx(e, t);
		return n += `?${r.toString()}`, await (await fetch(n, { method: "GET" })).json();
	} catch (e) {
		throw Error(`Cloud function error ${D(e)}`);
	}
}
async function Ex(e, t, n) {
	let r = new URLSearchParams({
		action: _.Isochrones,
		planId: n.planId,
		appVersion: n.appVersion
	}), i = {};
	n.password && (i.password = n.password), n.isochronesFilter && (i.isochronesFilter = n.isochronesFilter);
	try {
		let n = bx(e, t);
		return n += `?${r.toString()}`, await (await fetch(n, {
			method: "POST",
			body: JSON.stringify(i)
		})).json();
	} catch (e) {
		throw Error(`Cloud function error ${D(e)}`);
	}
}
async function Dx(e, t, n) {
	let r = new URLSearchParams({
		action: _.ExistCustomPOIsGroups,
		planId: n.planId,
		appVersion: n.appVersion,
		customPoisIds: n.customPoisIds?.join(",") || ""
	});
	try {
		let n = bx(e, t);
		return n += `?${r.toString()}`, await (await fetch(n, { method: "GET" })).json();
	} catch (e) {
		throw Error(`Cloud function error ${D(e)}`);
	}
}
async function Ox(e, t, n, r) {
	let i = new URLSearchParams({
		action: _.CustomPOIs,
		planId: n.planId,
		appVersion: n.appVersion,
		activeSubPlanFiltersIndex: r.toString()
	});
	n.password && i.append("password", n.password);
	try {
		let n = bx(e, t);
		n += `?${i.toString()}`;
		let r = await fetch(n, { method: "GET" }), a = await r.json();
		if (r.ok) return a;
		throw Error(a);
	} catch (e) {
		throw Error(`Cloud function error ${D(e)}`);
	}
}
async function kx(e, t, n, r) {
	let i = new URLSearchParams({
		action: _.Asset,
		planId: n.planId,
		appVersion: n.appVersion,
		assetId: r
	});
	n.password && i.append("password", n.password);
	try {
		let n = bx(e, t);
		n += `?${i.toString()}`;
		let r = await fetch(n, { method: "GET" }), a = await r.json();
		if (r.ok) return a;
		throw Error(a);
	} catch (e) {
		throw Error(`Cloud function error ${D(e)}`);
	}
}
async function Ax(e, t, n) {
	let r = new URLSearchParams({
		action: _.Insights,
		planId: n.planId,
		appVersion: n.appVersion
	});
	n.password && r.append("password", n.password);
	try {
		let n = bx(e, t);
		n += `?${r.toString()}`;
		let i = await fetch(n, { method: "GET" }), a = await i.json();
		if (i.ok) return a;
		throw Error(a);
	} catch (e) {
		throw Error(`Cloud function error ${D(e)}`);
	}
}
async function jx(e, t, n) {
	return await Rv(e, t, n, Z.SharedPlans);
}
async function Mx(e, t, n) {
	let r = [pp("planId", "==", n)], i = (await zv(e, t, {
		collectionFullPath: [Z.SharedPlans],
		queryConstraints: r
	}))[0];
	return i ? (i.expiracyDate = i.expiracyDate.toDate(), i.creationDate = i.creationDate.toDate(), i) : null;
}
async function Nx(e, t, n, r) {
	await Vv(e, t, r, n, Z.SharedPlans);
}
async function Px(e, t, n) {
	let r = new URLSearchParams({
		action: _.AudiencesQuintiles,
		planId: n.planId,
		appVersion: n.appVersion
	});
	n.password && r.append("password", n.password);
	try {
		let n = bx(e, t);
		n += `?${r.toString()}`;
		let i = await fetch(n, { method: "GET" }), a = await i.json();
		if (i.ok) return a;
		throw Error(a);
	} catch (e) {
		throw Error(`Cloud function error ${D(e)}`);
	}
}
async function Fx(e, t, n, r) {
	let i = new URLSearchParams({
		action: _.AdvanceOptions,
		planId: n.planId,
		appVersion: n.appVersion
	});
	n.password && i.append("password", n.password), r && i.append("export", r.toString());
	try {
		let n = bx(e, t);
		return n += `?${i.toString()}`, await (await fetch(n, { method: "GET" })).json();
	} catch (e) {
		throw Error(`Cloud function error ${D(e)}`);
	}
}
async function Ix(e, t, n, r, i) {
	let a = new URLSearchParams({
		action: r,
		planId: n.planId,
		appVersion: n.appVersion
	});
	n.password && a.append("password", n.password), i && a.append("export", i.toString()), n.mappingValues?.length && a.append("values", JSON.stringify(n.mappingValues));
	try {
		let n = bx(e, t);
		return n += `?${a.toString()}`, await (await fetch(n, { method: "GET" })).json();
	} catch (e) {
		throw Error(`Cloud function error ${D(e)}`);
	}
}
//#endregion
//#region src/geometry.service.ts
var Lx = /* @__PURE__ */ u({ getGeometriesCustomFileGeometries: () => zx });
function Rx(e, t, n) {
	return `
    SELECT
      geoms as geom
    FROM ${S(e, t, e.data_model.custom_geoboundaries)} , UNNEST(geom) as geoms
    WHERE id IN (${n.map((e) => `'${e}'`).join(",")})
    ORDER BY id ASC
  `;
}
async function zx(e, t, n) {
	return (await b(Rx(e, t, n), e, t)).map((e) => e.geom);
}
//#endregion
//#region src/client.service.ts
var Bx = /* @__PURE__ */ u({
	createClient: () => Hx,
	getAllClients: () => Vx
});
async function Vx(e, t) {
	return await zv(e, t, {
		collectionFullPath: [Z.Clients],
		queryConstraints: []
	});
}
async function Hx(e, t, n) {
	try {
		await Bv(e, t, n, Z.Clients);
	} catch (e) {
		let t = `Could not save client with name ${n.name}`;
		throw console.error(`${t}`, e), Error(t);
	}
}
//#endregion
//#region src/brand.service.ts
var Ux = /* @__PURE__ */ u({
	createBrand: () => Gx,
	getAllBrands: () => Wx
});
async function Wx(e, t) {
	return await zv(e, t, {
		collectionFullPath: [Z.Brands],
		queryConstraints: []
	});
}
async function Gx(e, t, n) {
	try {
		await Bv(e, t, n, Z.Brands);
	} catch (e) {
		let t = `Could not save brand with name ${n.name}`;
		throw console.error(`${t}`, e), Error(t);
	}
}
//#endregion
//#region src/carto-metric-event.service.ts
var Kx = /* @__PURE__ */ u({ sendCartoMetricEvent: () => qx });
async function qx(e, t, n) {
	let r = y.getInstance().getToken(), { apiBaseUrl: i } = qe(e, t), a = rt(e), o = {
		accessToken: r,
		apiBaseUrl: i
	};
	await _e({
		abortController: new AbortController().signal,
		credentials: o,
		method: le.Post,
		body: n,
		url: a
	});
}
//#endregion
//#region src/signed-url.service.ts
var Jx = /* @__PURE__ */ u({ getSignedUrlForFile: () => Yx });
async function Yx(e, t, n, r, i, a) {
	let o = C(e, t, h.SignedUrls);
	if (!o) throw Error("🔴🔴🔴 No cloud function url define for managing signed urls. Check .env file 🔴🔴🔴");
	let s = new URLSearchParams({
		action: a,
		bucketName: r,
		fileName: n,
		type: i
	}).toString(), c = `Bearer ${y.getInstance().getToken()}`;
	return (await (await fetch(`${o}?${s}`, {
		method: "GET",
		headers: { Authorization: c }
	})).json()).url;
}
//#endregion
//#region src/firestore/firestore.subscriber.ts
async function Xx(e, t, n) {
	let r = _v(t, n);
	return jp(e, (e) => {
		console.debug(`⭕️ 👋 Firestore has tell us document has been updated, waiting ${n}s before running callback`), r(e.data());
	});
}
async function Zx(e, t, n, r) {
	return Xx(Tf(await kv(e, t), `${t.isTesting() ? e.flavour_testing : e.flavour}_${Z.Subscriptions}`, Pp.Plans), r, n * 1e3);
}
//#endregion
//#region src/audiences-quintile-browser.service.ts
var Qx = /* @__PURE__ */ u({ getAudiencesQuintileOptions: () => $x });
async function $x(e, t, n) {
	let r = e.data_model.audiences_quintile;
	if (!r) throw Error("audiences_quintile table name not defined in metadata");
	let i = S(e, t, r), a = n.dma;
	return await b(`
  SELECT
    Variable as id, Segment as name
  FROM ${i}
  ${E({
		columnName: "DMA",
		ids: a,
		equalityOperator: w.EQUALS,
		logicalOperator: T.WHERE
	})}
  GROUP BY Variable, Segment
  `, e, t);
}
//#endregion
//#region src/audiences-quintile.service.ts
var eS = /* @__PURE__ */ u({
	getAssetsToShow: () => tS,
	getZipCodesByQuintile: () => iS
});
async function tS(e, t, n) {
	let r = e.data_model.audiences_quintile;
	if (!r) throw Error("audiences_quintile table name not defined in metadata");
	let i = S(e, t, r), a = e.data_model.assets, o = S(e, t, a), s = n.geoboundary.dma;
	return await b(`
  WITH zip_codes AS (
    SELECT CAST(ZIP AS string)
    FROM ${i}
      ${E({
		columnName: "DMA",
		ids: s,
		equalityOperator: w.EQUALS,
		logicalOperator: T.WHERE
	})}
      ${E({
		columnName: "Variable",
		ids: n.audiencesQuintile.audiences,
		equalityOperator: w.EQUALS,
		logicalOperator: T.AND
	})}
      ${E({
		columnName: "QUINTILE",
		ids: n.audiencesQuintile.quintiles,
		equalityOperator: w.EQUALS,
		logicalOperator: T.AND
	})}
  )
  SELECT id as asset_id
  FROM ${o}
    WHERE zip_code_name in (Select * from zip_codes)
  ORDER BY asset_id
  `, e, t);
}
async function nS(e, t, n) {
	let r = e.data_model.audiences_quintile;
	if (!r) throw Error("audiences_quintile table name not defined in metadata");
	let i = S(e, t, r), a = n.geoboundary.dma;
	return await b(`
    SELECT ZIP AS zipCode, Value as value, QUINTILE AS quintile
    FROM ${i}
      ${E({
		columnName: "DMA",
		ids: a,
		equalityOperator: w.EQUALS,
		logicalOperator: T.WHERE
	})}
      ${E({
		columnName: "Variable",
		ids: n.audiencesQuintile.audiences,
		equalityOperator: w.EQUALS,
		logicalOperator: T.AND
	})}
    `, e, t);
}
async function rS(e, t, n) {
	let r = C(e, t, h.SharedPlan), i = new URLSearchParams(window.location.search).get("appVersion") || e.flavour, a = new URLSearchParams({
		action: _.SharedExportAudiencesAssets,
		appVersion: i,
		planId: n
	});
	return r += `?${a.toString()}`, await (await fetch(r, {
		method: "POST",
		body: JSON.stringify({ planId: n })
	})).json();
}
async function iS(e, t, n, r) {
	return t.isSharePlan().sharing ? rS(e, t, r) : nS(e, t, n);
}
//#endregion
//#region src/stats.service.ts
var aS = /* @__PURE__ */ u({
	getMaxEditorUsersQuota: () => sS,
	getMaxEditorUsersUsage: () => cS
}), oS = "https://accounts.app.carto.com/accounts";
async function sS() {
	let e = { Authorization: `Bearer ${y.getInstance().getToken()}` }, t = await (await fetch(oS, {
		method: "GET",
		headers: e
	})).json(), n = Number(t?.quotas?.max_editor_users);
	if (isNaN(n)) throw Error("Max editor users quota limit not available in stats service");
	return n;
}
async function cS() {
	let e = { Authorization: `Bearer ${y.getInstance().getToken()}` }, t = await (await fetch("https://accounts.app.carto.com/accounts/stats", {
		method: "GET",
		headers: e
	})).json(), n = Number(t?.editorUsers);
	if (isNaN(n)) throw Error("Max editor users usage not available in stats service");
	return n;
}
//#endregion
//#region src/advance-options.service.ts
var lS = /* @__PURE__ */ u({
	getExportFileColumnsSelection: () => uS,
	updateExportFileColumnsSelection: () => dS
});
async function uS(e, t, n) {
	return (await Rv(e, t, n, Z.AdvanceOptionsExportColumns)).columns;
}
async function dS(e, t, n, r) {
	await Vv(e, t, {
		id: n,
		columns: r
	}, n, Z.AdvanceOptionsExportColumns);
}
//#endregion
//#region src/pois-tileset.service.ts
var fS = /* @__PURE__ */ u({
	getIdsForBrands: () => pS,
	getIdsForSubCategories: () => gS,
	getIdsForTags: () => mS,
	getIdsForTopCategories: () => hS
});
async function pS(e, t, n) {
	return (await b(`
    SELECT id
    FROM ${S(e, t, e.data_model.pois_unique_brands)}
    ${E({
		columnName: "brand",
		ids: n,
		equalityOperator: w.EQUALS,
		logicalOperator: T.WHERE
	})}
    `, e, t)).map((e) => Number(e.id));
}
async function mS(e, t, n) {
	return (await b(`
    SELECT id
    FROM ${S(e, t, e.data_model.pois_unique_category_tags)}
    ${E({
		columnName: "category",
		ids: n,
		equalityOperator: w.EQUALS,
		logicalOperator: T.WHERE
	})}
    `, e, t)).map((e) => Number(e.id));
}
async function hS(e, t, n) {
	return (await b(`
    SELECT id
    FROM ${S(e, t, e.data_model.pois_unique_top_categories)}
    ${E({
		columnName: "top_category",
		ids: n,
		equalityOperator: w.EQUALS,
		logicalOperator: T.WHERE
	})}
    `, e, t)).map((e) => Number(e.id));
}
async function gS(e, t, n) {
	return (await b(`
    SELECT id
    FROM ${S(e, t, e.data_model.pois_unique_sub_categories)}
    ${E({
		columnName: "sub_category",
		ids: n,
		equalityOperator: w.EQUALS,
		logicalOperator: T.WHERE
	})}
    `, e, t)).map((e) => Number(e.id));
}
//#endregion
export { lS as AdvanceOptionsService, Et as AssetsService, ny as AudienceService, Qx as AudiencesQuintileBrowserService, eS as AudiencesQuintileService, ux as AuditService, y as AuthManager, Ux as BrandService, ze as CacheManager, Kx as CartoMetricEventService, Bx as ClientService, _b as CustomGeoboundaryService, zb as ExportService, Ve as FilterOption, fn as GeoboundaryService, sx as GeocodingService, Lx as GeometryService, rb as InsightService, fx as IsochroneService, Uv as PlanService, Sy as PoiBrowserService, vy as PoiService, fS as PoisTilesetService, yx as SharePlanService, Jx as SignedUrlService, aS as StatsService, Le as buildSqlClientIdentifier, qe as getCartoCredentials, He as getColunmsIdFromModel, Av as getRoleFromFirebaseToken, Re as getTablesWithLastUpdate, Tv as initializeFirebaseApp, Zx as subscribeToPlans };
